// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../asset/font/PremierLeagueW01-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../asset/font/PremierLeagueW01-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../asset/font/PremierLeagueW01-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../asset/font/PremierLeagueW01-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../asset/font/PremierLeagueW01-Light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../asset/font/PremierLeagueW01-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../asset/font/PremierLeagueW01-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../asset/font/PremierLeagueW01-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../asset/font/PremierLeagueW01-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../asset/font/PremierLeagueW01-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../asset/font/PremierLeagueW01-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../asset/font/PremierLeagueW01-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../asset/font/PremierLeagueW01-Condensed.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../asset/font/PremierLeagueW01-Condensed.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../asset/font/PremierLeagueW01-Condensed.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../asset/font/PremierLeagueW01-Condensed.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../asset/font/PremierLeagueW01-CondBold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../asset/font/PremierLeagueW01-CondBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../asset/font/PremierLeagueW01-CondBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../asset/font/PremierLeagueW01-CondBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../asset/font/PremierLeagueW01-Italic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../asset/font/PremierLeagueW01-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../asset/font/PremierLeagueW01-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../asset/font/PremierLeagueW01-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../asset/font/PremierLeagueW01-LightIt.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../asset/font/PremierLeagueW01-LightIt.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../asset/font/PremierLeagueW01-LightIt.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../asset/font/PremierLeagueW01-LightIt.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../asset/font/PremierLeagueW01-BoldItalic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../asset/font/PremierLeagueW01-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../asset/font/PremierLeagueW01-BoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../asset/font/PremierLeagueW01-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../asset/font/PremierLeagueW01-Heavy.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../asset/font/PremierLeagueW01-Heavy.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../asset/font/PremierLeagueW01-Heavy.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../asset/font/PremierLeagueW01-Heavy.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("../asset/font/PremierLeagueW01-HeavyIt.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("../asset/font/PremierLeagueW01-HeavyIt.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("../asset/font/PremierLeagueW01-HeavyIt.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("../asset/font/PremierLeagueW01-HeavyIt.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-regular-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-regular-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-solid-900.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-solid-900.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%2386b7fe%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23198754%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2833, 37, 41, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23212529%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27M2 5L8 11L14 5%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23052c65%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27M2 5L8 11L14 5%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%236ea8fe%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_60___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%280, 0, 0, 0%29%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_61___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_62___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_63___ = new URL("../asset/img/login_bg@2x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_64___ = new URL("../asset/img/login-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_60___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_61___);
var ___CSS_LOADER_URL_REPLACEMENT_62___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_62___);
var ___CSS_LOADER_URL_REPLACEMENT_63___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_63___);
var ___CSS_LOADER_URL_REPLACEMENT_64___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_64___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@font-face {
  font-family: "PremierLeague-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
@font-face {
  font-family: "PremierLeague-Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
}
@font-face {
  font-family: "PremierLeague-Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype");
}
@font-face {
  font-family: "PremierLeague-Condensed";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("truetype");
}
@font-face {
  font-family: "PremierLeague-CondBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("truetype");
}
@font-face {
  font-family: "PremierLeague-Italic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("truetype");
}
@font-face {
  font-family: "PremierLeague-LightIt";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("truetype");
}
@font-face {
  font-family: "PremierLeague-BoldItalic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("truetype");
}
@font-face {
  font-family: "PremierLeague-Heavy";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format("truetype");
}
@font-face {
  font-family: "PremierLeague-HeavyIt";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_36___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_37___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_38___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_39___}) format("truetype");
}
/*!
 * Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
.fa {
  font-family: var(--fa-style-family, "Font Awesome 6 Free");
  font-weight: var(--fa-style, 900);
}

.fa,
.fa-classic,
.fa-sharp,
.fas,
.fa-solid,
.far,
.fa-regular,
.fab,
.fa-brands {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: var(--fa-display, inline-block);
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  text-rendering: auto;
}

.fas,
.fa-classic,
.fa-solid,
.far,
.fa-regular {
  font-family: "Font Awesome 6 Free";
}

.fab,
.fa-brands {
  font-family: "Font Awesome 6 Brands";
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(var(--fa-li-width, 2em) * -1);
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
  .fa-bounce,
  .fa-fade,
  .fa-beat-fade,
  .fa-flip,
  .fa-pulse,
  .fa-shake,
  .fa-spin,
  .fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  height: 2em;
  line-height: 2em;
  position: relative;
  vertical-align: middle;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  left: 0;
  position: absolute;
  text-align: center;
  width: 100%;
  z-index: var(--fa-stack-z-index, auto);
}

.fa-stack-1x {
  line-height: inherit;
}

.fa-stack-2x {
  font-size: 2em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen
readers do not read off random characters that represent icons */
.fa-0::before {
  content: "\\30 ";
}

.fa-1::before {
  content: "\\31 ";
}

.fa-2::before {
  content: "\\32 ";
}

.fa-3::before {
  content: "\\33 ";
}

.fa-4::before {
  content: "\\34 ";
}

.fa-5::before {
  content: "\\35 ";
}

.fa-6::before {
  content: "\\36 ";
}

.fa-7::before {
  content: "\\37 ";
}

.fa-8::before {
  content: "\\38 ";
}

.fa-9::before {
  content: "\\39 ";
}

.fa-fill-drip::before {
  content: "\\f576";
}

.fa-arrows-to-circle::before {
  content: "\\e4bd";
}

.fa-circle-chevron-right::before {
  content: "\\f138";
}

.fa-chevron-circle-right::before {
  content: "\\f138";
}

.fa-at::before {
  content: "\\@";
}

.fa-trash-can::before {
  content: "\\f2ed";
}

.fa-trash-alt::before {
  content: "\\f2ed";
}

.fa-text-height::before {
  content: "\\f034";
}

.fa-user-xmark::before {
  content: "\\f235";
}

.fa-user-times::before {
  content: "\\f235";
}

.fa-stethoscope::before {
  content: "\\f0f1";
}

.fa-message::before {
  content: "\\f27a";
}

.fa-comment-alt::before {
  content: "\\f27a";
}

.fa-info::before {
  content: "\\f129";
}

.fa-down-left-and-up-right-to-center::before {
  content: "\\f422";
}

.fa-compress-alt::before {
  content: "\\f422";
}

.fa-explosion::before {
  content: "\\e4e9";
}

.fa-file-lines::before {
  content: "\\f15c";
}

.fa-file-alt::before {
  content: "\\f15c";
}

.fa-file-text::before {
  content: "\\f15c";
}

.fa-wave-square::before {
  content: "\\f83e";
}

.fa-ring::before {
  content: "\\f70b";
}

.fa-building-un::before {
  content: "\\e4d9";
}

.fa-dice-three::before {
  content: "\\f527";
}

.fa-calendar-days::before {
  content: "\\f073";
}

.fa-calendar-alt::before {
  content: "\\f073";
}

.fa-anchor-circle-check::before {
  content: "\\e4aa";
}

.fa-building-circle-arrow-right::before {
  content: "\\e4d1";
}

.fa-volleyball::before {
  content: "\\f45f";
}

.fa-volleyball-ball::before {
  content: "\\f45f";
}

.fa-arrows-up-to-line::before {
  content: "\\e4c2";
}

.fa-sort-down::before {
  content: "\\f0dd";
}

.fa-sort-desc::before {
  content: "\\f0dd";
}

.fa-circle-minus::before {
  content: "\\f056";
}

.fa-minus-circle::before {
  content: "\\f056";
}

.fa-door-open::before {
  content: "\\f52b";
}

.fa-right-from-bracket::before {
  content: "\\f2f5";
}

.fa-sign-out-alt::before {
  content: "\\f2f5";
}

.fa-atom::before {
  content: "\\f5d2";
}

.fa-soap::before {
  content: "\\e06e";
}

.fa-icons::before {
  content: "\\f86d";
}

.fa-heart-music-camera-bolt::before {
  content: "\\f86d";
}

.fa-microphone-lines-slash::before {
  content: "\\f539";
}

.fa-microphone-alt-slash::before {
  content: "\\f539";
}

.fa-bridge-circle-check::before {
  content: "\\e4c9";
}

.fa-pump-medical::before {
  content: "\\e06a";
}

.fa-fingerprint::before {
  content: "\\f577";
}

.fa-hand-point-right::before {
  content: "\\f0a4";
}

.fa-magnifying-glass-location::before {
  content: "\\f689";
}

.fa-search-location::before {
  content: "\\f689";
}

.fa-forward-step::before {
  content: "\\f051";
}

.fa-step-forward::before {
  content: "\\f051";
}

.fa-face-smile-beam::before {
  content: "\\f5b8";
}

.fa-smile-beam::before {
  content: "\\f5b8";
}

.fa-flag-checkered::before {
  content: "\\f11e";
}

.fa-football::before {
  content: "\\f44e";
}

.fa-football-ball::before {
  content: "\\f44e";
}

.fa-school-circle-exclamation::before {
  content: "\\e56c";
}

.fa-crop::before {
  content: "\\f125";
}

.fa-angles-down::before {
  content: "\\f103";
}

.fa-angle-double-down::before {
  content: "\\f103";
}

.fa-users-rectangle::before {
  content: "\\e594";
}

.fa-people-roof::before {
  content: "\\e537";
}

.fa-people-line::before {
  content: "\\e534";
}

.fa-beer-mug-empty::before {
  content: "\\f0fc";
}

.fa-beer::before {
  content: "\\f0fc";
}

.fa-diagram-predecessor::before {
  content: "\\e477";
}

.fa-arrow-up-long::before {
  content: "\\f176";
}

.fa-long-arrow-up::before {
  content: "\\f176";
}

.fa-fire-flame-simple::before {
  content: "\\f46a";
}

.fa-burn::before {
  content: "\\f46a";
}

.fa-person::before {
  content: "\\f183";
}

.fa-male::before {
  content: "\\f183";
}

.fa-laptop::before {
  content: "\\f109";
}

.fa-file-csv::before {
  content: "\\f6dd";
}

.fa-menorah::before {
  content: "\\f676";
}

.fa-truck-plane::before {
  content: "\\e58f";
}

.fa-record-vinyl::before {
  content: "\\f8d9";
}

.fa-face-grin-stars::before {
  content: "\\f587";
}

.fa-grin-stars::before {
  content: "\\f587";
}

.fa-bong::before {
  content: "\\f55c";
}

.fa-spaghetti-monster-flying::before {
  content: "\\f67b";
}

.fa-pastafarianism::before {
  content: "\\f67b";
}

.fa-arrow-down-up-across-line::before {
  content: "\\e4af";
}

.fa-spoon::before {
  content: "\\f2e5";
}

.fa-utensil-spoon::before {
  content: "\\f2e5";
}

.fa-jar-wheat::before {
  content: "\\e517";
}

.fa-envelopes-bulk::before {
  content: "\\f674";
}

.fa-mail-bulk::before {
  content: "\\f674";
}

.fa-file-circle-exclamation::before {
  content: "\\e4eb";
}

.fa-circle-h::before {
  content: "\\f47e";
}

.fa-hospital-symbol::before {
  content: "\\f47e";
}

.fa-pager::before {
  content: "\\f815";
}

.fa-address-book::before {
  content: "\\f2b9";
}

.fa-contact-book::before {
  content: "\\f2b9";
}

.fa-strikethrough::before {
  content: "\\f0cc";
}

.fa-k::before {
  content: "K";
}

.fa-landmark-flag::before {
  content: "\\e51c";
}

.fa-pencil::before {
  content: "\\f303";
}

.fa-pencil-alt::before {
  content: "\\f303";
}

.fa-backward::before {
  content: "\\f04a";
}

.fa-caret-right::before {
  content: "\\f0da";
}

.fa-comments::before {
  content: "\\f086";
}

.fa-paste::before {
  content: "\\f0ea";
}

.fa-file-clipboard::before {
  content: "\\f0ea";
}

.fa-code-pull-request::before {
  content: "\\e13c";
}

.fa-clipboard-list::before {
  content: "\\f46d";
}

.fa-truck-ramp-box::before {
  content: "\\f4de";
}

.fa-truck-loading::before {
  content: "\\f4de";
}

.fa-user-check::before {
  content: "\\f4fc";
}

.fa-vial-virus::before {
  content: "\\e597";
}

.fa-sheet-plastic::before {
  content: "\\e571";
}

.fa-blog::before {
  content: "\\f781";
}

.fa-user-ninja::before {
  content: "\\f504";
}

.fa-person-arrow-up-from-line::before {
  content: "\\e539";
}

.fa-scroll-torah::before {
  content: "\\f6a0";
}

.fa-torah::before {
  content: "\\f6a0";
}

.fa-broom-ball::before {
  content: "\\f458";
}

.fa-quidditch::before {
  content: "\\f458";
}

.fa-quidditch-broom-ball::before {
  content: "\\f458";
}

.fa-toggle-off::before {
  content: "\\f204";
}

.fa-box-archive::before {
  content: "\\f187";
}

.fa-archive::before {
  content: "\\f187";
}

.fa-person-drowning::before {
  content: "\\e545";
}

.fa-arrow-down-9-1::before {
  content: "\\f886";
}

.fa-sort-numeric-desc::before {
  content: "\\f886";
}

.fa-sort-numeric-down-alt::before {
  content: "\\f886";
}

.fa-face-grin-tongue-squint::before {
  content: "\\f58a";
}

.fa-grin-tongue-squint::before {
  content: "\\f58a";
}

.fa-spray-can::before {
  content: "\\f5bd";
}

.fa-truck-monster::before {
  content: "\\f63b";
}

.fa-w::before {
  content: "W";
}

.fa-earth-africa::before {
  content: "\\f57c";
}

.fa-globe-africa::before {
  content: "\\f57c";
}

.fa-rainbow::before {
  content: "\\f75b";
}

.fa-circle-notch::before {
  content: "\\f1ce";
}

.fa-tablet-screen-button::before {
  content: "\\f3fa";
}

.fa-tablet-alt::before {
  content: "\\f3fa";
}

.fa-paw::before {
  content: "\\f1b0";
}

.fa-cloud::before {
  content: "\\f0c2";
}

.fa-trowel-bricks::before {
  content: "\\e58a";
}

.fa-face-flushed::before {
  content: "\\f579";
}

.fa-flushed::before {
  content: "\\f579";
}

.fa-hospital-user::before {
  content: "\\f80d";
}

.fa-tent-arrow-left-right::before {
  content: "\\e57f";
}

.fa-gavel::before {
  content: "\\f0e3";
}

.fa-legal::before {
  content: "\\f0e3";
}

.fa-binoculars::before {
  content: "\\f1e5";
}

.fa-microphone-slash::before {
  content: "\\f131";
}

.fa-box-tissue::before {
  content: "\\e05b";
}

.fa-motorcycle::before {
  content: "\\f21c";
}

.fa-bell-concierge::before {
  content: "\\f562";
}

.fa-concierge-bell::before {
  content: "\\f562";
}

.fa-pen-ruler::before {
  content: "\\f5ae";
}

.fa-pencil-ruler::before {
  content: "\\f5ae";
}

.fa-people-arrows::before {
  content: "\\e068";
}

.fa-people-arrows-left-right::before {
  content: "\\e068";
}

.fa-mars-and-venus-burst::before {
  content: "\\e523";
}

.fa-square-caret-right::before {
  content: "\\f152";
}

.fa-caret-square-right::before {
  content: "\\f152";
}

.fa-scissors::before {
  content: "\\f0c4";
}

.fa-cut::before {
  content: "\\f0c4";
}

.fa-sun-plant-wilt::before {
  content: "\\e57a";
}

.fa-toilets-portable::before {
  content: "\\e584";
}

.fa-hockey-puck::before {
  content: "\\f453";
}

.fa-table::before {
  content: "\\f0ce";
}

.fa-magnifying-glass-arrow-right::before {
  content: "\\e521";
}

.fa-tachograph-digital::before {
  content: "\\f566";
}

.fa-digital-tachograph::before {
  content: "\\f566";
}

.fa-users-slash::before {
  content: "\\e073";
}

.fa-clover::before {
  content: "\\e139";
}

.fa-reply::before {
  content: "\\f3e5";
}

.fa-mail-reply::before {
  content: "\\f3e5";
}

.fa-star-and-crescent::before {
  content: "\\f699";
}

.fa-house-fire::before {
  content: "\\e50c";
}

.fa-square-minus::before {
  content: "\\f146";
}

.fa-minus-square::before {
  content: "\\f146";
}

.fa-helicopter::before {
  content: "\\f533";
}

.fa-compass::before {
  content: "\\f14e";
}

.fa-square-caret-down::before {
  content: "\\f150";
}

.fa-caret-square-down::before {
  content: "\\f150";
}

.fa-file-circle-question::before {
  content: "\\e4ef";
}

.fa-laptop-code::before {
  content: "\\f5fc";
}

.fa-swatchbook::before {
  content: "\\f5c3";
}

.fa-prescription-bottle::before {
  content: "\\f485";
}

.fa-bars::before {
  content: "\\f0c9";
}

.fa-navicon::before {
  content: "\\f0c9";
}

.fa-people-group::before {
  content: "\\e533";
}

.fa-hourglass-end::before {
  content: "\\f253";
}

.fa-hourglass-3::before {
  content: "\\f253";
}

.fa-heart-crack::before {
  content: "\\f7a9";
}

.fa-heart-broken::before {
  content: "\\f7a9";
}

.fa-square-up-right::before {
  content: "\\f360";
}

.fa-external-link-square-alt::before {
  content: "\\f360";
}

.fa-face-kiss-beam::before {
  content: "\\f597";
}

.fa-kiss-beam::before {
  content: "\\f597";
}

.fa-film::before {
  content: "\\f008";
}

.fa-ruler-horizontal::before {
  content: "\\f547";
}

.fa-people-robbery::before {
  content: "\\e536";
}

.fa-lightbulb::before {
  content: "\\f0eb";
}

.fa-caret-left::before {
  content: "\\f0d9";
}

.fa-circle-exclamation::before {
  content: "\\f06a";
}

.fa-exclamation-circle::before {
  content: "\\f06a";
}

.fa-school-circle-xmark::before {
  content: "\\e56d";
}

.fa-arrow-right-from-bracket::before {
  content: "\\f08b";
}

.fa-sign-out::before {
  content: "\\f08b";
}

.fa-circle-chevron-down::before {
  content: "\\f13a";
}

.fa-chevron-circle-down::before {
  content: "\\f13a";
}

.fa-unlock-keyhole::before {
  content: "\\f13e";
}

.fa-unlock-alt::before {
  content: "\\f13e";
}

.fa-cloud-showers-heavy::before {
  content: "\\f740";
}

.fa-headphones-simple::before {
  content: "\\f58f";
}

.fa-headphones-alt::before {
  content: "\\f58f";
}

.fa-sitemap::before {
  content: "\\f0e8";
}

.fa-circle-dollar-to-slot::before {
  content: "\\f4b9";
}

.fa-donate::before {
  content: "\\f4b9";
}

.fa-memory::before {
  content: "\\f538";
}

.fa-road-spikes::before {
  content: "\\e568";
}

.fa-fire-burner::before {
  content: "\\e4f1";
}

.fa-flag::before {
  content: "\\f024";
}

.fa-hanukiah::before {
  content: "\\f6e6";
}

.fa-feather::before {
  content: "\\f52d";
}

.fa-volume-low::before {
  content: "\\f027";
}

.fa-volume-down::before {
  content: "\\f027";
}

.fa-comment-slash::before {
  content: "\\f4b3";
}

.fa-cloud-sun-rain::before {
  content: "\\f743";
}

.fa-compress::before {
  content: "\\f066";
}

.fa-wheat-awn::before {
  content: "\\e2cd";
}

.fa-wheat-alt::before {
  content: "\\e2cd";
}

.fa-ankh::before {
  content: "\\f644";
}

.fa-hands-holding-child::before {
  content: "\\e4fa";
}

.fa-asterisk::before {
  content: "\\*";
}

.fa-square-check::before {
  content: "\\f14a";
}

.fa-check-square::before {
  content: "\\f14a";
}

.fa-peseta-sign::before {
  content: "\\e221";
}

.fa-heading::before {
  content: "\\f1dc";
}

.fa-header::before {
  content: "\\f1dc";
}

.fa-ghost::before {
  content: "\\f6e2";
}

.fa-list::before {
  content: "\\f03a";
}

.fa-list-squares::before {
  content: "\\f03a";
}

.fa-square-phone-flip::before {
  content: "\\f87b";
}

.fa-phone-square-alt::before {
  content: "\\f87b";
}

.fa-cart-plus::before {
  content: "\\f217";
}

.fa-gamepad::before {
  content: "\\f11b";
}

.fa-circle-dot::before {
  content: "\\f192";
}

.fa-dot-circle::before {
  content: "\\f192";
}

.fa-face-dizzy::before {
  content: "\\f567";
}

.fa-dizzy::before {
  content: "\\f567";
}

.fa-egg::before {
  content: "\\f7fb";
}

.fa-house-medical-circle-xmark::before {
  content: "\\e513";
}

.fa-campground::before {
  content: "\\f6bb";
}

.fa-folder-plus::before {
  content: "\\f65e";
}

.fa-futbol::before {
  content: "\\f1e3";
}

.fa-futbol-ball::before {
  content: "\\f1e3";
}

.fa-soccer-ball::before {
  content: "\\f1e3";
}

.fa-paintbrush::before {
  content: "\\f1fc";
}

.fa-paint-brush::before {
  content: "\\f1fc";
}

.fa-lock::before {
  content: "\\f023";
}

.fa-gas-pump::before {
  content: "\\f52f";
}

.fa-hot-tub-person::before {
  content: "\\f593";
}

.fa-hot-tub::before {
  content: "\\f593";
}

.fa-map-location::before {
  content: "\\f59f";
}

.fa-map-marked::before {
  content: "\\f59f";
}

.fa-house-flood-water::before {
  content: "\\e50e";
}

.fa-tree::before {
  content: "\\f1bb";
}

.fa-bridge-lock::before {
  content: "\\e4cc";
}

.fa-sack-dollar::before {
  content: "\\f81d";
}

.fa-pen-to-square::before {
  content: "\\f044";
}

.fa-edit::before {
  content: "\\f044";
}

.fa-car-side::before {
  content: "\\f5e4";
}

.fa-share-nodes::before {
  content: "\\f1e0";
}

.fa-share-alt::before {
  content: "\\f1e0";
}

.fa-heart-circle-minus::before {
  content: "\\e4ff";
}

.fa-hourglass-half::before {
  content: "\\f252";
}

.fa-hourglass-2::before {
  content: "\\f252";
}

.fa-microscope::before {
  content: "\\f610";
}

.fa-sink::before {
  content: "\\e06d";
}

.fa-bag-shopping::before {
  content: "\\f290";
}

.fa-shopping-bag::before {
  content: "\\f290";
}

.fa-arrow-down-z-a::before {
  content: "\\f881";
}

.fa-sort-alpha-desc::before {
  content: "\\f881";
}

.fa-sort-alpha-down-alt::before {
  content: "\\f881";
}

.fa-mitten::before {
  content: "\\f7b5";
}

.fa-person-rays::before {
  content: "\\e54d";
}

.fa-users::before {
  content: "\\f0c0";
}

.fa-eye-slash::before {
  content: "\\f070";
}

.fa-flask-vial::before {
  content: "\\e4f3";
}

.fa-hand::before {
  content: "\\f256";
}

.fa-hand-paper::before {
  content: "\\f256";
}

.fa-om::before {
  content: "\\f679";
}

.fa-worm::before {
  content: "\\e599";
}

.fa-house-circle-xmark::before {
  content: "\\e50b";
}

.fa-plug::before {
  content: "\\f1e6";
}

.fa-chevron-up::before {
  content: "\\f077";
}

.fa-hand-spock::before {
  content: "\\f259";
}

.fa-stopwatch::before {
  content: "\\f2f2";
}

.fa-face-kiss::before {
  content: "\\f596";
}

.fa-kiss::before {
  content: "\\f596";
}

.fa-bridge-circle-xmark::before {
  content: "\\e4cb";
}

.fa-face-grin-tongue::before {
  content: "\\f589";
}

.fa-grin-tongue::before {
  content: "\\f589";
}

.fa-chess-bishop::before {
  content: "\\f43a";
}

.fa-face-grin-wink::before {
  content: "\\f58c";
}

.fa-grin-wink::before {
  content: "\\f58c";
}

.fa-ear-deaf::before {
  content: "\\f2a4";
}

.fa-deaf::before {
  content: "\\f2a4";
}

.fa-deafness::before {
  content: "\\f2a4";
}

.fa-hard-of-hearing::before {
  content: "\\f2a4";
}

.fa-road-circle-check::before {
  content: "\\e564";
}

.fa-dice-five::before {
  content: "\\f523";
}

.fa-square-rss::before {
  content: "\\f143";
}

.fa-rss-square::before {
  content: "\\f143";
}

.fa-land-mine-on::before {
  content: "\\e51b";
}

.fa-i-cursor::before {
  content: "\\f246";
}

.fa-stamp::before {
  content: "\\f5bf";
}

.fa-stairs::before {
  content: "\\e289";
}

.fa-i::before {
  content: "I";
}

.fa-hryvnia-sign::before {
  content: "\\f6f2";
}

.fa-hryvnia::before {
  content: "\\f6f2";
}

.fa-pills::before {
  content: "\\f484";
}

.fa-face-grin-wide::before {
  content: "\\f581";
}

.fa-grin-alt::before {
  content: "\\f581";
}

.fa-tooth::before {
  content: "\\f5c9";
}

.fa-v::before {
  content: "V";
}

.fa-bangladeshi-taka-sign::before {
  content: "\\e2e6";
}

.fa-bicycle::before {
  content: "\\f206";
}

.fa-staff-snake::before {
  content: "\\e579";
}

.fa-rod-asclepius::before {
  content: "\\e579";
}

.fa-rod-snake::before {
  content: "\\e579";
}

.fa-staff-aesculapius::before {
  content: "\\e579";
}

.fa-head-side-cough-slash::before {
  content: "\\e062";
}

.fa-truck-medical::before {
  content: "\\f0f9";
}

.fa-ambulance::before {
  content: "\\f0f9";
}

.fa-wheat-awn-circle-exclamation::before {
  content: "\\e598";
}

.fa-snowman::before {
  content: "\\f7d0";
}

.fa-mortar-pestle::before {
  content: "\\f5a7";
}

.fa-road-barrier::before {
  content: "\\e562";
}

.fa-school::before {
  content: "\\f549";
}

.fa-igloo::before {
  content: "\\f7ae";
}

.fa-joint::before {
  content: "\\f595";
}

.fa-angle-right::before {
  content: "\\f105";
}

.fa-horse::before {
  content: "\\f6f0";
}

.fa-q::before {
  content: "Q";
}

.fa-g::before {
  content: "G";
}

.fa-notes-medical::before {
  content: "\\f481";
}

.fa-temperature-half::before {
  content: "\\f2c9";
}

.fa-temperature-2::before {
  content: "\\f2c9";
}

.fa-thermometer-2::before {
  content: "\\f2c9";
}

.fa-thermometer-half::before {
  content: "\\f2c9";
}

.fa-dong-sign::before {
  content: "\\e169";
}

.fa-capsules::before {
  content: "\\f46b";
}

.fa-poo-storm::before {
  content: "\\f75a";
}

.fa-poo-bolt::before {
  content: "\\f75a";
}

.fa-face-frown-open::before {
  content: "\\f57a";
}

.fa-frown-open::before {
  content: "\\f57a";
}

.fa-hand-point-up::before {
  content: "\\f0a6";
}

.fa-money-bill::before {
  content: "\\f0d6";
}

.fa-bookmark::before {
  content: "\\f02e";
}

.fa-align-justify::before {
  content: "\\f039";
}

.fa-umbrella-beach::before {
  content: "\\f5ca";
}

.fa-helmet-un::before {
  content: "\\e503";
}

.fa-bullseye::before {
  content: "\\f140";
}

.fa-bacon::before {
  content: "\\f7e5";
}

.fa-hand-point-down::before {
  content: "\\f0a7";
}

.fa-arrow-up-from-bracket::before {
  content: "\\e09a";
}

.fa-folder::before {
  content: "\\f07b";
}

.fa-folder-blank::before {
  content: "\\f07b";
}

.fa-file-waveform::before {
  content: "\\f478";
}

.fa-file-medical-alt::before {
  content: "\\f478";
}

.fa-radiation::before {
  content: "\\f7b9";
}

.fa-chart-simple::before {
  content: "\\e473";
}

.fa-mars-stroke::before {
  content: "\\f229";
}

.fa-vial::before {
  content: "\\f492";
}

.fa-gauge::before {
  content: "\\f624";
}

.fa-dashboard::before {
  content: "\\f624";
}

.fa-gauge-med::before {
  content: "\\f624";
}

.fa-tachometer-alt-average::before {
  content: "\\f624";
}

.fa-wand-magic-sparkles::before {
  content: "\\e2ca";
}

.fa-magic-wand-sparkles::before {
  content: "\\e2ca";
}

.fa-e::before {
  content: "E";
}

.fa-pen-clip::before {
  content: "\\f305";
}

.fa-pen-alt::before {
  content: "\\f305";
}

.fa-bridge-circle-exclamation::before {
  content: "\\e4ca";
}

.fa-user::before {
  content: "\\f007";
}

.fa-school-circle-check::before {
  content: "\\e56b";
}

.fa-dumpster::before {
  content: "\\f793";
}

.fa-van-shuttle::before {
  content: "\\f5b6";
}

.fa-shuttle-van::before {
  content: "\\f5b6";
}

.fa-building-user::before {
  content: "\\e4da";
}

.fa-square-caret-left::before {
  content: "\\f191";
}

.fa-caret-square-left::before {
  content: "\\f191";
}

.fa-highlighter::before {
  content: "\\f591";
}

.fa-key::before {
  content: "\\f084";
}

.fa-bullhorn::before {
  content: "\\f0a1";
}

.fa-globe::before {
  content: "\\f0ac";
}

.fa-synagogue::before {
  content: "\\f69b";
}

.fa-person-half-dress::before {
  content: "\\e548";
}

.fa-road-bridge::before {
  content: "\\e563";
}

.fa-location-arrow::before {
  content: "\\f124";
}

.fa-c::before {
  content: "C";
}

.fa-tablet-button::before {
  content: "\\f10a";
}

.fa-building-lock::before {
  content: "\\e4d6";
}

.fa-pizza-slice::before {
  content: "\\f818";
}

.fa-money-bill-wave::before {
  content: "\\f53a";
}

.fa-chart-area::before {
  content: "\\f1fe";
}

.fa-area-chart::before {
  content: "\\f1fe";
}

.fa-house-flag::before {
  content: "\\e50d";
}

.fa-person-circle-minus::before {
  content: "\\e540";
}

.fa-ban::before {
  content: "\\f05e";
}

.fa-cancel::before {
  content: "\\f05e";
}

.fa-camera-rotate::before {
  content: "\\e0d8";
}

.fa-spray-can-sparkles::before {
  content: "\\f5d0";
}

.fa-air-freshener::before {
  content: "\\f5d0";
}

.fa-star::before {
  content: "\\f005";
}

.fa-repeat::before {
  content: "\\f363";
}

.fa-cross::before {
  content: "\\f654";
}

.fa-box::before {
  content: "\\f466";
}

.fa-venus-mars::before {
  content: "\\f228";
}

.fa-arrow-pointer::before {
  content: "\\f245";
}

.fa-mouse-pointer::before {
  content: "\\f245";
}

.fa-maximize::before {
  content: "\\f31e";
}

.fa-expand-arrows-alt::before {
  content: "\\f31e";
}

.fa-charging-station::before {
  content: "\\f5e7";
}

.fa-shapes::before {
  content: "\\f61f";
}

.fa-triangle-circle-square::before {
  content: "\\f61f";
}

.fa-shuffle::before {
  content: "\\f074";
}

.fa-random::before {
  content: "\\f074";
}

.fa-person-running::before {
  content: "\\f70c";
}

.fa-running::before {
  content: "\\f70c";
}

.fa-mobile-retro::before {
  content: "\\e527";
}

.fa-grip-lines-vertical::before {
  content: "\\f7a5";
}

.fa-spider::before {
  content: "\\f717";
}

.fa-hands-bound::before {
  content: "\\e4f9";
}

.fa-file-invoice-dollar::before {
  content: "\\f571";
}

.fa-plane-circle-exclamation::before {
  content: "\\e556";
}

.fa-x-ray::before {
  content: "\\f497";
}

.fa-spell-check::before {
  content: "\\f891";
}

.fa-slash::before {
  content: "\\f715";
}

.fa-computer-mouse::before {
  content: "\\f8cc";
}

.fa-mouse::before {
  content: "\\f8cc";
}

.fa-arrow-right-to-bracket::before {
  content: "\\f090";
}

.fa-sign-in::before {
  content: "\\f090";
}

.fa-shop-slash::before {
  content: "\\e070";
}

.fa-store-alt-slash::before {
  content: "\\e070";
}

.fa-server::before {
  content: "\\f233";
}

.fa-virus-covid-slash::before {
  content: "\\e4a9";
}

.fa-shop-lock::before {
  content: "\\e4a5";
}

.fa-hourglass-start::before {
  content: "\\f251";
}

.fa-hourglass-1::before {
  content: "\\f251";
}

.fa-blender-phone::before {
  content: "\\f6b6";
}

.fa-building-wheat::before {
  content: "\\e4db";
}

.fa-person-breastfeeding::before {
  content: "\\e53a";
}

.fa-right-to-bracket::before {
  content: "\\f2f6";
}

.fa-sign-in-alt::before {
  content: "\\f2f6";
}

.fa-venus::before {
  content: "\\f221";
}

.fa-passport::before {
  content: "\\f5ab";
}

.fa-heart-pulse::before {
  content: "\\f21e";
}

.fa-heartbeat::before {
  content: "\\f21e";
}

.fa-people-carry-box::before {
  content: "\\f4ce";
}

.fa-people-carry::before {
  content: "\\f4ce";
}

.fa-temperature-high::before {
  content: "\\f769";
}

.fa-microchip::before {
  content: "\\f2db";
}

.fa-crown::before {
  content: "\\f521";
}

.fa-weight-hanging::before {
  content: "\\f5cd";
}

.fa-xmarks-lines::before {
  content: "\\e59a";
}

.fa-file-prescription::before {
  content: "\\f572";
}

.fa-weight-scale::before {
  content: "\\f496";
}

.fa-weight::before {
  content: "\\f496";
}

.fa-user-group::before {
  content: "\\f500";
}

.fa-user-friends::before {
  content: "\\f500";
}

.fa-arrow-up-a-z::before {
  content: "\\f15e";
}

.fa-sort-alpha-up::before {
  content: "\\f15e";
}

.fa-chess-knight::before {
  content: "\\f441";
}

.fa-face-laugh-squint::before {
  content: "\\f59b";
}

.fa-laugh-squint::before {
  content: "\\f59b";
}

.fa-wheelchair::before {
  content: "\\f193";
}

.fa-circle-arrow-up::before {
  content: "\\f0aa";
}

.fa-arrow-circle-up::before {
  content: "\\f0aa";
}

.fa-toggle-on::before {
  content: "\\f205";
}

.fa-person-walking::before {
  content: "\\f554";
}

.fa-walking::before {
  content: "\\f554";
}

.fa-l::before {
  content: "L";
}

.fa-fire::before {
  content: "\\f06d";
}

.fa-bed-pulse::before {
  content: "\\f487";
}

.fa-procedures::before {
  content: "\\f487";
}

.fa-shuttle-space::before {
  content: "\\f197";
}

.fa-space-shuttle::before {
  content: "\\f197";
}

.fa-face-laugh::before {
  content: "\\f599";
}

.fa-laugh::before {
  content: "\\f599";
}

.fa-folder-open::before {
  content: "\\f07c";
}

.fa-heart-circle-plus::before {
  content: "\\e500";
}

.fa-code-fork::before {
  content: "\\e13b";
}

.fa-city::before {
  content: "\\f64f";
}

.fa-microphone-lines::before {
  content: "\\f3c9";
}

.fa-microphone-alt::before {
  content: "\\f3c9";
}

.fa-pepper-hot::before {
  content: "\\f816";
}

.fa-unlock::before {
  content: "\\f09c";
}

.fa-colon-sign::before {
  content: "\\e140";
}

.fa-headset::before {
  content: "\\f590";
}

.fa-store-slash::before {
  content: "\\e071";
}

.fa-road-circle-xmark::before {
  content: "\\e566";
}

.fa-user-minus::before {
  content: "\\f503";
}

.fa-mars-stroke-up::before {
  content: "\\f22a";
}

.fa-mars-stroke-v::before {
  content: "\\f22a";
}

.fa-champagne-glasses::before {
  content: "\\f79f";
}

.fa-glass-cheers::before {
  content: "\\f79f";
}

.fa-clipboard::before {
  content: "\\f328";
}

.fa-house-circle-exclamation::before {
  content: "\\e50a";
}

.fa-file-arrow-up::before {
  content: "\\f574";
}

.fa-file-upload::before {
  content: "\\f574";
}

.fa-wifi::before {
  content: "\\f1eb";
}

.fa-wifi-3::before {
  content: "\\f1eb";
}

.fa-wifi-strong::before {
  content: "\\f1eb";
}

.fa-bath::before {
  content: "\\f2cd";
}

.fa-bathtub::before {
  content: "\\f2cd";
}

.fa-underline::before {
  content: "\\f0cd";
}

.fa-user-pen::before {
  content: "\\f4ff";
}

.fa-user-edit::before {
  content: "\\f4ff";
}

.fa-signature::before {
  content: "\\f5b7";
}

.fa-stroopwafel::before {
  content: "\\f551";
}

.fa-bold::before {
  content: "\\f032";
}

.fa-anchor-lock::before {
  content: "\\e4ad";
}

.fa-building-ngo::before {
  content: "\\e4d7";
}

.fa-manat-sign::before {
  content: "\\e1d5";
}

.fa-not-equal::before {
  content: "\\f53e";
}

.fa-border-top-left::before {
  content: "\\f853";
}

.fa-border-style::before {
  content: "\\f853";
}

.fa-map-location-dot::before {
  content: "\\f5a0";
}

.fa-map-marked-alt::before {
  content: "\\f5a0";
}

.fa-jedi::before {
  content: "\\f669";
}

.fa-square-poll-vertical::before {
  content: "\\f681";
}

.fa-poll::before {
  content: "\\f681";
}

.fa-mug-hot::before {
  content: "\\f7b6";
}

.fa-car-battery::before {
  content: "\\f5df";
}

.fa-battery-car::before {
  content: "\\f5df";
}

.fa-gift::before {
  content: "\\f06b";
}

.fa-dice-two::before {
  content: "\\f528";
}

.fa-chess-queen::before {
  content: "\\f445";
}

.fa-glasses::before {
  content: "\\f530";
}

.fa-chess-board::before {
  content: "\\f43c";
}

.fa-building-circle-check::before {
  content: "\\e4d2";
}

.fa-person-chalkboard::before {
  content: "\\e53d";
}

.fa-mars-stroke-right::before {
  content: "\\f22b";
}

.fa-mars-stroke-h::before {
  content: "\\f22b";
}

.fa-hand-back-fist::before {
  content: "\\f255";
}

.fa-hand-rock::before {
  content: "\\f255";
}

.fa-square-caret-up::before {
  content: "\\f151";
}

.fa-caret-square-up::before {
  content: "\\f151";
}

.fa-cloud-showers-water::before {
  content: "\\e4e4";
}

.fa-chart-bar::before {
  content: "\\f080";
}

.fa-bar-chart::before {
  content: "\\f080";
}

.fa-hands-bubbles::before {
  content: "\\e05e";
}

.fa-hands-wash::before {
  content: "\\e05e";
}

.fa-less-than-equal::before {
  content: "\\f537";
}

.fa-train::before {
  content: "\\f238";
}

.fa-eye-low-vision::before {
  content: "\\f2a8";
}

.fa-low-vision::before {
  content: "\\f2a8";
}

.fa-crow::before {
  content: "\\f520";
}

.fa-sailboat::before {
  content: "\\e445";
}

.fa-window-restore::before {
  content: "\\f2d2";
}

.fa-square-plus::before {
  content: "\\f0fe";
}

.fa-plus-square::before {
  content: "\\f0fe";
}

.fa-torii-gate::before {
  content: "\\f6a1";
}

.fa-frog::before {
  content: "\\f52e";
}

.fa-bucket::before {
  content: "\\e4cf";
}

.fa-image::before {
  content: "\\f03e";
}

.fa-microphone::before {
  content: "\\f130";
}

.fa-cow::before {
  content: "\\f6c8";
}

.fa-caret-up::before {
  content: "\\f0d8";
}

.fa-screwdriver::before {
  content: "\\f54a";
}

.fa-folder-closed::before {
  content: "\\e185";
}

.fa-house-tsunami::before {
  content: "\\e515";
}

.fa-square-nfi::before {
  content: "\\e576";
}

.fa-arrow-up-from-ground-water::before {
  content: "\\e4b5";
}

.fa-martini-glass::before {
  content: "\\f57b";
}

.fa-glass-martini-alt::before {
  content: "\\f57b";
}

.fa-rotate-left::before {
  content: "\\f2ea";
}

.fa-rotate-back::before {
  content: "\\f2ea";
}

.fa-rotate-backward::before {
  content: "\\f2ea";
}

.fa-undo-alt::before {
  content: "\\f2ea";
}

.fa-table-columns::before {
  content: "\\f0db";
}

.fa-columns::before {
  content: "\\f0db";
}

.fa-lemon::before {
  content: "\\f094";
}

.fa-head-side-mask::before {
  content: "\\e063";
}

.fa-handshake::before {
  content: "\\f2b5";
}

.fa-gem::before {
  content: "\\f3a5";
}

.fa-dolly::before {
  content: "\\f472";
}

.fa-dolly-box::before {
  content: "\\f472";
}

.fa-smoking::before {
  content: "\\f48d";
}

.fa-minimize::before {
  content: "\\f78c";
}

.fa-compress-arrows-alt::before {
  content: "\\f78c";
}

.fa-monument::before {
  content: "\\f5a6";
}

.fa-snowplow::before {
  content: "\\f7d2";
}

.fa-angles-right::before {
  content: "\\f101";
}

.fa-angle-double-right::before {
  content: "\\f101";
}

.fa-cannabis::before {
  content: "\\f55f";
}

.fa-circle-play::before {
  content: "\\f144";
}

.fa-play-circle::before {
  content: "\\f144";
}

.fa-tablets::before {
  content: "\\f490";
}

.fa-ethernet::before {
  content: "\\f796";
}

.fa-euro-sign::before {
  content: "\\f153";
}

.fa-eur::before {
  content: "\\f153";
}

.fa-euro::before {
  content: "\\f153";
}

.fa-chair::before {
  content: "\\f6c0";
}

.fa-circle-check::before {
  content: "\\f058";
}

.fa-check-circle::before {
  content: "\\f058";
}

.fa-circle-stop::before {
  content: "\\f28d";
}

.fa-stop-circle::before {
  content: "\\f28d";
}

.fa-compass-drafting::before {
  content: "\\f568";
}

.fa-drafting-compass::before {
  content: "\\f568";
}

.fa-plate-wheat::before {
  content: "\\e55a";
}

.fa-icicles::before {
  content: "\\f7ad";
}

.fa-person-shelter::before {
  content: "\\e54f";
}

.fa-neuter::before {
  content: "\\f22c";
}

.fa-id-badge::before {
  content: "\\f2c1";
}

.fa-marker::before {
  content: "\\f5a1";
}

.fa-face-laugh-beam::before {
  content: "\\f59a";
}

.fa-laugh-beam::before {
  content: "\\f59a";
}

.fa-helicopter-symbol::before {
  content: "\\e502";
}

.fa-universal-access::before {
  content: "\\f29a";
}

.fa-circle-chevron-up::before {
  content: "\\f139";
}

.fa-chevron-circle-up::before {
  content: "\\f139";
}

.fa-lari-sign::before {
  content: "\\e1c8";
}

.fa-volcano::before {
  content: "\\f770";
}

.fa-person-walking-dashed-line-arrow-right::before {
  content: "\\e553";
}

.fa-sterling-sign::before {
  content: "\\f154";
}

.fa-gbp::before {
  content: "\\f154";
}

.fa-pound-sign::before {
  content: "\\f154";
}

.fa-viruses::before {
  content: "\\e076";
}

.fa-square-person-confined::before {
  content: "\\e577";
}

.fa-user-tie::before {
  content: "\\f508";
}

.fa-arrow-down-long::before {
  content: "\\f175";
}

.fa-long-arrow-down::before {
  content: "\\f175";
}

.fa-tent-arrow-down-to-line::before {
  content: "\\e57e";
}

.fa-certificate::before {
  content: "\\f0a3";
}

.fa-reply-all::before {
  content: "\\f122";
}

.fa-mail-reply-all::before {
  content: "\\f122";
}

.fa-suitcase::before {
  content: "\\f0f2";
}

.fa-person-skating::before {
  content: "\\f7c5";
}

.fa-skating::before {
  content: "\\f7c5";
}

.fa-filter-circle-dollar::before {
  content: "\\f662";
}

.fa-funnel-dollar::before {
  content: "\\f662";
}

.fa-camera-retro::before {
  content: "\\f083";
}

.fa-circle-arrow-down::before {
  content: "\\f0ab";
}

.fa-arrow-circle-down::before {
  content: "\\f0ab";
}

.fa-file-import::before {
  content: "\\f56f";
}

.fa-arrow-right-to-file::before {
  content: "\\f56f";
}

.fa-square-arrow-up-right::before {
  content: "\\f14c";
}

.fa-external-link-square::before {
  content: "\\f14c";
}

.fa-box-open::before {
  content: "\\f49e";
}

.fa-scroll::before {
  content: "\\f70e";
}

.fa-spa::before {
  content: "\\f5bb";
}

.fa-location-pin-lock::before {
  content: "\\e51f";
}

.fa-pause::before {
  content: "\\f04c";
}

.fa-hill-avalanche::before {
  content: "\\e507";
}

.fa-temperature-empty::before {
  content: "\\f2cb";
}

.fa-temperature-0::before {
  content: "\\f2cb";
}

.fa-thermometer-0::before {
  content: "\\f2cb";
}

.fa-thermometer-empty::before {
  content: "\\f2cb";
}

.fa-bomb::before {
  content: "\\f1e2";
}

.fa-registered::before {
  content: "\\f25d";
}

.fa-address-card::before {
  content: "\\f2bb";
}

.fa-contact-card::before {
  content: "\\f2bb";
}

.fa-vcard::before {
  content: "\\f2bb";
}

.fa-scale-unbalanced-flip::before {
  content: "\\f516";
}

.fa-balance-scale-right::before {
  content: "\\f516";
}

.fa-subscript::before {
  content: "\\f12c";
}

.fa-diamond-turn-right::before {
  content: "\\f5eb";
}

.fa-directions::before {
  content: "\\f5eb";
}

.fa-burst::before {
  content: "\\e4dc";
}

.fa-house-laptop::before {
  content: "\\e066";
}

.fa-laptop-house::before {
  content: "\\e066";
}

.fa-face-tired::before {
  content: "\\f5c8";
}

.fa-tired::before {
  content: "\\f5c8";
}

.fa-money-bills::before {
  content: "\\e1f3";
}

.fa-smog::before {
  content: "\\f75f";
}

.fa-crutch::before {
  content: "\\f7f7";
}

.fa-cloud-arrow-up::before {
  content: "\\f0ee";
}

.fa-cloud-upload::before {
  content: "\\f0ee";
}

.fa-cloud-upload-alt::before {
  content: "\\f0ee";
}

.fa-palette::before {
  content: "\\f53f";
}

.fa-arrows-turn-right::before {
  content: "\\e4c0";
}

.fa-vest::before {
  content: "\\e085";
}

.fa-ferry::before {
  content: "\\e4ea";
}

.fa-arrows-down-to-people::before {
  content: "\\e4b9";
}

.fa-seedling::before {
  content: "\\f4d8";
}

.fa-sprout::before {
  content: "\\f4d8";
}

.fa-left-right::before {
  content: "\\f337";
}

.fa-arrows-alt-h::before {
  content: "\\f337";
}

.fa-boxes-packing::before {
  content: "\\e4c7";
}

.fa-circle-arrow-left::before {
  content: "\\f0a8";
}

.fa-arrow-circle-left::before {
  content: "\\f0a8";
}

.fa-group-arrows-rotate::before {
  content: "\\e4f6";
}

.fa-bowl-food::before {
  content: "\\e4c6";
}

.fa-candy-cane::before {
  content: "\\f786";
}

.fa-arrow-down-wide-short::before {
  content: "\\f160";
}

.fa-sort-amount-asc::before {
  content: "\\f160";
}

.fa-sort-amount-down::before {
  content: "\\f160";
}

.fa-cloud-bolt::before {
  content: "\\f76c";
}

.fa-thunderstorm::before {
  content: "\\f76c";
}

.fa-text-slash::before {
  content: "\\f87d";
}

.fa-remove-format::before {
  content: "\\f87d";
}

.fa-face-smile-wink::before {
  content: "\\f4da";
}

.fa-smile-wink::before {
  content: "\\f4da";
}

.fa-file-word::before {
  content: "\\f1c2";
}

.fa-file-powerpoint::before {
  content: "\\f1c4";
}

.fa-arrows-left-right::before {
  content: "\\f07e";
}

.fa-arrows-h::before {
  content: "\\f07e";
}

.fa-house-lock::before {
  content: "\\e510";
}

.fa-cloud-arrow-down::before {
  content: "\\f0ed";
}

.fa-cloud-download::before {
  content: "\\f0ed";
}

.fa-cloud-download-alt::before {
  content: "\\f0ed";
}

.fa-children::before {
  content: "\\e4e1";
}

.fa-chalkboard::before {
  content: "\\f51b";
}

.fa-blackboard::before {
  content: "\\f51b";
}

.fa-user-large-slash::before {
  content: "\\f4fa";
}

.fa-user-alt-slash::before {
  content: "\\f4fa";
}

.fa-envelope-open::before {
  content: "\\f2b6";
}

.fa-handshake-simple-slash::before {
  content: "\\e05f";
}

.fa-handshake-alt-slash::before {
  content: "\\e05f";
}

.fa-mattress-pillow::before {
  content: "\\e525";
}

.fa-guarani-sign::before {
  content: "\\e19a";
}

.fa-arrows-rotate::before {
  content: "\\f021";
}

.fa-refresh::before {
  content: "\\f021";
}

.fa-sync::before {
  content: "\\f021";
}

.fa-fire-extinguisher::before {
  content: "\\f134";
}

.fa-cruzeiro-sign::before {
  content: "\\e152";
}

.fa-greater-than-equal::before {
  content: "\\f532";
}

.fa-shield-halved::before {
  content: "\\f3ed";
}

.fa-shield-alt::before {
  content: "\\f3ed";
}

.fa-book-atlas::before {
  content: "\\f558";
}

.fa-atlas::before {
  content: "\\f558";
}

.fa-virus::before {
  content: "\\e074";
}

.fa-envelope-circle-check::before {
  content: "\\e4e8";
}

.fa-layer-group::before {
  content: "\\f5fd";
}

.fa-arrows-to-dot::before {
  content: "\\e4be";
}

.fa-archway::before {
  content: "\\f557";
}

.fa-heart-circle-check::before {
  content: "\\e4fd";
}

.fa-house-chimney-crack::before {
  content: "\\f6f1";
}

.fa-house-damage::before {
  content: "\\f6f1";
}

.fa-file-zipper::before {
  content: "\\f1c6";
}

.fa-file-archive::before {
  content: "\\f1c6";
}

.fa-square::before {
  content: "\\f0c8";
}

.fa-martini-glass-empty::before {
  content: "\\f000";
}

.fa-glass-martini::before {
  content: "\\f000";
}

.fa-couch::before {
  content: "\\f4b8";
}

.fa-cedi-sign::before {
  content: "\\e0df";
}

.fa-italic::before {
  content: "\\f033";
}

.fa-table-cells-column-lock::before {
  content: "\\e678";
}

.fa-church::before {
  content: "\\f51d";
}

.fa-comments-dollar::before {
  content: "\\f653";
}

.fa-democrat::before {
  content: "\\f747";
}

.fa-z::before {
  content: "Z";
}

.fa-person-skiing::before {
  content: "\\f7c9";
}

.fa-skiing::before {
  content: "\\f7c9";
}

.fa-road-lock::before {
  content: "\\e567";
}

.fa-a::before {
  content: "A";
}

.fa-temperature-arrow-down::before {
  content: "\\e03f";
}

.fa-temperature-down::before {
  content: "\\e03f";
}

.fa-feather-pointed::before {
  content: "\\f56b";
}

.fa-feather-alt::before {
  content: "\\f56b";
}

.fa-p::before {
  content: "P";
}

.fa-snowflake::before {
  content: "\\f2dc";
}

.fa-newspaper::before {
  content: "\\f1ea";
}

.fa-rectangle-ad::before {
  content: "\\f641";
}

.fa-ad::before {
  content: "\\f641";
}

.fa-circle-arrow-right::before {
  content: "\\f0a9";
}

.fa-arrow-circle-right::before {
  content: "\\f0a9";
}

.fa-filter-circle-xmark::before {
  content: "\\e17b";
}

.fa-locust::before {
  content: "\\e520";
}

.fa-sort::before {
  content: "\\f0dc";
}

.fa-unsorted::before {
  content: "\\f0dc";
}

.fa-list-ol::before {
  content: "\\f0cb";
}

.fa-list-1-2::before {
  content: "\\f0cb";
}

.fa-list-numeric::before {
  content: "\\f0cb";
}

.fa-person-dress-burst::before {
  content: "\\e544";
}

.fa-money-check-dollar::before {
  content: "\\f53d";
}

.fa-money-check-alt::before {
  content: "\\f53d";
}

.fa-vector-square::before {
  content: "\\f5cb";
}

.fa-bread-slice::before {
  content: "\\f7ec";
}

.fa-language::before {
  content: "\\f1ab";
}

.fa-face-kiss-wink-heart::before {
  content: "\\f598";
}

.fa-kiss-wink-heart::before {
  content: "\\f598";
}

.fa-filter::before {
  content: "\\f0b0";
}

.fa-question::before {
  content: "\\?";
}

.fa-file-signature::before {
  content: "\\f573";
}

.fa-up-down-left-right::before {
  content: "\\f0b2";
}

.fa-arrows-alt::before {
  content: "\\f0b2";
}

.fa-house-chimney-user::before {
  content: "\\e065";
}

.fa-hand-holding-heart::before {
  content: "\\f4be";
}

.fa-puzzle-piece::before {
  content: "\\f12e";
}

.fa-money-check::before {
  content: "\\f53c";
}

.fa-star-half-stroke::before {
  content: "\\f5c0";
}

.fa-star-half-alt::before {
  content: "\\f5c0";
}

.fa-code::before {
  content: "\\f121";
}

.fa-whiskey-glass::before {
  content: "\\f7a0";
}

.fa-glass-whiskey::before {
  content: "\\f7a0";
}

.fa-building-circle-exclamation::before {
  content: "\\e4d3";
}

.fa-magnifying-glass-chart::before {
  content: "\\e522";
}

.fa-arrow-up-right-from-square::before {
  content: "\\f08e";
}

.fa-external-link::before {
  content: "\\f08e";
}

.fa-cubes-stacked::before {
  content: "\\e4e6";
}

.fa-won-sign::before {
  content: "\\f159";
}

.fa-krw::before {
  content: "\\f159";
}

.fa-won::before {
  content: "\\f159";
}

.fa-virus-covid::before {
  content: "\\e4a8";
}

.fa-austral-sign::before {
  content: "\\e0a9";
}

.fa-f::before {
  content: "F";
}

.fa-leaf::before {
  content: "\\f06c";
}

.fa-road::before {
  content: "\\f018";
}

.fa-taxi::before {
  content: "\\f1ba";
}

.fa-cab::before {
  content: "\\f1ba";
}

.fa-person-circle-plus::before {
  content: "\\e541";
}

.fa-chart-pie::before {
  content: "\\f200";
}

.fa-pie-chart::before {
  content: "\\f200";
}

.fa-bolt-lightning::before {
  content: "\\e0b7";
}

.fa-sack-xmark::before {
  content: "\\e56a";
}

.fa-file-excel::before {
  content: "\\f1c3";
}

.fa-file-contract::before {
  content: "\\f56c";
}

.fa-fish-fins::before {
  content: "\\e4f2";
}

.fa-building-flag::before {
  content: "\\e4d5";
}

.fa-face-grin-beam::before {
  content: "\\f582";
}

.fa-grin-beam::before {
  content: "\\f582";
}

.fa-object-ungroup::before {
  content: "\\f248";
}

.fa-poop::before {
  content: "\\f619";
}

.fa-location-pin::before {
  content: "\\f041";
}

.fa-map-marker::before {
  content: "\\f041";
}

.fa-kaaba::before {
  content: "\\f66b";
}

.fa-toilet-paper::before {
  content: "\\f71e";
}

.fa-helmet-safety::before {
  content: "\\f807";
}

.fa-hard-hat::before {
  content: "\\f807";
}

.fa-hat-hard::before {
  content: "\\f807";
}

.fa-eject::before {
  content: "\\f052";
}

.fa-circle-right::before {
  content: "\\f35a";
}

.fa-arrow-alt-circle-right::before {
  content: "\\f35a";
}

.fa-plane-circle-check::before {
  content: "\\e555";
}

.fa-face-rolling-eyes::before {
  content: "\\f5a5";
}

.fa-meh-rolling-eyes::before {
  content: "\\f5a5";
}

.fa-object-group::before {
  content: "\\f247";
}

.fa-chart-line::before {
  content: "\\f201";
}

.fa-line-chart::before {
  content: "\\f201";
}

.fa-mask-ventilator::before {
  content: "\\e524";
}

.fa-arrow-right::before {
  content: "\\f061";
}

.fa-signs-post::before {
  content: "\\f277";
}

.fa-map-signs::before {
  content: "\\f277";
}

.fa-cash-register::before {
  content: "\\f788";
}

.fa-person-circle-question::before {
  content: "\\e542";
}

.fa-h::before {
  content: "H";
}

.fa-tarp::before {
  content: "\\e57b";
}

.fa-screwdriver-wrench::before {
  content: "\\f7d9";
}

.fa-tools::before {
  content: "\\f7d9";
}

.fa-arrows-to-eye::before {
  content: "\\e4bf";
}

.fa-plug-circle-bolt::before {
  content: "\\e55b";
}

.fa-heart::before {
  content: "\\f004";
}

.fa-mars-and-venus::before {
  content: "\\f224";
}

.fa-house-user::before {
  content: "\\e1b0";
}

.fa-home-user::before {
  content: "\\e1b0";
}

.fa-dumpster-fire::before {
  content: "\\f794";
}

.fa-house-crack::before {
  content: "\\e3b1";
}

.fa-martini-glass-citrus::before {
  content: "\\f561";
}

.fa-cocktail::before {
  content: "\\f561";
}

.fa-face-surprise::before {
  content: "\\f5c2";
}

.fa-surprise::before {
  content: "\\f5c2";
}

.fa-bottle-water::before {
  content: "\\e4c5";
}

.fa-circle-pause::before {
  content: "\\f28b";
}

.fa-pause-circle::before {
  content: "\\f28b";
}

.fa-toilet-paper-slash::before {
  content: "\\e072";
}

.fa-apple-whole::before {
  content: "\\f5d1";
}

.fa-apple-alt::before {
  content: "\\f5d1";
}

.fa-kitchen-set::before {
  content: "\\e51a";
}

.fa-r::before {
  content: "R";
}

.fa-temperature-quarter::before {
  content: "\\f2ca";
}

.fa-temperature-1::before {
  content: "\\f2ca";
}

.fa-thermometer-1::before {
  content: "\\f2ca";
}

.fa-thermometer-quarter::before {
  content: "\\f2ca";
}

.fa-cube::before {
  content: "\\f1b2";
}

.fa-bitcoin-sign::before {
  content: "\\e0b4";
}

.fa-shield-dog::before {
  content: "\\e573";
}

.fa-solar-panel::before {
  content: "\\f5ba";
}

.fa-lock-open::before {
  content: "\\f3c1";
}

.fa-elevator::before {
  content: "\\e16d";
}

.fa-money-bill-transfer::before {
  content: "\\e528";
}

.fa-money-bill-trend-up::before {
  content: "\\e529";
}

.fa-house-flood-water-circle-arrow-right::before {
  content: "\\e50f";
}

.fa-square-poll-horizontal::before {
  content: "\\f682";
}

.fa-poll-h::before {
  content: "\\f682";
}

.fa-circle::before {
  content: "\\f111";
}

.fa-backward-fast::before {
  content: "\\f049";
}

.fa-fast-backward::before {
  content: "\\f049";
}

.fa-recycle::before {
  content: "\\f1b8";
}

.fa-user-astronaut::before {
  content: "\\f4fb";
}

.fa-plane-slash::before {
  content: "\\e069";
}

.fa-trademark::before {
  content: "\\f25c";
}

.fa-basketball::before {
  content: "\\f434";
}

.fa-basketball-ball::before {
  content: "\\f434";
}

.fa-satellite-dish::before {
  content: "\\f7c0";
}

.fa-circle-up::before {
  content: "\\f35b";
}

.fa-arrow-alt-circle-up::before {
  content: "\\f35b";
}

.fa-mobile-screen-button::before {
  content: "\\f3cd";
}

.fa-mobile-alt::before {
  content: "\\f3cd";
}

.fa-volume-high::before {
  content: "\\f028";
}

.fa-volume-up::before {
  content: "\\f028";
}

.fa-users-rays::before {
  content: "\\e593";
}

.fa-wallet::before {
  content: "\\f555";
}

.fa-clipboard-check::before {
  content: "\\f46c";
}

.fa-file-audio::before {
  content: "\\f1c7";
}

.fa-burger::before {
  content: "\\f805";
}

.fa-hamburger::before {
  content: "\\f805";
}

.fa-wrench::before {
  content: "\\f0ad";
}

.fa-bugs::before {
  content: "\\e4d0";
}

.fa-rupee-sign::before {
  content: "\\f156";
}

.fa-rupee::before {
  content: "\\f156";
}

.fa-file-image::before {
  content: "\\f1c5";
}

.fa-circle-question::before {
  content: "\\f059";
}

.fa-question-circle::before {
  content: "\\f059";
}

.fa-plane-departure::before {
  content: "\\f5b0";
}

.fa-handshake-slash::before {
  content: "\\e060";
}

.fa-book-bookmark::before {
  content: "\\e0bb";
}

.fa-code-branch::before {
  content: "\\f126";
}

.fa-hat-cowboy::before {
  content: "\\f8c0";
}

.fa-bridge::before {
  content: "\\e4c8";
}

.fa-phone-flip::before {
  content: "\\f879";
}

.fa-phone-alt::before {
  content: "\\f879";
}

.fa-truck-front::before {
  content: "\\e2b7";
}

.fa-cat::before {
  content: "\\f6be";
}

.fa-anchor-circle-exclamation::before {
  content: "\\e4ab";
}

.fa-truck-field::before {
  content: "\\e58d";
}

.fa-route::before {
  content: "\\f4d7";
}

.fa-clipboard-question::before {
  content: "\\e4e3";
}

.fa-panorama::before {
  content: "\\e209";
}

.fa-comment-medical::before {
  content: "\\f7f5";
}

.fa-teeth-open::before {
  content: "\\f62f";
}

.fa-file-circle-minus::before {
  content: "\\e4ed";
}

.fa-tags::before {
  content: "\\f02c";
}

.fa-wine-glass::before {
  content: "\\f4e3";
}

.fa-forward-fast::before {
  content: "\\f050";
}

.fa-fast-forward::before {
  content: "\\f050";
}

.fa-face-meh-blank::before {
  content: "\\f5a4";
}

.fa-meh-blank::before {
  content: "\\f5a4";
}

.fa-square-parking::before {
  content: "\\f540";
}

.fa-parking::before {
  content: "\\f540";
}

.fa-house-signal::before {
  content: "\\e012";
}

.fa-bars-progress::before {
  content: "\\f828";
}

.fa-tasks-alt::before {
  content: "\\f828";
}

.fa-faucet-drip::before {
  content: "\\e006";
}

.fa-cart-flatbed::before {
  content: "\\f474";
}

.fa-dolly-flatbed::before {
  content: "\\f474";
}

.fa-ban-smoking::before {
  content: "\\f54d";
}

.fa-smoking-ban::before {
  content: "\\f54d";
}

.fa-terminal::before {
  content: "\\f120";
}

.fa-mobile-button::before {
  content: "\\f10b";
}

.fa-house-medical-flag::before {
  content: "\\e514";
}

.fa-basket-shopping::before {
  content: "\\f291";
}

.fa-shopping-basket::before {
  content: "\\f291";
}

.fa-tape::before {
  content: "\\f4db";
}

.fa-bus-simple::before {
  content: "\\f55e";
}

.fa-bus-alt::before {
  content: "\\f55e";
}

.fa-eye::before {
  content: "\\f06e";
}

.fa-face-sad-cry::before {
  content: "\\f5b3";
}

.fa-sad-cry::before {
  content: "\\f5b3";
}

.fa-audio-description::before {
  content: "\\f29e";
}

.fa-person-military-to-person::before {
  content: "\\e54c";
}

.fa-file-shield::before {
  content: "\\e4f0";
}

.fa-user-slash::before {
  content: "\\f506";
}

.fa-pen::before {
  content: "\\f304";
}

.fa-tower-observation::before {
  content: "\\e586";
}

.fa-file-code::before {
  content: "\\f1c9";
}

.fa-signal::before {
  content: "\\f012";
}

.fa-signal-5::before {
  content: "\\f012";
}

.fa-signal-perfect::before {
  content: "\\f012";
}

.fa-bus::before {
  content: "\\f207";
}

.fa-heart-circle-xmark::before {
  content: "\\e501";
}

.fa-house-chimney::before {
  content: "\\e3af";
}

.fa-home-lg::before {
  content: "\\e3af";
}

.fa-window-maximize::before {
  content: "\\f2d0";
}

.fa-face-frown::before {
  content: "\\f119";
}

.fa-frown::before {
  content: "\\f119";
}

.fa-prescription::before {
  content: "\\f5b1";
}

.fa-shop::before {
  content: "\\f54f";
}

.fa-store-alt::before {
  content: "\\f54f";
}

.fa-floppy-disk::before {
  content: "\\f0c7";
}

.fa-save::before {
  content: "\\f0c7";
}

.fa-vihara::before {
  content: "\\f6a7";
}

.fa-scale-unbalanced::before {
  content: "\\f515";
}

.fa-balance-scale-left::before {
  content: "\\f515";
}

.fa-sort-up::before {
  content: "\\f0de";
}

.fa-sort-asc::before {
  content: "\\f0de";
}

.fa-comment-dots::before {
  content: "\\f4ad";
}

.fa-commenting::before {
  content: "\\f4ad";
}

.fa-plant-wilt::before {
  content: "\\e5aa";
}

.fa-diamond::before {
  content: "\\f219";
}

.fa-face-grin-squint::before {
  content: "\\f585";
}

.fa-grin-squint::before {
  content: "\\f585";
}

.fa-hand-holding-dollar::before {
  content: "\\f4c0";
}

.fa-hand-holding-usd::before {
  content: "\\f4c0";
}

.fa-bacterium::before {
  content: "\\e05a";
}

.fa-hand-pointer::before {
  content: "\\f25a";
}

.fa-drum-steelpan::before {
  content: "\\f56a";
}

.fa-hand-scissors::before {
  content: "\\f257";
}

.fa-hands-praying::before {
  content: "\\f684";
}

.fa-praying-hands::before {
  content: "\\f684";
}

.fa-arrow-rotate-right::before {
  content: "\\f01e";
}

.fa-arrow-right-rotate::before {
  content: "\\f01e";
}

.fa-arrow-rotate-forward::before {
  content: "\\f01e";
}

.fa-redo::before {
  content: "\\f01e";
}

.fa-biohazard::before {
  content: "\\f780";
}

.fa-location-crosshairs::before {
  content: "\\f601";
}

.fa-location::before {
  content: "\\f601";
}

.fa-mars-double::before {
  content: "\\f227";
}

.fa-child-dress::before {
  content: "\\e59c";
}

.fa-users-between-lines::before {
  content: "\\e591";
}

.fa-lungs-virus::before {
  content: "\\e067";
}

.fa-face-grin-tears::before {
  content: "\\f588";
}

.fa-grin-tears::before {
  content: "\\f588";
}

.fa-phone::before {
  content: "\\f095";
}

.fa-calendar-xmark::before {
  content: "\\f273";
}

.fa-calendar-times::before {
  content: "\\f273";
}

.fa-child-reaching::before {
  content: "\\e59d";
}

.fa-head-side-virus::before {
  content: "\\e064";
}

.fa-user-gear::before {
  content: "\\f4fe";
}

.fa-user-cog::before {
  content: "\\f4fe";
}

.fa-arrow-up-1-9::before {
  content: "\\f163";
}

.fa-sort-numeric-up::before {
  content: "\\f163";
}

.fa-door-closed::before {
  content: "\\f52a";
}

.fa-shield-virus::before {
  content: "\\e06c";
}

.fa-dice-six::before {
  content: "\\f526";
}

.fa-mosquito-net::before {
  content: "\\e52c";
}

.fa-bridge-water::before {
  content: "\\e4ce";
}

.fa-person-booth::before {
  content: "\\f756";
}

.fa-text-width::before {
  content: "\\f035";
}

.fa-hat-wizard::before {
  content: "\\f6e8";
}

.fa-pen-fancy::before {
  content: "\\f5ac";
}

.fa-person-digging::before {
  content: "\\f85e";
}

.fa-digging::before {
  content: "\\f85e";
}

.fa-trash::before {
  content: "\\f1f8";
}

.fa-gauge-simple::before {
  content: "\\f629";
}

.fa-gauge-simple-med::before {
  content: "\\f629";
}

.fa-tachometer-average::before {
  content: "\\f629";
}

.fa-book-medical::before {
  content: "\\f7e6";
}

.fa-poo::before {
  content: "\\f2fe";
}

.fa-quote-right::before {
  content: "\\f10e";
}

.fa-quote-right-alt::before {
  content: "\\f10e";
}

.fa-shirt::before {
  content: "\\f553";
}

.fa-t-shirt::before {
  content: "\\f553";
}

.fa-tshirt::before {
  content: "\\f553";
}

.fa-cubes::before {
  content: "\\f1b3";
}

.fa-divide::before {
  content: "\\f529";
}

.fa-tenge-sign::before {
  content: "\\f7d7";
}

.fa-tenge::before {
  content: "\\f7d7";
}

.fa-headphones::before {
  content: "\\f025";
}

.fa-hands-holding::before {
  content: "\\f4c2";
}

.fa-hands-clapping::before {
  content: "\\e1a8";
}

.fa-republican::before {
  content: "\\f75e";
}

.fa-arrow-left::before {
  content: "\\f060";
}

.fa-person-circle-xmark::before {
  content: "\\e543";
}

.fa-ruler::before {
  content: "\\f545";
}

.fa-align-left::before {
  content: "\\f036";
}

.fa-dice-d6::before {
  content: "\\f6d1";
}

.fa-restroom::before {
  content: "\\f7bd";
}

.fa-j::before {
  content: "J";
}

.fa-users-viewfinder::before {
  content: "\\e595";
}

.fa-file-video::before {
  content: "\\f1c8";
}

.fa-up-right-from-square::before {
  content: "\\f35d";
}

.fa-external-link-alt::before {
  content: "\\f35d";
}

.fa-table-cells::before {
  content: "\\f00a";
}

.fa-th::before {
  content: "\\f00a";
}

.fa-file-pdf::before {
  content: "\\f1c1";
}

.fa-book-bible::before {
  content: "\\f647";
}

.fa-bible::before {
  content: "\\f647";
}

.fa-o::before {
  content: "O";
}

.fa-suitcase-medical::before {
  content: "\\f0fa";
}

.fa-medkit::before {
  content: "\\f0fa";
}

.fa-user-secret::before {
  content: "\\f21b";
}

.fa-otter::before {
  content: "\\f700";
}

.fa-person-dress::before {
  content: "\\f182";
}

.fa-female::before {
  content: "\\f182";
}

.fa-comment-dollar::before {
  content: "\\f651";
}

.fa-business-time::before {
  content: "\\f64a";
}

.fa-briefcase-clock::before {
  content: "\\f64a";
}

.fa-table-cells-large::before {
  content: "\\f009";
}

.fa-th-large::before {
  content: "\\f009";
}

.fa-book-tanakh::before {
  content: "\\f827";
}

.fa-tanakh::before {
  content: "\\f827";
}

.fa-phone-volume::before {
  content: "\\f2a0";
}

.fa-volume-control-phone::before {
  content: "\\f2a0";
}

.fa-hat-cowboy-side::before {
  content: "\\f8c1";
}

.fa-clipboard-user::before {
  content: "\\f7f3";
}

.fa-child::before {
  content: "\\f1ae";
}

.fa-lira-sign::before {
  content: "\\f195";
}

.fa-satellite::before {
  content: "\\f7bf";
}

.fa-plane-lock::before {
  content: "\\e558";
}

.fa-tag::before {
  content: "\\f02b";
}

.fa-comment::before {
  content: "\\f075";
}

.fa-cake-candles::before {
  content: "\\f1fd";
}

.fa-birthday-cake::before {
  content: "\\f1fd";
}

.fa-cake::before {
  content: "\\f1fd";
}

.fa-envelope::before {
  content: "\\f0e0";
}

.fa-angles-up::before {
  content: "\\f102";
}

.fa-angle-double-up::before {
  content: "\\f102";
}

.fa-paperclip::before {
  content: "\\f0c6";
}

.fa-arrow-right-to-city::before {
  content: "\\e4b3";
}

.fa-ribbon::before {
  content: "\\f4d6";
}

.fa-lungs::before {
  content: "\\f604";
}

.fa-arrow-up-9-1::before {
  content: "\\f887";
}

.fa-sort-numeric-up-alt::before {
  content: "\\f887";
}

.fa-litecoin-sign::before {
  content: "\\e1d3";
}

.fa-border-none::before {
  content: "\\f850";
}

.fa-circle-nodes::before {
  content: "\\e4e2";
}

.fa-parachute-box::before {
  content: "\\f4cd";
}

.fa-indent::before {
  content: "\\f03c";
}

.fa-truck-field-un::before {
  content: "\\e58e";
}

.fa-hourglass::before {
  content: "\\f254";
}

.fa-hourglass-empty::before {
  content: "\\f254";
}

.fa-mountain::before {
  content: "\\f6fc";
}

.fa-user-doctor::before {
  content: "\\f0f0";
}

.fa-user-md::before {
  content: "\\f0f0";
}

.fa-circle-info::before {
  content: "\\f05a";
}

.fa-info-circle::before {
  content: "\\f05a";
}

.fa-cloud-meatball::before {
  content: "\\f73b";
}

.fa-camera::before {
  content: "\\f030";
}

.fa-camera-alt::before {
  content: "\\f030";
}

.fa-square-virus::before {
  content: "\\e578";
}

.fa-meteor::before {
  content: "\\f753";
}

.fa-car-on::before {
  content: "\\e4dd";
}

.fa-sleigh::before {
  content: "\\f7cc";
}

.fa-arrow-down-1-9::before {
  content: "\\f162";
}

.fa-sort-numeric-asc::before {
  content: "\\f162";
}

.fa-sort-numeric-down::before {
  content: "\\f162";
}

.fa-hand-holding-droplet::before {
  content: "\\f4c1";
}

.fa-hand-holding-water::before {
  content: "\\f4c1";
}

.fa-water::before {
  content: "\\f773";
}

.fa-calendar-check::before {
  content: "\\f274";
}

.fa-braille::before {
  content: "\\f2a1";
}

.fa-prescription-bottle-medical::before {
  content: "\\f486";
}

.fa-prescription-bottle-alt::before {
  content: "\\f486";
}

.fa-landmark::before {
  content: "\\f66f";
}

.fa-truck::before {
  content: "\\f0d1";
}

.fa-crosshairs::before {
  content: "\\f05b";
}

.fa-person-cane::before {
  content: "\\e53c";
}

.fa-tent::before {
  content: "\\e57d";
}

.fa-vest-patches::before {
  content: "\\e086";
}

.fa-check-double::before {
  content: "\\f560";
}

.fa-arrow-down-a-z::before {
  content: "\\f15d";
}

.fa-sort-alpha-asc::before {
  content: "\\f15d";
}

.fa-sort-alpha-down::before {
  content: "\\f15d";
}

.fa-money-bill-wheat::before {
  content: "\\e52a";
}

.fa-cookie::before {
  content: "\\f563";
}

.fa-arrow-rotate-left::before {
  content: "\\f0e2";
}

.fa-arrow-left-rotate::before {
  content: "\\f0e2";
}

.fa-arrow-rotate-back::before {
  content: "\\f0e2";
}

.fa-arrow-rotate-backward::before {
  content: "\\f0e2";
}

.fa-undo::before {
  content: "\\f0e2";
}

.fa-hard-drive::before {
  content: "\\f0a0";
}

.fa-hdd::before {
  content: "\\f0a0";
}

.fa-face-grin-squint-tears::before {
  content: "\\f586";
}

.fa-grin-squint-tears::before {
  content: "\\f586";
}

.fa-dumbbell::before {
  content: "\\f44b";
}

.fa-rectangle-list::before {
  content: "\\f022";
}

.fa-list-alt::before {
  content: "\\f022";
}

.fa-tarp-droplet::before {
  content: "\\e57c";
}

.fa-house-medical-circle-check::before {
  content: "\\e511";
}

.fa-person-skiing-nordic::before {
  content: "\\f7ca";
}

.fa-skiing-nordic::before {
  content: "\\f7ca";
}

.fa-calendar-plus::before {
  content: "\\f271";
}

.fa-plane-arrival::before {
  content: "\\f5af";
}

.fa-circle-left::before {
  content: "\\f359";
}

.fa-arrow-alt-circle-left::before {
  content: "\\f359";
}

.fa-train-subway::before {
  content: "\\f239";
}

.fa-subway::before {
  content: "\\f239";
}

.fa-chart-gantt::before {
  content: "\\e0e4";
}

.fa-indian-rupee-sign::before {
  content: "\\e1bc";
}

.fa-indian-rupee::before {
  content: "\\e1bc";
}

.fa-inr::before {
  content: "\\e1bc";
}

.fa-crop-simple::before {
  content: "\\f565";
}

.fa-crop-alt::before {
  content: "\\f565";
}

.fa-money-bill-1::before {
  content: "\\f3d1";
}

.fa-money-bill-alt::before {
  content: "\\f3d1";
}

.fa-left-long::before {
  content: "\\f30a";
}

.fa-long-arrow-alt-left::before {
  content: "\\f30a";
}

.fa-dna::before {
  content: "\\f471";
}

.fa-virus-slash::before {
  content: "\\e075";
}

.fa-minus::before {
  content: "\\f068";
}

.fa-subtract::before {
  content: "\\f068";
}

.fa-chess::before {
  content: "\\f439";
}

.fa-arrow-left-long::before {
  content: "\\f177";
}

.fa-long-arrow-left::before {
  content: "\\f177";
}

.fa-plug-circle-check::before {
  content: "\\e55c";
}

.fa-street-view::before {
  content: "\\f21d";
}

.fa-franc-sign::before {
  content: "\\e18f";
}

.fa-volume-off::before {
  content: "\\f026";
}

.fa-hands-asl-interpreting::before {
  content: "\\f2a3";
}

.fa-american-sign-language-interpreting::before {
  content: "\\f2a3";
}

.fa-asl-interpreting::before {
  content: "\\f2a3";
}

.fa-hands-american-sign-language-interpreting::before {
  content: "\\f2a3";
}

.fa-gear::before {
  content: "\\f013";
}

.fa-cog::before {
  content: "\\f013";
}

.fa-droplet-slash::before {
  content: "\\f5c7";
}

.fa-tint-slash::before {
  content: "\\f5c7";
}

.fa-mosque::before {
  content: "\\f678";
}

.fa-mosquito::before {
  content: "\\e52b";
}

.fa-star-of-david::before {
  content: "\\f69a";
}

.fa-person-military-rifle::before {
  content: "\\e54b";
}

.fa-cart-shopping::before {
  content: "\\f07a";
}

.fa-shopping-cart::before {
  content: "\\f07a";
}

.fa-vials::before {
  content: "\\f493";
}

.fa-plug-circle-plus::before {
  content: "\\e55f";
}

.fa-place-of-worship::before {
  content: "\\f67f";
}

.fa-grip-vertical::before {
  content: "\\f58e";
}

.fa-arrow-turn-up::before {
  content: "\\f148";
}

.fa-level-up::before {
  content: "\\f148";
}

.fa-u::before {
  content: "U";
}

.fa-square-root-variable::before {
  content: "\\f698";
}

.fa-square-root-alt::before {
  content: "\\f698";
}

.fa-clock::before {
  content: "\\f017";
}

.fa-clock-four::before {
  content: "\\f017";
}

.fa-backward-step::before {
  content: "\\f048";
}

.fa-step-backward::before {
  content: "\\f048";
}

.fa-pallet::before {
  content: "\\f482";
}

.fa-faucet::before {
  content: "\\e005";
}

.fa-baseball-bat-ball::before {
  content: "\\f432";
}

.fa-s::before {
  content: "S";
}

.fa-timeline::before {
  content: "\\e29c";
}

.fa-keyboard::before {
  content: "\\f11c";
}

.fa-caret-down::before {
  content: "\\f0d7";
}

.fa-house-chimney-medical::before {
  content: "\\f7f2";
}

.fa-clinic-medical::before {
  content: "\\f7f2";
}

.fa-temperature-three-quarters::before {
  content: "\\f2c8";
}

.fa-temperature-3::before {
  content: "\\f2c8";
}

.fa-thermometer-3::before {
  content: "\\f2c8";
}

.fa-thermometer-three-quarters::before {
  content: "\\f2c8";
}

.fa-mobile-screen::before {
  content: "\\f3cf";
}

.fa-mobile-android-alt::before {
  content: "\\f3cf";
}

.fa-plane-up::before {
  content: "\\e22d";
}

.fa-piggy-bank::before {
  content: "\\f4d3";
}

.fa-battery-half::before {
  content: "\\f242";
}

.fa-battery-3::before {
  content: "\\f242";
}

.fa-mountain-city::before {
  content: "\\e52e";
}

.fa-coins::before {
  content: "\\f51e";
}

.fa-khanda::before {
  content: "\\f66d";
}

.fa-sliders::before {
  content: "\\f1de";
}

.fa-sliders-h::before {
  content: "\\f1de";
}

.fa-folder-tree::before {
  content: "\\f802";
}

.fa-network-wired::before {
  content: "\\f6ff";
}

.fa-map-pin::before {
  content: "\\f276";
}

.fa-hamsa::before {
  content: "\\f665";
}

.fa-cent-sign::before {
  content: "\\e3f5";
}

.fa-flask::before {
  content: "\\f0c3";
}

.fa-person-pregnant::before {
  content: "\\e31e";
}

.fa-wand-sparkles::before {
  content: "\\f72b";
}

.fa-ellipsis-vertical::before {
  content: "\\f142";
}

.fa-ellipsis-v::before {
  content: "\\f142";
}

.fa-ticket::before {
  content: "\\f145";
}

.fa-power-off::before {
  content: "\\f011";
}

.fa-right-long::before {
  content: "\\f30b";
}

.fa-long-arrow-alt-right::before {
  content: "\\f30b";
}

.fa-flag-usa::before {
  content: "\\f74d";
}

.fa-laptop-file::before {
  content: "\\e51d";
}

.fa-tty::before {
  content: "\\f1e4";
}

.fa-teletype::before {
  content: "\\f1e4";
}

.fa-diagram-next::before {
  content: "\\e476";
}

.fa-person-rifle::before {
  content: "\\e54e";
}

.fa-house-medical-circle-exclamation::before {
  content: "\\e512";
}

.fa-closed-captioning::before {
  content: "\\f20a";
}

.fa-person-hiking::before {
  content: "\\f6ec";
}

.fa-hiking::before {
  content: "\\f6ec";
}

.fa-venus-double::before {
  content: "\\f226";
}

.fa-images::before {
  content: "\\f302";
}

.fa-calculator::before {
  content: "\\f1ec";
}

.fa-people-pulling::before {
  content: "\\e535";
}

.fa-n::before {
  content: "N";
}

.fa-cable-car::before {
  content: "\\f7da";
}

.fa-tram::before {
  content: "\\f7da";
}

.fa-cloud-rain::before {
  content: "\\f73d";
}

.fa-building-circle-xmark::before {
  content: "\\e4d4";
}

.fa-ship::before {
  content: "\\f21a";
}

.fa-arrows-down-to-line::before {
  content: "\\e4b8";
}

.fa-download::before {
  content: "\\f019";
}

.fa-face-grin::before {
  content: "\\f580";
}

.fa-grin::before {
  content: "\\f580";
}

.fa-delete-left::before {
  content: "\\f55a";
}

.fa-backspace::before {
  content: "\\f55a";
}

.fa-eye-dropper::before {
  content: "\\f1fb";
}

.fa-eye-dropper-empty::before {
  content: "\\f1fb";
}

.fa-eyedropper::before {
  content: "\\f1fb";
}

.fa-file-circle-check::before {
  content: "\\e5a0";
}

.fa-forward::before {
  content: "\\f04e";
}

.fa-mobile::before {
  content: "\\f3ce";
}

.fa-mobile-android::before {
  content: "\\f3ce";
}

.fa-mobile-phone::before {
  content: "\\f3ce";
}

.fa-face-meh::before {
  content: "\\f11a";
}

.fa-meh::before {
  content: "\\f11a";
}

.fa-align-center::before {
  content: "\\f037";
}

.fa-book-skull::before {
  content: "\\f6b7";
}

.fa-book-dead::before {
  content: "\\f6b7";
}

.fa-id-card::before {
  content: "\\f2c2";
}

.fa-drivers-license::before {
  content: "\\f2c2";
}

.fa-outdent::before {
  content: "\\f03b";
}

.fa-dedent::before {
  content: "\\f03b";
}

.fa-heart-circle-exclamation::before {
  content: "\\e4fe";
}

.fa-house::before {
  content: "\\f015";
}

.fa-home::before {
  content: "\\f015";
}

.fa-home-alt::before {
  content: "\\f015";
}

.fa-home-lg-alt::before {
  content: "\\f015";
}

.fa-calendar-week::before {
  content: "\\f784";
}

.fa-laptop-medical::before {
  content: "\\f812";
}

.fa-b::before {
  content: "B";
}

.fa-file-medical::before {
  content: "\\f477";
}

.fa-dice-one::before {
  content: "\\f525";
}

.fa-kiwi-bird::before {
  content: "\\f535";
}

.fa-arrow-right-arrow-left::before {
  content: "\\f0ec";
}

.fa-exchange::before {
  content: "\\f0ec";
}

.fa-rotate-right::before {
  content: "\\f2f9";
}

.fa-redo-alt::before {
  content: "\\f2f9";
}

.fa-rotate-forward::before {
  content: "\\f2f9";
}

.fa-utensils::before {
  content: "\\f2e7";
}

.fa-cutlery::before {
  content: "\\f2e7";
}

.fa-arrow-up-wide-short::before {
  content: "\\f161";
}

.fa-sort-amount-up::before {
  content: "\\f161";
}

.fa-mill-sign::before {
  content: "\\e1ed";
}

.fa-bowl-rice::before {
  content: "\\e2eb";
}

.fa-skull::before {
  content: "\\f54c";
}

.fa-tower-broadcast::before {
  content: "\\f519";
}

.fa-broadcast-tower::before {
  content: "\\f519";
}

.fa-truck-pickup::before {
  content: "\\f63c";
}

.fa-up-long::before {
  content: "\\f30c";
}

.fa-long-arrow-alt-up::before {
  content: "\\f30c";
}

.fa-stop::before {
  content: "\\f04d";
}

.fa-code-merge::before {
  content: "\\f387";
}

.fa-upload::before {
  content: "\\f093";
}

.fa-hurricane::before {
  content: "\\f751";
}

.fa-mound::before {
  content: "\\e52d";
}

.fa-toilet-portable::before {
  content: "\\e583";
}

.fa-compact-disc::before {
  content: "\\f51f";
}

.fa-file-arrow-down::before {
  content: "\\f56d";
}

.fa-file-download::before {
  content: "\\f56d";
}

.fa-caravan::before {
  content: "\\f8ff";
}

.fa-shield-cat::before {
  content: "\\e572";
}

.fa-bolt::before {
  content: "\\f0e7";
}

.fa-zap::before {
  content: "\\f0e7";
}

.fa-glass-water::before {
  content: "\\e4f4";
}

.fa-oil-well::before {
  content: "\\e532";
}

.fa-vault::before {
  content: "\\e2c5";
}

.fa-mars::before {
  content: "\\f222";
}

.fa-toilet::before {
  content: "\\f7d8";
}

.fa-plane-circle-xmark::before {
  content: "\\e557";
}

.fa-yen-sign::before {
  content: "\\f157";
}

.fa-cny::before {
  content: "\\f157";
}

.fa-jpy::before {
  content: "\\f157";
}

.fa-rmb::before {
  content: "\\f157";
}

.fa-yen::before {
  content: "\\f157";
}

.fa-ruble-sign::before {
  content: "\\f158";
}

.fa-rouble::before {
  content: "\\f158";
}

.fa-rub::before {
  content: "\\f158";
}

.fa-ruble::before {
  content: "\\f158";
}

.fa-sun::before {
  content: "\\f185";
}

.fa-guitar::before {
  content: "\\f7a6";
}

.fa-face-laugh-wink::before {
  content: "\\f59c";
}

.fa-laugh-wink::before {
  content: "\\f59c";
}

.fa-horse-head::before {
  content: "\\f7ab";
}

.fa-bore-hole::before {
  content: "\\e4c3";
}

.fa-industry::before {
  content: "\\f275";
}

.fa-circle-down::before {
  content: "\\f358";
}

.fa-arrow-alt-circle-down::before {
  content: "\\f358";
}

.fa-arrows-turn-to-dots::before {
  content: "\\e4c1";
}

.fa-florin-sign::before {
  content: "\\e184";
}

.fa-arrow-down-short-wide::before {
  content: "\\f884";
}

.fa-sort-amount-desc::before {
  content: "\\f884";
}

.fa-sort-amount-down-alt::before {
  content: "\\f884";
}

.fa-less-than::before {
  content: "\\<";
}

.fa-angle-down::before {
  content: "\\f107";
}

.fa-car-tunnel::before {
  content: "\\e4de";
}

.fa-head-side-cough::before {
  content: "\\e061";
}

.fa-grip-lines::before {
  content: "\\f7a4";
}

.fa-thumbs-down::before {
  content: "\\f165";
}

.fa-user-lock::before {
  content: "\\f502";
}

.fa-arrow-right-long::before {
  content: "\\f178";
}

.fa-long-arrow-right::before {
  content: "\\f178";
}

.fa-anchor-circle-xmark::before {
  content: "\\e4ac";
}

.fa-ellipsis::before {
  content: "\\f141";
}

.fa-ellipsis-h::before {
  content: "\\f141";
}

.fa-chess-pawn::before {
  content: "\\f443";
}

.fa-kit-medical::before {
  content: "\\f479";
}

.fa-first-aid::before {
  content: "\\f479";
}

.fa-person-through-window::before {
  content: "\\e5a9";
}

.fa-toolbox::before {
  content: "\\f552";
}

.fa-hands-holding-circle::before {
  content: "\\e4fb";
}

.fa-bug::before {
  content: "\\f188";
}

.fa-credit-card::before {
  content: "\\f09d";
}

.fa-credit-card-alt::before {
  content: "\\f09d";
}

.fa-car::before {
  content: "\\f1b9";
}

.fa-automobile::before {
  content: "\\f1b9";
}

.fa-hand-holding-hand::before {
  content: "\\e4f7";
}

.fa-book-open-reader::before {
  content: "\\f5da";
}

.fa-book-reader::before {
  content: "\\f5da";
}

.fa-mountain-sun::before {
  content: "\\e52f";
}

.fa-arrows-left-right-to-line::before {
  content: "\\e4ba";
}

.fa-dice-d20::before {
  content: "\\f6cf";
}

.fa-truck-droplet::before {
  content: "\\e58c";
}

.fa-file-circle-xmark::before {
  content: "\\e5a1";
}

.fa-temperature-arrow-up::before {
  content: "\\e040";
}

.fa-temperature-up::before {
  content: "\\e040";
}

.fa-medal::before {
  content: "\\f5a2";
}

.fa-bed::before {
  content: "\\f236";
}

.fa-square-h::before {
  content: "\\f0fd";
}

.fa-h-square::before {
  content: "\\f0fd";
}

.fa-podcast::before {
  content: "\\f2ce";
}

.fa-temperature-full::before {
  content: "\\f2c7";
}

.fa-temperature-4::before {
  content: "\\f2c7";
}

.fa-thermometer-4::before {
  content: "\\f2c7";
}

.fa-thermometer-full::before {
  content: "\\f2c7";
}

.fa-bell::before {
  content: "\\f0f3";
}

.fa-superscript::before {
  content: "\\f12b";
}

.fa-plug-circle-xmark::before {
  content: "\\e560";
}

.fa-star-of-life::before {
  content: "\\f621";
}

.fa-phone-slash::before {
  content: "\\f3dd";
}

.fa-paint-roller::before {
  content: "\\f5aa";
}

.fa-handshake-angle::before {
  content: "\\f4c4";
}

.fa-hands-helping::before {
  content: "\\f4c4";
}

.fa-location-dot::before {
  content: "\\f3c5";
}

.fa-map-marker-alt::before {
  content: "\\f3c5";
}

.fa-file::before {
  content: "\\f15b";
}

.fa-greater-than::before {
  content: "\\>";
}

.fa-person-swimming::before {
  content: "\\f5c4";
}

.fa-swimmer::before {
  content: "\\f5c4";
}

.fa-arrow-down::before {
  content: "\\f063";
}

.fa-droplet::before {
  content: "\\f043";
}

.fa-tint::before {
  content: "\\f043";
}

.fa-eraser::before {
  content: "\\f12d";
}

.fa-earth-americas::before {
  content: "\\f57d";
}

.fa-earth::before {
  content: "\\f57d";
}

.fa-earth-america::before {
  content: "\\f57d";
}

.fa-globe-americas::before {
  content: "\\f57d";
}

.fa-person-burst::before {
  content: "\\e53b";
}

.fa-dove::before {
  content: "\\f4ba";
}

.fa-battery-empty::before {
  content: "\\f244";
}

.fa-battery-0::before {
  content: "\\f244";
}

.fa-socks::before {
  content: "\\f696";
}

.fa-inbox::before {
  content: "\\f01c";
}

.fa-section::before {
  content: "\\e447";
}

.fa-gauge-high::before {
  content: "\\f625";
}

.fa-tachometer-alt::before {
  content: "\\f625";
}

.fa-tachometer-alt-fast::before {
  content: "\\f625";
}

.fa-envelope-open-text::before {
  content: "\\f658";
}

.fa-hospital::before {
  content: "\\f0f8";
}

.fa-hospital-alt::before {
  content: "\\f0f8";
}

.fa-hospital-wide::before {
  content: "\\f0f8";
}

.fa-wine-bottle::before {
  content: "\\f72f";
}

.fa-chess-rook::before {
  content: "\\f447";
}

.fa-bars-staggered::before {
  content: "\\f550";
}

.fa-reorder::before {
  content: "\\f550";
}

.fa-stream::before {
  content: "\\f550";
}

.fa-dharmachakra::before {
  content: "\\f655";
}

.fa-hotdog::before {
  content: "\\f80f";
}

.fa-person-walking-with-cane::before {
  content: "\\f29d";
}

.fa-blind::before {
  content: "\\f29d";
}

.fa-drum::before {
  content: "\\f569";
}

.fa-ice-cream::before {
  content: "\\f810";
}

.fa-heart-circle-bolt::before {
  content: "\\e4fc";
}

.fa-fax::before {
  content: "\\f1ac";
}

.fa-paragraph::before {
  content: "\\f1dd";
}

.fa-check-to-slot::before {
  content: "\\f772";
}

.fa-vote-yea::before {
  content: "\\f772";
}

.fa-star-half::before {
  content: "\\f089";
}

.fa-boxes-stacked::before {
  content: "\\f468";
}

.fa-boxes::before {
  content: "\\f468";
}

.fa-boxes-alt::before {
  content: "\\f468";
}

.fa-link::before {
  content: "\\f0c1";
}

.fa-chain::before {
  content: "\\f0c1";
}

.fa-ear-listen::before {
  content: "\\f2a2";
}

.fa-assistive-listening-systems::before {
  content: "\\f2a2";
}

.fa-tree-city::before {
  content: "\\e587";
}

.fa-play::before {
  content: "\\f04b";
}

.fa-font::before {
  content: "\\f031";
}

.fa-table-cells-row-lock::before {
  content: "\\e67a";
}

.fa-rupiah-sign::before {
  content: "\\e23d";
}

.fa-magnifying-glass::before {
  content: "\\f002";
}

.fa-search::before {
  content: "\\f002";
}

.fa-table-tennis-paddle-ball::before {
  content: "\\f45d";
}

.fa-ping-pong-paddle-ball::before {
  content: "\\f45d";
}

.fa-table-tennis::before {
  content: "\\f45d";
}

.fa-person-dots-from-line::before {
  content: "\\f470";
}

.fa-diagnoses::before {
  content: "\\f470";
}

.fa-trash-can-arrow-up::before {
  content: "\\f82a";
}

.fa-trash-restore-alt::before {
  content: "\\f82a";
}

.fa-naira-sign::before {
  content: "\\e1f6";
}

.fa-cart-arrow-down::before {
  content: "\\f218";
}

.fa-walkie-talkie::before {
  content: "\\f8ef";
}

.fa-file-pen::before {
  content: "\\f31c";
}

.fa-file-edit::before {
  content: "\\f31c";
}

.fa-receipt::before {
  content: "\\f543";
}

.fa-square-pen::before {
  content: "\\f14b";
}

.fa-pen-square::before {
  content: "\\f14b";
}

.fa-pencil-square::before {
  content: "\\f14b";
}

.fa-suitcase-rolling::before {
  content: "\\f5c1";
}

.fa-person-circle-exclamation::before {
  content: "\\e53f";
}

.fa-chevron-down::before {
  content: "\\f078";
}

.fa-battery-full::before {
  content: "\\f240";
}

.fa-battery::before {
  content: "\\f240";
}

.fa-battery-5::before {
  content: "\\f240";
}

.fa-skull-crossbones::before {
  content: "\\f714";
}

.fa-code-compare::before {
  content: "\\e13a";
}

.fa-list-ul::before {
  content: "\\f0ca";
}

.fa-list-dots::before {
  content: "\\f0ca";
}

.fa-school-lock::before {
  content: "\\e56f";
}

.fa-tower-cell::before {
  content: "\\e585";
}

.fa-down-long::before {
  content: "\\f309";
}

.fa-long-arrow-alt-down::before {
  content: "\\f309";
}

.fa-ranking-star::before {
  content: "\\e561";
}

.fa-chess-king::before {
  content: "\\f43f";
}

.fa-person-harassing::before {
  content: "\\e549";
}

.fa-brazilian-real-sign::before {
  content: "\\e46c";
}

.fa-landmark-dome::before {
  content: "\\f752";
}

.fa-landmark-alt::before {
  content: "\\f752";
}

.fa-arrow-up::before {
  content: "\\f062";
}

.fa-tv::before {
  content: "\\f26c";
}

.fa-television::before {
  content: "\\f26c";
}

.fa-tv-alt::before {
  content: "\\f26c";
}

.fa-shrimp::before {
  content: "\\e448";
}

.fa-list-check::before {
  content: "\\f0ae";
}

.fa-tasks::before {
  content: "\\f0ae";
}

.fa-jug-detergent::before {
  content: "\\e519";
}

.fa-circle-user::before {
  content: "\\f2bd";
}

.fa-user-circle::before {
  content: "\\f2bd";
}

.fa-user-shield::before {
  content: "\\f505";
}

.fa-wind::before {
  content: "\\f72e";
}

.fa-car-burst::before {
  content: "\\f5e1";
}

.fa-car-crash::before {
  content: "\\f5e1";
}

.fa-y::before {
  content: "Y";
}

.fa-person-snowboarding::before {
  content: "\\f7ce";
}

.fa-snowboarding::before {
  content: "\\f7ce";
}

.fa-truck-fast::before {
  content: "\\f48b";
}

.fa-shipping-fast::before {
  content: "\\f48b";
}

.fa-fish::before {
  content: "\\f578";
}

.fa-user-graduate::before {
  content: "\\f501";
}

.fa-circle-half-stroke::before {
  content: "\\f042";
}

.fa-adjust::before {
  content: "\\f042";
}

.fa-clapperboard::before {
  content: "\\e131";
}

.fa-circle-radiation::before {
  content: "\\f7ba";
}

.fa-radiation-alt::before {
  content: "\\f7ba";
}

.fa-baseball::before {
  content: "\\f433";
}

.fa-baseball-ball::before {
  content: "\\f433";
}

.fa-jet-fighter-up::before {
  content: "\\e518";
}

.fa-diagram-project::before {
  content: "\\f542";
}

.fa-project-diagram::before {
  content: "\\f542";
}

.fa-copy::before {
  content: "\\f0c5";
}

.fa-volume-xmark::before {
  content: "\\f6a9";
}

.fa-volume-mute::before {
  content: "\\f6a9";
}

.fa-volume-times::before {
  content: "\\f6a9";
}

.fa-hand-sparkles::before {
  content: "\\e05d";
}

.fa-grip::before {
  content: "\\f58d";
}

.fa-grip-horizontal::before {
  content: "\\f58d";
}

.fa-share-from-square::before {
  content: "\\f14d";
}

.fa-share-square::before {
  content: "\\f14d";
}

.fa-child-combatant::before {
  content: "\\e4e0";
}

.fa-child-rifle::before {
  content: "\\e4e0";
}

.fa-gun::before {
  content: "\\e19b";
}

.fa-square-phone::before {
  content: "\\f098";
}

.fa-phone-square::before {
  content: "\\f098";
}

.fa-plus::before {
  content: "\\+";
}

.fa-add::before {
  content: "\\+";
}

.fa-expand::before {
  content: "\\f065";
}

.fa-computer::before {
  content: "\\e4e5";
}

.fa-xmark::before {
  content: "\\f00d";
}

.fa-close::before {
  content: "\\f00d";
}

.fa-multiply::before {
  content: "\\f00d";
}

.fa-remove::before {
  content: "\\f00d";
}

.fa-times::before {
  content: "\\f00d";
}

.fa-arrows-up-down-left-right::before {
  content: "\\f047";
}

.fa-arrows::before {
  content: "\\f047";
}

.fa-chalkboard-user::before {
  content: "\\f51c";
}

.fa-chalkboard-teacher::before {
  content: "\\f51c";
}

.fa-peso-sign::before {
  content: "\\e222";
}

.fa-building-shield::before {
  content: "\\e4d8";
}

.fa-baby::before {
  content: "\\f77c";
}

.fa-users-line::before {
  content: "\\e592";
}

.fa-quote-left::before {
  content: "\\f10d";
}

.fa-quote-left-alt::before {
  content: "\\f10d";
}

.fa-tractor::before {
  content: "\\f722";
}

.fa-trash-arrow-up::before {
  content: "\\f829";
}

.fa-trash-restore::before {
  content: "\\f829";
}

.fa-arrow-down-up-lock::before {
  content: "\\e4b0";
}

.fa-lines-leaning::before {
  content: "\\e51e";
}

.fa-ruler-combined::before {
  content: "\\f546";
}

.fa-copyright::before {
  content: "\\f1f9";
}

.fa-equals::before {
  content: "\\=";
}

.fa-blender::before {
  content: "\\f517";
}

.fa-teeth::before {
  content: "\\f62e";
}

.fa-shekel-sign::before {
  content: "\\f20b";
}

.fa-ils::before {
  content: "\\f20b";
}

.fa-shekel::before {
  content: "\\f20b";
}

.fa-sheqel::before {
  content: "\\f20b";
}

.fa-sheqel-sign::before {
  content: "\\f20b";
}

.fa-map::before {
  content: "\\f279";
}

.fa-rocket::before {
  content: "\\f135";
}

.fa-photo-film::before {
  content: "\\f87c";
}

.fa-photo-video::before {
  content: "\\f87c";
}

.fa-folder-minus::before {
  content: "\\f65d";
}

.fa-store::before {
  content: "\\f54e";
}

.fa-arrow-trend-up::before {
  content: "\\e098";
}

.fa-plug-circle-minus::before {
  content: "\\e55e";
}

.fa-sign-hanging::before {
  content: "\\f4d9";
}

.fa-sign::before {
  content: "\\f4d9";
}

.fa-bezier-curve::before {
  content: "\\f55b";
}

.fa-bell-slash::before {
  content: "\\f1f6";
}

.fa-tablet::before {
  content: "\\f3fb";
}

.fa-tablet-android::before {
  content: "\\f3fb";
}

.fa-school-flag::before {
  content: "\\e56e";
}

.fa-fill::before {
  content: "\\f575";
}

.fa-angle-up::before {
  content: "\\f106";
}

.fa-drumstick-bite::before {
  content: "\\f6d7";
}

.fa-holly-berry::before {
  content: "\\f7aa";
}

.fa-chevron-left::before {
  content: "\\f053";
}

.fa-bacteria::before {
  content: "\\e059";
}

.fa-hand-lizard::before {
  content: "\\f258";
}

.fa-notdef::before {
  content: "\\e1fe";
}

.fa-disease::before {
  content: "\\f7fa";
}

.fa-briefcase-medical::before {
  content: "\\f469";
}

.fa-genderless::before {
  content: "\\f22d";
}

.fa-chevron-right::before {
  content: "\\f054";
}

.fa-retweet::before {
  content: "\\f079";
}

.fa-car-rear::before {
  content: "\\f5de";
}

.fa-car-alt::before {
  content: "\\f5de";
}

.fa-pump-soap::before {
  content: "\\e06b";
}

.fa-video-slash::before {
  content: "\\f4e2";
}

.fa-battery-quarter::before {
  content: "\\f243";
}

.fa-battery-2::before {
  content: "\\f243";
}

.fa-radio::before {
  content: "\\f8d7";
}

.fa-baby-carriage::before {
  content: "\\f77d";
}

.fa-carriage-baby::before {
  content: "\\f77d";
}

.fa-traffic-light::before {
  content: "\\f637";
}

.fa-thermometer::before {
  content: "\\f491";
}

.fa-vr-cardboard::before {
  content: "\\f729";
}

.fa-hand-middle-finger::before {
  content: "\\f806";
}

.fa-percent::before {
  content: "\\%";
}

.fa-percentage::before {
  content: "\\%";
}

.fa-truck-moving::before {
  content: "\\f4df";
}

.fa-glass-water-droplet::before {
  content: "\\e4f5";
}

.fa-display::before {
  content: "\\e163";
}

.fa-face-smile::before {
  content: "\\f118";
}

.fa-smile::before {
  content: "\\f118";
}

.fa-thumbtack::before {
  content: "\\f08d";
}

.fa-thumb-tack::before {
  content: "\\f08d";
}

.fa-trophy::before {
  content: "\\f091";
}

.fa-person-praying::before {
  content: "\\f683";
}

.fa-pray::before {
  content: "\\f683";
}

.fa-hammer::before {
  content: "\\f6e3";
}

.fa-hand-peace::before {
  content: "\\f25b";
}

.fa-rotate::before {
  content: "\\f2f1";
}

.fa-sync-alt::before {
  content: "\\f2f1";
}

.fa-spinner::before {
  content: "\\f110";
}

.fa-robot::before {
  content: "\\f544";
}

.fa-peace::before {
  content: "\\f67c";
}

.fa-gears::before {
  content: "\\f085";
}

.fa-cogs::before {
  content: "\\f085";
}

.fa-warehouse::before {
  content: "\\f494";
}

.fa-arrow-up-right-dots::before {
  content: "\\e4b7";
}

.fa-splotch::before {
  content: "\\f5bc";
}

.fa-face-grin-hearts::before {
  content: "\\f584";
}

.fa-grin-hearts::before {
  content: "\\f584";
}

.fa-dice-four::before {
  content: "\\f524";
}

.fa-sim-card::before {
  content: "\\f7c4";
}

.fa-transgender::before {
  content: "\\f225";
}

.fa-transgender-alt::before {
  content: "\\f225";
}

.fa-mercury::before {
  content: "\\f223";
}

.fa-arrow-turn-down::before {
  content: "\\f149";
}

.fa-level-down::before {
  content: "\\f149";
}

.fa-person-falling-burst::before {
  content: "\\e547";
}

.fa-award::before {
  content: "\\f559";
}

.fa-ticket-simple::before {
  content: "\\f3ff";
}

.fa-ticket-alt::before {
  content: "\\f3ff";
}

.fa-building::before {
  content: "\\f1ad";
}

.fa-angles-left::before {
  content: "\\f100";
}

.fa-angle-double-left::before {
  content: "\\f100";
}

.fa-qrcode::before {
  content: "\\f029";
}

.fa-clock-rotate-left::before {
  content: "\\f1da";
}

.fa-history::before {
  content: "\\f1da";
}

.fa-face-grin-beam-sweat::before {
  content: "\\f583";
}

.fa-grin-beam-sweat::before {
  content: "\\f583";
}

.fa-file-export::before {
  content: "\\f56e";
}

.fa-arrow-right-from-file::before {
  content: "\\f56e";
}

.fa-shield::before {
  content: "\\f132";
}

.fa-shield-blank::before {
  content: "\\f132";
}

.fa-arrow-up-short-wide::before {
  content: "\\f885";
}

.fa-sort-amount-up-alt::before {
  content: "\\f885";
}

.fa-house-medical::before {
  content: "\\e3b2";
}

.fa-golf-ball-tee::before {
  content: "\\f450";
}

.fa-golf-ball::before {
  content: "\\f450";
}

.fa-circle-chevron-left::before {
  content: "\\f137";
}

.fa-chevron-circle-left::before {
  content: "\\f137";
}

.fa-house-chimney-window::before {
  content: "\\e00d";
}

.fa-pen-nib::before {
  content: "\\f5ad";
}

.fa-tent-arrow-turn-left::before {
  content: "\\e580";
}

.fa-tents::before {
  content: "\\e582";
}

.fa-wand-magic::before {
  content: "\\f0d0";
}

.fa-magic::before {
  content: "\\f0d0";
}

.fa-dog::before {
  content: "\\f6d3";
}

.fa-carrot::before {
  content: "\\f787";
}

.fa-moon::before {
  content: "\\f186";
}

.fa-wine-glass-empty::before {
  content: "\\f5ce";
}

.fa-wine-glass-alt::before {
  content: "\\f5ce";
}

.fa-cheese::before {
  content: "\\f7ef";
}

.fa-yin-yang::before {
  content: "\\f6ad";
}

.fa-music::before {
  content: "\\f001";
}

.fa-code-commit::before {
  content: "\\f386";
}

.fa-temperature-low::before {
  content: "\\f76b";
}

.fa-person-biking::before {
  content: "\\f84a";
}

.fa-biking::before {
  content: "\\f84a";
}

.fa-broom::before {
  content: "\\f51a";
}

.fa-shield-heart::before {
  content: "\\e574";
}

.fa-gopuram::before {
  content: "\\f664";
}

.fa-earth-oceania::before {
  content: "\\e47b";
}

.fa-globe-oceania::before {
  content: "\\e47b";
}

.fa-square-xmark::before {
  content: "\\f2d3";
}

.fa-times-square::before {
  content: "\\f2d3";
}

.fa-xmark-square::before {
  content: "\\f2d3";
}

.fa-hashtag::before {
  content: "\\#";
}

.fa-up-right-and-down-left-from-center::before {
  content: "\\f424";
}

.fa-expand-alt::before {
  content: "\\f424";
}

.fa-oil-can::before {
  content: "\\f613";
}

.fa-t::before {
  content: "T";
}

.fa-hippo::before {
  content: "\\f6ed";
}

.fa-chart-column::before {
  content: "\\e0e3";
}

.fa-infinity::before {
  content: "\\f534";
}

.fa-vial-circle-check::before {
  content: "\\e596";
}

.fa-person-arrow-down-to-line::before {
  content: "\\e538";
}

.fa-voicemail::before {
  content: "\\f897";
}

.fa-fan::before {
  content: "\\f863";
}

.fa-person-walking-luggage::before {
  content: "\\e554";
}

.fa-up-down::before {
  content: "\\f338";
}

.fa-arrows-alt-v::before {
  content: "\\f338";
}

.fa-cloud-moon-rain::before {
  content: "\\f73c";
}

.fa-calendar::before {
  content: "\\f133";
}

.fa-trailer::before {
  content: "\\e041";
}

.fa-bahai::before {
  content: "\\f666";
}

.fa-haykal::before {
  content: "\\f666";
}

.fa-sd-card::before {
  content: "\\f7c2";
}

.fa-dragon::before {
  content: "\\f6d5";
}

.fa-shoe-prints::before {
  content: "\\f54b";
}

.fa-circle-plus::before {
  content: "\\f055";
}

.fa-plus-circle::before {
  content: "\\f055";
}

.fa-face-grin-tongue-wink::before {
  content: "\\f58b";
}

.fa-grin-tongue-wink::before {
  content: "\\f58b";
}

.fa-hand-holding::before {
  content: "\\f4bd";
}

.fa-plug-circle-exclamation::before {
  content: "\\e55d";
}

.fa-link-slash::before {
  content: "\\f127";
}

.fa-chain-broken::before {
  content: "\\f127";
}

.fa-chain-slash::before {
  content: "\\f127";
}

.fa-unlink::before {
  content: "\\f127";
}

.fa-clone::before {
  content: "\\f24d";
}

.fa-person-walking-arrow-loop-left::before {
  content: "\\e551";
}

.fa-arrow-up-z-a::before {
  content: "\\f882";
}

.fa-sort-alpha-up-alt::before {
  content: "\\f882";
}

.fa-fire-flame-curved::before {
  content: "\\f7e4";
}

.fa-fire-alt::before {
  content: "\\f7e4";
}

.fa-tornado::before {
  content: "\\f76f";
}

.fa-file-circle-plus::before {
  content: "\\e494";
}

.fa-book-quran::before {
  content: "\\f687";
}

.fa-quran::before {
  content: "\\f687";
}

.fa-anchor::before {
  content: "\\f13d";
}

.fa-border-all::before {
  content: "\\f84c";
}

.fa-face-angry::before {
  content: "\\f556";
}

.fa-angry::before {
  content: "\\f556";
}

.fa-cookie-bite::before {
  content: "\\f564";
}

.fa-arrow-trend-down::before {
  content: "\\e097";
}

.fa-rss::before {
  content: "\\f09e";
}

.fa-feed::before {
  content: "\\f09e";
}

.fa-draw-polygon::before {
  content: "\\f5ee";
}

.fa-scale-balanced::before {
  content: "\\f24e";
}

.fa-balance-scale::before {
  content: "\\f24e";
}

.fa-gauge-simple-high::before {
  content: "\\f62a";
}

.fa-tachometer::before {
  content: "\\f62a";
}

.fa-tachometer-fast::before {
  content: "\\f62a";
}

.fa-shower::before {
  content: "\\f2cc";
}

.fa-desktop::before {
  content: "\\f390";
}

.fa-desktop-alt::before {
  content: "\\f390";
}

.fa-m::before {
  content: "M";
}

.fa-table-list::before {
  content: "\\f00b";
}

.fa-th-list::before {
  content: "\\f00b";
}

.fa-comment-sms::before {
  content: "\\f7cd";
}

.fa-sms::before {
  content: "\\f7cd";
}

.fa-book::before {
  content: "\\f02d";
}

.fa-user-plus::before {
  content: "\\f234";
}

.fa-check::before {
  content: "\\f00c";
}

.fa-battery-three-quarters::before {
  content: "\\f241";
}

.fa-battery-4::before {
  content: "\\f241";
}

.fa-house-circle-check::before {
  content: "\\e509";
}

.fa-angle-left::before {
  content: "\\f104";
}

.fa-diagram-successor::before {
  content: "\\e47a";
}

.fa-truck-arrow-right::before {
  content: "\\e58b";
}

.fa-arrows-split-up-and-left::before {
  content: "\\e4bc";
}

.fa-hand-fist::before {
  content: "\\f6de";
}

.fa-fist-raised::before {
  content: "\\f6de";
}

.fa-cloud-moon::before {
  content: "\\f6c3";
}

.fa-briefcase::before {
  content: "\\f0b1";
}

.fa-person-falling::before {
  content: "\\e546";
}

.fa-image-portrait::before {
  content: "\\f3e0";
}

.fa-portrait::before {
  content: "\\f3e0";
}

.fa-user-tag::before {
  content: "\\f507";
}

.fa-rug::before {
  content: "\\e569";
}

.fa-earth-europe::before {
  content: "\\f7a2";
}

.fa-globe-europe::before {
  content: "\\f7a2";
}

.fa-cart-flatbed-suitcase::before {
  content: "\\f59d";
}

.fa-luggage-cart::before {
  content: "\\f59d";
}

.fa-rectangle-xmark::before {
  content: "\\f410";
}

.fa-rectangle-times::before {
  content: "\\f410";
}

.fa-times-rectangle::before {
  content: "\\f410";
}

.fa-window-close::before {
  content: "\\f410";
}

.fa-baht-sign::before {
  content: "\\e0ac";
}

.fa-book-open::before {
  content: "\\f518";
}

.fa-book-journal-whills::before {
  content: "\\f66a";
}

.fa-journal-whills::before {
  content: "\\f66a";
}

.fa-handcuffs::before {
  content: "\\e4f8";
}

.fa-triangle-exclamation::before {
  content: "\\f071";
}

.fa-exclamation-triangle::before {
  content: "\\f071";
}

.fa-warning::before {
  content: "\\f071";
}

.fa-database::before {
  content: "\\f1c0";
}

.fa-share::before {
  content: "\\f064";
}

.fa-mail-forward::before {
  content: "\\f064";
}

.fa-bottle-droplet::before {
  content: "\\e4c4";
}

.fa-mask-face::before {
  content: "\\e1d7";
}

.fa-hill-rockslide::before {
  content: "\\e508";
}

.fa-right-left::before {
  content: "\\f362";
}

.fa-exchange-alt::before {
  content: "\\f362";
}

.fa-paper-plane::before {
  content: "\\f1d8";
}

.fa-road-circle-exclamation::before {
  content: "\\e565";
}

.fa-dungeon::before {
  content: "\\f6d9";
}

.fa-align-right::before {
  content: "\\f038";
}

.fa-money-bill-1-wave::before {
  content: "\\f53b";
}

.fa-money-bill-wave-alt::before {
  content: "\\f53b";
}

.fa-life-ring::before {
  content: "\\f1cd";
}

.fa-hands::before {
  content: "\\f2a7";
}

.fa-sign-language::before {
  content: "\\f2a7";
}

.fa-signing::before {
  content: "\\f2a7";
}

.fa-calendar-day::before {
  content: "\\f783";
}

.fa-water-ladder::before {
  content: "\\f5c5";
}

.fa-ladder-water::before {
  content: "\\f5c5";
}

.fa-swimming-pool::before {
  content: "\\f5c5";
}

.fa-arrows-up-down::before {
  content: "\\f07d";
}

.fa-arrows-v::before {
  content: "\\f07d";
}

.fa-face-grimace::before {
  content: "\\f57f";
}

.fa-grimace::before {
  content: "\\f57f";
}

.fa-wheelchair-move::before {
  content: "\\e2ce";
}

.fa-wheelchair-alt::before {
  content: "\\e2ce";
}

.fa-turn-down::before {
  content: "\\f3be";
}

.fa-level-down-alt::before {
  content: "\\f3be";
}

.fa-person-walking-arrow-right::before {
  content: "\\e552";
}

.fa-square-envelope::before {
  content: "\\f199";
}

.fa-envelope-square::before {
  content: "\\f199";
}

.fa-dice::before {
  content: "\\f522";
}

.fa-bowling-ball::before {
  content: "\\f436";
}

.fa-brain::before {
  content: "\\f5dc";
}

.fa-bandage::before {
  content: "\\f462";
}

.fa-band-aid::before {
  content: "\\f462";
}

.fa-calendar-minus::before {
  content: "\\f272";
}

.fa-circle-xmark::before {
  content: "\\f057";
}

.fa-times-circle::before {
  content: "\\f057";
}

.fa-xmark-circle::before {
  content: "\\f057";
}

.fa-gifts::before {
  content: "\\f79c";
}

.fa-hotel::before {
  content: "\\f594";
}

.fa-earth-asia::before {
  content: "\\f57e";
}

.fa-globe-asia::before {
  content: "\\f57e";
}

.fa-id-card-clip::before {
  content: "\\f47f";
}

.fa-id-card-alt::before {
  content: "\\f47f";
}

.fa-magnifying-glass-plus::before {
  content: "\\f00e";
}

.fa-search-plus::before {
  content: "\\f00e";
}

.fa-thumbs-up::before {
  content: "\\f164";
}

.fa-user-clock::before {
  content: "\\f4fd";
}

.fa-hand-dots::before {
  content: "\\f461";
}

.fa-allergies::before {
  content: "\\f461";
}

.fa-file-invoice::before {
  content: "\\f570";
}

.fa-window-minimize::before {
  content: "\\f2d1";
}

.fa-mug-saucer::before {
  content: "\\f0f4";
}

.fa-coffee::before {
  content: "\\f0f4";
}

.fa-brush::before {
  content: "\\f55d";
}

.fa-mask::before {
  content: "\\f6fa";
}

.fa-magnifying-glass-minus::before {
  content: "\\f010";
}

.fa-search-minus::before {
  content: "\\f010";
}

.fa-ruler-vertical::before {
  content: "\\f548";
}

.fa-user-large::before {
  content: "\\f406";
}

.fa-user-alt::before {
  content: "\\f406";
}

.fa-train-tram::before {
  content: "\\e5b4";
}

.fa-user-nurse::before {
  content: "\\f82f";
}

.fa-syringe::before {
  content: "\\f48e";
}

.fa-cloud-sun::before {
  content: "\\f6c4";
}

.fa-stopwatch-20::before {
  content: "\\e06f";
}

.fa-square-full::before {
  content: "\\f45c";
}

.fa-magnet::before {
  content: "\\f076";
}

.fa-jar::before {
  content: "\\e516";
}

.fa-note-sticky::before {
  content: "\\f249";
}

.fa-sticky-note::before {
  content: "\\f249";
}

.fa-bug-slash::before {
  content: "\\e490";
}

.fa-arrow-up-from-water-pump::before {
  content: "\\e4b6";
}

.fa-bone::before {
  content: "\\f5d7";
}

.fa-user-injured::before {
  content: "\\f728";
}

.fa-face-sad-tear::before {
  content: "\\f5b4";
}

.fa-sad-tear::before {
  content: "\\f5b4";
}

.fa-plane::before {
  content: "\\f072";
}

.fa-tent-arrows-down::before {
  content: "\\e581";
}

.fa-exclamation::before {
  content: "\\!";
}

.fa-arrows-spin::before {
  content: "\\e4bb";
}

.fa-print::before {
  content: "\\f02f";
}

.fa-turkish-lira-sign::before {
  content: "\\e2bb";
}

.fa-try::before {
  content: "\\e2bb";
}

.fa-turkish-lira::before {
  content: "\\e2bb";
}

.fa-dollar-sign::before {
  content: "\\\$";
}

.fa-dollar::before {
  content: "\\\$";
}

.fa-usd::before {
  content: "\\\$";
}

.fa-x::before {
  content: "X";
}

.fa-magnifying-glass-dollar::before {
  content: "\\f688";
}

.fa-search-dollar::before {
  content: "\\f688";
}

.fa-users-gear::before {
  content: "\\f509";
}

.fa-users-cog::before {
  content: "\\f509";
}

.fa-person-military-pointing::before {
  content: "\\e54a";
}

.fa-building-columns::before {
  content: "\\f19c";
}

.fa-bank::before {
  content: "\\f19c";
}

.fa-institution::before {
  content: "\\f19c";
}

.fa-museum::before {
  content: "\\f19c";
}

.fa-university::before {
  content: "\\f19c";
}

.fa-umbrella::before {
  content: "\\f0e9";
}

.fa-trowel::before {
  content: "\\e589";
}

.fa-d::before {
  content: "D";
}

.fa-stapler::before {
  content: "\\e5af";
}

.fa-masks-theater::before {
  content: "\\f630";
}

.fa-theater-masks::before {
  content: "\\f630";
}

.fa-kip-sign::before {
  content: "\\e1c4";
}

.fa-hand-point-left::before {
  content: "\\f0a5";
}

.fa-handshake-simple::before {
  content: "\\f4c6";
}

.fa-handshake-alt::before {
  content: "\\f4c6";
}

.fa-jet-fighter::before {
  content: "\\f0fb";
}

.fa-fighter-jet::before {
  content: "\\f0fb";
}

.fa-square-share-nodes::before {
  content: "\\f1e1";
}

.fa-share-alt-square::before {
  content: "\\f1e1";
}

.fa-barcode::before {
  content: "\\f02a";
}

.fa-plus-minus::before {
  content: "\\e43c";
}

.fa-video::before {
  content: "\\f03d";
}

.fa-video-camera::before {
  content: "\\f03d";
}

.fa-graduation-cap::before {
  content: "\\f19d";
}

.fa-mortar-board::before {
  content: "\\f19d";
}

.fa-hand-holding-medical::before {
  content: "\\e05c";
}

.fa-person-circle-check::before {
  content: "\\e53e";
}

.fa-turn-up::before {
  content: "\\f3bf";
}

.fa-level-up-alt::before {
  content: "\\f3bf";
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

/*!
 * Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
:root, :host {
  --fa-style-family-classic: "Font Awesome 6 Free";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
}

@font-face {
  font-family: "Font Awesome 6 Free";
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_40___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_41___}) format("truetype");
}
.far,
.fa-regular {
  font-weight: 400;
}

/*!
 * Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
:root, :host {
  --fa-style-family-classic: "Font Awesome 6 Free";
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
}

@font-face {
  font-family: "Font Awesome 6 Free";
  font-style: normal;
  font-weight: 900;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_42___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_43___}) format("truetype");
}
.fas,
.fa-solid {
  font-weight: 900;
}

/*!
 * Bootstrap  v5.3.3 (https://getbootstrap.com/)
 * Copyright 2011-2024 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: rgba(0, 0, 0, 0);
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-primary-rgb: 13, 110, 253;
  --bs-secondary-rgb: 108, 117, 125;
  --bs-success-rgb: 25, 135, 84;
  --bs-info-rgb: 13, 202, 240;
  --bs-warning-rgb: 255, 193, 7;
  --bs-danger-rgb: 220, 53, 69;
  --bs-light-rgb: 248, 249, 250;
  --bs-dark-rgb: 33, 37, 41;
  --bs-primary-text-emphasis: #052c65;
  --bs-secondary-text-emphasis: #2b2f32;
  --bs-success-text-emphasis: #0a3622;
  --bs-info-text-emphasis: #055160;
  --bs-warning-text-emphasis: #664d03;
  --bs-danger-text-emphasis: #58151c;
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: #cfe2ff;
  --bs-secondary-bg-subtle: #e2e3e5;
  --bs-success-bg-subtle: #d1e7dd;
  --bs-info-bg-subtle: #cff4fc;
  --bs-warning-bg-subtle: #fff3cd;
  --bs-danger-bg-subtle: #f8d7da;
  --bs-light-bg-subtle: #fcfcfd;
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: #9ec5fe;
  --bs-secondary-border-subtle: #c4c8cb;
  --bs-success-border-subtle: #a3cfbb;
  --bs-info-border-subtle: #9eeaf9;
  --bs-warning-border-subtle: #ffe69c;
  --bs-danger-border-subtle: #f1aeb5;
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-color-rgb: 33, 37, 41;
  --bs-body-bg: #f7f7f7;
  --bs-body-bg-rgb: 247, 247, 247;
  --bs-emphasis-color: rgba(0, 0, 0, 0);
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #0d6efd;
  --bs-link-color-rgb: 13, 110, 253;
  --bs-link-decoration: underline;
  --bs-link-hover-color: #0a58ca;
  --bs-link-hover-color-rgb: 10, 88, 202;
  --bs-code-color: #d63384;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: #fff3cd;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: #2b3035;
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: #6ea8fe;
  --bs-secondary-text-emphasis: #a7acb1;
  --bs-success-text-emphasis: #75b798;
  --bs-info-text-emphasis: #6edff6;
  --bs-warning-text-emphasis: #ffda6a;
  --bs-danger-text-emphasis: #ea868f;
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: #031633;
  --bs-secondary-bg-subtle: #161719;
  --bs-success-bg-subtle: #051b11;
  --bs-info-bg-subtle: #032830;
  --bs-warning-bg-subtle: #332701;
  --bs-danger-bg-subtle: #2c0b0e;
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: rgba(52, 58, 64, 0.5);
  --bs-primary-border-subtle: #084298;
  --bs-secondary-border-subtle: #41464b;
  --bs-success-border-subtle: #0f5132;
  --bs-info-border-subtle: #087990;
  --bs-warning-border-subtle: #997404;
  --bs-danger-border-subtle: #842029;
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: #6ea8fe;
  --bs-link-hover-color: #8bb9fe;
  --bs-link-color-rgb: 110, 168, 254;
  --bs-link-hover-color-rgb: 139, 185, 254;
  --bs-code-color: #e685b5;
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: #664d03;
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: #75b798;
  --bs-form-valid-border-color: #75b798;
  --bs-form-invalid-color: #ea868f;
  --bs-form-invalid-border-color: #ea868f;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.5rem;
  }
}

h2, .h2 {
  font-size: calc(1.325rem + 0.9vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 2rem;
  }
}

h3, .h3 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.75rem;
  }
}

h4, .h4 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.5rem;
  }
}

h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.25rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-secondary-color);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0 0%;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0 0%;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0 0%;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0 0%;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0 0%;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0 0%;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-emphasis-color);
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-emphasis-color);
  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
  --bs-table-active-color: var(--bs-emphasis-color);
  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);
  --bs-table-hover-color: var(--bs-emphasis-color);
  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--bs-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--bs-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #fff;
  --bs-table-bg: #cfe2ff;
  --bs-table-border-color: #d9e8ff;
  --bs-table-striped-bg: #d1e3ff;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #d4e5ff;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #d3e4ff;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #fff;
  --bs-table-bg: #e2e3e5;
  --bs-table-border-color: #e8e9ea;
  --bs-table-striped-bg: #e3e4e6;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #e5e6e8;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #e4e5e7;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #fff;
  --bs-table-bg: #d1e7dd;
  --bs-table-border-color: #daece4;
  --bs-table-striped-bg: #d3e8df;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #d6e9e0;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #d4e9e0;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #fff;
  --bs-table-bg: #cff4fc;
  --bs-table-border-color: #d9f6fd;
  --bs-table-striped-bg: #d1f5fc;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #d4f5fc;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #d3f5fc;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #fff;
  --bs-table-bg: #fff3cd;
  --bs-table-border-color: #fff5d7;
  --bs-table-striped-bg: #fff4d0;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #fff4d2;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #fff4d1;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #fff;
  --bs-table-bg: #f8d7da;
  --bs-table-border-color: #f9dfe1;
  --bs-table-striped-bg: #f8d9dc;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #f9dbde;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #f9dadd;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #fff;
  --bs-table-bg: #f8f9fa;
  --bs-table-border-color: #f9fafb;
  --bs-table-striped-bg: #f8f9fa;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #f9fafb;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #f9f9fa;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #212529;
  --bs-table-border-color: #4d5154;
  --bs-table-striped-bg: #2c3034;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #373b3e;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #323539;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.375rem + var(--bs-border-width));
  padding-bottom: calc(0.375rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + var(--bs-border-width));
  padding-bottom: calc(0.5rem + var(--bs-border-width));
  font-size: 1.25rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--bs-border-width));
  padding-bottom: calc(0.25rem + var(--bs-border-width));
  font-size: 0.875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: var(--bs-body-color);
  background-color: var(--bs-body-bg);
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: var(--bs-secondary-color);
  opacity: 1;
}
.form-control:disabled {
  background-color: var(--bs-secondary-bg);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--bs-body-color);
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--bs-border-width) 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
  padding: 0.375rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}
.form-select:disabled {
  background-color: var(--bs-secondary-bg);
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--bs-body-color);
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: var(--bs-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--bs-border-width) solid var(--bs-border-color);
  print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #0d6efd;
  border-color: #0d6efd;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_51___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #f7f7f7, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #f7f7f7, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: #b6d4fe;
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: #b6d4fe;
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--bs-body-bg);
  border-radius: var(--bs-border-radius);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: var(--bs-border-width) 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #6c757d;
}
.form-floating > :disabled ~ label::after,
.form-floating > .form-control:disabled ~ label::after {
  background-color: var(--bs-secondary-bg);
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-tertiary-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(var(--bs-border-width) * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: var(--bs-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_53___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_53___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--bs-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--bs-form-valid-color);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: var(--bs-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--bs-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-form-invalid-color);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: var(--bs-border-radius);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked:focus-visible + .btn {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0b5ed7;
  --bs-btn-hover-border-color: #0a58ca;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0a58ca;
  --bs-btn-active-border-color: #0a53be;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0d6efd;
  --bs-btn-disabled-border-color: #0d6efd;
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #5c636a;
  --bs-btn-hover-border-color: #565e64;
  --bs-btn-focus-shadow-rgb: 130, 138, 145;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #565e64;
  --bs-btn-active-border-color: #51585e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6c757d;
  --bs-btn-disabled-border-color: #6c757d;
}

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #157347;
  --bs-btn-hover-border-color: #146c43;
  --bs-btn-focus-shadow-rgb: 60, 153, 110;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #146c43;
  --bs-btn-active-border-color: #13653f;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #198754;
  --bs-btn-disabled-border-color: #198754;
}

.btn-info {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0baccc;
  --bs-btn-hover-border-color: #0aa2c0;
  --bs-btn-focus-shadow-rgb: 49, 210, 242;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0aa2c0;
  --bs-btn-active-border-color: #0a98b4;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0dcaf0;
  --bs-btn-disabled-border-color: #0dcaf0;
}

.btn-warning {
  --bs-btn-color: #fff;
  --bs-btn-bg: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #d9a406;
  --bs-btn-hover-border-color: #cc9a06;
  --bs-btn-focus-shadow-rgb: 255, 202, 44;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #cc9a06;
  --bs-btn-active-border-color: #bf9105;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #ffc107;
  --bs-btn-disabled-border-color: #ffc107;
}

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #bb2d3b;
  --bs-btn-hover-border-color: #b02a37;
  --bs-btn-focus-shadow-rgb: 225, 83, 97;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #b02a37;
  --bs-btn-active-border-color: #a52834;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #dc3545;
  --bs-btn-disabled-border-color: #dc3545;
}

.btn-light {
  --bs-btn-color: #fff;
  --bs-btn-bg: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #d3d4d5;
  --bs-btn-hover-border-color: #c6c7c8;
  --bs-btn-focus-shadow-rgb: 249, 250, 251;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #c6c7c8;
  --bs-btn-active-border-color: #babbbc;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #f8f9fa;
  --bs-btn-disabled-border-color: #f8f9fa;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #424649;
  --bs-btn-hover-border-color: #373b3e;
  --bs-btn-focus-shadow-rgb: 66, 70, 73;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #4d5154;
  --bs-btn-active-border-color: #373b3e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #212529;
  --bs-btn-disabled-border-color: #212529;
}

.btn-outline-primary {
  --bs-btn-color: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0d6efd;
  --bs-btn-hover-border-color: #0d6efd;
  --bs-btn-focus-shadow-rgb: 13, 110, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0d6efd;
  --bs-btn-active-border-color: #0d6efd;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0d6efd;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0d6efd;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6c757d;
  --bs-btn-hover-border-color: #6c757d;
  --bs-btn-focus-shadow-rgb: 108, 117, 125;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #6c757d;
  --bs-btn-active-border-color: #6c757d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6c757d;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #198754;
  --bs-btn-hover-border-color: #198754;
  --bs-btn-focus-shadow-rgb: 25, 135, 84;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #198754;
  --bs-btn-active-border-color: #198754;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #198754;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #198754;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0dcaf0;
  --bs-btn-hover-border-color: #0dcaf0;
  --bs-btn-focus-shadow-rgb: 13, 202, 240;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0dcaf0;
  --bs-btn-active-border-color: #0dcaf0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0dcaf0;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0dcaf0;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #ffc107;
  --bs-btn-hover-border-color: #ffc107;
  --bs-btn-focus-shadow-rgb: 255, 193, 7;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #ffc107;
  --bs-btn-active-border-color: #ffc107;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffc107;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffc107;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #dc3545;
  --bs-btn-hover-border-color: #dc3545;
  --bs-btn-focus-shadow-rgb: 220, 53, 69;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #dc3545;
  --bs-btn-active-border-color: #dc3545;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #dc3545;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #dc3545;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #f8f9fa;
  --bs-btn-hover-border-color: #f8f9fa;
  --bs-btn-focus-shadow-rgb: 248, 249, 250;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #f8f9fa;
  --bs-btn-active-border-color: #f8f9fa;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f8f9fa;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f8f9fa;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #212529;
  --bs-btn-hover-border-color: #212529;
  --bs-btn-focus-shadow-rgb: 33, 37, 41;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #212529;
  --bs-btn-active-border-color: #212529;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #212529;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #212529;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.25rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg);
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-border-radius: var(--bs-border-radius-sm);
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 1rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: var(--bs-border-radius);
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: var(--bs-box-shadow);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.25rem;
  --bs-dropdown-header-color: #6c757d;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #dee2e6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dee2e6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: var(--bs-border-radius);
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(var(--bs-border-width) * -1);
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(var(--bs-border-width) * -1);
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #0d6efd;
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.3125rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.25rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.25rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: var(--bs-border-radius);
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
}

.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: var(--bs-border-color-translucent);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-body-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0 0%;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_57___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_58___});
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-primary-text-emphasis);
  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush > .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush > .accordion-item > .accordion-header .accordion-button, .accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}
.accordion-flush > .accordion-item > .accordion-collapse {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_59___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_59___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: var(--bs-body-bg);
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #0d6efd;
  --bs-pagination-active-border-color: #0d6efd;
  --bs-pagination-disabled-color: var(--bs-secondary-color);
  --bs-pagination-disabled-bg: var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(var(--bs-border-width) * -1);
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.25rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.875rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}

.badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: var(--bs-secondary-bg);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #0d6efd;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: var(--bs-body-bg);
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #0d6efd;
  --bs-list-group-active-border-color: #0d6efd;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: rgba(0, 0, 0, 0);
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_60___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--bs-btn-close-white-filter);
}

[data-bs-theme=dark] .btn-close {
  filter: var(--bs-btn-close-white-filter);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: var(--bs-box-shadow-sm);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: rgba(0, 0, 0, 0);
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--bs-box-shadow);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.875rem;
  --bs-tooltip-color: var(--bs-body-bg);
  --bs-tooltip-bg: var(--bs-emphasis-color);
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.875rem;
  --bs-popover-bg: var(--bs-body-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: var(--bs-box-shadow);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: var(--bs-secondary-bg);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_61___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e")*/;
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_62___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e")*/;
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: rgba(0, 0, 0, 0);
}
.carousel-dark .carousel-caption {
  color: rgba(0, 0, 0, 0);
}

[data-bs-theme=dark] .carousel .carousel-control-prev-icon,
[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,
[data-bs-theme=dark].carousel .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {
  background-color: rgba(0, 0, 0, 0);
}
[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {
  color: rgba(0, 0, 0, 0);
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0);
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-offcanvas-padding-y)) calc(-0.5 * var(--bs-offcanvas-padding-x)) calc(-0.5 * var(--bs-offcanvas-padding-y)) auto;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, rgba(0, 0, 0, 0) 55%, rgba(0, 0, 0, 0.8) 75%, rgba(0, 0, 0, 0) 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #fff !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #fff !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #fff !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(10, 88, 202, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(10, 88, 202, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(86, 94, 100, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(10, 162, 192, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(10, 162, 192, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(204, 154, 6, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(204, 154, 6, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(198, 199, 200, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(198, 199, 200, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-6 {
  font-size: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  user-select: all !important;
}

.user-select-auto {
  user-select: auto !important;
}

.user-select-none {
  user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important;
  }
  .fs-2 {
    font-size: 2rem !important;
  }
  .fs-3 {
    font-size: 1.75rem !important;
  }
  .fs-4 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
* {
  font-family: "PremierLeague-Regular", serif;
}

iframe ::-webkit-scrollbar {
  width: 16px;
  background: transparent;
}

iframe::-webkit-scrollbar-track {
  background: transparent;
}

iframe::-webkit-scrollbar-thumb {
  background-color: #787878;
  border: 3px solid #f7f7f7;
  border-radius: 10px;
}

a {
  color: #000 !important;
  text-decoration: none !important;
}
a .anticon {
  vertical-align: middle;
}

.text-white {
  color: #fff;
}

.text-pink {
  color: #e2407e !important;
}

body,
html {
  height: 100vh;
  overflow-x: hidden;
  background: #f7f7f7 !important;
}

.full-height {
  height: 100vh;
}

.nav-logo {
  float: left;
}

.nav-bar {
  height: 130px;
  padding: 0 140px;
}

.ant-col {
  width: 100%;
}

.about-scrollable {
  height: 400px;
  padding-top: 24px;
  overflow-y: auto;
}

.login-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_63___}), #37033c;
  background-repeat: no-repeat, no-repeat;
  background-position: right center;
  background-size: auto 75%;
}
.login-bg .logo {
  width: 200px;
  height: auto;
}
.login-bg h1, .login-bg .h1 {
  color: #fff;
  font-size: 34px;
  font-family: "PremierLeague-BoldItalic", serif;
  line-height: 46px;
  text-align: center;
}
.login-bg p {
  max-width: 480px;
  margin-bottom: 0 !important;
  color: #fff;
  font-size: 16px;
  font-family: "PremierLeague-Regular", serif;
  line-height: 22px;
  text-align: center;
}
.login-bg p a {
  color: #e2407e;
}
.login-bg .login_button_container {
  width: 56%;
}
.login-bg small, .login-bg .small {
  color: #fff;
  font-size: 12px;
  font-family: "PremierLeague-Regular", serif;
  line-height: 22px;
}

@media only screen and (max-width: 576px) {
  .login-bg .logo {
    width: 150px;
    height: auto;
  }
  .login-bg h1, .login-bg .h1 {
    font-size: 28px;
  }
  .login-bg p {
    font-size: 14px;
  }
  .login-bg .login_button_container {
    width: 89%;
  }
}
@media only screen and (min-width: 577px) and (max-width: 768px) {
  .login-bg .login_button_container {
    width: 64%;
  }
}
@media only screen and (max-width: 992px) {
  .login-bg {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_64___}), linear-gradient(140deg, #37033c 0%, #e2407e 100%) 0% 0%;
    background-repeat: no-repeat, no-repeat;
    background-position: bottom right;
    background-size: cover, contain;
  }
}
.card_shadow {
  width: 100%;
  margin-bottom: 32px;
  padding: 20px;
  background: #fff;
  border-radius: 12px;
}

.card_shadow_posts {
  height: calc(100vh - 390px);
  margin-bottom: 16px;
  overflow: auto;
}
@media (max-width: 991.98px) {
  .card_shadow_posts {
    height: calc(50vh - 140px);
  }
}

h4, .h4 {
  font-size: 12px !important;
  font-family: PremierLeague-Bold, sans-serif;
}

.bold {
  font-weight: bold;
  font-family: PremierLeague-Bold, sans-serif;
}

.avatar-insight {
  float: right;
  color: #490c4e !important;
  background: #dacddb !important;
  border-radius: 12px !important;
}

.avatar {
  color: #490c4e !important;
  background: #dacddb !important;
  border-radius: 12px !important;
  cursor: pointer;
  transition: 0.3s ease-in-out;
}
.avatar .anticon {
  vertical-align: middle !important;
}

.anticon {
  vertical-align: 0 !important;
}

.avatar-initials {
  color: #490c4e !important;
  background: #dacddb !important;
  border-radius: 12px !important;
  transition: 0.3s ease-in-out;
}
.avatar-initials .anticon {
  vertical-align: middle !important;
}

.ant-menu .anticon {
  width: 14px;
  height: 14px;
  vertical-align: middle;
}

.avatar:hover {
  transform: scale(1.02);
  opacity: 0.8;
  transition: 0.3s ease-in-out;
}

.avatar-insight:hover {
  transform: scale(1.02);
  opacity: 0.8;
  transition: 0.3s ease-in-out;
}

.first-avatar {
  margin-right: 5px !important;
}

@media only screen and (max-width: 1305px) {
  .first-avatar {
    margin-right: 0 !important;
    margin-bottom: 5px !important;
  }
}
@media (max-width: 991.98px) {
  .first-avatar {
    margin-right: 5px !important;
    margin-bottom: 0 !important;
  }
}
.text-right {
  text-align: right;
}

p:last-child {
  margin-bottom: 0 !important;
}

.font-fourteen {
  font-size: 12px;
}

.flex-flow {
  flex-direction: row !important;
  flex-flow: nowrap !important;
  justify-content: space-between;
}

.ant-row *::-webkit-scrollbar-track {
  background: white;
  border-radius: 10px;
}
.ant-row *::-webkit-scrollbar-thumb {
  border: 3px solid white;
  border-radius: 10px;
}

@media (max-width: 991.98px) {
  .article_meta {
    margin-top: 32px;
  }
}
.site_padding {
  padding-top: 26px;
}
@media (max-width: 991.98px) {
  .site_padding {
    padding-top: 10px;
  }
}

.ant-tabs-tabpane {
  padding: 20px;
  background-color: #f7f7f7;
}

.ant-tabs > .ant-tabs-nav,
.ant-tabs > div > .ant-tabs-nav {
  padding: 20px;
}

.ant-table-body {
  height: calc(100vh - 452px);
}
@media (max-width: 767.98px) {
  .ant-table-body {
    height: auto;
    max-height: calc(100vh - 415px) !important;
  }
}

.ant-table {
  font-size: 12px !important;
}

.ant-menu {
  font-size: 12px !important;
}

.ant-table-cell {
  padding: 13px 16px !important;
}

.font-12 {
  font-size: 12px !important;
}

.ant-form {
  font-size: 12px !important;
}

.ant-form label {
  font-size: 12px !important;
}

.ant-select-lg {
  font-size: 12px !important;
}

.ant-table .ant-table-thead .ant-table-column-sorters {
  padding: 0;
}

.ant-table-pagination.ant-pagination {
  margin-top: 16px !important;
  margin-bottom: 0 !important;
}
.ant-table-pagination.ant-pagination .ant-pagination-item-link {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table {
  margin: -13px -16px -16px 34px !important;
}

.max-height {
  max-height: calc(100vh - 530px);
  margin-bottom: 0;
  overflow: auto;
}

.about-tables {
  padding-right: 24px;
}

.ant-carousel {
  height: 100%;
}
.ant-carousel .slick-dots li {
  width: 10px !important;
}
.ant-carousel .slick-dots li button {
  width: 7px !important;
  height: 7px !important;
  background: rgba(0, 0, 0, 0.8) !important;
  border-radius: 100% !important;
}
.ant-carousel .slick-dots li.slick-active {
  width: 10px !important;
}
.ant-carousel .slick-dots li.slick-active button {
  width: 7px !important;
  height: 7px !important;
  background: #000 !important;
  border-radius: 100% !important;
}
.ant-carousel .slick-slider {
  height: 100%;
}
.ant-carousel .slick-dots-bottom {
  bottom: -38px !important;
}

.mce-preview-object {
  width: 100%;
}

h2, .h2 {
  font-size: 1.5rem !important;
}

.bg-purple {
  background-color: #490c4e !important;
}

.plcp-bg-height {
  height: calc(100vh - 60px);
}`, "",{"version":3,"sources":["webpack://./scss/app.scss","webpack://./scss/_fonts.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/fontawesome.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/_core.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/_sizing.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/_mixins.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/_fixed-width.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/_variables.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/_list.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/_bordered-pulled.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/_animated.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/_rotated-flipped.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/_stacked.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/_icons.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/_screen-reader.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/regular.scss","webpack://./../../node_modules/@fortawesome/fontawesome-free/scss/solid.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./../../node_modules/bootstrap/scss/_root.scss","webpack://./../../node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./../../node_modules/bootstrap/scss/_reboot.scss","webpack://./../../node_modules/bootstrap/scss/_variables.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./../../node_modules/bootstrap/scss/_type.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./../../node_modules/bootstrap/scss/_images.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_image.scss","webpack://./../../node_modules/bootstrap/scss/_containers.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_container.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./../../node_modules/bootstrap/scss/_grid.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./../../node_modules/bootstrap/scss/_tables.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./../../node_modules/bootstrap/scss/forms/_labels.scss","webpack://./../../node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./../../node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./../../node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./../../node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./../../node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./../../node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./../../node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./../../node_modules/bootstrap/scss/_buttons.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./../../node_modules/bootstrap/scss/_transitions.scss","webpack://./../../node_modules/bootstrap/scss/_dropdown.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./../../node_modules/bootstrap/scss/_button-group.scss","webpack://./../../node_modules/bootstrap/scss/_nav.scss","webpack://./../../node_modules/bootstrap/scss/_navbar.scss","webpack://./../../node_modules/bootstrap/scss/_card.scss","webpack://./../../node_modules/bootstrap/scss/_accordion.scss","webpack://./../../node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./../../node_modules/bootstrap/scss/_pagination.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./../../node_modules/bootstrap/scss/_badge.scss","webpack://./../../node_modules/bootstrap/scss/_alert.scss","webpack://./../../node_modules/bootstrap/scss/_progress.scss","webpack://./../../node_modules/bootstrap/scss/_list-group.scss","webpack://./../../node_modules/bootstrap/scss/_close.scss","webpack://./../../node_modules/bootstrap/scss/_toasts.scss","webpack://./../../node_modules/bootstrap/scss/_modal.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./../../node_modules/bootstrap/scss/_tooltip.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./../../node_modules/bootstrap/scss/_popover.scss","webpack://./../../node_modules/bootstrap/scss/_carousel.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./scss/_variables.scss","webpack://./../../node_modules/bootstrap/scss/_spinners.scss","webpack://./../../node_modules/bootstrap/scss/_offcanvas.scss","webpack://./../../node_modules/bootstrap/scss/_placeholders.scss","webpack://./../../node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./../../node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./../../node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./../../node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./../../node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./../../node_modules/bootstrap/scss/helpers/_position.scss","webpack://./../../node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./../../node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./../../node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./../../node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./../../node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./../../node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./../../node_modules/bootstrap/scss/utilities/_api.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACE,oCAAA;EACA,4CAAA;EACA,uOAAA;ADEF;ACCA;EACE,kCAAA;EACA,4CAAA;EACA,uOAAA;ADCF;ACEA;EACE,iCAAA;EACA,4CAAA;EACA,yOAAA;ADAF;ACGA;EACE,sCAAA;EACA,6CAAA;EACA,2OAAA;ADDF;ACIA;EACE,qCAAA;EACA,6CAAA;EACA,2OAAA;ADFF;ACKA;EACE,mCAAA;EACA,6CAAA;EACA,2OAAA;ADHF;ACMA;EACE,oCAAA;EACA,6CAAA;EACA,2OAAA;ADJF;ACOA;EACE,uCAAA;EACA,6CAAA;EACA,2OAAA;ADLF;ACQA;EACE,kCAAA;EACA,6CAAA;EACA,2OAAA;ADNF;ACSA;EACE,oCAAA;EACA,6CAAA;EACA,2OAAA;ADPF;AElDA;;;;EAAA;ACGA;EACE,0DAAA;EACA,iCAAA;AHsDF;;AGnDA;;;;;;;;;EASE,kCAAA;EACA,mCAAA;EACA,wCAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,oBAAA;AHsDF;;AGnDA;;;;;EAKE,kCAAA;AHsDF;;AGnDA;;EAEE,oCAAA;AHsDF;;AIrFE;EACE,cAAA;AJwFJ;;AIzFE;EACE,cAAA;AJ4FJ;;AI7FE;EACE,cAAA;AJgGJ;;AIjGE;EACE,cAAA;AJoGJ;;AIrGE;EACE,cAAA;AJwGJ;;AIzGE;EACE,cAAA;AJ4GJ;;AI7GE;EACE,cAAA;AJgHJ;;AIjHE;EACE,cAAA;AJoHJ;;AIrHE;EACE,cAAA;AJwHJ;;AIzHE;EACE,eAAA;AJ4HJ;;AItHE;ECIA,kBAAA;EACA,kBAAA;EACA,uBAAA;ALsHF;;AI5HE;ECIA,iBAAA;EACA,2BAAA;EACA,uBAAA;AL4HF;;AIlIE;ECIA,kBAAA;EACA,2BAAA;EACA,8BAAA;ALkIF;;AIxIE;ECIA,iBAAA;EACA,mBAAA;EACA,wBAAA;ALwIF;;AI9IE;ECIA,gBAAA;EACA,2BAAA;EACA,wBAAA;AL8IF;;AIpJE;ECIA,cAAA;EACA,sBAAA;EACA,yBAAA;ALoJF;;AMnKA;EACE,kBAAA;EACA,aCIwB;APkK1B;;AQxKA;EACE,qBAAA;EACA,uCAAA;EACA,eAAA;AR2KF;AQzKE;EAAO,kBAAA;AR4KT;;AQzKA;EACE,wCAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,oBAAA;AR4KF;;ASzLA;EACE,0CAAA;EACA,6CAAA;EACA,2CAAA;EACA,4CAAA;EACA,sDAAA;AT4LF;;ASzLA;EACE,WAAA;EACA,0CAAA;AT4LF;;ASzLA;EACE,YAAA;EACA,yCAAA;AT4LF;;AU3MA;EACE,uBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,kEAAA;AV8MF;;AU3MA;EACE,yBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,wFAAA;AV8MF;;AU3MA;EACE,uBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,mFAAA;AV8MF;;AU3MA;EACE,4BAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,mFAAA;AV8MF;;AU3MA;EACE,uBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,kEAAA;AV8MF;;AU3MA;EACE,wBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,6DAAA;AV8MF;;AU3MA;EACE,uBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,6DAAA;AV8MF;;AU3MA;EACE,iCAAA;AV8MF;;AU3MA;;EAEE,uBAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,+DAAA;AV8MF;;AUxMA;EACE;;;;;;;;;IASE,qBAAA;IACA,uBAAA;IACA,4BAAA;IACA,oBAAA;IACA,uBAAA;EV2MF;AACF;AUxMA;EACE;IAAU,mBAAA;EV2MV;EU1MA;IAAM,4CAAA;EV6MN;AACF;AU3MA;EACE;IAAO,oCAAA;EV8MP;EU7MA;IAAO,wGAAA;EVgNP;EU/MA;IAAO,oIAAA;EVkNP;EUjNA;IAAO,wGAAA;EVoNP;EUnNA;IAAO,qEAAA;EVsNP;EUrNA;IAAO,oCAAA;EVwNP;EUvNA;IAAO,oCAAA;EV0NP;AACF;AUxNA;EACE;IAAM,oCAAA;EV2NN;AACF;AUzNA;EACE;IACE,yCAAA;IACA,mBAAA;EV2NF;EUzNA;IACE,UAAA;IACA,kDAAA;EV2NF;AACF;AUxNA;EACE;IACE,iHAAA;EV0NF;AACF;AUvNA;EACE;IAAK,yBAAA;EV0NL;EUzNA;IAAK,wBAAA;EV4NL;EU3NA;IAAU,yBAAA;EV8NV;EU7NA;IAAW,wBAAA;EVgOX;EU/NA;IAAM,yBAAA;EVkON;EUjOA;IAAM,wBAAA;EVoON;EUnOA;IAAM,yBAAA;EVsON;EUrOA;IAAM,wBAAA;EVwON;EUvOA;IAAY,uBAAA;EV0OZ;AACF;AUxOA;EACE;IAAK,uBAAA;EV2OL;EU1OA;IAAO,yBAAA;EV6OP;AACF;AWjYA;EACE,wBAAA;AXmYF;;AWhYA;EACE,yBAAA;AXmYF;;AWhYA;EACE,yBAAA;AXmYF;;AWhYA;EACE,uBAAA;AXmYF;;AWhYA;EACE,uBAAA;AXmYF;;AWhYA;;EAEE,wBAAA;AXmYF;;AWhYA;EACE,4CAAA;AXmYF;;AY7ZA;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBLmCwB;EKlCxB,YLmCwB;AP6X1B;;AY7ZA;;EAEE,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,sCAAA;AZgaF;;AY7ZA;EACE,oBAAA;AZgaF;;AY7ZA;EACE,cAAA;AZgaF;;AY7ZA;EACE,8BAAA;AZgaF;;Aa3bA;gEAAA;AAIE;EAAsC,eAAA;Ab6bxC;;Aa7bE;EAAsC,eAAA;AbicxC;;AajcE;EAAsC,eAAA;AbqcxC;;AarcE;EAAsC,eAAA;AbycxC;;AazcE;EAAsC,eAAA;Ab6cxC;;Aa7cE;EAAsC,eAAA;AbidxC;;AajdE;EAAsC,eAAA;AbqdxC;;AardE;EAAsC,eAAA;AbydxC;;AazdE;EAAsC,eAAA;Ab6dxC;;Aa7dE;EAAsC,eAAA;AbiexC;;AajeE;EAAsC,gBAAA;AbqexC;;AareE;EAAsC,gBAAA;AbyexC;;AazeE;EAAsC,gBAAA;Ab6exC;;Aa7eE;EAAsC,gBAAA;AbifxC;;AajfE;EAAsC,aAAA;AbqfxC;;AarfE;EAAsC,gBAAA;AbyfxC;;AazfE;EAAsC,gBAAA;Ab6fxC;;Aa7fE;EAAsC,gBAAA;AbigBxC;;AajgBE;EAAsC,gBAAA;AbqgBxC;;AargBE;EAAsC,gBAAA;AbygBxC;;AazgBE;EAAsC,gBAAA;Ab6gBxC;;Aa7gBE;EAAsC,gBAAA;AbihBxC;;AajhBE;EAAsC,gBAAA;AbqhBxC;;AarhBE;EAAsC,gBAAA;AbyhBxC;;AazhBE;EAAsC,gBAAA;Ab6hBxC;;Aa7hBE;EAAsC,gBAAA;AbiiBxC;;AajiBE;EAAsC,gBAAA;AbqiBxC;;AariBE;EAAsC,gBAAA;AbyiBxC;;AaziBE;EAAsC,gBAAA;Ab6iBxC;;Aa7iBE;EAAsC,gBAAA;AbijBxC;;AajjBE;EAAsC,gBAAA;AbqjBxC;;AarjBE;EAAsC,gBAAA;AbyjBxC;;AazjBE;EAAsC,gBAAA;Ab6jBxC;;Aa7jBE;EAAsC,gBAAA;AbikBxC;;AajkBE;EAAsC,gBAAA;AbqkBxC;;AarkBE;EAAsC,gBAAA;AbykBxC;;AazkBE;EAAsC,gBAAA;Ab6kBxC;;Aa7kBE;EAAsC,gBAAA;AbilBxC;;AajlBE;EAAsC,gBAAA;AbqlBxC;;AarlBE;EAAsC,gBAAA;AbylBxC;;AazlBE;EAAsC,gBAAA;Ab6lBxC;;Aa7lBE;EAAsC,gBAAA;AbimBxC;;AajmBE;EAAsC,gBAAA;AbqmBxC;;AarmBE;EAAsC,gBAAA;AbymBxC;;AazmBE;EAAsC,gBAAA;Ab6mBxC;;Aa7mBE;EAAsC,gBAAA;AbinBxC;;AajnBE;EAAsC,gBAAA;AbqnBxC;;AarnBE;EAAsC,gBAAA;AbynBxC;;AaznBE;EAAsC,gBAAA;Ab6nBxC;;Aa7nBE;EAAsC,gBAAA;AbioBxC;;AajoBE;EAAsC,gBAAA;AbqoBxC;;AaroBE;EAAsC,gBAAA;AbyoBxC;;AazoBE;EAAsC,gBAAA;Ab6oBxC;;Aa7oBE;EAAsC,gBAAA;AbipBxC;;AajpBE;EAAsC,gBAAA;AbqpBxC;;AarpBE;EAAsC,gBAAA;AbypBxC;;AazpBE;EAAsC,gBAAA;Ab6pBxC;;Aa7pBE;EAAsC,gBAAA;AbiqBxC;;AajqBE;EAAsC,gBAAA;AbqqBxC;;AarqBE;EAAsC,gBAAA;AbyqBxC;;AazqBE;EAAsC,gBAAA;Ab6qBxC;;Aa7qBE;EAAsC,gBAAA;AbirBxC;;AajrBE;EAAsC,gBAAA;AbqrBxC;;AarrBE;EAAsC,gBAAA;AbyrBxC;;AazrBE;EAAsC,gBAAA;Ab6rBxC;;Aa7rBE;EAAsC,gBAAA;AbisBxC;;AajsBE;EAAsC,gBAAA;AbqsBxC;;AarsBE;EAAsC,gBAAA;AbysBxC;;AazsBE;EAAsC,gBAAA;Ab6sBxC;;Aa7sBE;EAAsC,gBAAA;AbitBxC;;AajtBE;EAAsC,gBAAA;AbqtBxC;;AartBE;EAAsC,gBAAA;AbytBxC;;AaztBE;EAAsC,gBAAA;Ab6tBxC;;Aa7tBE;EAAsC,gBAAA;AbiuBxC;;AajuBE;EAAsC,gBAAA;AbquBxC;;AaruBE;EAAsC,gBAAA;AbyuBxC;;AazuBE;EAAsC,gBAAA;Ab6uBxC;;Aa7uBE;EAAsC,gBAAA;AbivBxC;;AajvBE;EAAsC,gBAAA;AbqvBxC;;AarvBE;EAAsC,gBAAA;AbyvBxC;;AazvBE;EAAsC,gBAAA;Ab6vBxC;;Aa7vBE;EAAsC,gBAAA;AbiwBxC;;AajwBE;EAAsC,gBAAA;AbqwBxC;;AarwBE;EAAsC,gBAAA;AbywBxC;;AazwBE;EAAsC,gBAAA;Ab6wBxC;;Aa7wBE;EAAsC,gBAAA;AbixBxC;;AajxBE;EAAsC,gBAAA;AbqxBxC;;AarxBE;EAAsC,gBAAA;AbyxBxC;;AazxBE;EAAsC,gBAAA;Ab6xBxC;;Aa7xBE;EAAsC,gBAAA;AbiyBxC;;AajyBE;EAAsC,gBAAA;AbqyBxC;;AaryBE;EAAsC,gBAAA;AbyyBxC;;AazyBE;EAAsC,gBAAA;Ab6yBxC;;Aa7yBE;EAAsC,gBAAA;AbizBxC;;AajzBE;EAAsC,gBAAA;AbqzBxC;;AarzBE;EAAsC,gBAAA;AbyzBxC;;AazzBE;EAAsC,gBAAA;Ab6zBxC;;Aa7zBE;EAAsC,gBAAA;Abi0BxC;;Aaj0BE;EAAsC,gBAAA;Abq0BxC;;Aar0BE;EAAsC,gBAAA;Aby0BxC;;Aaz0BE;EAAsC,gBAAA;Ab60BxC;;Aa70BE;EAAsC,gBAAA;Abi1BxC;;Aaj1BE;EAAsC,gBAAA;Abq1BxC;;Aar1BE;EAAsC,gBAAA;Aby1BxC;;Aaz1BE;EAAsC,gBAAA;Ab61BxC;;Aa71BE;EAAsC,gBAAA;Abi2BxC;;Aaj2BE;EAAsC,YAAA;Abq2BxC;;Aar2BE;EAAsC,gBAAA;Aby2BxC;;Aaz2BE;EAAsC,gBAAA;Ab62BxC;;Aa72BE;EAAsC,gBAAA;Abi3BxC;;Aaj3BE;EAAsC,gBAAA;Abq3BxC;;Aar3BE;EAAsC,gBAAA;Aby3BxC;;Aaz3BE;EAAsC,gBAAA;Ab63BxC;;Aa73BE;EAAsC,gBAAA;Abi4BxC;;Aaj4BE;EAAsC,gBAAA;Abq4BxC;;Aar4BE;EAAsC,gBAAA;Aby4BxC;;Aaz4BE;EAAsC,gBAAA;Ab64BxC;;Aa74BE;EAAsC,gBAAA;Abi5BxC;;Aaj5BE;EAAsC,gBAAA;Abq5BxC;;Aar5BE;EAAsC,gBAAA;Aby5BxC;;Aaz5BE;EAAsC,gBAAA;Ab65BxC;;Aa75BE;EAAsC,gBAAA;Abi6BxC;;Aaj6BE;EAAsC,gBAAA;Abq6BxC;;Aar6BE;EAAsC,gBAAA;Aby6BxC;;Aaz6BE;EAAsC,gBAAA;Ab66BxC;;Aa76BE;EAAsC,gBAAA;Abi7BxC;;Aaj7BE;EAAsC,gBAAA;Abq7BxC;;Aar7BE;EAAsC,gBAAA;Aby7BxC;;Aaz7BE;EAAsC,gBAAA;Ab67BxC;;Aa77BE;EAAsC,gBAAA;Abi8BxC;;Aaj8BE;EAAsC,gBAAA;Abq8BxC;;Aar8BE;EAAsC,gBAAA;Aby8BxC;;Aaz8BE;EAAsC,gBAAA;Ab68BxC;;Aa78BE;EAAsC,gBAAA;Abi9BxC;;Aaj9BE;EAAsC,gBAAA;Abq9BxC;;Aar9BE;EAAsC,gBAAA;Aby9BxC;;Aaz9BE;EAAsC,gBAAA;Ab69BxC;;Aa79BE;EAAsC,gBAAA;Abi+BxC;;Aaj+BE;EAAsC,gBAAA;Abq+BxC;;Aar+BE;EAAsC,gBAAA;Aby+BxC;;Aaz+BE;EAAsC,gBAAA;Ab6+BxC;;Aa7+BE;EAAsC,YAAA;Abi/BxC;;Aaj/BE;EAAsC,gBAAA;Abq/BxC;;Aar/BE;EAAsC,gBAAA;Aby/BxC;;Aaz/BE;EAAsC,gBAAA;Ab6/BxC;;Aa7/BE;EAAsC,gBAAA;AbigCxC;;AajgCE;EAAsC,gBAAA;AbqgCxC;;AargCE;EAAsC,gBAAA;AbygCxC;;AazgCE;EAAsC,gBAAA;Ab6gCxC;;Aa7gCE;EAAsC,gBAAA;AbihCxC;;AajhCE;EAAsC,gBAAA;AbqhCxC;;AarhCE;EAAsC,gBAAA;AbyhCxC;;AazhCE;EAAsC,gBAAA;Ab6hCxC;;Aa7hCE;EAAsC,gBAAA;AbiiCxC;;AajiCE;EAAsC,gBAAA;AbqiCxC;;AariCE;EAAsC,gBAAA;AbyiCxC;;AaziCE;EAAsC,gBAAA;Ab6iCxC;;Aa7iCE;EAAsC,gBAAA;AbijCxC;;AajjCE;EAAsC,gBAAA;AbqjCxC;;AarjCE;EAAsC,gBAAA;AbyjCxC;;AazjCE;EAAsC,gBAAA;Ab6jCxC;;Aa7jCE;EAAsC,gBAAA;AbikCxC;;AajkCE;EAAsC,gBAAA;AbqkCxC;;AarkCE;EAAsC,gBAAA;AbykCxC;;AazkCE;EAAsC,gBAAA;Ab6kCxC;;Aa7kCE;EAAsC,gBAAA;AbilCxC;;AajlCE;EAAsC,gBAAA;AbqlCxC;;AarlCE;EAAsC,gBAAA;AbylCxC;;AazlCE;EAAsC,gBAAA;Ab6lCxC;;Aa7lCE;EAAsC,gBAAA;AbimCxC;;AajmCE;EAAsC,gBAAA;AbqmCxC;;AarmCE;EAAsC,gBAAA;AbymCxC;;AazmCE;EAAsC,gBAAA;Ab6mCxC;;Aa7mCE;EAAsC,gBAAA;AbinCxC;;AajnCE;EAAsC,gBAAA;AbqnCxC;;AarnCE;EAAsC,gBAAA;AbynCxC;;AaznCE;EAAsC,gBAAA;Ab6nCxC;;Aa7nCE;EAAsC,gBAAA;AbioCxC;;AajoCE;EAAsC,gBAAA;AbqoCxC;;AaroCE;EAAsC,gBAAA;AbyoCxC;;AazoCE;EAAsC,gBAAA;Ab6oCxC;;Aa7oCE;EAAsC,gBAAA;AbipCxC;;AajpCE;EAAsC,gBAAA;AbqpCxC;;AarpCE;EAAsC,gBAAA;AbypCxC;;AazpCE;EAAsC,gBAAA;Ab6pCxC;;Aa7pCE;EAAsC,gBAAA;AbiqCxC;;AajqCE;EAAsC,gBAAA;AbqqCxC;;AarqCE;EAAsC,gBAAA;AbyqCxC;;AazqCE;EAAsC,gBAAA;Ab6qCxC;;Aa7qCE;EAAsC,gBAAA;AbirCxC;;AajrCE;EAAsC,gBAAA;AbqrCxC;;AarrCE;EAAsC,gBAAA;AbyrCxC;;AazrCE;EAAsC,gBAAA;Ab6rCxC;;Aa7rCE;EAAsC,gBAAA;AbisCxC;;AajsCE;EAAsC,gBAAA;AbqsCxC;;AarsCE;EAAsC,gBAAA;AbysCxC;;AazsCE;EAAsC,gBAAA;Ab6sCxC;;Aa7sCE;EAAsC,gBAAA;AbitCxC;;AajtCE;EAAsC,gBAAA;AbqtCxC;;AartCE;EAAsC,gBAAA;AbytCxC;;AaztCE;EAAsC,gBAAA;Ab6tCxC;;Aa7tCE;EAAsC,gBAAA;AbiuCxC;;AajuCE;EAAsC,gBAAA;AbquCxC;;AaruCE;EAAsC,gBAAA;AbyuCxC;;AazuCE;EAAsC,gBAAA;Ab6uCxC;;Aa7uCE;EAAsC,gBAAA;AbivCxC;;AajvCE;EAAsC,gBAAA;AbqvCxC;;AarvCE;EAAsC,gBAAA;AbyvCxC;;AazvCE;EAAsC,gBAAA;Ab6vCxC;;Aa7vCE;EAAsC,gBAAA;AbiwCxC;;AajwCE;EAAsC,gBAAA;AbqwCxC;;AarwCE;EAAsC,gBAAA;AbywCxC;;AazwCE;EAAsC,gBAAA;Ab6wCxC;;Aa7wCE;EAAsC,gBAAA;AbixCxC;;AajxCE;EAAsC,gBAAA;AbqxCxC;;AarxCE;EAAsC,gBAAA;AbyxCxC;;AazxCE;EAAsC,gBAAA;Ab6xCxC;;Aa7xCE;EAAsC,gBAAA;AbiyCxC;;AajyCE;EAAsC,gBAAA;AbqyCxC;;AaryCE;EAAsC,gBAAA;AbyyCxC;;AazyCE;EAAsC,gBAAA;Ab6yCxC;;Aa7yCE;EAAsC,gBAAA;AbizCxC;;AajzCE;EAAsC,gBAAA;AbqzCxC;;AarzCE;EAAsC,gBAAA;AbyzCxC;;AazzCE;EAAsC,gBAAA;Ab6zCxC;;Aa7zCE;EAAsC,gBAAA;Abi0CxC;;Aaj0CE;EAAsC,gBAAA;Abq0CxC;;Aar0CE;EAAsC,gBAAA;Aby0CxC;;Aaz0CE;EAAsC,gBAAA;Ab60CxC;;Aa70CE;EAAsC,gBAAA;Abi1CxC;;Aaj1CE;EAAsC,gBAAA;Abq1CxC;;Aar1CE;EAAsC,gBAAA;Aby1CxC;;Aaz1CE;EAAsC,gBAAA;Ab61CxC;;Aa71CE;EAAsC,gBAAA;Abi2CxC;;Aaj2CE;EAAsC,gBAAA;Abq2CxC;;Aar2CE;EAAsC,gBAAA;Aby2CxC;;Aaz2CE;EAAsC,gBAAA;Ab62CxC;;Aa72CE;EAAsC,gBAAA;Abi3CxC;;Aaj3CE;EAAsC,gBAAA;Abq3CxC;;Aar3CE;EAAsC,gBAAA;Aby3CxC;;Aaz3CE;EAAsC,gBAAA;Ab63CxC;;Aa73CE;EAAsC,aAAA;Abi4CxC;;Aaj4CE;EAAsC,gBAAA;Abq4CxC;;Aar4CE;EAAsC,gBAAA;Aby4CxC;;Aaz4CE;EAAsC,gBAAA;Ab64CxC;;Aa74CE;EAAsC,gBAAA;Abi5CxC;;Aaj5CE;EAAsC,gBAAA;Abq5CxC;;Aar5CE;EAAsC,gBAAA;Aby5CxC;;Aaz5CE;EAAsC,gBAAA;Ab65CxC;;Aa75CE;EAAsC,gBAAA;Abi6CxC;;Aaj6CE;EAAsC,gBAAA;Abq6CxC;;Aar6CE;EAAsC,gBAAA;Aby6CxC;;Aaz6CE;EAAsC,gBAAA;Ab66CxC;;Aa76CE;EAAsC,gBAAA;Abi7CxC;;Aaj7CE;EAAsC,gBAAA;Abq7CxC;;Aar7CE;EAAsC,gBAAA;Aby7CxC;;Aaz7CE;EAAsC,gBAAA;Ab67CxC;;Aa77CE;EAAsC,gBAAA;Abi8CxC;;Aaj8CE;EAAsC,gBAAA;Abq8CxC;;Aar8CE;EAAsC,gBAAA;Aby8CxC;;Aaz8CE;EAAsC,gBAAA;Ab68CxC;;Aa78CE;EAAsC,gBAAA;Abi9CxC;;Aaj9CE;EAAsC,gBAAA;Abq9CxC;;Aar9CE;EAAsC,gBAAA;Aby9CxC;;Aaz9CE;EAAsC,gBAAA;Ab69CxC;;Aa79CE;EAAsC,gBAAA;Abi+CxC;;Aaj+CE;EAAsC,gBAAA;Abq+CxC;;Aar+CE;EAAsC,gBAAA;Aby+CxC;;Aaz+CE;EAAsC,gBAAA;Ab6+CxC;;Aa7+CE;EAAsC,gBAAA;Abi/CxC;;Aaj/CE;EAAsC,gBAAA;Abq/CxC;;Aar/CE;EAAsC,gBAAA;Aby/CxC;;Aaz/CE;EAAsC,gBAAA;Ab6/CxC;;Aa7/CE;EAAsC,gBAAA;AbigDxC;;AajgDE;EAAsC,gBAAA;AbqgDxC;;AargDE;EAAsC,gBAAA;AbygDxC;;AazgDE;EAAsC,gBAAA;Ab6gDxC;;Aa7gDE;EAAsC,gBAAA;AbihDxC;;AajhDE;EAAsC,gBAAA;AbqhDxC;;AarhDE;EAAsC,gBAAA;AbyhDxC;;AazhDE;EAAsC,gBAAA;Ab6hDxC;;Aa7hDE;EAAsC,gBAAA;AbiiDxC;;AajiDE;EAAsC,gBAAA;AbqiDxC;;AariDE;EAAsC,gBAAA;AbyiDxC;;AaziDE;EAAsC,gBAAA;Ab6iDxC;;Aa7iDE;EAAsC,gBAAA;AbijDxC;;AajjDE;EAAsC,gBAAA;AbqjDxC;;AarjDE;EAAsC,gBAAA;AbyjDxC;;AazjDE;EAAsC,gBAAA;Ab6jDxC;;Aa7jDE;EAAsC,gBAAA;AbikDxC;;AajkDE;EAAsC,gBAAA;AbqkDxC;;AarkDE;EAAsC,gBAAA;AbykDxC;;AazkDE;EAAsC,gBAAA;Ab6kDxC;;Aa7kDE;EAAsC,gBAAA;AbilDxC;;AajlDE;EAAsC,gBAAA;AbqlDxC;;AarlDE;EAAsC,gBAAA;AbylDxC;;AazlDE;EAAsC,gBAAA;Ab6lDxC;;Aa7lDE;EAAsC,gBAAA;AbimDxC;;AajmDE;EAAsC,gBAAA;AbqmDxC;;AarmDE;EAAsC,gBAAA;AbymDxC;;AazmDE;EAAsC,gBAAA;Ab6mDxC;;Aa7mDE;EAAsC,gBAAA;AbinDxC;;AajnDE;EAAsC,gBAAA;AbqnDxC;;AarnDE;EAAsC,gBAAA;AbynDxC;;AaznDE;EAAsC,gBAAA;Ab6nDxC;;Aa7nDE;EAAsC,gBAAA;AbioDxC;;AajoDE;EAAsC,gBAAA;AbqoDxC;;AaroDE;EAAsC,gBAAA;AbyoDxC;;AazoDE;EAAsC,gBAAA;Ab6oDxC;;Aa7oDE;EAAsC,gBAAA;AbipDxC;;AajpDE;EAAsC,gBAAA;AbqpDxC;;AarpDE;EAAsC,gBAAA;AbypDxC;;AazpDE;EAAsC,gBAAA;Ab6pDxC;;Aa7pDE;EAAsC,gBAAA;AbiqDxC;;AajqDE;EAAsC,gBAAA;AbqqDxC;;AarqDE;EAAsC,gBAAA;AbyqDxC;;AazqDE;EAAsC,gBAAA;Ab6qDxC;;Aa7qDE;EAAsC,gBAAA;AbirDxC;;AajrDE;EAAsC,gBAAA;AbqrDxC;;AarrDE;EAAsC,gBAAA;AbyrDxC;;AazrDE;EAAsC,gBAAA;Ab6rDxC;;Aa7rDE;EAAsC,gBAAA;AbisDxC;;AajsDE;EAAsC,gBAAA;AbqsDxC;;AarsDE;EAAsC,gBAAA;AbysDxC;;AazsDE;EAAsC,gBAAA;Ab6sDxC;;Aa7sDE;EAAsC,gBAAA;AbitDxC;;AajtDE;EAAsC,YAAA;AbqtDxC;;AartDE;EAAsC,gBAAA;AbytDxC;;AaztDE;EAAsC,gBAAA;Ab6tDxC;;Aa7tDE;EAAsC,gBAAA;AbiuDxC;;AajuDE;EAAsC,gBAAA;AbquDxC;;AaruDE;EAAsC,gBAAA;AbyuDxC;;AazuDE;EAAsC,gBAAA;Ab6uDxC;;Aa7uDE;EAAsC,YAAA;AbivDxC;;AajvDE;EAAsC,gBAAA;AbqvDxC;;AarvDE;EAAsC,gBAAA;AbyvDxC;;AazvDE;EAAsC,gBAAA;Ab6vDxC;;Aa7vDE;EAAsC,gBAAA;AbiwDxC;;AajwDE;EAAsC,gBAAA;AbqwDxC;;AarwDE;EAAsC,gBAAA;AbywDxC;;AazwDE;EAAsC,gBAAA;Ab6wDxC;;Aa7wDE;EAAsC,gBAAA;AbixDxC;;AajxDE;EAAsC,gBAAA;AbqxDxC;;AarxDE;EAAsC,gBAAA;AbyxDxC;;AazxDE;EAAsC,gBAAA;Ab6xDxC;;Aa7xDE;EAAsC,gBAAA;AbiyDxC;;AajyDE;EAAsC,gBAAA;AbqyDxC;;AaryDE;EAAsC,gBAAA;AbyyDxC;;AazyDE;EAAsC,gBAAA;Ab6yDxC;;Aa7yDE;EAAsC,gBAAA;AbizDxC;;AajzDE;EAAsC,gBAAA;AbqzDxC;;AarzDE;EAAsC,gBAAA;AbyzDxC;;AazzDE;EAAsC,YAAA;Ab6zDxC;;Aa7zDE;EAAsC,YAAA;Abi0DxC;;Aaj0DE;EAAsC,gBAAA;Abq0DxC;;Aar0DE;EAAsC,gBAAA;Aby0DxC;;Aaz0DE;EAAsC,gBAAA;Ab60DxC;;Aa70DE;EAAsC,gBAAA;Abi1DxC;;Aaj1DE;EAAsC,gBAAA;Abq1DxC;;Aar1DE;EAAsC,gBAAA;Aby1DxC;;Aaz1DE;EAAsC,gBAAA;Ab61DxC;;Aa71DE;EAAsC,gBAAA;Abi2DxC;;Aaj2DE;EAAsC,gBAAA;Abq2DxC;;Aar2DE;EAAsC,gBAAA;Aby2DxC;;Aaz2DE;EAAsC,gBAAA;Ab62DxC;;Aa72DE;EAAsC,gBAAA;Abi3DxC;;Aaj3DE;EAAsC,gBAAA;Abq3DxC;;Aar3DE;EAAsC,gBAAA;Aby3DxC;;Aaz3DE;EAAsC,gBAAA;Ab63DxC;;Aa73DE;EAAsC,gBAAA;Abi4DxC;;Aaj4DE;EAAsC,gBAAA;Abq4DxC;;Aar4DE;EAAsC,gBAAA;Aby4DxC;;Aaz4DE;EAAsC,gBAAA;Ab64DxC;;Aa74DE;EAAsC,gBAAA;Abi5DxC;;Aaj5DE;EAAsC,gBAAA;Abq5DxC;;Aar5DE;EAAsC,gBAAA;Aby5DxC;;Aaz5DE;EAAsC,gBAAA;Ab65DxC;;Aa75DE;EAAsC,gBAAA;Abi6DxC;;Aaj6DE;EAAsC,gBAAA;Abq6DxC;;Aar6DE;EAAsC,gBAAA;Aby6DxC;;Aaz6DE;EAAsC,gBAAA;Ab66DxC;;Aa76DE;EAAsC,gBAAA;Abi7DxC;;Aaj7DE;EAAsC,gBAAA;Abq7DxC;;Aar7DE;EAAsC,gBAAA;Aby7DxC;;Aaz7DE;EAAsC,gBAAA;Ab67DxC;;Aa77DE;EAAsC,gBAAA;Abi8DxC;;Aaj8DE;EAAsC,gBAAA;Abq8DxC;;Aar8DE;EAAsC,gBAAA;Aby8DxC;;Aaz8DE;EAAsC,gBAAA;Ab68DxC;;Aa78DE;EAAsC,YAAA;Abi9DxC;;Aaj9DE;EAAsC,gBAAA;Abq9DxC;;Aar9DE;EAAsC,gBAAA;Aby9DxC;;Aaz9DE;EAAsC,gBAAA;Ab69DxC;;Aa79DE;EAAsC,gBAAA;Abi+DxC;;Aaj+DE;EAAsC,gBAAA;Abq+DxC;;Aar+DE;EAAsC,gBAAA;Aby+DxC;;Aaz+DE;EAAsC,gBAAA;Ab6+DxC;;Aa7+DE;EAAsC,gBAAA;Abi/DxC;;Aaj/DE;EAAsC,gBAAA;Abq/DxC;;Aar/DE;EAAsC,gBAAA;Aby/DxC;;Aaz/DE;EAAsC,gBAAA;Ab6/DxC;;Aa7/DE;EAAsC,gBAAA;AbigExC;;AajgEE;EAAsC,gBAAA;AbqgExC;;AargEE;EAAsC,gBAAA;AbygExC;;AazgEE;EAAsC,gBAAA;Ab6gExC;;Aa7gEE;EAAsC,gBAAA;AbihExC;;AajhEE;EAAsC,gBAAA;AbqhExC;;AarhEE;EAAsC,gBAAA;AbyhExC;;AazhEE;EAAsC,gBAAA;Ab6hExC;;Aa7hEE;EAAsC,YAAA;AbiiExC;;AajiEE;EAAsC,gBAAA;AbqiExC;;AariEE;EAAsC,gBAAA;AbyiExC;;AaziEE;EAAsC,gBAAA;Ab6iExC;;Aa7iEE;EAAsC,gBAAA;AbijExC;;AajjEE;EAAsC,gBAAA;AbqjExC;;AarjEE;EAAsC,gBAAA;AbyjExC;;AazjEE;EAAsC,gBAAA;Ab6jExC;;Aa7jEE;EAAsC,gBAAA;AbikExC;;AajkEE;EAAsC,gBAAA;AbqkExC;;AarkEE;EAAsC,gBAAA;AbykExC;;AazkEE;EAAsC,gBAAA;Ab6kExC;;Aa7kEE;EAAsC,gBAAA;AbilExC;;AajlEE;EAAsC,gBAAA;AbqlExC;;AarlEE;EAAsC,gBAAA;AbylExC;;AazlEE;EAAsC,gBAAA;Ab6lExC;;Aa7lEE;EAAsC,gBAAA;AbimExC;;AajmEE;EAAsC,gBAAA;AbqmExC;;AarmEE;EAAsC,gBAAA;AbymExC;;AazmEE;EAAsC,gBAAA;Ab6mExC;;Aa7mEE;EAAsC,gBAAA;AbinExC;;AajnEE;EAAsC,gBAAA;AbqnExC;;AarnEE;EAAsC,gBAAA;AbynExC;;AaznEE;EAAsC,gBAAA;Ab6nExC;;Aa7nEE;EAAsC,gBAAA;AbioExC;;AajoEE;EAAsC,gBAAA;AbqoExC;;AaroEE;EAAsC,gBAAA;AbyoExC;;AazoEE;EAAsC,gBAAA;Ab6oExC;;Aa7oEE;EAAsC,gBAAA;AbipExC;;AajpEE;EAAsC,gBAAA;AbqpExC;;AarpEE;EAAsC,gBAAA;AbypExC;;AazpEE;EAAsC,gBAAA;Ab6pExC;;Aa7pEE;EAAsC,gBAAA;AbiqExC;;AajqEE;EAAsC,gBAAA;AbqqExC;;AarqEE;EAAsC,gBAAA;AbyqExC;;AazqEE;EAAsC,gBAAA;Ab6qExC;;Aa7qEE;EAAsC,gBAAA;AbirExC;;AajrEE;EAAsC,gBAAA;AbqrExC;;AarrEE;EAAsC,gBAAA;AbyrExC;;AazrEE;EAAsC,gBAAA;Ab6rExC;;Aa7rEE;EAAsC,gBAAA;AbisExC;;AajsEE;EAAsC,gBAAA;AbqsExC;;AarsEE;EAAsC,gBAAA;AbysExC;;AazsEE;EAAsC,gBAAA;Ab6sExC;;Aa7sEE;EAAsC,gBAAA;AbitExC;;AajtEE;EAAsC,gBAAA;AbqtExC;;AartEE;EAAsC,gBAAA;AbytExC;;AaztEE;EAAsC,gBAAA;Ab6tExC;;Aa7tEE;EAAsC,gBAAA;AbiuExC;;AajuEE;EAAsC,gBAAA;AbquExC;;AaruEE;EAAsC,gBAAA;AbyuExC;;AazuEE;EAAsC,gBAAA;Ab6uExC;;Aa7uEE;EAAsC,gBAAA;AbivExC;;AajvEE;EAAsC,gBAAA;AbqvExC;;AarvEE;EAAsC,gBAAA;AbyvExC;;AazvEE;EAAsC,gBAAA;Ab6vExC;;Aa7vEE;EAAsC,gBAAA;AbiwExC;;AajwEE;EAAsC,gBAAA;AbqwExC;;AarwEE;EAAsC,gBAAA;AbywExC;;AazwEE;EAAsC,gBAAA;Ab6wExC;;Aa7wEE;EAAsC,gBAAA;AbixExC;;AajxEE;EAAsC,gBAAA;AbqxExC;;AarxEE;EAAsC,gBAAA;AbyxExC;;AazxEE;EAAsC,gBAAA;Ab6xExC;;Aa7xEE;EAAsC,gBAAA;AbiyExC;;AajyEE;EAAsC,gBAAA;AbqyExC;;AaryEE;EAAsC,gBAAA;AbyyExC;;AazyEE;EAAsC,gBAAA;Ab6yExC;;Aa7yEE;EAAsC,gBAAA;AbizExC;;AajzEE;EAAsC,gBAAA;AbqzExC;;AarzEE;EAAsC,gBAAA;AbyzExC;;AazzEE;EAAsC,gBAAA;Ab6zExC;;Aa7zEE;EAAsC,gBAAA;Abi0ExC;;Aaj0EE;EAAsC,gBAAA;Abq0ExC;;Aar0EE;EAAsC,gBAAA;Aby0ExC;;Aaz0EE;EAAsC,gBAAA;Ab60ExC;;Aa70EE;EAAsC,gBAAA;Abi1ExC;;Aaj1EE;EAAsC,gBAAA;Abq1ExC;;Aar1EE;EAAsC,gBAAA;Aby1ExC;;Aaz1EE;EAAsC,gBAAA;Ab61ExC;;Aa71EE;EAAsC,gBAAA;Abi2ExC;;Aaj2EE;EAAsC,gBAAA;Abq2ExC;;Aar2EE;EAAsC,YAAA;Aby2ExC;;Aaz2EE;EAAsC,gBAAA;Ab62ExC;;Aa72EE;EAAsC,gBAAA;Abi3ExC;;Aaj3EE;EAAsC,gBAAA;Abq3ExC;;Aar3EE;EAAsC,gBAAA;Aby3ExC;;Aaz3EE;EAAsC,gBAAA;Ab63ExC;;Aa73EE;EAAsC,gBAAA;Abi4ExC;;Aaj4EE;EAAsC,gBAAA;Abq4ExC;;Aar4EE;EAAsC,gBAAA;Aby4ExC;;Aaz4EE;EAAsC,gBAAA;Ab64ExC;;Aa74EE;EAAsC,gBAAA;Abi5ExC;;Aaj5EE;EAAsC,gBAAA;Abq5ExC;;Aar5EE;EAAsC,gBAAA;Aby5ExC;;Aaz5EE;EAAsC,gBAAA;Ab65ExC;;Aa75EE;EAAsC,gBAAA;Abi6ExC;;Aaj6EE;EAAsC,gBAAA;Abq6ExC;;Aar6EE;EAAsC,gBAAA;Aby6ExC;;Aaz6EE;EAAsC,gBAAA;Ab66ExC;;Aa76EE;EAAsC,gBAAA;Abi7ExC;;Aaj7EE;EAAsC,gBAAA;Abq7ExC;;Aar7EE;EAAsC,gBAAA;Aby7ExC;;Aaz7EE;EAAsC,gBAAA;Ab67ExC;;Aa77EE;EAAsC,gBAAA;Abi8ExC;;Aaj8EE;EAAsC,gBAAA;Abq8ExC;;Aar8EE;EAAsC,gBAAA;Aby8ExC;;Aaz8EE;EAAsC,gBAAA;Ab68ExC;;Aa78EE;EAAsC,gBAAA;Abi9ExC;;Aaj9EE;EAAsC,gBAAA;Abq9ExC;;Aar9EE;EAAsC,gBAAA;Aby9ExC;;Aaz9EE;EAAsC,gBAAA;Ab69ExC;;Aa79EE;EAAsC,gBAAA;Abi+ExC;;Aaj+EE;EAAsC,gBAAA;Abq+ExC;;Aar+EE;EAAsC,gBAAA;Aby+ExC;;Aaz+EE;EAAsC,gBAAA;Ab6+ExC;;Aa7+EE;EAAsC,gBAAA;Abi/ExC;;Aaj/EE;EAAsC,gBAAA;Abq/ExC;;Aar/EE;EAAsC,gBAAA;Aby/ExC;;Aaz/EE;EAAsC,gBAAA;Ab6/ExC;;Aa7/EE;EAAsC,gBAAA;AbigFxC;;AajgFE;EAAsC,gBAAA;AbqgFxC;;AargFE;EAAsC,gBAAA;AbygFxC;;AazgFE;EAAsC,gBAAA;Ab6gFxC;;Aa7gFE;EAAsC,gBAAA;AbihFxC;;AajhFE;EAAsC,gBAAA;AbqhFxC;;AarhFE;EAAsC,gBAAA;AbyhFxC;;AazhFE;EAAsC,gBAAA;Ab6hFxC;;Aa7hFE;EAAsC,gBAAA;AbiiFxC;;AajiFE;EAAsC,gBAAA;AbqiFxC;;AariFE;EAAsC,gBAAA;AbyiFxC;;AaziFE;EAAsC,gBAAA;Ab6iFxC;;Aa7iFE;EAAsC,gBAAA;AbijFxC;;AajjFE;EAAsC,gBAAA;AbqjFxC;;AarjFE;EAAsC,gBAAA;AbyjFxC;;AazjFE;EAAsC,gBAAA;Ab6jFxC;;Aa7jFE;EAAsC,gBAAA;AbikFxC;;AajkFE;EAAsC,gBAAA;AbqkFxC;;AarkFE;EAAsC,gBAAA;AbykFxC;;AazkFE;EAAsC,gBAAA;Ab6kFxC;;Aa7kFE;EAAsC,gBAAA;AbilFxC;;AajlFE;EAAsC,gBAAA;AbqlFxC;;AarlFE;EAAsC,gBAAA;AbylFxC;;AazlFE;EAAsC,gBAAA;Ab6lFxC;;Aa7lFE;EAAsC,gBAAA;AbimFxC;;AajmFE;EAAsC,gBAAA;AbqmFxC;;AarmFE;EAAsC,gBAAA;AbymFxC;;AazmFE;EAAsC,gBAAA;Ab6mFxC;;Aa7mFE;EAAsC,gBAAA;AbinFxC;;AajnFE;EAAsC,gBAAA;AbqnFxC;;AarnFE;EAAsC,gBAAA;AbynFxC;;AaznFE;EAAsC,gBAAA;Ab6nFxC;;Aa7nFE;EAAsC,gBAAA;AbioFxC;;AajoFE;EAAsC,gBAAA;AbqoFxC;;AaroFE;EAAsC,gBAAA;AbyoFxC;;AazoFE;EAAsC,gBAAA;Ab6oFxC;;Aa7oFE;EAAsC,gBAAA;AbipFxC;;AajpFE;EAAsC,gBAAA;AbqpFxC;;AarpFE;EAAsC,gBAAA;AbypFxC;;AazpFE;EAAsC,gBAAA;Ab6pFxC;;Aa7pFE;EAAsC,gBAAA;AbiqFxC;;AajqFE;EAAsC,gBAAA;AbqqFxC;;AarqFE;EAAsC,gBAAA;AbyqFxC;;AazqFE;EAAsC,gBAAA;Ab6qFxC;;Aa7qFE;EAAsC,gBAAA;AbirFxC;;AajrFE;EAAsC,gBAAA;AbqrFxC;;AarrFE;EAAsC,gBAAA;AbyrFxC;;AazrFE;EAAsC,gBAAA;Ab6rFxC;;Aa7rFE;EAAsC,gBAAA;AbisFxC;;AajsFE;EAAsC,gBAAA;AbqsFxC;;AarsFE;EAAsC,gBAAA;AbysFxC;;AazsFE;EAAsC,gBAAA;Ab6sFxC;;Aa7sFE;EAAsC,gBAAA;AbitFxC;;AajtFE;EAAsC,gBAAA;AbqtFxC;;AartFE;EAAsC,gBAAA;AbytFxC;;AaztFE;EAAsC,gBAAA;Ab6tFxC;;Aa7tFE;EAAsC,gBAAA;AbiuFxC;;AajuFE;EAAsC,gBAAA;AbquFxC;;AaruFE;EAAsC,gBAAA;AbyuFxC;;AazuFE;EAAsC,gBAAA;Ab6uFxC;;Aa7uFE;EAAsC,gBAAA;AbivFxC;;AajvFE;EAAsC,gBAAA;AbqvFxC;;AarvFE;EAAsC,gBAAA;AbyvFxC;;AazvFE;EAAsC,gBAAA;Ab6vFxC;;Aa7vFE;EAAsC,gBAAA;AbiwFxC;;AajwFE;EAAsC,gBAAA;AbqwFxC;;AarwFE;EAAsC,gBAAA;AbywFxC;;AazwFE;EAAsC,gBAAA;Ab6wFxC;;Aa7wFE;EAAsC,gBAAA;AbixFxC;;AajxFE;EAAsC,gBAAA;AbqxFxC;;AarxFE;EAAsC,gBAAA;AbyxFxC;;AazxFE;EAAsC,gBAAA;Ab6xFxC;;Aa7xFE;EAAsC,gBAAA;AbiyFxC;;AajyFE;EAAsC,gBAAA;AbqyFxC;;AaryFE;EAAsC,gBAAA;AbyyFxC;;AazyFE;EAAsC,gBAAA;Ab6yFxC;;Aa7yFE;EAAsC,gBAAA;AbizFxC;;AajzFE;EAAsC,gBAAA;AbqzFxC;;AarzFE;EAAsC,gBAAA;AbyzFxC;;AazzFE;EAAsC,gBAAA;Ab6zFxC;;Aa7zFE;EAAsC,gBAAA;Abi0FxC;;Aaj0FE;EAAsC,gBAAA;Abq0FxC;;Aar0FE;EAAsC,gBAAA;Aby0FxC;;Aaz0FE;EAAsC,gBAAA;Ab60FxC;;Aa70FE;EAAsC,gBAAA;Abi1FxC;;Aaj1FE;EAAsC,gBAAA;Abq1FxC;;Aar1FE;EAAsC,gBAAA;Aby1FxC;;Aaz1FE;EAAsC,gBAAA;Ab61FxC;;Aa71FE;EAAsC,gBAAA;Abi2FxC;;Aaj2FE;EAAsC,gBAAA;Abq2FxC;;Aar2FE;EAAsC,gBAAA;Aby2FxC;;Aaz2FE;EAAsC,gBAAA;Ab62FxC;;Aa72FE;EAAsC,gBAAA;Abi3FxC;;Aaj3FE;EAAsC,gBAAA;Abq3FxC;;Aar3FE;EAAsC,gBAAA;Aby3FxC;;Aaz3FE;EAAsC,gBAAA;Ab63FxC;;Aa73FE;EAAsC,gBAAA;Abi4FxC;;Aaj4FE;EAAsC,gBAAA;Abq4FxC;;Aar4FE;EAAsC,gBAAA;Aby4FxC;;Aaz4FE;EAAsC,gBAAA;Ab64FxC;;Aa74FE;EAAsC,gBAAA;Abi5FxC;;Aaj5FE;EAAsC,gBAAA;Abq5FxC;;Aar5FE;EAAsC,gBAAA;Aby5FxC;;Aaz5FE;EAAsC,gBAAA;Ab65FxC;;Aa75FE;EAAsC,gBAAA;Abi6FxC;;Aaj6FE;EAAsC,gBAAA;Abq6FxC;;Aar6FE;EAAsC,gBAAA;Aby6FxC;;Aaz6FE;EAAsC,gBAAA;Ab66FxC;;Aa76FE;EAAsC,gBAAA;Abi7FxC;;Aaj7FE;EAAsC,gBAAA;Abq7FxC;;Aar7FE;EAAsC,gBAAA;Aby7FxC;;Aaz7FE;EAAsC,gBAAA;Ab67FxC;;Aa77FE;EAAsC,gBAAA;Abi8FxC;;Aaj8FE;EAAsC,gBAAA;Abq8FxC;;Aar8FE;EAAsC,gBAAA;Aby8FxC;;Aaz8FE;EAAsC,gBAAA;Ab68FxC;;Aa78FE;EAAsC,gBAAA;Abi9FxC;;Aaj9FE;EAAsC,gBAAA;Abq9FxC;;Aar9FE;EAAsC,gBAAA;Aby9FxC;;Aaz9FE;EAAsC,gBAAA;Ab69FxC;;Aa79FE;EAAsC,gBAAA;Abi+FxC;;Aaj+FE;EAAsC,gBAAA;Abq+FxC;;Aar+FE;EAAsC,gBAAA;Aby+FxC;;Aaz+FE;EAAsC,gBAAA;Ab6+FxC;;Aa7+FE;EAAsC,gBAAA;Abi/FxC;;Aaj/FE;EAAsC,gBAAA;Abq/FxC;;Aar/FE;EAAsC,gBAAA;Aby/FxC;;Aaz/FE;EAAsC,gBAAA;Ab6/FxC;;Aa7/FE;EAAsC,gBAAA;AbigGxC;;AajgGE;EAAsC,gBAAA;AbqgGxC;;AargGE;EAAsC,gBAAA;AbygGxC;;AazgGE;EAAsC,gBAAA;Ab6gGxC;;Aa7gGE;EAAsC,gBAAA;AbihGxC;;AajhGE;EAAsC,gBAAA;AbqhGxC;;AarhGE;EAAsC,gBAAA;AbyhGxC;;AazhGE;EAAsC,gBAAA;Ab6hGxC;;Aa7hGE;EAAsC,gBAAA;AbiiGxC;;AajiGE;EAAsC,gBAAA;AbqiGxC;;AariGE;EAAsC,gBAAA;AbyiGxC;;AaziGE;EAAsC,gBAAA;Ab6iGxC;;Aa7iGE;EAAsC,gBAAA;AbijGxC;;AajjGE;EAAsC,gBAAA;AbqjGxC;;AarjGE;EAAsC,gBAAA;AbyjGxC;;AazjGE;EAAsC,gBAAA;Ab6jGxC;;Aa7jGE;EAAsC,gBAAA;AbikGxC;;AajkGE;EAAsC,gBAAA;AbqkGxC;;AarkGE;EAAsC,gBAAA;AbykGxC;;AazkGE;EAAsC,gBAAA;Ab6kGxC;;Aa7kGE;EAAsC,gBAAA;AbilGxC;;AajlGE;EAAsC,gBAAA;AbqlGxC;;AarlGE;EAAsC,gBAAA;AbylGxC;;AazlGE;EAAsC,gBAAA;Ab6lGxC;;Aa7lGE;EAAsC,gBAAA;AbimGxC;;AajmGE;EAAsC,gBAAA;AbqmGxC;;AarmGE;EAAsC,gBAAA;AbymGxC;;AazmGE;EAAsC,gBAAA;Ab6mGxC;;Aa7mGE;EAAsC,gBAAA;AbinGxC;;AajnGE;EAAsC,gBAAA;AbqnGxC;;AarnGE;EAAsC,gBAAA;AbynGxC;;AaznGE;EAAsC,gBAAA;Ab6nGxC;;Aa7nGE;EAAsC,gBAAA;AbioGxC;;AajoGE;EAAsC,gBAAA;AbqoGxC;;AaroGE;EAAsC,gBAAA;AbyoGxC;;AazoGE;EAAsC,gBAAA;Ab6oGxC;;Aa7oGE;EAAsC,gBAAA;AbipGxC;;AajpGE;EAAsC,gBAAA;AbqpGxC;;AarpGE;EAAsC,gBAAA;AbypGxC;;AazpGE;EAAsC,gBAAA;Ab6pGxC;;Aa7pGE;EAAsC,gBAAA;AbiqGxC;;AajqGE;EAAsC,gBAAA;AbqqGxC;;AarqGE;EAAsC,gBAAA;AbyqGxC;;AazqGE;EAAsC,gBAAA;Ab6qGxC;;Aa7qGE;EAAsC,gBAAA;AbirGxC;;AajrGE;EAAsC,gBAAA;AbqrGxC;;AarrGE;EAAsC,gBAAA;AbyrGxC;;AazrGE;EAAsC,gBAAA;Ab6rGxC;;Aa7rGE;EAAsC,gBAAA;AbisGxC;;AajsGE;EAAsC,gBAAA;AbqsGxC;;AarsGE;EAAsC,gBAAA;AbysGxC;;AazsGE;EAAsC,gBAAA;Ab6sGxC;;Aa7sGE;EAAsC,gBAAA;AbitGxC;;AajtGE;EAAsC,gBAAA;AbqtGxC;;AartGE;EAAsC,gBAAA;AbytGxC;;AaztGE;EAAsC,gBAAA;Ab6tGxC;;Aa7tGE;EAAsC,gBAAA;AbiuGxC;;AajuGE;EAAsC,gBAAA;AbquGxC;;AaruGE;EAAsC,gBAAA;AbyuGxC;;AazuGE;EAAsC,gBAAA;Ab6uGxC;;Aa7uGE;EAAsC,gBAAA;AbivGxC;;AajvGE;EAAsC,gBAAA;AbqvGxC;;AarvGE;EAAsC,gBAAA;AbyvGxC;;AazvGE;EAAsC,gBAAA;Ab6vGxC;;Aa7vGE;EAAsC,gBAAA;AbiwGxC;;AajwGE;EAAsC,gBAAA;AbqwGxC;;AarwGE;EAAsC,gBAAA;AbywGxC;;AazwGE;EAAsC,gBAAA;Ab6wGxC;;Aa7wGE;EAAsC,gBAAA;AbixGxC;;AajxGE;EAAsC,gBAAA;AbqxGxC;;AarxGE;EAAsC,gBAAA;AbyxGxC;;AazxGE;EAAsC,gBAAA;Ab6xGxC;;Aa7xGE;EAAsC,gBAAA;AbiyGxC;;AajyGE;EAAsC,gBAAA;AbqyGxC;;AaryGE;EAAsC,gBAAA;AbyyGxC;;AazyGE;EAAsC,gBAAA;Ab6yGxC;;Aa7yGE;EAAsC,gBAAA;AbizGxC;;AajzGE;EAAsC,gBAAA;AbqzGxC;;AarzGE;EAAsC,gBAAA;AbyzGxC;;AazzGE;EAAsC,gBAAA;Ab6zGxC;;Aa7zGE;EAAsC,gBAAA;Abi0GxC;;Aaj0GE;EAAsC,gBAAA;Abq0GxC;;Aar0GE;EAAsC,gBAAA;Aby0GxC;;Aaz0GE;EAAsC,gBAAA;Ab60GxC;;Aa70GE;EAAsC,gBAAA;Abi1GxC;;Aaj1GE;EAAsC,gBAAA;Abq1GxC;;Aar1GE;EAAsC,gBAAA;Aby1GxC;;Aaz1GE;EAAsC,gBAAA;Ab61GxC;;Aa71GE;EAAsC,gBAAA;Abi2GxC;;Aaj2GE;EAAsC,gBAAA;Abq2GxC;;Aar2GE;EAAsC,gBAAA;Aby2GxC;;Aaz2GE;EAAsC,gBAAA;Ab62GxC;;Aa72GE;EAAsC,gBAAA;Abi3GxC;;Aaj3GE;EAAsC,gBAAA;Abq3GxC;;Aar3GE;EAAsC,gBAAA;Aby3GxC;;Aaz3GE;EAAsC,gBAAA;Ab63GxC;;Aa73GE;EAAsC,gBAAA;Abi4GxC;;Aaj4GE;EAAsC,gBAAA;Abq4GxC;;Aar4GE;EAAsC,gBAAA;Aby4GxC;;Aaz4GE;EAAsC,gBAAA;Ab64GxC;;Aa74GE;EAAsC,gBAAA;Abi5GxC;;Aaj5GE;EAAsC,gBAAA;Abq5GxC;;Aar5GE;EAAsC,gBAAA;Aby5GxC;;Aaz5GE;EAAsC,gBAAA;Ab65GxC;;Aa75GE;EAAsC,gBAAA;Abi6GxC;;Aaj6GE;EAAsC,YAAA;Abq6GxC;;Aar6GE;EAAsC,gBAAA;Aby6GxC;;Aaz6GE;EAAsC,gBAAA;Ab66GxC;;Aa76GE;EAAsC,gBAAA;Abi7GxC;;Aaj7GE;EAAsC,YAAA;Abq7GxC;;Aar7GE;EAAsC,gBAAA;Aby7GxC;;Aaz7GE;EAAsC,gBAAA;Ab67GxC;;Aa77GE;EAAsC,gBAAA;Abi8GxC;;Aaj8GE;EAAsC,gBAAA;Abq8GxC;;Aar8GE;EAAsC,YAAA;Aby8GxC;;Aaz8GE;EAAsC,gBAAA;Ab68GxC;;Aa78GE;EAAsC,gBAAA;Abi9GxC;;Aaj9GE;EAAsC,gBAAA;Abq9GxC;;Aar9GE;EAAsC,gBAAA;Aby9GxC;;Aaz9GE;EAAsC,gBAAA;Ab69GxC;;Aa79GE;EAAsC,gBAAA;Abi+GxC;;Aaj+GE;EAAsC,gBAAA;Abq+GxC;;Aar+GE;EAAsC,gBAAA;Aby+GxC;;Aaz+GE;EAAsC,gBAAA;Ab6+GxC;;Aa7+GE;EAAsC,gBAAA;Abi/GxC;;Aaj/GE;EAAsC,gBAAA;Abq/GxC;;Aar/GE;EAAsC,gBAAA;Aby/GxC;;Aaz/GE;EAAsC,gBAAA;Ab6/GxC;;Aa7/GE;EAAsC,gBAAA;AbigHxC;;AajgHE;EAAsC,gBAAA;AbqgHxC;;AargHE;EAAsC,gBAAA;AbygHxC;;AazgHE;EAAsC,gBAAA;Ab6gHxC;;Aa7gHE;EAAsC,gBAAA;AbihHxC;;AajhHE;EAAsC,gBAAA;AbqhHxC;;AarhHE;EAAsC,gBAAA;AbyhHxC;;AazhHE;EAAsC,gBAAA;Ab6hHxC;;Aa7hHE;EAAsC,gBAAA;AbiiHxC;;AajiHE;EAAsC,aAAA;AbqiHxC;;AariHE;EAAsC,gBAAA;AbyiHxC;;AaziHE;EAAsC,gBAAA;Ab6iHxC;;Aa7iHE;EAAsC,gBAAA;AbijHxC;;AajjHE;EAAsC,gBAAA;AbqjHxC;;AarjHE;EAAsC,gBAAA;AbyjHxC;;AazjHE;EAAsC,gBAAA;Ab6jHxC;;Aa7jHE;EAAsC,gBAAA;AbikHxC;;AajkHE;EAAsC,gBAAA;AbqkHxC;;AarkHE;EAAsC,gBAAA;AbykHxC;;AazkHE;EAAsC,gBAAA;Ab6kHxC;;Aa7kHE;EAAsC,gBAAA;AbilHxC;;AajlHE;EAAsC,gBAAA;AbqlHxC;;AarlHE;EAAsC,gBAAA;AbylHxC;;AazlHE;EAAsC,gBAAA;Ab6lHxC;;Aa7lHE;EAAsC,gBAAA;AbimHxC;;AajmHE;EAAsC,gBAAA;AbqmHxC;;AarmHE;EAAsC,gBAAA;AbymHxC;;AazmHE;EAAsC,gBAAA;Ab6mHxC;;Aa7mHE;EAAsC,gBAAA;AbinHxC;;AajnHE;EAAsC,gBAAA;AbqnHxC;;AarnHE;EAAsC,gBAAA;AbynHxC;;AaznHE;EAAsC,gBAAA;Ab6nHxC;;Aa7nHE;EAAsC,YAAA;AbioHxC;;AajoHE;EAAsC,gBAAA;AbqoHxC;;AaroHE;EAAsC,gBAAA;AbyoHxC;;AazoHE;EAAsC,gBAAA;Ab6oHxC;;Aa7oHE;EAAsC,gBAAA;AbipHxC;;AajpHE;EAAsC,gBAAA;AbqpHxC;;AarpHE;EAAsC,gBAAA;AbypHxC;;AazpHE;EAAsC,gBAAA;Ab6pHxC;;Aa7pHE;EAAsC,gBAAA;AbiqHxC;;AajqHE;EAAsC,gBAAA;AbqqHxC;;AarqHE;EAAsC,gBAAA;AbyqHxC;;AazqHE;EAAsC,gBAAA;Ab6qHxC;;Aa7qHE;EAAsC,gBAAA;AbirHxC;;AajrHE;EAAsC,gBAAA;AbqrHxC;;AarrHE;EAAsC,gBAAA;AbyrHxC;;AazrHE;EAAsC,gBAAA;Ab6rHxC;;Aa7rHE;EAAsC,gBAAA;AbisHxC;;AajsHE;EAAsC,gBAAA;AbqsHxC;;AarsHE;EAAsC,gBAAA;AbysHxC;;AazsHE;EAAsC,gBAAA;Ab6sHxC;;Aa7sHE;EAAsC,gBAAA;AbitHxC;;AajtHE;EAAsC,gBAAA;AbqtHxC;;AartHE;EAAsC,gBAAA;AbytHxC;;AaztHE;EAAsC,gBAAA;Ab6tHxC;;Aa7tHE;EAAsC,gBAAA;AbiuHxC;;AajuHE;EAAsC,gBAAA;AbquHxC;;AaruHE;EAAsC,gBAAA;AbyuHxC;;AazuHE;EAAsC,gBAAA;Ab6uHxC;;Aa7uHE;EAAsC,gBAAA;AbivHxC;;AajvHE;EAAsC,gBAAA;AbqvHxC;;AarvHE;EAAsC,gBAAA;AbyvHxC;;AazvHE;EAAsC,gBAAA;Ab6vHxC;;Aa7vHE;EAAsC,gBAAA;AbiwHxC;;AajwHE;EAAsC,gBAAA;AbqwHxC;;AarwHE;EAAsC,gBAAA;AbywHxC;;AazwHE;EAAsC,gBAAA;Ab6wHxC;;Aa7wHE;EAAsC,gBAAA;AbixHxC;;AajxHE;EAAsC,gBAAA;AbqxHxC;;AarxHE;EAAsC,gBAAA;AbyxHxC;;AazxHE;EAAsC,gBAAA;Ab6xHxC;;Aa7xHE;EAAsC,YAAA;AbiyHxC;;AajyHE;EAAsC,gBAAA;AbqyHxC;;AaryHE;EAAsC,gBAAA;AbyyHxC;;AazyHE;EAAsC,gBAAA;Ab6yHxC;;Aa7yHE;EAAsC,gBAAA;AbizHxC;;AajzHE;EAAsC,gBAAA;AbqzHxC;;AarzHE;EAAsC,gBAAA;AbyzHxC;;AazzHE;EAAsC,gBAAA;Ab6zHxC;;Aa7zHE;EAAsC,gBAAA;Abi0HxC;;Aaj0HE;EAAsC,gBAAA;Abq0HxC;;Aar0HE;EAAsC,gBAAA;Aby0HxC;;Aaz0HE;EAAsC,gBAAA;Ab60HxC;;Aa70HE;EAAsC,gBAAA;Abi1HxC;;Aaj1HE;EAAsC,gBAAA;Abq1HxC;;Aar1HE;EAAsC,gBAAA;Aby1HxC;;Aaz1HE;EAAsC,gBAAA;Ab61HxC;;Aa71HE;EAAsC,gBAAA;Abi2HxC;;Aaj2HE;EAAsC,gBAAA;Abq2HxC;;Aar2HE;EAAsC,gBAAA;Aby2HxC;;Aaz2HE;EAAsC,gBAAA;Ab62HxC;;Aa72HE;EAAsC,gBAAA;Abi3HxC;;Aaj3HE;EAAsC,gBAAA;Abq3HxC;;Aar3HE;EAAsC,gBAAA;Aby3HxC;;Aaz3HE;EAAsC,YAAA;Ab63HxC;;Aa73HE;EAAsC,gBAAA;Abi4HxC;;Aaj4HE;EAAsC,gBAAA;Abq4HxC;;Aar4HE;EAAsC,gBAAA;Aby4HxC;;Aaz4HE;EAAsC,gBAAA;Ab64HxC;;Aa74HE;EAAsC,gBAAA;Abi5HxC;;Aaj5HE;EAAsC,gBAAA;Abq5HxC;;Aar5HE;EAAsC,gBAAA;Aby5HxC;;Aaz5HE;EAAsC,gBAAA;Ab65HxC;;Aa75HE;EAAsC,gBAAA;Abi6HxC;;Aaj6HE;EAAsC,gBAAA;Abq6HxC;;Aar6HE;EAAsC,gBAAA;Aby6HxC;;Aaz6HE;EAAsC,gBAAA;Ab66HxC;;Aa76HE;EAAsC,gBAAA;Abi7HxC;;Aaj7HE;EAAsC,gBAAA;Abq7HxC;;Aar7HE;EAAsC,gBAAA;Aby7HxC;;Aaz7HE;EAAsC,gBAAA;Ab67HxC;;Aa77HE;EAAsC,gBAAA;Abi8HxC;;Aaj8HE;EAAsC,gBAAA;Abq8HxC;;Aar8HE;EAAsC,gBAAA;Aby8HxC;;Aaz8HE;EAAsC,gBAAA;Ab68HxC;;Aa78HE;EAAsC,gBAAA;Abi9HxC;;Aaj9HE;EAAsC,gBAAA;Abq9HxC;;Aar9HE;EAAsC,gBAAA;Aby9HxC;;Aaz9HE;EAAsC,gBAAA;Ab69HxC;;Aa79HE;EAAsC,gBAAA;Abi+HxC;;Aaj+HE;EAAsC,gBAAA;Abq+HxC;;Aar+HE;EAAsC,gBAAA;Aby+HxC;;Aaz+HE;EAAsC,gBAAA;Ab6+HxC;;Aa7+HE;EAAsC,gBAAA;Abi/HxC;;Aaj/HE;EAAsC,gBAAA;Abq/HxC;;Aar/HE;EAAsC,gBAAA;Aby/HxC;;Aaz/HE;EAAsC,gBAAA;Ab6/HxC;;Aa7/HE;EAAsC,gBAAA;AbigIxC;;AajgIE;EAAsC,gBAAA;AbqgIxC;;AargIE;EAAsC,gBAAA;AbygIxC;;AazgIE;EAAsC,gBAAA;Ab6gIxC;;Aa7gIE;EAAsC,gBAAA;AbihIxC;;AajhIE;EAAsC,gBAAA;AbqhIxC;;AarhIE;EAAsC,gBAAA;AbyhIxC;;AazhIE;EAAsC,gBAAA;Ab6hIxC;;Aa7hIE;EAAsC,gBAAA;AbiiIxC;;AajiIE;EAAsC,gBAAA;AbqiIxC;;AariIE;EAAsC,gBAAA;AbyiIxC;;AaziIE;EAAsC,gBAAA;Ab6iIxC;;Aa7iIE;EAAsC,gBAAA;AbijIxC;;AajjIE;EAAsC,gBAAA;AbqjIxC;;AarjIE;EAAsC,gBAAA;AbyjIxC;;AazjIE;EAAsC,gBAAA;Ab6jIxC;;Aa7jIE;EAAsC,gBAAA;AbikIxC;;AajkIE;EAAsC,gBAAA;AbqkIxC;;AarkIE;EAAsC,gBAAA;AbykIxC;;AazkIE;EAAsC,gBAAA;Ab6kIxC;;Aa7kIE;EAAsC,gBAAA;AbilIxC;;AajlIE;EAAsC,gBAAA;AbqlIxC;;AarlIE;EAAsC,gBAAA;AbylIxC;;AazlIE;EAAsC,gBAAA;Ab6lIxC;;Aa7lIE;EAAsC,gBAAA;AbimIxC;;AajmIE;EAAsC,gBAAA;AbqmIxC;;AarmIE;EAAsC,gBAAA;AbymIxC;;AazmIE;EAAsC,gBAAA;Ab6mIxC;;Aa7mIE;EAAsC,gBAAA;AbinIxC;;AajnIE;EAAsC,gBAAA;AbqnIxC;;AarnIE;EAAsC,gBAAA;AbynIxC;;AaznIE;EAAsC,gBAAA;Ab6nIxC;;Aa7nIE;EAAsC,gBAAA;AbioIxC;;AajoIE;EAAsC,gBAAA;AbqoIxC;;AaroIE;EAAsC,gBAAA;AbyoIxC;;AazoIE;EAAsC,gBAAA;Ab6oIxC;;Aa7oIE;EAAsC,gBAAA;AbipIxC;;AajpIE;EAAsC,gBAAA;AbqpIxC;;AarpIE;EAAsC,gBAAA;AbypIxC;;AazpIE;EAAsC,gBAAA;Ab6pIxC;;Aa7pIE;EAAsC,gBAAA;AbiqIxC;;AajqIE;EAAsC,gBAAA;AbqqIxC;;AarqIE;EAAsC,gBAAA;AbyqIxC;;AazqIE;EAAsC,gBAAA;Ab6qIxC;;Aa7qIE;EAAsC,gBAAA;AbirIxC;;AajrIE;EAAsC,gBAAA;AbqrIxC;;AarrIE;EAAsC,gBAAA;AbyrIxC;;AazrIE;EAAsC,gBAAA;Ab6rIxC;;Aa7rIE;EAAsC,gBAAA;AbisIxC;;AajsIE;EAAsC,gBAAA;AbqsIxC;;AarsIE;EAAsC,gBAAA;AbysIxC;;AazsIE;EAAsC,gBAAA;Ab6sIxC;;Aa7sIE;EAAsC,gBAAA;AbitIxC;;AajtIE;EAAsC,gBAAA;AbqtIxC;;AartIE;EAAsC,gBAAA;AbytIxC;;AaztIE;EAAsC,gBAAA;Ab6tIxC;;Aa7tIE;EAAsC,gBAAA;AbiuIxC;;AajuIE;EAAsC,gBAAA;AbquIxC;;AaruIE;EAAsC,gBAAA;AbyuIxC;;AazuIE;EAAsC,gBAAA;Ab6uIxC;;Aa7uIE;EAAsC,gBAAA;AbivIxC;;AajvIE;EAAsC,gBAAA;AbqvIxC;;AarvIE;EAAsC,gBAAA;AbyvIxC;;AazvIE;EAAsC,gBAAA;Ab6vIxC;;Aa7vIE;EAAsC,gBAAA;AbiwIxC;;AajwIE;EAAsC,gBAAA;AbqwIxC;;AarwIE;EAAsC,gBAAA;AbywIxC;;AazwIE;EAAsC,gBAAA;Ab6wIxC;;Aa7wIE;EAAsC,gBAAA;AbixIxC;;AajxIE;EAAsC,gBAAA;AbqxIxC;;AarxIE;EAAsC,gBAAA;AbyxIxC;;AazxIE;EAAsC,gBAAA;Ab6xIxC;;Aa7xIE;EAAsC,gBAAA;AbiyIxC;;AajyIE;EAAsC,gBAAA;AbqyIxC;;AaryIE;EAAsC,gBAAA;AbyyIxC;;AazyIE;EAAsC,gBAAA;Ab6yIxC;;Aa7yIE;EAAsC,gBAAA;AbizIxC;;AajzIE;EAAsC,gBAAA;AbqzIxC;;AarzIE;EAAsC,gBAAA;AbyzIxC;;AazzIE;EAAsC,gBAAA;Ab6zIxC;;Aa7zIE;EAAsC,gBAAA;Abi0IxC;;Aaj0IE;EAAsC,gBAAA;Abq0IxC;;Aar0IE;EAAsC,gBAAA;Aby0IxC;;Aaz0IE;EAAsC,gBAAA;Ab60IxC;;Aa70IE;EAAsC,gBAAA;Abi1IxC;;Aaj1IE;EAAsC,gBAAA;Abq1IxC;;Aar1IE;EAAsC,gBAAA;Aby1IxC;;Aaz1IE;EAAsC,gBAAA;Ab61IxC;;Aa71IE;EAAsC,gBAAA;Abi2IxC;;Aaj2IE;EAAsC,gBAAA;Abq2IxC;;Aar2IE;EAAsC,gBAAA;Aby2IxC;;Aaz2IE;EAAsC,gBAAA;Ab62IxC;;Aa72IE;EAAsC,gBAAA;Abi3IxC;;Aaj3IE;EAAsC,gBAAA;Abq3IxC;;Aar3IE;EAAsC,gBAAA;Aby3IxC;;Aaz3IE;EAAsC,gBAAA;Ab63IxC;;Aa73IE;EAAsC,gBAAA;Abi4IxC;;Aaj4IE;EAAsC,gBAAA;Abq4IxC;;Aar4IE;EAAsC,gBAAA;Aby4IxC;;Aaz4IE;EAAsC,gBAAA;Ab64IxC;;Aa74IE;EAAsC,gBAAA;Abi5IxC;;Aaj5IE;EAAsC,gBAAA;Abq5IxC;;Aar5IE;EAAsC,gBAAA;Aby5IxC;;Aaz5IE;EAAsC,gBAAA;Ab65IxC;;Aa75IE;EAAsC,gBAAA;Abi6IxC;;Aaj6IE;EAAsC,gBAAA;Abq6IxC;;Aar6IE;EAAsC,gBAAA;Aby6IxC;;Aaz6IE;EAAsC,gBAAA;Ab66IxC;;Aa76IE;EAAsC,gBAAA;Abi7IxC;;Aaj7IE;EAAsC,gBAAA;Abq7IxC;;Aar7IE;EAAsC,gBAAA;Aby7IxC;;Aaz7IE;EAAsC,gBAAA;Ab67IxC;;Aa77IE;EAAsC,gBAAA;Abi8IxC;;Aaj8IE;EAAsC,gBAAA;Abq8IxC;;Aar8IE;EAAsC,gBAAA;Aby8IxC;;Aaz8IE;EAAsC,gBAAA;Ab68IxC;;Aa78IE;EAAsC,gBAAA;Abi9IxC;;Aaj9IE;EAAsC,gBAAA;Abq9IxC;;Aar9IE;EAAsC,gBAAA;Aby9IxC;;Aaz9IE;EAAsC,gBAAA;Ab69IxC;;Aa79IE;EAAsC,gBAAA;Abi+IxC;;Aaj+IE;EAAsC,gBAAA;Abq+IxC;;Aar+IE;EAAsC,gBAAA;Aby+IxC;;Aaz+IE;EAAsC,gBAAA;Ab6+IxC;;Aa7+IE;EAAsC,gBAAA;Abi/IxC;;Aaj/IE;EAAsC,gBAAA;Abq/IxC;;Aar/IE;EAAsC,gBAAA;Aby/IxC;;Aaz/IE;EAAsC,gBAAA;Ab6/IxC;;Aa7/IE;EAAsC,gBAAA;AbigJxC;;AajgJE;EAAsC,gBAAA;AbqgJxC;;AargJE;EAAsC,gBAAA;AbygJxC;;AazgJE;EAAsC,gBAAA;Ab6gJxC;;Aa7gJE;EAAsC,gBAAA;AbihJxC;;AajhJE;EAAsC,gBAAA;AbqhJxC;;AarhJE;EAAsC,gBAAA;AbyhJxC;;AazhJE;EAAsC,gBAAA;Ab6hJxC;;Aa7hJE;EAAsC,gBAAA;AbiiJxC;;AajiJE;EAAsC,gBAAA;AbqiJxC;;AariJE;EAAsC,gBAAA;AbyiJxC;;AaziJE;EAAsC,gBAAA;Ab6iJxC;;Aa7iJE;EAAsC,gBAAA;AbijJxC;;AajjJE;EAAsC,gBAAA;AbqjJxC;;AarjJE;EAAsC,gBAAA;AbyjJxC;;AazjJE;EAAsC,gBAAA;Ab6jJxC;;Aa7jJE;EAAsC,gBAAA;AbikJxC;;AajkJE;EAAsC,gBAAA;AbqkJxC;;AarkJE;EAAsC,gBAAA;AbykJxC;;AazkJE;EAAsC,gBAAA;Ab6kJxC;;Aa7kJE;EAAsC,gBAAA;AbilJxC;;AajlJE;EAAsC,gBAAA;AbqlJxC;;AarlJE;EAAsC,gBAAA;AbylJxC;;AazlJE;EAAsC,gBAAA;Ab6lJxC;;Aa7lJE;EAAsC,gBAAA;AbimJxC;;AajmJE;EAAsC,gBAAA;AbqmJxC;;AarmJE;EAAsC,gBAAA;AbymJxC;;AazmJE;EAAsC,gBAAA;Ab6mJxC;;Aa7mJE;EAAsC,YAAA;AbinJxC;;AajnJE;EAAsC,gBAAA;AbqnJxC;;AarnJE;EAAsC,gBAAA;AbynJxC;;AaznJE;EAAsC,gBAAA;Ab6nJxC;;Aa7nJE;EAAsC,gBAAA;AbioJxC;;AajoJE;EAAsC,gBAAA;AbqoJxC;;AaroJE;EAAsC,gBAAA;AbyoJxC;;AazoJE;EAAsC,gBAAA;Ab6oJxC;;Aa7oJE;EAAsC,gBAAA;AbipJxC;;AajpJE;EAAsC,gBAAA;AbqpJxC;;AarpJE;EAAsC,YAAA;AbypJxC;;AazpJE;EAAsC,gBAAA;Ab6pJxC;;Aa7pJE;EAAsC,gBAAA;AbiqJxC;;AajqJE;EAAsC,gBAAA;AbqqJxC;;AarqJE;EAAsC,gBAAA;AbyqJxC;;AazqJE;EAAsC,gBAAA;Ab6qJxC;;Aa7qJE;EAAsC,gBAAA;AbirJxC;;AajrJE;EAAsC,gBAAA;AbqrJxC;;AarrJE;EAAsC,gBAAA;AbyrJxC;;AazrJE;EAAsC,gBAAA;Ab6rJxC;;Aa7rJE;EAAsC,gBAAA;AbisJxC;;AajsJE;EAAsC,gBAAA;AbqsJxC;;AarsJE;EAAsC,gBAAA;AbysJxC;;AazsJE;EAAsC,gBAAA;Ab6sJxC;;Aa7sJE;EAAsC,gBAAA;AbitJxC;;AajtJE;EAAsC,gBAAA;AbqtJxC;;AartJE;EAAsC,gBAAA;AbytJxC;;AaztJE;EAAsC,gBAAA;Ab6tJxC;;Aa7tJE;EAAsC,gBAAA;AbiuJxC;;AajuJE;EAAsC,gBAAA;AbquJxC;;AaruJE;EAAsC,gBAAA;AbyuJxC;;AazuJE;EAAsC,gBAAA;Ab6uJxC;;Aa7uJE;EAAsC,gBAAA;AbivJxC;;AajvJE;EAAsC,gBAAA;AbqvJxC;;AarvJE;EAAsC,gBAAA;AbyvJxC;;AazvJE;EAAsC,gBAAA;Ab6vJxC;;Aa7vJE;EAAsC,gBAAA;AbiwJxC;;AajwJE;EAAsC,gBAAA;AbqwJxC;;AarwJE;EAAsC,gBAAA;AbywJxC;;AazwJE;EAAsC,gBAAA;Ab6wJxC;;Aa7wJE;EAAsC,gBAAA;AbixJxC;;AajxJE;EAAsC,gBAAA;AbqxJxC;;AarxJE;EAAsC,gBAAA;AbyxJxC;;AazxJE;EAAsC,gBAAA;Ab6xJxC;;Aa7xJE;EAAsC,gBAAA;AbiyJxC;;AajyJE;EAAsC,gBAAA;AbqyJxC;;AaryJE;EAAsC,gBAAA;AbyyJxC;;AazyJE;EAAsC,gBAAA;Ab6yJxC;;Aa7yJE;EAAsC,gBAAA;AbizJxC;;AajzJE;EAAsC,gBAAA;AbqzJxC;;AarzJE;EAAsC,gBAAA;AbyzJxC;;AazzJE;EAAsC,gBAAA;Ab6zJxC;;Aa7zJE;EAAsC,gBAAA;Abi0JxC;;Aaj0JE;EAAsC,gBAAA;Abq0JxC;;Aar0JE;EAAsC,gBAAA;Aby0JxC;;Aaz0JE;EAAsC,gBAAA;Ab60JxC;;Aa70JE;EAAsC,gBAAA;Abi1JxC;;Aaj1JE;EAAsC,gBAAA;Abq1JxC;;Aar1JE;EAAsC,gBAAA;Aby1JxC;;Aaz1JE;EAAsC,gBAAA;Ab61JxC;;Aa71JE;EAAsC,gBAAA;Abi2JxC;;Aaj2JE;EAAsC,gBAAA;Abq2JxC;;Aar2JE;EAAsC,gBAAA;Aby2JxC;;Aaz2JE;EAAsC,gBAAA;Ab62JxC;;Aa72JE;EAAsC,gBAAA;Abi3JxC;;Aaj3JE;EAAsC,gBAAA;Abq3JxC;;Aar3JE;EAAsC,gBAAA;Aby3JxC;;Aaz3JE;EAAsC,gBAAA;Ab63JxC;;Aa73JE;EAAsC,gBAAA;Abi4JxC;;Aaj4JE;EAAsC,gBAAA;Abq4JxC;;Aar4JE;EAAsC,gBAAA;Aby4JxC;;Aaz4JE;EAAsC,gBAAA;Ab64JxC;;Aa74JE;EAAsC,gBAAA;Abi5JxC;;Aaj5JE;EAAsC,gBAAA;Abq5JxC;;Aar5JE;EAAsC,gBAAA;Aby5JxC;;Aaz5JE;EAAsC,gBAAA;Ab65JxC;;Aa75JE;EAAsC,gBAAA;Abi6JxC;;Aaj6JE;EAAsC,gBAAA;Abq6JxC;;Aar6JE;EAAsC,gBAAA;Aby6JxC;;Aaz6JE;EAAsC,gBAAA;Ab66JxC;;Aa76JE;EAAsC,gBAAA;Abi7JxC;;Aaj7JE;EAAsC,gBAAA;Abq7JxC;;Aar7JE;EAAsC,gBAAA;Aby7JxC;;Aaz7JE;EAAsC,gBAAA;Ab67JxC;;Aa77JE;EAAsC,gBAAA;Abi8JxC;;Aaj8JE;EAAsC,gBAAA;Abq8JxC;;Aar8JE;EAAsC,gBAAA;Aby8JxC;;Aaz8JE;EAAsC,gBAAA;Ab68JxC;;Aa78JE;EAAsC,gBAAA;Abi9JxC;;Aaj9JE;EAAsC,gBAAA;Abq9JxC;;Aar9JE;EAAsC,gBAAA;Aby9JxC;;Aaz9JE;EAAsC,gBAAA;Ab69JxC;;Aa79JE;EAAsC,gBAAA;Abi+JxC;;Aaj+JE;EAAsC,gBAAA;Abq+JxC;;Aar+JE;EAAsC,gBAAA;Aby+JxC;;Aaz+JE;EAAsC,gBAAA;Ab6+JxC;;Aa7+JE;EAAsC,gBAAA;Abi/JxC;;Aaj/JE;EAAsC,gBAAA;Abq/JxC;;Aar/JE;EAAsC,gBAAA;Aby/JxC;;Aaz/JE;EAAsC,gBAAA;Ab6/JxC;;Aa7/JE;EAAsC,gBAAA;AbigKxC;;AajgKE;EAAsC,gBAAA;AbqgKxC;;AargKE;EAAsC,gBAAA;AbygKxC;;AazgKE;EAAsC,gBAAA;Ab6gKxC;;Aa7gKE;EAAsC,gBAAA;AbihKxC;;AajhKE;EAAsC,gBAAA;AbqhKxC;;AarhKE;EAAsC,gBAAA;AbyhKxC;;AazhKE;EAAsC,gBAAA;Ab6hKxC;;Aa7hKE;EAAsC,gBAAA;AbiiKxC;;AajiKE;EAAsC,gBAAA;AbqiKxC;;AariKE;EAAsC,gBAAA;AbyiKxC;;AaziKE;EAAsC,gBAAA;Ab6iKxC;;Aa7iKE;EAAsC,gBAAA;AbijKxC;;AajjKE;EAAsC,gBAAA;AbqjKxC;;AarjKE;EAAsC,gBAAA;AbyjKxC;;AazjKE;EAAsC,gBAAA;Ab6jKxC;;Aa7jKE;EAAsC,gBAAA;AbikKxC;;AajkKE;EAAsC,gBAAA;AbqkKxC;;AarkKE;EAAsC,gBAAA;AbykKxC;;AazkKE;EAAsC,gBAAA;Ab6kKxC;;Aa7kKE;EAAsC,gBAAA;AbilKxC;;AajlKE;EAAsC,gBAAA;AbqlKxC;;AarlKE;EAAsC,gBAAA;AbylKxC;;AazlKE;EAAsC,gBAAA;Ab6lKxC;;Aa7lKE;EAAsC,gBAAA;AbimKxC;;AajmKE;EAAsC,gBAAA;AbqmKxC;;AarmKE;EAAsC,gBAAA;AbymKxC;;AazmKE;EAAsC,gBAAA;Ab6mKxC;;Aa7mKE;EAAsC,gBAAA;AbinKxC;;AajnKE;EAAsC,gBAAA;AbqnKxC;;AarnKE;EAAsC,gBAAA;AbynKxC;;AaznKE;EAAsC,gBAAA;Ab6nKxC;;Aa7nKE;EAAsC,gBAAA;AbioKxC;;AajoKE;EAAsC,gBAAA;AbqoKxC;;AaroKE;EAAsC,gBAAA;AbyoKxC;;AazoKE;EAAsC,gBAAA;Ab6oKxC;;Aa7oKE;EAAsC,gBAAA;AbipKxC;;AajpKE;EAAsC,gBAAA;AbqpKxC;;AarpKE;EAAsC,gBAAA;AbypKxC;;AazpKE;EAAsC,gBAAA;Ab6pKxC;;Aa7pKE;EAAsC,gBAAA;AbiqKxC;;AajqKE;EAAsC,gBAAA;AbqqKxC;;AarqKE;EAAsC,gBAAA;AbyqKxC;;AazqKE;EAAsC,gBAAA;Ab6qKxC;;Aa7qKE;EAAsC,gBAAA;AbirKxC;;AajrKE;EAAsC,gBAAA;AbqrKxC;;AarrKE;EAAsC,gBAAA;AbyrKxC;;AazrKE;EAAsC,gBAAA;Ab6rKxC;;Aa7rKE;EAAsC,gBAAA;AbisKxC;;AajsKE;EAAsC,gBAAA;AbqsKxC;;AarsKE;EAAsC,gBAAA;AbysKxC;;AazsKE;EAAsC,YAAA;Ab6sKxC;;Aa7sKE;EAAsC,gBAAA;AbitKxC;;AajtKE;EAAsC,gBAAA;AbqtKxC;;AartKE;EAAsC,gBAAA;AbytKxC;;AaztKE;EAAsC,gBAAA;Ab6tKxC;;Aa7tKE;EAAsC,gBAAA;AbiuKxC;;AajuKE;EAAsC,gBAAA;AbquKxC;;AaruKE;EAAsC,gBAAA;AbyuKxC;;AazuKE;EAAsC,gBAAA;Ab6uKxC;;Aa7uKE;EAAsC,gBAAA;AbivKxC;;AajvKE;EAAsC,YAAA;AbqvKxC;;AarvKE;EAAsC,gBAAA;AbyvKxC;;AazvKE;EAAsC,gBAAA;Ab6vKxC;;Aa7vKE;EAAsC,gBAAA;AbiwKxC;;AajwKE;EAAsC,gBAAA;AbqwKxC;;AarwKE;EAAsC,gBAAA;AbywKxC;;AazwKE;EAAsC,gBAAA;Ab6wKxC;;Aa7wKE;EAAsC,gBAAA;AbixKxC;;AajxKE;EAAsC,gBAAA;AbqxKxC;;AarxKE;EAAsC,gBAAA;AbyxKxC;;AazxKE;EAAsC,gBAAA;Ab6xKxC;;Aa7xKE;EAAsC,gBAAA;AbiyKxC;;AajyKE;EAAsC,gBAAA;AbqyKxC;;AaryKE;EAAsC,gBAAA;AbyyKxC;;AazyKE;EAAsC,gBAAA;Ab6yKxC;;Aa7yKE;EAAsC,gBAAA;AbizKxC;;AajzKE;EAAsC,gBAAA;AbqzKxC;;AarzKE;EAAsC,gBAAA;AbyzKxC;;AazzKE;EAAsC,gBAAA;Ab6zKxC;;Aa7zKE;EAAsC,gBAAA;Abi0KxC;;Aaj0KE;EAAsC,gBAAA;Abq0KxC;;Aar0KE;EAAsC,gBAAA;Aby0KxC;;Aaz0KE;EAAsC,gBAAA;Ab60KxC;;Aa70KE;EAAsC,gBAAA;Abi1KxC;;Aaj1KE;EAAsC,gBAAA;Abq1KxC;;Aar1KE;EAAsC,gBAAA;Aby1KxC;;Aaz1KE;EAAsC,gBAAA;Ab61KxC;;Aa71KE;EAAsC,gBAAA;Abi2KxC;;Aaj2KE;EAAsC,gBAAA;Abq2KxC;;Aar2KE;EAAsC,gBAAA;Aby2KxC;;Aaz2KE;EAAsC,gBAAA;Ab62KxC;;Aa72KE;EAAsC,gBAAA;Abi3KxC;;Aaj3KE;EAAsC,gBAAA;Abq3KxC;;Aar3KE;EAAsC,gBAAA;Aby3KxC;;Aaz3KE;EAAsC,gBAAA;Ab63KxC;;Aa73KE;EAAsC,gBAAA;Abi4KxC;;Aaj4KE;EAAsC,gBAAA;Abq4KxC;;Aar4KE;EAAsC,gBAAA;Aby4KxC;;Aaz4KE;EAAsC,gBAAA;Ab64KxC;;Aa74KE;EAAsC,gBAAA;Abi5KxC;;Aaj5KE;EAAsC,gBAAA;Abq5KxC;;Aar5KE;EAAsC,gBAAA;Aby5KxC;;Aaz5KE;EAAsC,gBAAA;Ab65KxC;;Aa75KE;EAAsC,gBAAA;Abi6KxC;;Aaj6KE;EAAsC,gBAAA;Abq6KxC;;Aar6KE;EAAsC,gBAAA;Aby6KxC;;Aaz6KE;EAAsC,gBAAA;Ab66KxC;;Aa76KE;EAAsC,gBAAA;Abi7KxC;;Aaj7KE;EAAsC,gBAAA;Abq7KxC;;Aar7KE;EAAsC,YAAA;Aby7KxC;;Aaz7KE;EAAsC,gBAAA;Ab67KxC;;Aa77KE;EAAsC,gBAAA;Abi8KxC;;Aaj8KE;EAAsC,gBAAA;Abq8KxC;;Aar8KE;EAAsC,gBAAA;Aby8KxC;;Aaz8KE;EAAsC,gBAAA;Ab68KxC;;Aa78KE;EAAsC,gBAAA;Abi9KxC;;Aaj9KE;EAAsC,gBAAA;Abq9KxC;;Aar9KE;EAAsC,gBAAA;Aby9KxC;;Aaz9KE;EAAsC,gBAAA;Ab69KxC;;Aa79KE;EAAsC,gBAAA;Abi+KxC;;Aaj+KE;EAAsC,gBAAA;Abq+KxC;;Aar+KE;EAAsC,gBAAA;Aby+KxC;;Aaz+KE;EAAsC,gBAAA;Ab6+KxC;;Aa7+KE;EAAsC,gBAAA;Abi/KxC;;Aaj/KE;EAAsC,gBAAA;Abq/KxC;;Aar/KE;EAAsC,gBAAA;Aby/KxC;;Aaz/KE;EAAsC,gBAAA;Ab6/KxC;;Aa7/KE;EAAsC,gBAAA;AbigLxC;;AajgLE;EAAsC,gBAAA;AbqgLxC;;AargLE;EAAsC,gBAAA;AbygLxC;;AazgLE;EAAsC,gBAAA;Ab6gLxC;;Aa7gLE;EAAsC,gBAAA;AbihLxC;;AajhLE;EAAsC,gBAAA;AbqhLxC;;AarhLE;EAAsC,gBAAA;AbyhLxC;;AazhLE;EAAsC,gBAAA;Ab6hLxC;;Aa7hLE;EAAsC,gBAAA;AbiiLxC;;AajiLE;EAAsC,gBAAA;AbqiLxC;;AariLE;EAAsC,gBAAA;AbyiLxC;;AaziLE;EAAsC,gBAAA;Ab6iLxC;;Aa7iLE;EAAsC,gBAAA;AbijLxC;;AajjLE;EAAsC,gBAAA;AbqjLxC;;AarjLE;EAAsC,gBAAA;AbyjLxC;;AazjLE;EAAsC,gBAAA;Ab6jLxC;;Aa7jLE;EAAsC,gBAAA;AbikLxC;;AajkLE;EAAsC,gBAAA;AbqkLxC;;AarkLE;EAAsC,YAAA;AbykLxC;;AazkLE;EAAsC,gBAAA;Ab6kLxC;;Aa7kLE;EAAsC,gBAAA;AbilLxC;;AajlLE;EAAsC,gBAAA;AbqlLxC;;AarlLE;EAAsC,gBAAA;AbylLxC;;AazlLE;EAAsC,gBAAA;Ab6lLxC;;Aa7lLE;EAAsC,gBAAA;AbimLxC;;AajmLE;EAAsC,gBAAA;AbqmLxC;;AarmLE;EAAsC,gBAAA;AbymLxC;;AazmLE;EAAsC,gBAAA;Ab6mLxC;;Aa7mLE;EAAsC,gBAAA;AbinLxC;;AajnLE;EAAsC,gBAAA;AbqnLxC;;AarnLE;EAAsC,gBAAA;AbynLxC;;AaznLE;EAAsC,gBAAA;Ab6nLxC;;Aa7nLE;EAAsC,gBAAA;AbioLxC;;AajoLE;EAAsC,gBAAA;AbqoLxC;;AaroLE;EAAsC,gBAAA;AbyoLxC;;AazoLE;EAAsC,gBAAA;Ab6oLxC;;Aa7oLE;EAAsC,gBAAA;AbipLxC;;AajpLE;EAAsC,gBAAA;AbqpLxC;;AarpLE;EAAsC,gBAAA;AbypLxC;;AazpLE;EAAsC,gBAAA;Ab6pLxC;;Aa7pLE;EAAsC,gBAAA;AbiqLxC;;AajqLE;EAAsC,gBAAA;AbqqLxC;;AarqLE;EAAsC,gBAAA;AbyqLxC;;AazqLE;EAAsC,gBAAA;Ab6qLxC;;Aa7qLE;EAAsC,gBAAA;AbirLxC;;AajrLE;EAAsC,gBAAA;AbqrLxC;;AarrLE;EAAsC,gBAAA;AbyrLxC;;AazrLE;EAAsC,gBAAA;Ab6rLxC;;Aa7rLE;EAAsC,gBAAA;AbisLxC;;AajsLE;EAAsC,gBAAA;AbqsLxC;;AarsLE;EAAsC,gBAAA;AbysLxC;;AazsLE;EAAsC,gBAAA;Ab6sLxC;;Aa7sLE;EAAsC,gBAAA;AbitLxC;;AajtLE;EAAsC,gBAAA;AbqtLxC;;AartLE;EAAsC,gBAAA;AbytLxC;;AaztLE;EAAsC,gBAAA;Ab6tLxC;;Aa7tLE;EAAsC,gBAAA;AbiuLxC;;AajuLE;EAAsC,gBAAA;AbquLxC;;AaruLE;EAAsC,gBAAA;AbyuLxC;;AazuLE;EAAsC,gBAAA;Ab6uLxC;;Aa7uLE;EAAsC,gBAAA;AbivLxC;;AajvLE;EAAsC,gBAAA;AbqvLxC;;AarvLE;EAAsC,gBAAA;AbyvLxC;;AazvLE;EAAsC,gBAAA;Ab6vLxC;;Aa7vLE;EAAsC,gBAAA;AbiwLxC;;AajwLE;EAAsC,gBAAA;AbqwLxC;;AarwLE;EAAsC,gBAAA;AbywLxC;;AazwLE;EAAsC,gBAAA;Ab6wLxC;;Aa7wLE;EAAsC,gBAAA;AbixLxC;;AajxLE;EAAsC,gBAAA;AbqxLxC;;AarxLE;EAAsC,gBAAA;AbyxLxC;;AazxLE;EAAsC,gBAAA;Ab6xLxC;;Aa7xLE;EAAsC,gBAAA;AbiyLxC;;AajyLE;EAAsC,gBAAA;AbqyLxC;;AaryLE;EAAsC,gBAAA;AbyyLxC;;AazyLE;EAAsC,gBAAA;Ab6yLxC;;Aa7yLE;EAAsC,gBAAA;AbizLxC;;AajzLE;EAAsC,gBAAA;AbqzLxC;;AarzLE;EAAsC,gBAAA;AbyzLxC;;AazzLE;EAAsC,gBAAA;Ab6zLxC;;Aa7zLE;EAAsC,gBAAA;Abi0LxC;;Aaj0LE;EAAsC,aAAA;Abq0LxC;;Aar0LE;EAAsC,gBAAA;Aby0LxC;;Aaz0LE;EAAsC,gBAAA;Ab60LxC;;Aa70LE;EAAsC,gBAAA;Abi1LxC;;Aaj1LE;EAAsC,gBAAA;Abq1LxC;;Aar1LE;EAAsC,gBAAA;Aby1LxC;;Aaz1LE;EAAsC,gBAAA;Ab61LxC;;Aa71LE;EAAsC,gBAAA;Abi2LxC;;Aaj2LE;EAAsC,gBAAA;Abq2LxC;;Aar2LE;EAAsC,gBAAA;Aby2LxC;;Aaz2LE;EAAsC,gBAAA;Ab62LxC;;Aa72LE;EAAsC,gBAAA;Abi3LxC;;Aaj3LE;EAAsC,gBAAA;Abq3LxC;;Aar3LE;EAAsC,gBAAA;Aby3LxC;;Aaz3LE;EAAsC,gBAAA;Ab63LxC;;Aa73LE;EAAsC,gBAAA;Abi4LxC;;Aaj4LE;EAAsC,gBAAA;Abq4LxC;;Aar4LE;EAAsC,gBAAA;Aby4LxC;;Aaz4LE;EAAsC,gBAAA;Ab64LxC;;Aa74LE;EAAsC,gBAAA;Abi5LxC;;Aaj5LE;EAAsC,gBAAA;Abq5LxC;;Aar5LE;EAAsC,gBAAA;Aby5LxC;;Aaz5LE;EAAsC,gBAAA;Ab65LxC;;Aa75LE;EAAsC,gBAAA;Abi6LxC;;Aaj6LE;EAAsC,gBAAA;Abq6LxC;;Aar6LE;EAAsC,gBAAA;Aby6LxC;;Aaz6LE;EAAsC,gBAAA;Ab66LxC;;Aa76LE;EAAsC,gBAAA;Abi7LxC;;Aaj7LE;EAAsC,gBAAA;Abq7LxC;;Aar7LE;EAAsC,gBAAA;Aby7LxC;;Aaz7LE;EAAsC,gBAAA;Ab67LxC;;Aa77LE;EAAsC,gBAAA;Abi8LxC;;Aaj8LE;EAAsC,gBAAA;Abq8LxC;;Aar8LE;EAAsC,gBAAA;Aby8LxC;;Aaz8LE;EAAsC,gBAAA;Ab68LxC;;Aa78LE;EAAsC,gBAAA;Abi9LxC;;Aaj9LE;EAAsC,gBAAA;Abq9LxC;;Aar9LE;EAAsC,gBAAA;Aby9LxC;;Aaz9LE;EAAsC,gBAAA;Ab69LxC;;Aa79LE;EAAsC,gBAAA;Abi+LxC;;Aaj+LE;EAAsC,gBAAA;Abq+LxC;;Aar+LE;EAAsC,gBAAA;Aby+LxC;;Aaz+LE;EAAsC,gBAAA;Ab6+LxC;;Aa7+LE;EAAsC,gBAAA;Abi/LxC;;Aaj/LE;EAAsC,gBAAA;Abq/LxC;;Aar/LE;EAAsC,gBAAA;Aby/LxC;;Aaz/LE;EAAsC,gBAAA;Ab6/LxC;;Aa7/LE;EAAsC,gBAAA;AbigMxC;;AajgME;EAAsC,gBAAA;AbqgMxC;;AargME;EAAsC,gBAAA;AbygMxC;;AazgME;EAAsC,gBAAA;Ab6gMxC;;Aa7gME;EAAsC,gBAAA;AbihMxC;;AajhME;EAAsC,gBAAA;AbqhMxC;;AarhME;EAAsC,aAAA;AbyhMxC;;AazhME;EAAsC,gBAAA;Ab6hMxC;;Aa7hME;EAAsC,gBAAA;AbiiMxC;;AajiME;EAAsC,gBAAA;AbqiMxC;;AariME;EAAsC,gBAAA;AbyiMxC;;AaziME;EAAsC,gBAAA;Ab6iMxC;;Aa7iME;EAAsC,gBAAA;AbijMxC;;AajjME;EAAsC,gBAAA;AbqjMxC;;AarjME;EAAsC,gBAAA;AbyjMxC;;AazjME;EAAsC,gBAAA;Ab6jMxC;;Aa7jME;EAAsC,gBAAA;AbikMxC;;AajkME;EAAsC,gBAAA;AbqkMxC;;AarkME;EAAsC,gBAAA;AbykMxC;;AazkME;EAAsC,gBAAA;Ab6kMxC;;Aa7kME;EAAsC,gBAAA;AbilMxC;;AajlME;EAAsC,gBAAA;AbqlMxC;;AarlME;EAAsC,gBAAA;AbylMxC;;AazlME;EAAsC,gBAAA;Ab6lMxC;;Aa7lME;EAAsC,gBAAA;AbimMxC;;AajmME;EAAsC,gBAAA;AbqmMxC;;AarmME;EAAsC,gBAAA;AbymMxC;;AazmME;EAAsC,gBAAA;Ab6mMxC;;Aa7mME;EAAsC,gBAAA;AbinMxC;;AajnME;EAAsC,gBAAA;AbqnMxC;;AarnME;EAAsC,gBAAA;AbynMxC;;AaznME;EAAsC,gBAAA;Ab6nMxC;;Aa7nME;EAAsC,gBAAA;AbioMxC;;AajoME;EAAsC,gBAAA;AbqoMxC;;AaroME;EAAsC,gBAAA;AbyoMxC;;AazoME;EAAsC,gBAAA;Ab6oMxC;;Aa7oME;EAAsC,gBAAA;AbipMxC;;AajpME;EAAsC,gBAAA;AbqpMxC;;AarpME;EAAsC,gBAAA;AbypMxC;;AazpME;EAAsC,gBAAA;Ab6pMxC;;Aa7pME;EAAsC,gBAAA;AbiqMxC;;AajqME;EAAsC,gBAAA;AbqqMxC;;AarqME;EAAsC,gBAAA;AbyqMxC;;AazqME;EAAsC,gBAAA;Ab6qMxC;;Aa7qME;EAAsC,gBAAA;AbirMxC;;AajrME;EAAsC,gBAAA;AbqrMxC;;AarrME;EAAsC,gBAAA;AbyrMxC;;AazrME;EAAsC,gBAAA;Ab6rMxC;;Aa7rME;EAAsC,gBAAA;AbisMxC;;AajsME;EAAsC,gBAAA;AbqsMxC;;AarsME;EAAsC,gBAAA;AbysMxC;;AazsME;EAAsC,gBAAA;Ab6sMxC;;Aa7sME;EAAsC,gBAAA;AbitMxC;;AajtME;EAAsC,gBAAA;AbqtMxC;;AartME;EAAsC,gBAAA;AbytMxC;;AaztME;EAAsC,gBAAA;Ab6tMxC;;Aa7tME;EAAsC,gBAAA;AbiuMxC;;AajuME;EAAsC,gBAAA;AbquMxC;;AaruME;EAAsC,gBAAA;AbyuMxC;;AazuME;EAAsC,gBAAA;Ab6uMxC;;Aa7uME;EAAsC,gBAAA;AbivMxC;;AajvME;EAAsC,gBAAA;AbqvMxC;;AarvME;EAAsC,gBAAA;AbyvMxC;;AazvME;EAAsC,gBAAA;Ab6vMxC;;Aa7vME;EAAsC,gBAAA;AbiwMxC;;AajwME;EAAsC,gBAAA;AbqwMxC;;AarwME;EAAsC,gBAAA;AbywMxC;;AazwME;EAAsC,gBAAA;Ab6wMxC;;Aa7wME;EAAsC,gBAAA;AbixMxC;;AajxME;EAAsC,gBAAA;AbqxMxC;;AarxME;EAAsC,gBAAA;AbyxMxC;;AazxME;EAAsC,gBAAA;Ab6xMxC;;Aa7xME;EAAsC,gBAAA;AbiyMxC;;AajyME;EAAsC,gBAAA;AbqyMxC;;AaryME;EAAsC,gBAAA;AbyyMxC;;AazyME;EAAsC,gBAAA;Ab6yMxC;;Aa7yME;EAAsC,gBAAA;AbizMxC;;AajzME;EAAsC,gBAAA;AbqzMxC;;AarzME;EAAsC,gBAAA;AbyzMxC;;AazzME;EAAsC,gBAAA;Ab6zMxC;;Aa7zME;EAAsC,gBAAA;Abi0MxC;;Aaj0ME;EAAsC,gBAAA;Abq0MxC;;Aar0ME;EAAsC,gBAAA;Aby0MxC;;Aaz0ME;EAAsC,gBAAA;Ab60MxC;;Aa70ME;EAAsC,gBAAA;Abi1MxC;;Aaj1ME;EAAsC,gBAAA;Abq1MxC;;Aar1ME;EAAsC,gBAAA;Aby1MxC;;Aaz1ME;EAAsC,gBAAA;Ab61MxC;;Aa71ME;EAAsC,gBAAA;Abi2MxC;;Aaj2ME;EAAsC,gBAAA;Abq2MxC;;Aar2ME;EAAsC,gBAAA;Aby2MxC;;Aaz2ME;EAAsC,gBAAA;Ab62MxC;;Aa72ME;EAAsC,gBAAA;Abi3MxC;;Aaj3ME;EAAsC,gBAAA;Abq3MxC;;Aar3ME;EAAsC,gBAAA;Aby3MxC;;Aaz3ME;EAAsC,gBAAA;Ab63MxC;;Aa73ME;EAAsC,gBAAA;Abi4MxC;;Aaj4ME;EAAsC,gBAAA;Abq4MxC;;Aar4ME;EAAsC,gBAAA;Aby4MxC;;Aaz4ME;EAAsC,gBAAA;Ab64MxC;;Aa74ME;EAAsC,gBAAA;Abi5MxC;;Aaj5ME;EAAsC,gBAAA;Abq5MxC;;Aar5ME;EAAsC,gBAAA;Aby5MxC;;Aaz5ME;EAAsC,gBAAA;Ab65MxC;;Aa75ME;EAAsC,gBAAA;Abi6MxC;;Aaj6ME;EAAsC,gBAAA;Abq6MxC;;Aar6ME;EAAsC,gBAAA;Aby6MxC;;Aaz6ME;EAAsC,gBAAA;Ab66MxC;;Aa76ME;EAAsC,gBAAA;Abi7MxC;;Aaj7ME;EAAsC,gBAAA;Abq7MxC;;Aar7ME;EAAsC,gBAAA;Aby7MxC;;Aaz7ME;EAAsC,gBAAA;Ab67MxC;;Aa77ME;EAAsC,YAAA;Abi8MxC;;Aaj8ME;EAAsC,gBAAA;Abq8MxC;;Aar8ME;EAAsC,gBAAA;Aby8MxC;;Aaz8ME;EAAsC,gBAAA;Ab68MxC;;Aa78ME;EAAsC,gBAAA;Abi9MxC;;Aaj9ME;EAAsC,gBAAA;Abq9MxC;;Aar9ME;EAAsC,gBAAA;Aby9MxC;;Aaz9ME;EAAsC,gBAAA;Ab69MxC;;Aa79ME;EAAsC,gBAAA;Abi+MxC;;Aaj+ME;EAAsC,gBAAA;Abq+MxC;;Aar+ME;EAAsC,gBAAA;Aby+MxC;;Aaz+ME;EAAsC,gBAAA;Ab6+MxC;;Aa7+ME;EAAsC,gBAAA;Abi/MxC;;Aaj/ME;EAAsC,gBAAA;Abq/MxC;;Aar/ME;EAAsC,gBAAA;Aby/MxC;;Aaz/ME;EAAsC,gBAAA;Ab6/MxC;;Aa7/ME;EAAsC,gBAAA;AbigNxC;;AajgNE;EAAsC,gBAAA;AbqgNxC;;AargNE;EAAsC,gBAAA;AbygNxC;;AazgNE;EAAsC,gBAAA;Ab6gNxC;;Aa7gNE;EAAsC,gBAAA;AbihNxC;;AajhNE;EAAsC,gBAAA;AbqhNxC;;AarhNE;EAAsC,gBAAA;AbyhNxC;;AazhNE;EAAsC,gBAAA;Ab6hNxC;;Aa7hNE;EAAsC,gBAAA;AbiiNxC;;AajiNE;EAAsC,gBAAA;AbqiNxC;;AariNE;EAAsC,gBAAA;AbyiNxC;;AaziNE;EAAsC,gBAAA;Ab6iNxC;;Aa7iNE;EAAsC,gBAAA;AbijNxC;;AajjNE;EAAsC,gBAAA;AbqjNxC;;AarjNE;EAAsC,gBAAA;AbyjNxC;;AazjNE;EAAsC,aAAA;Ab6jNxC;;Aa7jNE;EAAsC,aAAA;AbikNxC;;AajkNE;EAAsC,gBAAA;AbqkNxC;;AarkNE;EAAsC,gBAAA;AbykNxC;;AazkNE;EAAsC,gBAAA;Ab6kNxC;;Aa7kNE;EAAsC,gBAAA;AbilNxC;;AajlNE;EAAsC,gBAAA;AbqlNxC;;AarlNE;EAAsC,gBAAA;AbylNxC;;AazlNE;EAAsC,gBAAA;Ab6lNxC;;Aa7lNE;EAAsC,gBAAA;AbimNxC;;AajmNE;EAAsC,gBAAA;AbqmNxC;;AarmNE;EAAsC,gBAAA;AbymNxC;;AazmNE;EAAsC,gBAAA;Ab6mNxC;;Aa7mNE;EAAsC,gBAAA;AbinNxC;;AajnNE;EAAsC,gBAAA;AbqnNxC;;AarnNE;EAAsC,gBAAA;AbynNxC;;AaznNE;EAAsC,gBAAA;Ab6nNxC;;Aa7nNE;EAAsC,gBAAA;AbioNxC;;AajoNE;EAAsC,gBAAA;AbqoNxC;;AaroNE;EAAsC,gBAAA;AbyoNxC;;AazoNE;EAAsC,gBAAA;Ab6oNxC;;Aa7oNE;EAAsC,gBAAA;AbipNxC;;AajpNE;EAAsC,gBAAA;AbqpNxC;;AarpNE;EAAsC,gBAAA;AbypNxC;;AazpNE;EAAsC,gBAAA;Ab6pNxC;;Aa7pNE;EAAsC,gBAAA;AbiqNxC;;AajqNE;EAAsC,aAAA;AbqqNxC;;AarqNE;EAAsC,gBAAA;AbyqNxC;;AazqNE;EAAsC,gBAAA;Ab6qNxC;;Aa7qNE;EAAsC,gBAAA;AbirNxC;;AajrNE;EAAsC,gBAAA;AbqrNxC;;AarrNE;EAAsC,gBAAA;AbyrNxC;;AazrNE;EAAsC,gBAAA;Ab6rNxC;;Aa7rNE;EAAsC,gBAAA;AbisNxC;;AajsNE;EAAsC,gBAAA;AbqsNxC;;AarsNE;EAAsC,gBAAA;AbysNxC;;AazsNE;EAAsC,gBAAA;Ab6sNxC;;Aa7sNE;EAAsC,gBAAA;AbitNxC;;AajtNE;EAAsC,gBAAA;AbqtNxC;;AartNE;EAAsC,gBAAA;AbytNxC;;AaztNE;EAAsC,gBAAA;Ab6tNxC;;Aa7tNE;EAAsC,gBAAA;AbiuNxC;;AajuNE;EAAsC,gBAAA;AbquNxC;;AaruNE;EAAsC,gBAAA;AbyuNxC;;AazuNE;EAAsC,gBAAA;Ab6uNxC;;Aa7uNE;EAAsC,gBAAA;AbivNxC;;AajvNE;EAAsC,gBAAA;AbqvNxC;;AarvNE;EAAsC,gBAAA;AbyvNxC;;AazvNE;EAAsC,gBAAA;Ab6vNxC;;Aa7vNE;EAAsC,gBAAA;AbiwNxC;;AajwNE;EAAsC,gBAAA;AbqwNxC;;AarwNE;EAAsC,gBAAA;AbywNxC;;AazwNE;EAAsC,gBAAA;Ab6wNxC;;Aa7wNE;EAAsC,gBAAA;AbixNxC;;AajxNE;EAAsC,gBAAA;AbqxNxC;;AarxNE;EAAsC,gBAAA;AbyxNxC;;AazxNE;EAAsC,gBAAA;Ab6xNxC;;Aa7xNE;EAAsC,gBAAA;AbiyNxC;;AajyNE;EAAsC,gBAAA;AbqyNxC;;AaryNE;EAAsC,gBAAA;AbyyNxC;;AazyNE;EAAsC,gBAAA;Ab6yNxC;;Aa7yNE;EAAsC,gBAAA;AbizNxC;;AajzNE;EAAsC,gBAAA;AbqzNxC;;AarzNE;EAAsC,gBAAA;AbyzNxC;;AazzNE;EAAsC,gBAAA;Ab6zNxC;;Aa7zNE;EAAsC,gBAAA;Abi0NxC;;Aaj0NE;EAAsC,gBAAA;Abq0NxC;;Aar0NE;EAAsC,gBAAA;Aby0NxC;;Aaz0NE;EAAsC,gBAAA;Ab60NxC;;Aa70NE;EAAsC,gBAAA;Abi1NxC;;Aaj1NE;EAAsC,gBAAA;Abq1NxC;;Aar1NE;EAAsC,gBAAA;Aby1NxC;;Aaz1NE;EAAsC,gBAAA;Ab61NxC;;Aa71NE;EAAsC,gBAAA;Abi2NxC;;Aaj2NE;EAAsC,gBAAA;Abq2NxC;;Aar2NE;EAAsC,aAAA;Aby2NxC;;Aaz2NE;EAAsC,aAAA;Ab62NxC;;Aa72NE;EAAsC,gBAAA;Abi3NxC;;Aaj3NE;EAAsC,gBAAA;Abq3NxC;;Aar3NE;EAAsC,gBAAA;Aby3NxC;;Aaz3NE;EAAsC,gBAAA;Ab63NxC;;Aa73NE;EAAsC,gBAAA;Abi4NxC;;Aaj4NE;EAAsC,gBAAA;Abq4NxC;;Aar4NE;EAAsC,gBAAA;Aby4NxC;;Aaz4NE;EAAsC,gBAAA;Ab64NxC;;Aa74NE;EAAsC,gBAAA;Abi5NxC;;Aaj5NE;EAAsC,gBAAA;Abq5NxC;;Aar5NE;EAAsC,gBAAA;Aby5NxC;;Aaz5NE;EAAsC,gBAAA;Ab65NxC;;Aa75NE;EAAsC,gBAAA;Abi6NxC;;Aaj6NE;EAAsC,gBAAA;Abq6NxC;;Aar6NE;EAAsC,gBAAA;Aby6NxC;;Aaz6NE;EAAsC,gBAAA;Ab66NxC;;Aa76NE;EAAsC,gBAAA;Abi7NxC;;Aaj7NE;EAAsC,gBAAA;Abq7NxC;;Aar7NE;EAAsC,gBAAA;Aby7NxC;;Aaz7NE;EAAsC,gBAAA;Ab67NxC;;Aa77NE;EAAsC,gBAAA;Abi8NxC;;Aaj8NE;EAAsC,gBAAA;Abq8NxC;;Aar8NE;EAAsC,gBAAA;Aby8NxC;;Aaz8NE;EAAsC,gBAAA;Ab68NxC;;Aa78NE;EAAsC,gBAAA;Abi9NxC;;Aaj9NE;EAAsC,gBAAA;Abq9NxC;;Aar9NE;EAAsC,gBAAA;Aby9NxC;;Aaz9NE;EAAsC,gBAAA;Ab69NxC;;Aa79NE;EAAsC,gBAAA;Abi+NxC;;Aaj+NE;EAAsC,gBAAA;Abq+NxC;;Aar+NE;EAAsC,gBAAA;Aby+NxC;;Aaz+NE;EAAsC,gBAAA;Ab6+NxC;;Aa7+NE;EAAsC,gBAAA;Abi/NxC;;Aaj/NE;EAAsC,gBAAA;Abq/NxC;;Aar/NE;EAAsC,gBAAA;Aby/NxC;;Aaz/NE;EAAsC,gBAAA;Ab6/NxC;;Aa7/NE;EAAsC,gBAAA;AbigOxC;;AajgOE;EAAsC,gBAAA;AbqgOxC;;AargOE;EAAsC,gBAAA;AbygOxC;;AazgOE;EAAsC,gBAAA;Ab6gOxC;;Aa7gOE;EAAsC,gBAAA;AbihOxC;;AajhOE;EAAsC,gBAAA;AbqhOxC;;AarhOE;EAAsC,gBAAA;AbyhOxC;;AazhOE;EAAsC,gBAAA;Ab6hOxC;;Aa7hOE;EAAsC,gBAAA;AbiiOxC;;AajiOE;EAAsC,gBAAA;AbqiOxC;;AariOE;EAAsC,gBAAA;AbyiOxC;;AaziOE;EAAsC,gBAAA;Ab6iOxC;;Aa7iOE;EAAsC,gBAAA;AbijOxC;;AajjOE;EAAsC,gBAAA;AbqjOxC;;AarjOE;EAAsC,gBAAA;AbyjOxC;;AazjOE;EAAsC,gBAAA;Ab6jOxC;;Aa7jOE;EAAsC,gBAAA;AbikOxC;;AajkOE;EAAsC,gBAAA;AbqkOxC;;AarkOE;EAAsC,gBAAA;AbykOxC;;AazkOE;EAAsC,gBAAA;Ab6kOxC;;Aa7kOE;EAAsC,gBAAA;AbilOxC;;AajlOE;EAAsC,gBAAA;AbqlOxC;;AarlOE;EAAsC,gBAAA;AbylOxC;;AazlOE;EAAsC,gBAAA;Ab6lOxC;;Aa7lOE;EAAsC,gBAAA;AbimOxC;;AajmOE;EAAsC,gBAAA;AbqmOxC;;AarmOE;EAAsC,gBAAA;AbymOxC;;AazmOE;EAAsC,gBAAA;Ab6mOxC;;Aa7mOE;EAAsC,gBAAA;AbinOxC;;AajnOE;EAAsC,gBAAA;AbqnOxC;;AarnOE;EAAsC,gBAAA;AbynOxC;;AaznOE;EAAsC,gBAAA;Ab6nOxC;;Aa7nOE;EAAsC,gBAAA;AbioOxC;;AajoOE;EAAsC,gBAAA;AbqoOxC;;AaroOE;EAAsC,gBAAA;AbyoOxC;;AazoOE;EAAsC,gBAAA;Ab6oOxC;;Aa7oOE;EAAsC,gBAAA;AbipOxC;;AajpOE;EAAsC,gBAAA;AbqpOxC;;AarpOE;EAAsC,gBAAA;AbypOxC;;AazpOE;EAAsC,gBAAA;Ab6pOxC;;Aa7pOE;EAAsC,gBAAA;AbiqOxC;;AajqOE;EAAsC,gBAAA;AbqqOxC;;AarqOE;EAAsC,gBAAA;AbyqOxC;;AazqOE;EAAsC,gBAAA;Ab6qOxC;;Aa7qOE;EAAsC,aAAA;AbirOxC;;AajrOE;EAAsC,gBAAA;AbqrOxC;;AarrOE;EAAsC,gBAAA;AbyrOxC;;AazrOE;EAAsC,gBAAA;Ab6rOxC;;Aa7rOE;EAAsC,YAAA;AbisOxC;;AajsOE;EAAsC,gBAAA;AbqsOxC;;AarsOE;EAAsC,gBAAA;AbysOxC;;AazsOE;EAAsC,gBAAA;Ab6sOxC;;Aa7sOE;EAAsC,gBAAA;AbitOxC;;AajtOE;EAAsC,gBAAA;AbqtOxC;;AartOE;EAAsC,gBAAA;AbytOxC;;AaztOE;EAAsC,gBAAA;Ab6tOxC;;Aa7tOE;EAAsC,gBAAA;AbiuOxC;;AajuOE;EAAsC,gBAAA;AbquOxC;;AaruOE;EAAsC,gBAAA;AbyuOxC;;AazuOE;EAAsC,gBAAA;Ab6uOxC;;Aa7uOE;EAAsC,gBAAA;AbivOxC;;AajvOE;EAAsC,gBAAA;AbqvOxC;;AarvOE;EAAsC,gBAAA;AbyvOxC;;AazvOE;EAAsC,gBAAA;Ab6vOxC;;Aa7vOE;EAAsC,gBAAA;AbiwOxC;;AajwOE;EAAsC,gBAAA;AbqwOxC;;AarwOE;EAAsC,gBAAA;AbywOxC;;AazwOE;EAAsC,gBAAA;Ab6wOxC;;Aa7wOE;EAAsC,gBAAA;AbixOxC;;AajxOE;EAAsC,gBAAA;AbqxOxC;;AarxOE;EAAsC,gBAAA;AbyxOxC;;AazxOE;EAAsC,gBAAA;Ab6xOxC;;Aa7xOE;EAAsC,gBAAA;AbiyOxC;;AajyOE;EAAsC,gBAAA;AbqyOxC;;AaryOE;EAAsC,gBAAA;AbyyOxC;;AazyOE;EAAsC,gBAAA;Ab6yOxC;;Aa7yOE;EAAsC,gBAAA;AbizOxC;;AajzOE;EAAsC,gBAAA;AbqzOxC;;AarzOE;EAAsC,gBAAA;AbyzOxC;;AazzOE;EAAsC,gBAAA;Ab6zOxC;;Aa7zOE;EAAsC,gBAAA;Abi0OxC;;Aaj0OE;EAAsC,gBAAA;Abq0OxC;;Aar0OE;EAAsC,gBAAA;Aby0OxC;;Aaz0OE;EAAsC,gBAAA;Ab60OxC;;Aa70OE;EAAsC,gBAAA;Abi1OxC;;Aaj1OE;EAAsC,gBAAA;Abq1OxC;;Aar1OE;EAAsC,gBAAA;Aby1OxC;;Aaz1OE;EAAsC,gBAAA;Ab61OxC;;Aa71OE;EAAsC,gBAAA;Abi2OxC;;Aaj2OE;EAAsC,gBAAA;Abq2OxC;;Aar2OE;EAAsC,gBAAA;Aby2OxC;;Aaz2OE;EAAsC,gBAAA;Ab62OxC;;Aa72OE;EAAsC,gBAAA;Abi3OxC;;Aaj3OE;EAAsC,gBAAA;Abq3OxC;;Aar3OE;EAAsC,gBAAA;Aby3OxC;;Aaz3OE;EAAsC,gBAAA;Ab63OxC;;Aa73OE;EAAsC,gBAAA;Abi4OxC;;Aaj4OE;EAAsC,gBAAA;Abq4OxC;;Aar4OE;EAAsC,gBAAA;Aby4OxC;;Aaz4OE;EAAsC,gBAAA;Ab64OxC;;Aa74OE;EAAsC,gBAAA;Abi5OxC;;Aaj5OE;EAAsC,gBAAA;Abq5OxC;;Aar5OE;EAAsC,gBAAA;Aby5OxC;;Aaz5OE;EAAsC,gBAAA;Ab65OxC;;Aa75OE;EAAsC,YAAA;Abi6OxC;;Aaj6OE;EAAsC,gBAAA;Abq6OxC;;Aar6OE;EAAsC,gBAAA;Aby6OxC;;Aaz6OE;EAAsC,gBAAA;Ab66OxC;;Aa76OE;EAAsC,gBAAA;Abi7OxC;;Aaj7OE;EAAsC,gBAAA;Abq7OxC;;Aar7OE;EAAsC,gBAAA;Aby7OxC;;Aaz7OE;EAAsC,gBAAA;Ab67OxC;;Aa77OE;EAAsC,gBAAA;Abi8OxC;;Aaj8OE;EAAsC,gBAAA;Abq8OxC;;Aar8OE;EAAsC,gBAAA;Aby8OxC;;Aaz8OE;EAAsC,gBAAA;Ab68OxC;;Aa78OE;EAAsC,gBAAA;Abi9OxC;;Aaj9OE;EAAsC,gBAAA;Abq9OxC;;Aar9OE;EAAsC,gBAAA;Aby9OxC;;Aaz9OE;EAAsC,gBAAA;Ab69OxC;;Aa79OE;EAAsC,gBAAA;Abi+OxC;;Aaj+OE;EAAsC,gBAAA;Abq+OxC;;Aar+OE;EAAsC,gBAAA;Aby+OxC;;Aaz+OE;EAAsC,gBAAA;Ab6+OxC;;Aa7+OE;EAAsC,gBAAA;Abi/OxC;;Aaj/OE;EAAsC,gBAAA;Abq/OxC;;Aar/OE;EAAsC,gBAAA;Aby/OxC;;Aaz/OE;EAAsC,gBAAA;Ab6/OxC;;Aa7/OE;EAAsC,gBAAA;AbigPxC;;AajgPE;EAAsC,gBAAA;AbqgPxC;;AargPE;EAAsC,gBAAA;AbygPxC;;AazgPE;EAAsC,gBAAA;Ab6gPxC;;Aa7gPE;EAAsC,gBAAA;AbihPxC;;AajhPE;EAAsC,gBAAA;AbqhPxC;;AarhPE;EAAsC,gBAAA;AbyhPxC;;AazhPE;EAAsC,gBAAA;Ab6hPxC;;Aa7hPE;EAAsC,gBAAA;AbiiPxC;;AajiPE;EAAsC,gBAAA;AbqiPxC;;AariPE;EAAsC,gBAAA;AbyiPxC;;AaziPE;EAAsC,gBAAA;Ab6iPxC;;Aa7iPE;EAAsC,gBAAA;AbijPxC;;AajjPE;EAAsC,gBAAA;AbqjPxC;;AarjPE;EAAsC,gBAAA;AbyjPxC;;AazjPE;EAAsC,gBAAA;Ab6jPxC;;Aa7jPE;EAAsC,gBAAA;AbikPxC;;AajkPE;EAAsC,gBAAA;AbqkPxC;;AarkPE;EAAsC,gBAAA;AbykPxC;;AazkPE;EAAsC,gBAAA;Ab6kPxC;;Aa7kPE;EAAsC,gBAAA;AbilPxC;;AajlPE;EAAsC,gBAAA;AbqlPxC;;AarlPE;EAAsC,gBAAA;AbylPxC;;AazlPE;EAAsC,gBAAA;Ab6lPxC;;Aa7lPE;EAAsC,gBAAA;AbimPxC;;AajmPE;EAAsC,gBAAA;AbqmPxC;;AarmPE;EAAsC,gBAAA;AbymPxC;;AazmPE;EAAsC,gBAAA;Ab6mPxC;;Aa7mPE;EAAsC,gBAAA;AbinPxC;;AajnPE;EAAsC,gBAAA;AbqnPxC;;AarnPE;EAAsC,gBAAA;AbynPxC;;AaznPE;EAAsC,gBAAA;Ab6nPxC;;Aa7nPE;EAAsC,gBAAA;AbioPxC;;AajoPE;EAAsC,gBAAA;AbqoPxC;;AaroPE;EAAsC,gBAAA;AbyoPxC;;AazoPE;EAAsC,gBAAA;Ab6oPxC;;Aa7oPE;EAAsC,gBAAA;AbipPxC;;AajpPE;EAAsC,gBAAA;AbqpPxC;;AarpPE;EAAsC,gBAAA;AbypPxC;;AazpPE;EAAsC,gBAAA;Ab6pPxC;;Aa7pPE;EAAsC,gBAAA;AbiqPxC;;AajqPE;EAAsC,gBAAA;AbqqPxC;;AarqPE;EAAsC,gBAAA;AbyqPxC;;AazqPE;EAAsC,gBAAA;Ab6qPxC;;Aa7qPE;EAAsC,gBAAA;AbirPxC;;AajrPE;EAAsC,gBAAA;AbqrPxC;;AarrPE;EAAsC,gBAAA;AbyrPxC;;AazrPE;EAAsC,gBAAA;Ab6rPxC;;Aa7rPE;EAAsC,gBAAA;AbisPxC;;AajsPE;EAAsC,gBAAA;AbqsPxC;;AarsPE;EAAsC,gBAAA;AbysPxC;;AazsPE;EAAsC,gBAAA;Ab6sPxC;;Aa7sPE;EAAsC,gBAAA;AbitPxC;;AajtPE;EAAsC,gBAAA;AbqtPxC;;AartPE;EAAsC,gBAAA;AbytPxC;;AaztPE;EAAsC,gBAAA;Ab6tPxC;;Aa7tPE;EAAsC,gBAAA;AbiuPxC;;AajuPE;EAAsC,gBAAA;AbquPxC;;AaruPE;EAAsC,gBAAA;AbyuPxC;;AazuPE;EAAsC,gBAAA;Ab6uPxC;;Aa7uPE;EAAsC,gBAAA;AbivPxC;;AajvPE;EAAsC,gBAAA;AbqvPxC;;AarvPE;EAAsC,gBAAA;AbyvPxC;;AazvPE;EAAsC,gBAAA;Ab6vPxC;;Aa7vPE;EAAsC,gBAAA;AbiwPxC;;AajwPE;EAAsC,gBAAA;AbqwPxC;;AarwPE;EAAsC,gBAAA;AbywPxC;;AazwPE;EAAsC,gBAAA;Ab6wPxC;;Aa7wPE;EAAsC,gBAAA;AbixPxC;;AajxPE;EAAsC,gBAAA;AbqxPxC;;AarxPE;EAAsC,gBAAA;AbyxPxC;;AazxPE;EAAsC,gBAAA;Ab6xPxC;;Aa7xPE;EAAsC,gBAAA;AbiyPxC;;AajyPE;EAAsC,gBAAA;AbqyPxC;;AaryPE;EAAsC,gBAAA;AbyyPxC;;AazyPE;EAAsC,gBAAA;Ab6yPxC;;Aa7yPE;EAAsC,gBAAA;AbizPxC;;AajzPE;EAAsC,gBAAA;AbqzPxC;;AarzPE;EAAsC,gBAAA;AbyzPxC;;AazzPE;EAAsC,gBAAA;Ab6zPxC;;Aa7zPE;EAAsC,gBAAA;Abi0PxC;;Aaj0PE;EAAsC,gBAAA;Abq0PxC;;Aar0PE;EAAsC,gBAAA;Aby0PxC;;Aaz0PE;EAAsC,gBAAA;Ab60PxC;;Aa70PE;EAAsC,gBAAA;Abi1PxC;;Aaj1PE;EAAsC,gBAAA;Abq1PxC;;Aar1PE;EAAsC,gBAAA;Aby1PxC;;Aaz1PE;EAAsC,gBAAA;Ab61PxC;;Aa71PE;EAAsC,gBAAA;Abi2PxC;;Aaj2PE;EAAsC,gBAAA;Abq2PxC;;Aar2PE;EAAsC,gBAAA;Aby2PxC;;Aaz2PE;EAAsC,gBAAA;Ab62PxC;;Aa72PE;EAAsC,gBAAA;Abi3PxC;;Aaj3PE;EAAsC,gBAAA;Abq3PxC;;Aar3PE;EAAsC,gBAAA;Aby3PxC;;Aaz3PE;EAAsC,gBAAA;Ab63PxC;;Aa73PE;EAAsC,gBAAA;Abi4PxC;;Aaj4PE;EAAsC,gBAAA;Abq4PxC;;Aar4PE;EAAsC,gBAAA;Aby4PxC;;Aaz4PE;EAAsC,aAAA;Ab64PxC;;Aa74PE;EAAsC,gBAAA;Abi5PxC;;Aaj5PE;EAAsC,gBAAA;Abq5PxC;;Aar5PE;EAAsC,gBAAA;Aby5PxC;;Aaz5PE;EAAsC,gBAAA;Ab65PxC;;Aa75PE;EAAsC,gBAAA;Abi6PxC;;Aaj6PE;EAAsC,aAAA;Abq6PxC;;Aar6PE;EAAsC,aAAA;Aby6PxC;;Aaz6PE;EAAsC,aAAA;Ab66PxC;;Aa76PE;EAAsC,YAAA;Abi7PxC;;Aaj7PE;EAAsC,gBAAA;Abq7PxC;;Aar7PE;EAAsC,gBAAA;Aby7PxC;;Aaz7PE;EAAsC,gBAAA;Ab67PxC;;Aa77PE;EAAsC,gBAAA;Abi8PxC;;Aaj8PE;EAAsC,gBAAA;Abq8PxC;;Aar8PE;EAAsC,gBAAA;Aby8PxC;;Aaz8PE;EAAsC,gBAAA;Ab68PxC;;Aa78PE;EAAsC,gBAAA;Abi9PxC;;Aaj9PE;EAAsC,gBAAA;Abq9PxC;;Aar9PE;EAAsC,gBAAA;Aby9PxC;;Aaz9PE;EAAsC,gBAAA;Ab69PxC;;Aa79PE;EAAsC,gBAAA;Abi+PxC;;Aaj+PE;EAAsC,YAAA;Abq+PxC;;Aar+PE;EAAsC,gBAAA;Aby+PxC;;Aaz+PE;EAAsC,gBAAA;Ab6+PxC;;Aa7+PE;EAAsC,gBAAA;Abi/PxC;;Aaj/PE;EAAsC,gBAAA;Abq/PxC;;Aar/PE;EAAsC,gBAAA;Aby/PxC;;Aaz/PE;EAAsC,gBAAA;Ab6/PxC;;Aa7/PE;EAAsC,gBAAA;AbigQxC;;AajgQE;EAAsC,gBAAA;AbqgQxC;;AargQE;EAAsC,gBAAA;AbygQxC;;AazgQE;EAAsC,gBAAA;Ab6gQxC;;Aa7gQE;EAAsC,gBAAA;AbihQxC;;AajhQE;EAAsC,gBAAA;AbqhQxC;;AarhQE;EAAsC,gBAAA;AbyhQxC;;AazhQE;EAAsC,gBAAA;Ab6hQxC;;Aa7hQE;EAAsC,gBAAA;AbiiQxC;;AajiQE;EAAsC,gBAAA;AbqiQxC;;AariQE;EAAsC,gBAAA;AbyiQxC;;AaziQE;EAAsC,gBAAA;Ab6iQxC;;Aa7iQE;EAAsC,gBAAA;AbijQxC;;AajjQE;EAAsC,gBAAA;AbqjQxC;;AarjQE;EAAsC,gBAAA;AbyjQxC;;Ac5jQA;;ETqBE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AL4iQF;;AKviQE;;EAbA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;ALyjQF;;Ae1lQA;;;;EAAA;AAQA;EACE,gDAAA;EACA,yDAAA;Af0lQF;;AevlQA;EACE,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBR8BwB;EQ7BxB,0HAAA;Af0lQF;AetlQA;;EAEE,gBAAA;AfwlQF;;AgBhnQA;;;;EAAA;AAQA;EACE,gDAAA;EACA,uDAAA;AhBgnQF;;AgB7mQA;EACE,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBT8BwB;ES7BxB,0HAAA;AhBgnQF;AgB5mQA;;EAEE,gBAAA;AhB8mQF;;AiBroQE;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,4BAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAIA,8BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,yBAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,qNAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC2OI,yBALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,qBAAA;EACA,+BAAA;EAEA,qCAAA;EACA,gCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,iCAAA;EACA,+BAAA;EAEA,8BAAA;EACA,sCAAA;EAMA,wBAAA;EACA,6BAAA;EACA,0BAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,kDAAA;EACA,2DAAA;EACA,oDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,+CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AlBqoQF;;AoBrvQI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,yBAAA;EACA,gCAAA;EAGE,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,0CAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,wCAAA;EAEA,wBAAA;EACA,6BAAA;EACA,0BAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AlBqoQJ;;AqB7yQA;;;EAGE,sBAAA;ArBgzQF;;AqBjyQI;EANJ;IAOM,uBAAA;ErBqyQJ;AACF;;AqBxxQA;EACE,SAAA;EACA,uCAAA;EF6OI,mCALI;EEtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;ArB2xQF;;AqBlxQA;EACE,cAAA;EACA,cCmnB4B;EDlnB5B,SAAA;EACA,wCAAA;EACA,aCynB4B;AtB4pP9B;;AqB3wQA;EACE,aAAA;EACA,qBCwjB4B;EDrjB5B,gBCwjB4B;EDvjB5B,gBCwjB4B;EDvjB5B,8BAAA;ArB4wQF;;AqBzwQA;EFuMQ,iCAAA;AnBskQR;AmBluQI;EE3CJ;IF8MQ,iBAAA;EnBmkQN;AACF;;AqB7wQA;EFkMQ,iCAAA;AnB+kQR;AmB3uQI;EEtCJ;IFyMQ,eAAA;EnB4kQN;AACF;;AqBjxQA;EF6LQ,+BAAA;AnBwlQR;AmBpvQI;EEjCJ;IFoMQ,kBAAA;EnBqlQN;AACF;;AqBrxQA;EFwLQ,iCAAA;AnBimQR;AmB7vQI;EE5BJ;IF+LQ,iBAAA;EnB8lQN;AACF;;AqBzxQA;EF+KM,kBALI;AnBmnQV;;AqBxxQA;EF0KM,eALI;AnBunQV;;AqBjxQA;EACE,aAAA;EACA,mBCwV0B;AtB47P5B;;AqB1wQA;EACE,iCAAA;EACA,YAAA;EACA,8BAAA;ArB6wQF;;AqBvwQA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;ArB0wQF;;AqBpwQA;;EAEE,kBAAA;ArBuwQF;;AqBpwQA;;;EAGE,aAAA;EACA,mBAAA;ArBuwQF;;AqBpwQA;;;;EAIE,gBAAA;ArBuwQF;;AqBpwQA;EACE,gBC6b4B;AtB00P9B;;AqBlwQA;EACE,qBAAA;EACA,cAAA;ArBqwQF;;AqB/vQA;EACE,gBAAA;ArBkwQF;;AqB1vQA;;EAEE,mBCsa4B;AtBu1P9B;;AqBrvQA;EF6EM,kBALI;AnBirQV;;AqBlvQA;EACE,iBCqf4B;EDpf5B,gCAAA;EACA,wCAAA;ArBqvQF;;AqB5uQA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;ArB+uQF;;AqB5uQA;EAAM,eAAA;ArBgvQN;;AqB/uQA;EAAM,WAAA;ArBmvQN;;AqB9uQA;EACE,gEAAA;EACA,0BCgNwC;AtBiiQ1C;AqB/uQE;EACE,mDAAA;ArBivQJ;;AqBtuQE;EAEE,cAAA;EACA,qBAAA;ArBwuQJ;;AqBjuQA;;;;EAIE,qCCgV4B;EHlUxB,cALI;AnB4tQV;;AqB7tQA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,kBALI;AnBouQV;AqB5tQE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;ArB8tQJ;;AqB1tQA;EFVM,kBALI;EEiBR,2BAAA;EACA,qBAAA;ArB6tQF;AqB1tQE;EACE,cAAA;ArB4tQJ;;AqBxtQA;EACE,2BAAA;EFtBI,kBALI;EE6BR,wBCy5CkC;EDx5ClC,sCCy5CkC;EC9rDhC,sBAAA;AvBigRJ;AqBztQE;EACE,UAAA;EF7BE,cALI;AnB8vQV;;AqBjtQA;EACE,gBAAA;ArBotQF;;AqB9sQA;;EAEE,sBAAA;ArBitQF;;AqBzsQA;EACE,oBAAA;EACA,yBAAA;ArB4sQF;;AqBzsQA;EACE,mBC4X4B;ED3X5B,sBC2X4B;ED1X5B,gCC4Z4B;ED3Z5B,gBAAA;ArB4sQF;;AqBrsQA;EAEE,mBAAA;EACA,gCAAA;ArBusQF;;AqBpsQA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;ArBusQF;;AqB/rQA;EACE,qBAAA;ArBksQF;;AqB5rQA;EAEE,gBAAA;ArB8rQF;;AqBtrQA;EACE,UAAA;ArByrQF;;AqBprQA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;ArBurQF;;AqBnrQA;;EAEE,oBAAA;ArBsrQF;;AqBjrQA;EACE,eAAA;ArBorQF;;AqBjrQA;EAGE,iBAAA;ArBkrQF;AqB/qQE;EACE,UAAA;ArBirQJ;;AqB1qQA;EACE,wBAAA;ArB6qQF;;AqBrqQA;;;;EAIE,0BAAA;ArBwqQF;AqBrqQI;;;;EACE,eAAA;ArB0qQN;;AqBnqQA;EACE,UAAA;EACA,kBAAA;ArBsqQF;;AqBjqQA;EACE,gBAAA;ArBoqQF;;AqB1pQA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;ArB6pQF;;AqBrpQA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBCmN4B;EHpatB,iCAAA;EEoNN,oBAAA;ArBupQF;AmBvgRI;EEyWJ;IFtMQ,iBAAA;EnBw2QN;AACF;AqB1pQE;EACE,WAAA;ArB4pQJ;;AqBrpQA;;;;;;;EAOE,UAAA;ArBwpQF;;AqBrpQA;EACE,YAAA;ArBwpQF;;AqB/oQA;EACE,6BAAA;EACA,oBAAA;ArBkpQF;;AqB1oQA;;;;;;;CAAA;AAWA;EACE,wBAAA;ArB0oQF;;AqBroQA;EACE,UAAA;ArBwoQF;;AqBjoQA;EACE,aAAA;EACA,0BAAA;ArBooQF;;AqB/nQA;EACE,qBAAA;ArBkoQF;;AqB7nQA;EACE,SAAA;ArBgoQF;;AqBznQA;EACE,kBAAA;EACA,eAAA;ArB4nQF;;AqBpnQA;EACE,wBAAA;ArBunQF;;AqB/mQA;EACE,wBAAA;ArBknQF;;AwBvrRA;ELmQM,kBALI;EK5PR,gBFwoB4B;AtBkjQ9B;;AwBrrRE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;AtB8kQ9B;AmBvlRI;EKpGF;ILuQM,eAAA;EnBw7QN;AACF;;AwBhsRE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;AtBylQ9B;AmBlmRI;EKpGF;ILuQM,iBAAA;EnBm8QN;AACF;;AwB3sRE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;AtBomQ9B;AmB7mRI;EKpGF;ILuQM,eAAA;EnB88QN;AACF;;AwBttRE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;AtB+mQ9B;AmBxnRI;EKpGF;ILuQM,iBAAA;EnBy9QN;AACF;;AwBjuRE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;AtB0nQ9B;AmBnoRI;EKpGF;ILuQM,eAAA;EnBo+QN;AACF;;AwB5uRE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;AtBqoQ9B;AmB9oRI;EKpGF;ILuQM,iBAAA;EnB++QN;AACF;;AwB/tRA;ECvDE,eAAA;EACA,gBAAA;AzB0xRF;;AwB/tRA;EC5DE,eAAA;EACA,gBAAA;AzB+xRF;;AwBjuRA;EACE,qBAAA;AxBouRF;AwBluRE;EACE,oBFsoB0B;AtB8lQ9B;;AwB1tRA;EL8MM,kBALI;EKvMR,yBAAA;AxB6tRF;;AwBztRA;EACE,mBFiUO;EH1HH,kBALI;AnB2hRV;AwB1tRE;EACE,gBAAA;AxB4tRJ;;AwBxtRA;EACE,iBAAA;EACA,mBFuTO;EH1HH,kBALI;EKtLR,cFtFS;AtBizRX;AwBztRE;EACE,aAAA;AxB2tRJ;;A0B3zRA;ECIE,eAAA;EAGA,YAAA;A3ByzRF;;A0B1zRA;EACE,gBJ+jDkC;EI9jDlC,mCJ+jDkC;EI9jDlC,2DAAA;EHGE,sCAAA;EIRF,eAAA;EAGA,YAAA;A3Bk0RF;;A0BpzRA;EAEE,qBAAA;A1BszRF;;A0BnzRA;EACE,qBAAA;EACA,cAAA;A1BszRF;;A0BnzRA;EPyPM,kBALI;EOlPR,gCJkjDkC;AtBowOpC;;A4Bx1RE;;;;;;;ECHA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;A7Bq2RF;;A8B/yRI;EF5CE;IACE,gBNkee;EtB63QrB;AACF;A8BrzRI;EF5CE;IACE,gBNkee;EtBk4QrB;AACF;A8B1zRI;EF5CE;IACE,gBNkee;EtBu4QrB;AACF;A8B/zRI;EF5CE;IACE,iBNkee;EtB44QrB;AACF;A8Bp0RI;EF5CE;IACE,iBNkee;EtBi5QrB;AACF;A+Bp4RA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;A/B04RJ;;A+Br4RE;ECNA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AhC84RF;A+B54RI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AhCw4RF;;AgCz1RM;EACE,YAAA;AhC41RR;;AgCz1RM;EApCJ,cAAA;EACA,WAAA;AhCi4RF;;AgCn3RE;EACE,cAAA;EACA,WAAA;AhCs3RJ;;AgCx3RE;EACE,cAAA;EACA,UAAA;AhC23RJ;;AgC73RE;EACE,cAAA;EACA,mBAAA;AhCg4RJ;;AgCl4RE;EACE,cAAA;EACA,UAAA;AhCq4RJ;;AgCv4RE;EACE,cAAA;EACA,UAAA;AhC04RJ;;AgC54RE;EACE,cAAA;EACA,mBAAA;AhC+4RJ;;AgCh3RM;EAhDJ,cAAA;EACA,WAAA;AhCo6RF;;AgC/2RU;EAhEN,cAAA;EACA,kBAAA;AhCm7RJ;;AgCp3RU;EAhEN,cAAA;EACA,mBAAA;AhCw7RJ;;AgCz3RU;EAhEN,cAAA;EACA,UAAA;AhC67RJ;;AgC93RU;EAhEN,cAAA;EACA,mBAAA;AhCk8RJ;;AgCn4RU;EAhEN,cAAA;EACA,mBAAA;AhCu8RJ;;AgCx4RU;EAhEN,cAAA;EACA,UAAA;AhC48RJ;;AgC74RU;EAhEN,cAAA;EACA,mBAAA;AhCi9RJ;;AgCl5RU;EAhEN,cAAA;EACA,mBAAA;AhCs9RJ;;AgCv5RU;EAhEN,cAAA;EACA,UAAA;AhC29RJ;;AgC55RU;EAhEN,cAAA;EACA,mBAAA;AhCg+RJ;;AgCj6RU;EAhEN,cAAA;EACA,mBAAA;AhCq+RJ;;AgCt6RU;EAhEN,cAAA;EACA,WAAA;AhC0+RJ;;AgCn6RY;EAxDV,wBAAA;AhC+9RF;;AgCv6RY;EAxDV,yBAAA;AhCm+RF;;AgC36RY;EAxDV,gBAAA;AhCu+RF;;AgC/6RY;EAxDV,yBAAA;AhC2+RF;;AgCn7RY;EAxDV,yBAAA;AhC++RF;;AgCv7RY;EAxDV,gBAAA;AhCm/RF;;AgC37RY;EAxDV,yBAAA;AhCu/RF;;AgC/7RY;EAxDV,yBAAA;AhC2/RF;;AgCn8RY;EAxDV,gBAAA;AhC+/RF;;AgCv8RY;EAxDV,yBAAA;AhCmgSF;;AgC38RY;EAxDV,yBAAA;AhCugSF;;AgCp8RQ;;EAEE,gBAAA;AhCu8RV;;AgCp8RQ;;EAEE,gBAAA;AhCu8RV;;AgC98RQ;;EAEE,sBAAA;AhCi9RV;;AgC98RQ;;EAEE,sBAAA;AhCi9RV;;AgCx9RQ;;EAEE,qBAAA;AhC29RV;;AgCx9RQ;;EAEE,qBAAA;AhC29RV;;AgCl+RQ;;EAEE,mBAAA;AhCq+RV;;AgCl+RQ;;EAEE,mBAAA;AhCq+RV;;AgC5+RQ;;EAEE,qBAAA;AhC++RV;;AgC5+RQ;;EAEE,qBAAA;AhC++RV;;AgCt/RQ;;EAEE,mBAAA;AhCy/RV;;AgCt/RQ;;EAEE,mBAAA;AhCy/RV;;A8BnjSI;EEUE;IACE,YAAA;EhC6iSN;EgC1iSI;IApCJ,cAAA;IACA,WAAA;EhCilSA;EgCnkSA;IACE,cAAA;IACA,WAAA;EhCqkSF;EgCvkSA;IACE,cAAA;IACA,UAAA;EhCykSF;EgC3kSA;IACE,cAAA;IACA,mBAAA;EhC6kSF;EgC/kSA;IACE,cAAA;IACA,UAAA;EhCilSF;EgCnlSA;IACE,cAAA;IACA,UAAA;EhCqlSF;EgCvlSA;IACE,cAAA;IACA,mBAAA;EhCylSF;EgC1jSI;IAhDJ,cAAA;IACA,WAAA;EhC6mSA;EgCxjSQ;IAhEN,cAAA;IACA,kBAAA;EhC2nSF;EgC5jSQ;IAhEN,cAAA;IACA,mBAAA;EhC+nSF;EgChkSQ;IAhEN,cAAA;IACA,UAAA;EhCmoSF;EgCpkSQ;IAhEN,cAAA;IACA,mBAAA;EhCuoSF;EgCxkSQ;IAhEN,cAAA;IACA,mBAAA;EhC2oSF;EgC5kSQ;IAhEN,cAAA;IACA,UAAA;EhC+oSF;EgChlSQ;IAhEN,cAAA;IACA,mBAAA;EhCmpSF;EgCplSQ;IAhEN,cAAA;IACA,mBAAA;EhCupSF;EgCxlSQ;IAhEN,cAAA;IACA,UAAA;EhC2pSF;EgC5lSQ;IAhEN,cAAA;IACA,mBAAA;EhC+pSF;EgChmSQ;IAhEN,cAAA;IACA,mBAAA;EhCmqSF;EgCpmSQ;IAhEN,cAAA;IACA,WAAA;EhCuqSF;EgChmSU;IAxDV,cAAA;EhC2pSA;EgCnmSU;IAxDV,wBAAA;EhC8pSA;EgCtmSU;IAxDV,yBAAA;EhCiqSA;EgCzmSU;IAxDV,gBAAA;EhCoqSA;EgC5mSU;IAxDV,yBAAA;EhCuqSA;EgC/mSU;IAxDV,yBAAA;EhC0qSA;EgClnSU;IAxDV,gBAAA;EhC6qSA;EgCrnSU;IAxDV,yBAAA;EhCgrSA;EgCxnSU;IAxDV,yBAAA;EhCmrSA;EgC3nSU;IAxDV,gBAAA;EhCsrSA;EgC9nSU;IAxDV,yBAAA;EhCyrSA;EgCjoSU;IAxDV,yBAAA;EhC4rSA;EgCznSM;;IAEE,gBAAA;EhC2nSR;EgCxnSM;;IAEE,gBAAA;EhC0nSR;EgCjoSM;;IAEE,sBAAA;EhCmoSR;EgChoSM;;IAEE,sBAAA;EhCkoSR;EgCzoSM;;IAEE,qBAAA;EhC2oSR;EgCxoSM;;IAEE,qBAAA;EhC0oSR;EgCjpSM;;IAEE,mBAAA;EhCmpSR;EgChpSM;;IAEE,mBAAA;EhCkpSR;EgCzpSM;;IAEE,qBAAA;EhC2pSR;EgCxpSM;;IAEE,qBAAA;EhC0pSR;EgCjqSM;;IAEE,mBAAA;EhCmqSR;EgChqSM;;IAEE,mBAAA;EhCkqSR;AACF;A8B7tSI;EEUE;IACE,YAAA;EhCstSN;EgCntSI;IApCJ,cAAA;IACA,WAAA;EhC0vSA;EgC5uSA;IACE,cAAA;IACA,WAAA;EhC8uSF;EgChvSA;IACE,cAAA;IACA,UAAA;EhCkvSF;EgCpvSA;IACE,cAAA;IACA,mBAAA;EhCsvSF;EgCxvSA;IACE,cAAA;IACA,UAAA;EhC0vSF;EgC5vSA;IACE,cAAA;IACA,UAAA;EhC8vSF;EgChwSA;IACE,cAAA;IACA,mBAAA;EhCkwSF;EgCnuSI;IAhDJ,cAAA;IACA,WAAA;EhCsxSA;EgCjuSQ;IAhEN,cAAA;IACA,kBAAA;EhCoySF;EgCruSQ;IAhEN,cAAA;IACA,mBAAA;EhCwySF;EgCzuSQ;IAhEN,cAAA;IACA,UAAA;EhC4ySF;EgC7uSQ;IAhEN,cAAA;IACA,mBAAA;EhCgzSF;EgCjvSQ;IAhEN,cAAA;IACA,mBAAA;EhCozSF;EgCrvSQ;IAhEN,cAAA;IACA,UAAA;EhCwzSF;EgCzvSQ;IAhEN,cAAA;IACA,mBAAA;EhC4zSF;EgC7vSQ;IAhEN,cAAA;IACA,mBAAA;EhCg0SF;EgCjwSQ;IAhEN,cAAA;IACA,UAAA;EhCo0SF;EgCrwSQ;IAhEN,cAAA;IACA,mBAAA;EhCw0SF;EgCzwSQ;IAhEN,cAAA;IACA,mBAAA;EhC40SF;EgC7wSQ;IAhEN,cAAA;IACA,WAAA;EhCg1SF;EgCzwSU;IAxDV,cAAA;EhCo0SA;EgC5wSU;IAxDV,wBAAA;EhCu0SA;EgC/wSU;IAxDV,yBAAA;EhC00SA;EgClxSU;IAxDV,gBAAA;EhC60SA;EgCrxSU;IAxDV,yBAAA;EhCg1SA;EgCxxSU;IAxDV,yBAAA;EhCm1SA;EgC3xSU;IAxDV,gBAAA;EhCs1SA;EgC9xSU;IAxDV,yBAAA;EhCy1SA;EgCjySU;IAxDV,yBAAA;EhC41SA;EgCpySU;IAxDV,gBAAA;EhC+1SA;EgCvySU;IAxDV,yBAAA;EhCk2SA;EgC1ySU;IAxDV,yBAAA;EhCq2SA;EgClySM;;IAEE,gBAAA;EhCoySR;EgCjySM;;IAEE,gBAAA;EhCmySR;EgC1ySM;;IAEE,sBAAA;EhC4ySR;EgCzySM;;IAEE,sBAAA;EhC2ySR;EgClzSM;;IAEE,qBAAA;EhCozSR;EgCjzSM;;IAEE,qBAAA;EhCmzSR;EgC1zSM;;IAEE,mBAAA;EhC4zSR;EgCzzSM;;IAEE,mBAAA;EhC2zSR;EgCl0SM;;IAEE,qBAAA;EhCo0SR;EgCj0SM;;IAEE,qBAAA;EhCm0SR;EgC10SM;;IAEE,mBAAA;EhC40SR;EgCz0SM;;IAEE,mBAAA;EhC20SR;AACF;A8Bt4SI;EEUE;IACE,YAAA;EhC+3SN;EgC53SI;IApCJ,cAAA;IACA,WAAA;EhCm6SA;EgCr5SA;IACE,cAAA;IACA,WAAA;EhCu5SF;EgCz5SA;IACE,cAAA;IACA,UAAA;EhC25SF;EgC75SA;IACE,cAAA;IACA,mBAAA;EhC+5SF;EgCj6SA;IACE,cAAA;IACA,UAAA;EhCm6SF;EgCr6SA;IACE,cAAA;IACA,UAAA;EhCu6SF;EgCz6SA;IACE,cAAA;IACA,mBAAA;EhC26SF;EgC54SI;IAhDJ,cAAA;IACA,WAAA;EhC+7SA;EgC14SQ;IAhEN,cAAA;IACA,kBAAA;EhC68SF;EgC94SQ;IAhEN,cAAA;IACA,mBAAA;EhCi9SF;EgCl5SQ;IAhEN,cAAA;IACA,UAAA;EhCq9SF;EgCt5SQ;IAhEN,cAAA;IACA,mBAAA;EhCy9SF;EgC15SQ;IAhEN,cAAA;IACA,mBAAA;EhC69SF;EgC95SQ;IAhEN,cAAA;IACA,UAAA;EhCi+SF;EgCl6SQ;IAhEN,cAAA;IACA,mBAAA;EhCq+SF;EgCt6SQ;IAhEN,cAAA;IACA,mBAAA;EhCy+SF;EgC16SQ;IAhEN,cAAA;IACA,UAAA;EhC6+SF;EgC96SQ;IAhEN,cAAA;IACA,mBAAA;EhCi/SF;EgCl7SQ;IAhEN,cAAA;IACA,mBAAA;EhCq/SF;EgCt7SQ;IAhEN,cAAA;IACA,WAAA;EhCy/SF;EgCl7SU;IAxDV,cAAA;EhC6+SA;EgCr7SU;IAxDV,wBAAA;EhCg/SA;EgCx7SU;IAxDV,yBAAA;EhCm/SA;EgC37SU;IAxDV,gBAAA;EhCs/SA;EgC97SU;IAxDV,yBAAA;EhCy/SA;EgCj8SU;IAxDV,yBAAA;EhC4/SA;EgCp8SU;IAxDV,gBAAA;EhC+/SA;EgCv8SU;IAxDV,yBAAA;EhCkgTA;EgC18SU;IAxDV,yBAAA;EhCqgTA;EgC78SU;IAxDV,gBAAA;EhCwgTA;EgCh9SU;IAxDV,yBAAA;EhC2gTA;EgCn9SU;IAxDV,yBAAA;EhC8gTA;EgC38SM;;IAEE,gBAAA;EhC68SR;EgC18SM;;IAEE,gBAAA;EhC48SR;EgCn9SM;;IAEE,sBAAA;EhCq9SR;EgCl9SM;;IAEE,sBAAA;EhCo9SR;EgC39SM;;IAEE,qBAAA;EhC69SR;EgC19SM;;IAEE,qBAAA;EhC49SR;EgCn+SM;;IAEE,mBAAA;EhCq+SR;EgCl+SM;;IAEE,mBAAA;EhCo+SR;EgC3+SM;;IAEE,qBAAA;EhC6+SR;EgC1+SM;;IAEE,qBAAA;EhC4+SR;EgCn/SM;;IAEE,mBAAA;EhCq/SR;EgCl/SM;;IAEE,mBAAA;EhCo/SR;AACF;A8B/iTI;EEUE;IACE,YAAA;EhCwiTN;EgCriTI;IApCJ,cAAA;IACA,WAAA;EhC4kTA;EgC9jTA;IACE,cAAA;IACA,WAAA;EhCgkTF;EgClkTA;IACE,cAAA;IACA,UAAA;EhCokTF;EgCtkTA;IACE,cAAA;IACA,mBAAA;EhCwkTF;EgC1kTA;IACE,cAAA;IACA,UAAA;EhC4kTF;EgC9kTA;IACE,cAAA;IACA,UAAA;EhCglTF;EgCllTA;IACE,cAAA;IACA,mBAAA;EhColTF;EgCrjTI;IAhDJ,cAAA;IACA,WAAA;EhCwmTA;EgCnjTQ;IAhEN,cAAA;IACA,kBAAA;EhCsnTF;EgCvjTQ;IAhEN,cAAA;IACA,mBAAA;EhC0nTF;EgC3jTQ;IAhEN,cAAA;IACA,UAAA;EhC8nTF;EgC/jTQ;IAhEN,cAAA;IACA,mBAAA;EhCkoTF;EgCnkTQ;IAhEN,cAAA;IACA,mBAAA;EhCsoTF;EgCvkTQ;IAhEN,cAAA;IACA,UAAA;EhC0oTF;EgC3kTQ;IAhEN,cAAA;IACA,mBAAA;EhC8oTF;EgC/kTQ;IAhEN,cAAA;IACA,mBAAA;EhCkpTF;EgCnlTQ;IAhEN,cAAA;IACA,UAAA;EhCspTF;EgCvlTQ;IAhEN,cAAA;IACA,mBAAA;EhC0pTF;EgC3lTQ;IAhEN,cAAA;IACA,mBAAA;EhC8pTF;EgC/lTQ;IAhEN,cAAA;IACA,WAAA;EhCkqTF;EgC3lTU;IAxDV,cAAA;EhCspTA;EgC9lTU;IAxDV,wBAAA;EhCypTA;EgCjmTU;IAxDV,yBAAA;EhC4pTA;EgCpmTU;IAxDV,gBAAA;EhC+pTA;EgCvmTU;IAxDV,yBAAA;EhCkqTA;EgC1mTU;IAxDV,yBAAA;EhCqqTA;EgC7mTU;IAxDV,gBAAA;EhCwqTA;EgChnTU;IAxDV,yBAAA;EhC2qTA;EgCnnTU;IAxDV,yBAAA;EhC8qTA;EgCtnTU;IAxDV,gBAAA;EhCirTA;EgCznTU;IAxDV,yBAAA;EhCorTA;EgC5nTU;IAxDV,yBAAA;EhCurTA;EgCpnTM;;IAEE,gBAAA;EhCsnTR;EgCnnTM;;IAEE,gBAAA;EhCqnTR;EgC5nTM;;IAEE,sBAAA;EhC8nTR;EgC3nTM;;IAEE,sBAAA;EhC6nTR;EgCpoTM;;IAEE,qBAAA;EhCsoTR;EgCnoTM;;IAEE,qBAAA;EhCqoTR;EgC5oTM;;IAEE,mBAAA;EhC8oTR;EgC3oTM;;IAEE,mBAAA;EhC6oTR;EgCppTM;;IAEE,qBAAA;EhCspTR;EgCnpTM;;IAEE,qBAAA;EhCqpTR;EgC5pTM;;IAEE,mBAAA;EhC8pTR;EgC3pTM;;IAEE,mBAAA;EhC6pTR;AACF;A8BxtTI;EEUE;IACE,YAAA;EhCitTN;EgC9sTI;IApCJ,cAAA;IACA,WAAA;EhCqvTA;EgCvuTA;IACE,cAAA;IACA,WAAA;EhCyuTF;EgC3uTA;IACE,cAAA;IACA,UAAA;EhC6uTF;EgC/uTA;IACE,cAAA;IACA,mBAAA;EhCivTF;EgCnvTA;IACE,cAAA;IACA,UAAA;EhCqvTF;EgCvvTA;IACE,cAAA;IACA,UAAA;EhCyvTF;EgC3vTA;IACE,cAAA;IACA,mBAAA;EhC6vTF;EgC9tTI;IAhDJ,cAAA;IACA,WAAA;EhCixTA;EgC5tTQ;IAhEN,cAAA;IACA,kBAAA;EhC+xTF;EgChuTQ;IAhEN,cAAA;IACA,mBAAA;EhCmyTF;EgCpuTQ;IAhEN,cAAA;IACA,UAAA;EhCuyTF;EgCxuTQ;IAhEN,cAAA;IACA,mBAAA;EhC2yTF;EgC5uTQ;IAhEN,cAAA;IACA,mBAAA;EhC+yTF;EgChvTQ;IAhEN,cAAA;IACA,UAAA;EhCmzTF;EgCpvTQ;IAhEN,cAAA;IACA,mBAAA;EhCuzTF;EgCxvTQ;IAhEN,cAAA;IACA,mBAAA;EhC2zTF;EgC5vTQ;IAhEN,cAAA;IACA,UAAA;EhC+zTF;EgChwTQ;IAhEN,cAAA;IACA,mBAAA;EhCm0TF;EgCpwTQ;IAhEN,cAAA;IACA,mBAAA;EhCu0TF;EgCxwTQ;IAhEN,cAAA;IACA,WAAA;EhC20TF;EgCpwTU;IAxDV,cAAA;EhC+zTA;EgCvwTU;IAxDV,wBAAA;EhCk0TA;EgC1wTU;IAxDV,yBAAA;EhCq0TA;EgC7wTU;IAxDV,gBAAA;EhCw0TA;EgChxTU;IAxDV,yBAAA;EhC20TA;EgCnxTU;IAxDV,yBAAA;EhC80TA;EgCtxTU;IAxDV,gBAAA;EhCi1TA;EgCzxTU;IAxDV,yBAAA;EhCo1TA;EgC5xTU;IAxDV,yBAAA;EhCu1TA;EgC/xTU;IAxDV,gBAAA;EhC01TA;EgClyTU;IAxDV,yBAAA;EhC61TA;EgCryTU;IAxDV,yBAAA;EhCg2TA;EgC7xTM;;IAEE,gBAAA;EhC+xTR;EgC5xTM;;IAEE,gBAAA;EhC8xTR;EgCryTM;;IAEE,sBAAA;EhCuyTR;EgCpyTM;;IAEE,sBAAA;EhCsyTR;EgC7yTM;;IAEE,qBAAA;EhC+yTR;EgC5yTM;;IAEE,qBAAA;EhC8yTR;EgCrzTM;;IAEE,mBAAA;EhCuzTR;EgCpzTM;;IAEE,mBAAA;EhCszTR;EgC7zTM;;IAEE,qBAAA;EhC+zTR;EgC5zTM;;IAEE,qBAAA;EhC8zTR;EgCr0TM;;IAEE,mBAAA;EhCu0TR;EgCp0TM;;IAEE,mBAAA;EhCs0TR;AACF;AiC57TA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,0CAAA;EACA,gCAAA;EACA,+CAAA;EACA,iCAAA;EACA,kDAAA;EACA,+DAAA;EACA,iDAAA;EACA,6DAAA;EACA,gDAAA;EACA,8DAAA;EAEA,WAAA;EACA,mBXkYO;EWjYP,mBXusB4B;EWtsB5B,0CAAA;AjC27TF;AiCp7TE;EACE,sBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,2CX+sB0B;EW9sB1B,2GAAA;AjCq7TJ;AiCl7TE;EACE,uBAAA;AjCo7TJ;AiCj7TE;EACE,sBAAA;AjCm7TJ;;AiC/6TA;EACE,+DAAA;AjCk7TF;;AiC36TA;EACE,iBAAA;AjC86TF;;AiCp6TE;EACE,wBAAA;AjCu6TJ;;AiCx5TE;EACE,sCAAA;AjC25TJ;AiCx5TI;EACE,sCAAA;AjC05TN;;AiCn5TE;EACE,sBAAA;AjCs5TJ;AiCn5TE;EACE,mBAAA;AjCq5TJ;;AiC34TE;EACE,oDAAA;EACA,8CAAA;AjC84TJ;;AiCx4TE;EACE,oDAAA;EACA,8CAAA;AjC24TJ;;AiCn4TA;EACE,oDAAA;EACA,8CAAA;AjCs4TF;;AiC93TE;EACE,mDAAA;EACA,6CAAA;AjCi4TJ;;AkC7gUE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlCygUJ;;AkC3hUE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlCuhUJ;;AkCziUE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlCqiUJ;;AkCvjUE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlCmjUJ;;AkCrkUE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlCikUJ;;AkCnlUE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlC+kUJ;;AkCjmUE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlC6lUJ;;AkC/mUE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlC2mUJ;;AiC19TI;EACE,gBAAA;EACA,iCAAA;AjC69TN;;A8BxjUI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjCm+TJ;AACF;A8B/jUI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjCy+TJ;AACF;A8BrkUI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjC++TJ;AACF;A8B3kUI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjCq/TJ;AACF;A8BjlUI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjC2/TJ;AACF;AmC/pUA;EACE,qBbu2BsC;AtB0zSxC;;AmCxpUA;EACE,oDAAA;EACA,uDAAA;EACA,gBAAA;EhB8QI,kBALI;EgBrQR,gBb+lB4B;AtB0jT9B;;AmCrpUA;EACE,kDAAA;EACA,qDAAA;EhBoQI,kBALI;AnB05TV;;AmCrpUA;EACE,mDAAA;EACA,sDAAA;EhB8PI,mBALI;AnBg6TV;;AoCtrUA;EACE,mBd+1BsC;EHrkBlC,kBALI;EiBjRR,gCd+1BsC;AtBw1SxC;;AqC5rUA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;ElBwRI,eALI;EkBhRR,gBfkmB4B;EejmB5B,gBfymB4B;EexmB5B,2Bf43BsC;Ee33BtC,gBAAA;EACA,mCfq3BsC;Eep3BtC,4BAAA;EACA,2DAAA;EdGE,sCAAA;EeHE,wEDMJ;ArC0rUF;AsC5rUM;EDhBN;ICiBQ,gBAAA;EtC+rUN;AACF;AqC7rUE;EACE,gBAAA;ArC+rUJ;AqC7rUI;EACE,eAAA;ArC+rUN;AqC1rUE;EACE,2Bfs2BoC;Eer2BpC,mCfg2BoC;Ee/1BpC,qBf82BoC;Ee72BpC,UAAA;EAKE,kDfkhBkB;AtBsqTxB;AqCprUE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;ArCwqUJ;AqCnqUE;EACE,cAAA;EACA,UAAA;ArCqqUJ;AqCjqUE;EACE,gCf40BoC;Ee10BpC,UAAA;ArCkqUJ;AqC1pUE;EAEE,wCf8yBoC;Ee3yBpC,UAAA;ArCypUJ;AqCrpUE;EACE,yBAAA;EACA,0BAAA;EACA,0BforB0B;EenrB1B,2BfsyBoC;EiBp4BtC,uCjBqiCgC;Eer8B9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,+CfgsB0B;Ee/rB1B,gBAAA;ECzFE,qID0FF;ArCupUJ;AsC7uUM;ED0EJ;ICzEM,gBAAA;EtCgvUN;AACF;AqCzpUE;EACE,wCf47B8B;AtB+tSlC;;AqClpUA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBfwf4B;Eevf5B,2Bf2xBsC;Ee1xBtC,6BAAA;EACA,yBAAA;EACA,sCAAA;ArCqpUF;AqCnpUE;EACE,UAAA;ArCqpUJ;AqClpUE;EAEE,gBAAA;EACA,eAAA;ArCmpUJ;;AqCxoUA;EACE,mEf4wBsC;Ee3wBtC,uBAAA;ElByII,mBALI;EIvQN,yCAAA;AvBgxUJ;AqCzoUE;EACE,uBAAA;EACA,wBAAA;EACA,yBfooB0B;AtBugT9B;;AqCvoUA;EACE,iEfgwBsC;Ee/vBtC,oBAAA;ElB4HI,kBALI;EIvQN,yCAAA;AvB4xUJ;AqCxoUE;EACE,oBAAA;EACA,qBAAA;EACA,uBf2nB0B;AtB+gT9B;;AqCloUE;EACE,oEf6uBoC;AtBw5SxC;AqCloUE;EACE,mEf0uBoC;AtB05SxC;AqCjoUE;EACE,iEfuuBoC;AtB45SxC;;AqC9nUA;EACE,WfquBsC;EepuBtC,gEf8tBsC;Ee7tBtC,iBfilB4B;AtBgjT9B;AqC/nUE;EACE,eAAA;ArCioUJ;AqC9nUE;EACE,oBAAA;EdvLA,sCAAA;AvBwzUJ;AqC7nUE;EACE,oBAAA;Ed5LA,sCAAA;AvB4zUJ;AqC5nUE;EAAoB,+Df8sBkB;AtBi7SxC;AqC9nUE;EAAoB,6Df8sBkB;AtBm7SxC;;AwCh1UA;EACE,iEAAA;EAEA,cAAA;EACA,WAAA;EACA,0CAAA;ErBqRI,eALI;EqB7QR,gBlB+lB4B;EkB9lB5B,gBlBsmB4B;EkBrmB5B,2BlBy3BsC;EkBx3BtC,gBAAA;EACA,mClBk3BsC;EkBj3BtC,mFAAA;EACA,4BAAA;EACA,yClB+9BkC;EkB99BlC,0BlB+9BkC;EkB99BlC,2DAAA;EjBHE,sCAAA;EeHE,wEESJ;AxCg1UF;AsCr1UM;EEfN;IFgBQ,gBAAA;EtCw1UN;AACF;AwCn1UE;EACE,qBlBs3BoC;EkBr3BpC,UAAA;EAKE,kDlBi+B4B;AtBg3SlC;AwC70UE;EAEE,sBlB6uB0B;EkB5uB1B,sBAAA;AxC80UJ;AwC30UE;EAEE,wClBu1BoC;AtBq/SxC;AwCv0UE;EACE,kBAAA;EACA,uCAAA;AxCy0UJ;;AwCr0UA;EACE,oBlBsuB4B;EkBruB5B,uBlBquB4B;EkBpuB5B,oBlBquB4B;EHlgBxB,mBALI;EIvQN,yCAAA;AvBm3UJ;;AwCr0UA;EACE,mBlBkuB4B;EkBjuB5B,sBlBiuB4B;EkBhuB5B,kBlBiuB4B;EHtgBxB,kBALI;EIvQN,yCAAA;AvB23UJ;;AwCn0UI;EACE,iEAAA;AxCs0UN;;AyC94UA;EACE,cAAA;EACA,kBnBq6BwC;EmBp6BxC,mBnBq6BwC;EmBp6BxC,uBnBq6BwC;AtB4+S1C;AyC/4UE;EACE,WAAA;EACA,mBAAA;AzCi5UJ;;AyC74UA;EACE,oBnB25BwC;EmB15BxC,eAAA;EACA,iBAAA;AzCg5UF;AyC94UE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;AzCg5UJ;;AyC54UA;EACE,qCAAA;EAEA,cAAA;EACA,UnB04BwC;EmBz4BxC,WnBy4BwC;EmBx4BxC,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,2DnB24BwC;EmB14BxC,yBAAA;AzC84UF;AyC34UE;ElB3BE,qBAAA;AvBy6UJ;AyC14UE;EAEE,kBnBm4BsC;AtBwgT1C;AyCx4UE;EACE,uBnB03BsC;AtBghT1C;AyCv4UE;EACE,qBnBs1BoC;EmBr1BpC,UAAA;EACA,kDnB8foB;AtB24TxB;AyCt4UE;EACE,yBnB5BM;EmB6BN,qBnB7BM;AtBq6UV;AyCt4UI;EAII,kEAAA;AzCq4UR;AyCj4UI;EAII,kEAAA;AzCg4UR;AyC33UE;EACE,yBnBjDM;EmBkDN,qBnBlDM;EmBuDJ,kEAAA;AzCy3UN;AyCr3UE;EACE,oBAAA;EACA,YAAA;EACA,YnBk2BuC;AtBqhT3C;AyCh3UI;EACE,eAAA;EACA,YnBy1BqC;AtByhT3C;;AyCp2UA;EACE,mBnBo1BgC;AtBmhTlC;AyCr2UE;EACE,6DAAA;EAEA,UnB80B8B;EmB70B9B,mBAAA;EACA,0CAAA;EACA,gCAAA;ElBjHA,kBAAA;EeHE,iDGsHF;AzCs2UJ;AsCx9UM;EG0GJ;IHzGM,gBAAA;EtC29UN;AACF;AyCz2UI;EACE,6DAAA;AzC22UN;AyCx2UI;EACE,iCnB60B4B;EmBx0B1B,6DAAA;AzCs2UR;AyCj2UE;EACE,oBnBwzB8B;EmBvzB9B,eAAA;AzCm2UJ;AyCj2UI;EACE,oBAAA;EACA,cAAA;AzCm2UN;;AyC91UA;EACE,qBAAA;EACA,kBnBsyBgC;AtB2jTlC;;AyC91UA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;AzCi2UF;AyC71UI;EACE,oBAAA;EACA,YAAA;EACA,anBspBwB;AtBysT9B;;AyCx1UI;EACE,6DAAA;AzC21UN;;A0C9gVA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A1CihVF;A0C/gVE;EACE,UAAA;A1CihVJ;A0C7gVI;EAA0B,qEpB8gCa;AtBkgT3C;A0C/gVI;EAA0B,qEpB6gCa;AtBqgT3C;A0C/gVE;EACE,SAAA;A1CihVJ;A0C9gVE;EACE,WpB+/BuC;EoB9/BvC,YpB8/BuC;EoB7/BvC,oBAAA;EACA,gBAAA;EH1BF,yBjBkCQ;EoBNN,SpB6/BuC;EC1gCvC,mBAAA;EeHE,4GImBF;A1C+gVJ;AsC9hVM;EIMJ;IJLM,gBAAA;EtCiiVN;AACF;A0ClhVI;EHjCF,yBjB8hCyC;AtBwhT3C;A0ChhVE;EACE,WpBw+B8B;EoBv+B9B,cpBw+B8B;EoBv+B9B,kBAAA;EACA,epBu+B8B;EoBt+B9B,wCpBu+B8B;EoBt+B9B,yBAAA;EnB7BA,mBAAA;AvBgjVJ;A0C9gVE;EACE,WpBo+BuC;EoBn+BvC,YpBm+BuC;EoBl+BvC,gBAAA;EHpDF,yBjBkCQ;EoBoBN,SpBm+BuC;EC1gCvC,mBAAA;EeHE,4GI6CF;A1C+gVJ;AsCxjVM;EIiCJ;IJhCM,gBAAA;EtC2jVN;AACF;A0ClhVI;EH3DF,yBjB8hCyC;AtBkjT3C;A0ChhVE;EACE,WpB88B8B;EoB78B9B,cpB88B8B;EoB78B9B,kBAAA;EACA,epB68B8B;EoB58B9B,wCpB68B8B;EoB58B9B,yBAAA;EnBvDA,mBAAA;AvB0kVJ;A0C9gVE;EACE,oBAAA;A1CghVJ;A0C9gVI;EACE,2CpBg9BqC;AtBgkT3C;A0C7gVI;EACE,2CpB48BqC;AtBmkT3C;;A2CtmVA;EACE,kBAAA;A3CymVF;A2CvmVE;;;EAGE,uDrBwiCoC;EqBviCpC,2DrBuiCoC;EqBtiCpC,iBrBuiCoC;AtBkkTxC;A2CtmVE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;EACA,qBAAA;ELRE,gEKSF;A3CwmVJ;AsC7mVM;EKTJ;ILUM,gBAAA;EtCgnVN;AACF;A2C1mVE;;EAEE,qBAAA;A3C4mVJ;A2C1mVI;;EACE,kBAAA;A3C6mVN;A2C1mVI;;;EAEE,qBrB4gCkC;EqB3gClC,wBrB4gCkC;AtBimTxC;A2C1mVI;;EACE,qBrBugCkC;EqBtgClC,wBrBugCkC;AtBsmTxC;A2CzmVE;EACE,qBrBigCoC;EqBhgCpC,wBrBigCoC;AtB0mTxC;A2CpmVI;;;;EACE,2CAAA;EACA,8DrB2/BkC;AtB8mTxC;A2CvmVM;;;;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,arBm/BgC;EqBl/BhC,WAAA;EACA,mCrBg0BgC;ECh3BpC,sCAAA;AvB6pVJ;A2CtmVI;EACE,2CAAA;EACA,8DrB0+BkC;AtB8nTxC;A2CnmVI;EACE,sCAAA;A3CqmVN;A2CjmVE;;EAEE,crB1EO;AtB6qVX;A2CjmVI;;EACE,wCrB0yBkC;AtB0zTxC;;A4C3rVA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A5C8rVF;A4C5rVE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A5C8rVJ;A4C1rVE;;;EAGE,UAAA;A5C4rVJ;A4CtrVE;EACE,kBAAA;EACA,UAAA;A5CwrVJ;A4CtrVI;EACE,UAAA;A5CwrVN;;A4C7qVA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EzB8OI,eALI;EyBvOR,gBtByjB4B;EsBxjB5B,gBtBgkB4B;EsB/jB5B,2BtBm1BsC;EsBl1BtC,kBAAA;EACA,mBAAA;EACA,uCtB06BsC;EsBz6BtC,2DAAA;ErBtCE,sCAAA;AvButVJ;;A4CvqVA;;;;EAIE,oBAAA;EzBwNI,kBALI;EIvQN,yCAAA;AvBguVJ;;A4CvqVA;;;;EAIE,uBAAA;EzB+MI,mBALI;EIvQN,yCAAA;AvByuVJ;;A4CvqVA;;EAEE,mBAAA;A5C0qVF;;A4C7pVI;;;;ErBjEA,0BAAA;EACA,6BAAA;AvBquVJ;A4C5pVI;;;;ErB1EA,0BAAA;EACA,6BAAA;AvB4uVJ;A4CtpVE;EACE,8CAAA;ErB1EA,yBAAA;EACA,4BAAA;AvBmuVJ;A4CtpVE;;ErB9EE,yBAAA;EACA,4BAAA;AvBwuVJ;;A6ChwVE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,iCvBkjCqB;AtBgtTzB;;A6C/vVE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WvBqiCqB;EuBpiCrB,mCvBoiCqB;EC/jCrB,sCAAA;AvB6xVJ;;A6C7vVI;;;;EAEE,cAAA;A7CkwVN;;A6CjzVI;EAqDE,+CvBuhCmB;EuBphCjB,oCvB81BgC;EuB71BhC,0DAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A7C8vVR;A6C3vVM;EACE,+CvB4gCiB;EuBvgCf,2DvBugCe;AtBkvTzB;;A6C9zVI;EA+EI,oCvBu0BgC;EuBt0BhC,kFAAA;A7CmvVR;;A6Cn0VI;EAuFE,+CvBq/BmB;AtB2vTzB;A6C7uVQ;EAEE,kEAAA;EACA,uBvBq5B8B;EuBp5B9B,+DAAA;EACA,2EAAA;A7C8uVV;A6C1uVM;EACE,+CvBw+BiB;EuBn+Bf,2DvBm+Be;AtBqwTzB;;A6Cj1VI;EAkHI,yCAAA;A7CmuVR;;A6Cr1VI;EAyHE,+CvBm9BmB;AtB6wTzB;A6C9tVM;EACE,4CvBg9BiB;AtBgxTzB;A6C7tVM;EACE,2DvB48BiB;AtBmxTzB;A6C5tVM;EACE,iCvBw8BiB;AtBsxTzB;;A6CztVI;EACE,kBAAA;A7C4tVN;;A6Ct2VI;;;;;EAoJM,UAAA;A7C0tVV;;A6C11VE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,mCvBkjCqB;AtB0yTzB;;A6Cz1VE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WvBqiCqB;EuBpiCrB,kCvBoiCqB;EC/jCrB,sCAAA;AvBu3VJ;;A6Cv1VI;;;;EAEE,cAAA;A7C41VN;;A6C34VI;EAqDE,iDvBuhCmB;EuBphCjB,oCvB81BgC;EuB71BhC,0DAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A7Cw1VR;A6Cr1VM;EACE,iDvB4gCiB;EuBvgCf,0DvBugCe;AtB40TzB;;A6Cx5VI;EA+EI,oCvBu0BgC;EuBt0BhC,kFAAA;A7C60VR;;A6C75VI;EAuFE,iDvBq/BmB;AtBq1TzB;A6Cv0VQ;EAEE,kEAAA;EACA,uBvBq5B8B;EuBp5B9B,+DAAA;EACA,2EAAA;A7Cw0VV;A6Cp0VM;EACE,iDvBw+BiB;EuBn+Bf,0DvBm+Be;AtB+1TzB;;A6C36VI;EAkHI,yCAAA;A7C6zVR;;A6C/6VI;EAyHE,iDvBm9BmB;AtBu2TzB;A6CxzVM;EACE,8CvBg9BiB;AtB02TzB;A6CvzVM;EACE,0DvB48BiB;AtB62TzB;A6CtzVM;EACE,mCvBw8BiB;AtBg3TzB;;A6CnzVI;EACE,kBAAA;A7CszVN;;A6Ch8VI;;;;;EAsJM,UAAA;A7CkzVV;;A8C18VA;EAEE,2BAAA;EACA,4BAAA;EACA,sBAAA;E3BuRI,wBALI;E2BhRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,+CAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E3BsQI,kCALI;E2B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,mEAAA;EvBjBE,0CAAA;EgBfF,kCOkCqB;ERtBjB,qIQwBJ;A9Cw8VF;AsC59VM;EQhBN;IRiBQ,gBAAA;EtC+9VN;AACF;A8C38VE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;A9C48VJ;A8Cz8VE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;A9C08VJ;A8Cv8VE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;A9Cq8VN;A8Cj8VE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;A9C+7VN;A8C37VE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;A9Cu7VJ;A8Cp7VI;EAKI,0CAAA;A9Ck7VR;A8C76VE;EAKI,0CAAA;A9C26VN;A8Cv6VE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;A9Cs6VJ;;A8C15VE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/C6gWF;;A8C36VE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/C8hWF;;A8C57VE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/C+iWF;;A8C78VE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/CgkWF;;A8C99VE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/CilWF;;A8C/+VE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/CkmWF;;A8ChgWE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/CmnWF;;A8CjhWE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/CooWF;;A8CxgWE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/C4nWF;;A8CzhWE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/C6oWF;;A8C1iWE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/C8pWF;;A8C3jWE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/C+qWF;;A8C5kWE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/CgsWF;;A8C7lWE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/CitWF;;A8C9mWE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/CkuWF;;A8C/nWE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/CmvWF;;A8CpoWA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;EAEA,0BxB8QwC;AtBw3V1C;A8C5nWE;EACE,0BAAA;A9C8nWJ;A8C3nWE;EACE,gCAAA;A9C6nWJ;;A8ClnWA;ECjJE,0BAAA;EACA,wBAAA;E5B8NI,2BALI;E4BvNR,kDAAA;A/CuwWF;;A8CrnWA;ECrJE,2BAAA;EACA,0BAAA;E5B8NI,4BALI;E4BvNR,kDAAA;A/C8wWF;;AgDj1WA;EVgBM,gCUfJ;AhDo1WF;AsCj0WM;EUpBN;IVqBQ,gBAAA;EtCo0WN;AACF;AgDv1WE;EACE,UAAA;AhDy1WJ;;AgDn1WE;EACE,aAAA;AhDs1WJ;;AgDl1WA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;AhDq1WF;AsCn1WM;EULN;IVMQ,gBAAA;EtCs1WN;AACF;AgDx1WE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;AhD01WJ;AsC71WM;EUAJ;IVCM,gBAAA;EtCg2WN;AACF;;AiDr3WA;;;;;;EAME,kBAAA;AjDw3WF;;AiDr3WA;EACE,mBAAA;AjDw3WF;AkDh2WI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AlDw4WF;AkD90WI;EACE,cAAA;AlDg1WN;;AiD93WA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E9BuQI,6BALI;E8BhQR,yCAAA;EACA,mCAAA;EACA,8DAAA;EACA,oDAAA;EACA,kDAAA;EACA,yFAAA;EACA,4DAAA;EACA,sCAAA;EACA,8CAAA;EACA,8CAAA;EACA,oDAAA;EACA,kDAAA;EACA,qCAAA;EACA,qCAAA;EACA,2DAAA;EACA,kCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E9B0OI,uCALI;E8BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E1BzCE,+CAAA;AvBw6WJ;AiD33WE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AjD63WJ;;AiDr2WI;EACE,oBAAA;AjDw2WN;AiDt2WM;EACE,WAAA;EACA,OAAA;AjDw2WR;;AiDp2WI;EACE,kBAAA;AjDu2WN;AiDr2WM;EACE,QAAA;EACA,UAAA;AjDu2WR;;A8Bj5WI;EmB4BA;IACE,oBAAA;EjDy3WJ;EiDv3WI;IACE,WAAA;IACA,OAAA;EjDy3WN;EiDr3WE;IACE,kBAAA;EjDu3WJ;EiDr3WI;IACE,QAAA;IACA,UAAA;EjDu3WN;AACF;A8Bl6WI;EmB4BA;IACE,oBAAA;EjDy4WJ;EiDv4WI;IACE,WAAA;IACA,OAAA;EjDy4WN;EiDr4WE;IACE,kBAAA;EjDu4WJ;EiDr4WI;IACE,QAAA;IACA,UAAA;EjDu4WN;AACF;A8Bl7WI;EmB4BA;IACE,oBAAA;EjDy5WJ;EiDv5WI;IACE,WAAA;IACA,OAAA;EjDy5WN;EiDr5WE;IACE,kBAAA;EjDu5WJ;EiDr5WI;IACE,QAAA;IACA,UAAA;EjDu5WN;AACF;A8Bl8WI;EmB4BA;IACE,oBAAA;EjDy6WJ;EiDv6WI;IACE,WAAA;IACA,OAAA;EjDy6WN;EiDr6WE;IACE,kBAAA;EjDu6WJ;EiDr6WI;IACE,QAAA;IACA,UAAA;EjDu6WN;AACF;A8Bl9WI;EmB4BA;IACE,oBAAA;EjDy7WJ;EiDv7WI;IACE,WAAA;IACA,OAAA;EjDy7WN;EiDr7WE;IACE,kBAAA;EjDu7WJ;EiDr7WI;IACE,QAAA;IACA,UAAA;EjDu7WN;AACF;AiD96WE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AjDg7WJ;AkDpgXI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AlDqiXF;AkDl/WI;EACE,cAAA;AlDo/WN;;AiDp7WE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AjDu7WJ;AkDzhXI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;AlDmjXF;AkDvgXI;EACE,cAAA;AlDygXN;AiD/7WI;EACE,iBAAA;AjDi8WN;;AiD37WE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AjD87WJ;AkDjjXI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;AlDmjXN;AkDxiXM;EACE,aAAA;AlD0iXR;AkDviXM;EACE,qBAAA;EACA,qB5B0gBsB;E4BzgBtB,uB5BwgBsB;E4BvgBtB,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;AlD6kXF;AkDviXI;EACE,cAAA;AlDyiXN;AiD98WI;EACE,iBAAA;AjDg9WN;;AiDz8WA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AjD48WF;;AiDt8WA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB3Byb4B;E2Bxb5B,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;E1BtKE,uDAAA;AvBgnXJ;AiDv8WE;EAEE,0CAAA;EV1LF,kDU4LuB;AjDu8WzB;AiDp8WE;EAEE,2CAAA;EACA,qBAAA;EVlMF,mDUmMuB;AjDq8WzB;AiDl8WE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AjDm8WJ;;AiD77WA;EACE,cAAA;AjDg8WF;;AiD57WA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E9BmEI,mBALI;E8B5DR,sCAAA;EACA,mBAAA;AjD+7WF;;AiD37WA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AjD87WF;;AiD17WA;EAEE,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,4DAAA;EACA,sDAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AjD47WF;;AmDlrXA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AnDqrXF;AmDnrXE;;EACE,kBAAA;EACA,cAAA;AnDsrXJ;AmDjrXE;;;;;;;;;;;;EAME,UAAA;AnDyrXJ;;AmDprXA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AnDurXF;AmDrrXE;EACE,WAAA;AnDurXJ;;AmDnrXA;E5BhBI,sCAAA;AvBusXJ;AmDnrXE;;EAEE,8CAAA;AnDqrXJ;AmDjrXE;;;E5BVE,0BAAA;EACA,6BAAA;AvBgsXJ;AmD7qXE;;;E5BNE,yBAAA;EACA,4BAAA;AvBwrXJ;;AmDhqXA;EACE,wBAAA;EACA,uBAAA;AnDmqXF;AmDjqXE;EAGE,cAAA;AnDiqXJ;AmD9pXE;EACE,eAAA;AnDgqXJ;;AmD5pXA;EACE,uBAAA;EACA,sBAAA;AnD+pXF;;AmD5pXA;EACE,sBAAA;EACA,qBAAA;AnD+pXF;;AmD3oXA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AnD8oXF;AmD5oXE;;EAEE,WAAA;AnD8oXJ;AmD3oXE;;EAEE,6CAAA;AnD6oXJ;AmDzoXE;;E5B1FE,6BAAA;EACA,4BAAA;AvBuuXJ;AmDzoXE;;E5B7GE,yBAAA;EACA,0BAAA;AvB0vXJ;;AoDlxXA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ApDixXF;;AoD9wXA;EACE,cAAA;EACA,kEAAA;EjCsQI,uCALI;EiC/PR,2CAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EdfI,uGcgBJ;ApDixXF;AsC7xXM;EcGN;IdFQ,gBAAA;EtCgyXN;AACF;AoDpxXE;EAEE,qCAAA;ApDqxXJ;AoDjxXE;EACE,UAAA;EACA,kD9BkhBoB;AtBiwWxB;AoD/wXE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;ApDgxXJ;;AoDxwXA;EAEE,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,2GAAA;EACA,yDAAA;EACA,+CAAA;EACA,uGAAA;EAGA,oFAAA;ApDwwXF;AoDtwXE;EACE,yDAAA;EACA,yDAAA;E7B7CA,wDAAA;EACA,yDAAA;AvBszXJ;AoDvwXI;EAGE,kBAAA;EACA,wDAAA;ApDuwXN;AoDnwXE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;ApDqwXJ;AoDlwXE;EAEE,sDAAA;E7BjEA,yBAAA;EACA,0BAAA;AvBq0XJ;;AoD1vXA;EAEE,qDAAA;EACA,sCAAA;EACA,sCAAA;ApD4vXF;AoDzvXE;E7B5FE,gDAAA;AvBw1XJ;AoDxvXE;;EAEE,4CAAA;EbjHF,oDakHuB;ApD0vXzB;;AoDjvXA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;ApDivXF;AoD/uXE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;ApDivXJ;AoD/uXI;EAEE,iCAAA;ApDgvXN;AoD5uXE;;EAEE,gB9B0d0B;E8Bzd1B,gDAAA;EACA,iCAAA;ApD8uXJ;;AoDpuXE;;EAEE,cAAA;EACA,kBAAA;ApDuuXJ;;AoDluXE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;ApDquXJ;;AoD/tXE;;EACE,WAAA;ApDmuXJ;;AoDztXE;EACE,aAAA;ApD4tXJ;AoD1tXE;EACE,cAAA;ApD4tXJ;;AqDz5XA;EAEE,wBAAA;EACA,6BAAA;EACA,2DAAA;EACA,gEAAA;EACA,mEAAA;EACA,+DAAA;EACA,sCAAA;EACA,kCAAA;EACA,oCAAA;EACA,8DAAA;EACA,oEAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,qEAAA;EACA,0EAAA;EACA,0DAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;ArDy5XF;AqDn5XE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;ArD25XJ;AqDv4XA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;ElC4NI,2CALI;EkCrNR,mCAAA;EACA,qBAAA;EACA,mBAAA;ArDy4XF;AqDv4XE;EAEE,yCAAA;ArDw4XJ;;AqD93XA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ArD63XF;AqD13XI;EAEE,oCAAA;ArD23XN;AqDv3XE;EACE,gBAAA;ArDy3XJ;;AqDh3XA;EACE,mB/B8gCkC;E+B7gClC,sB/B6gCkC;E+B5gClC,6BAAA;ArDm3XF;AqDj3XE;;;EAGE,oCAAA;ArDm3XJ;;AqDt2XA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;ArDu2XF;;AqDn2XA;EACE,8EAAA;ElCyII,6CALI;EkClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E9BxIE,qDAAA;EeHE,+Ce6IJ;ArDs2XF;AsC/+XM;EeiIN;IfhIQ,gBAAA;EtCk/XN;AACF;AqDz2XE;EACE,qBAAA;ArD22XJ;AqDx2XE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;ArD02XJ;;AqDp2XA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;ArDu2XF;;AqDp2XA;EACE,yCAAA;EACA,gBAAA;ArDu2XF;;A8Bj+XI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErD81XN;EqD51XM;IACE,mBAAA;ErD81XR;EqD51XQ;IACE,kBAAA;ErD81XV;EqD31XQ;IACE,kDAAA;IACA,iDAAA;ErD61XV;EqDz1XM;IACE,iBAAA;ErD21XR;EqDx1XM;IACE,wBAAA;IACA,gBAAA;ErD01XR;EqDv1XM;IACE,aAAA;ErDy1XR;EqDt1XM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErDs1XR;EqDn1XQ;IACE,aAAA;ErDq1XV;EqDl1XQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErDo1XV;AACF;A8BjhYI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErD64XN;EqD34XM;IACE,mBAAA;ErD64XR;EqD34XQ;IACE,kBAAA;ErD64XV;EqD14XQ;IACE,kDAAA;IACA,iDAAA;ErD44XV;EqDx4XM;IACE,iBAAA;ErD04XR;EqDv4XM;IACE,wBAAA;IACA,gBAAA;ErDy4XR;EqDt4XM;IACE,aAAA;ErDw4XR;EqDr4XM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErDq4XR;EqDl4XQ;IACE,aAAA;ErDo4XV;EqDj4XQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErDm4XV;AACF;A8BhkYI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErD47XN;EqD17XM;IACE,mBAAA;ErD47XR;EqD17XQ;IACE,kBAAA;ErD47XV;EqDz7XQ;IACE,kDAAA;IACA,iDAAA;ErD27XV;EqDv7XM;IACE,iBAAA;ErDy7XR;EqDt7XM;IACE,wBAAA;IACA,gBAAA;ErDw7XR;EqDr7XM;IACE,aAAA;ErDu7XR;EqDp7XM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErDo7XR;EqDj7XQ;IACE,aAAA;ErDm7XV;EqDh7XQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErDk7XV;AACF;A8B/mYI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErD2+XN;EqDz+XM;IACE,mBAAA;ErD2+XR;EqDz+XQ;IACE,kBAAA;ErD2+XV;EqDx+XQ;IACE,kDAAA;IACA,iDAAA;ErD0+XV;EqDt+XM;IACE,iBAAA;ErDw+XR;EqDr+XM;IACE,wBAAA;IACA,gBAAA;ErDu+XR;EqDp+XM;IACE,aAAA;ErDs+XR;EqDn+XM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErDm+XR;EqDh+XQ;IACE,aAAA;ErDk+XV;EqD/9XQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErDi+XV;AACF;A8B9pYI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErD0hYN;EqDxhYM;IACE,mBAAA;ErD0hYR;EqDxhYQ;IACE,kBAAA;ErD0hYV;EqDvhYQ;IACE,kDAAA;IACA,iDAAA;ErDyhYV;EqDrhYM;IACE,iBAAA;ErDuhYR;EqDphYM;IACE,wBAAA;IACA,gBAAA;ErDshYR;EqDnhYM;IACE,aAAA;ErDqhYR;EqDlhYM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErDkhYR;EqD/gYQ;IACE,aAAA;ErDihYV;EqD9gYQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErDghYV;AACF;AqDvkYI;EAEI,iBAAA;EACA,2BAAA;ArDwkYR;AqDtkYQ;EACE,mBAAA;ArDwkYV;AqDtkYU;EACE,kBAAA;ArDwkYZ;AqDrkYU;EACE,kDAAA;EACA,iDAAA;ArDukYZ;AqDnkYQ;EACE,iBAAA;ArDqkYV;AqDlkYQ;EACE,wBAAA;EACA,gBAAA;ArDokYV;AqDjkYQ;EACE,aAAA;ArDmkYV;AqDhkYQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef9NJ,gBegOI;ArDgkYV;AqD7jYU;EACE,aAAA;ArD+jYZ;AqD5jYU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;ArD8jYZ;;AqD7iYA;;EAGE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;ArD+iYF;;AqDziYI;EACE,qEAAA;ArD4iYN;;AsDr0YA;EAEE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,8CAAA;EACA,0DAAA;EACA,gDAAA;EACA,sBAAA;EACA,uFAAA;EACA,+BAAA;EACA,6BAAA;EACA,sDAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mCAAA;EACA,+BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E/BjBE,2CAAA;AvBu1YJ;AsDl0YE;EACE,eAAA;EACA,cAAA;AtDo0YJ;AsDj0YE;EACE,mBAAA;EACA,sBAAA;AtDm0YJ;AsDj0YI;EACE,mBAAA;E/BtBF,0DAAA;EACA,2DAAA;AvB01YJ;AsDj0YI;EACE,sBAAA;E/BbF,8DAAA;EACA,6DAAA;AvBi1YJ;AsD9zYE;;EAEE,aAAA;AtDg0YJ;;AsD5zYA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;AtD6zYF;;AsD1zYA;EACE,4CAAA;EACA,iCAAA;AtD6zYF;;AsD1zYA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;AtD6zYF;;AsD1zYA;EACE,gBAAA;AtD6zYF;;AsDrzYE;EACE,oCAAA;AtDwzYJ;;AsDhzYA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AtDmzYF;AsDjzYE;E/B7FE,wFAAA;AvBi5YJ;;AsD/yYA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AtDkzYF;AsDhzYE;E/BxGE,wFAAA;AvB25YJ;;AsDzyYA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AtD4yYF;AsD1yYE;EACE,mCAAA;EACA,sCAAA;AtD4yYJ;;AsDxyYA;EACE,uDAAA;EACA,sDAAA;AtD2yYF;;AsDvyYA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E/B1IE,iDAAA;AvBq7YJ;;AsDvyYA;;;EAGE,WAAA;AtD0yYF;;AsDvyYA;;E/B3II,0DAAA;EACA,2DAAA;AvBu7YJ;;AsDxyYA;;E/BlII,8DAAA;EACA,6DAAA;AvB+6YJ;;AsDjyYE;EACE,0CAAA;AtDoyYJ;A8B/5YI;EwBuHJ;IAQI,aAAA;IACA,mBAAA;EtDoyYF;EsDjyYE;IAEE,YAAA;IACA,gBAAA;EtDkyYJ;EsDhyYI;IACE,cAAA;IACA,cAAA;EtDkyYN;EsD7xYM;I/B3KJ,0BAAA;IACA,6BAAA;EvB28YF;EsD9xYQ;;IAGE,0BAAA;EtD+xYV;EsD7xYQ;;IAGE,6BAAA;EtD8xYV;EsD1xYM;I/B5KJ,yBAAA;IACA,4BAAA;EvBy8YF;EsD3xYQ;;IAGE,yBAAA;EtD4xYV;EsD1xYQ;;IAGE,4BAAA;EtD2xYV;AACF;;AuDhgZA;EAEE,0CAAA;EACA,oCAAA;EACA,8KAAA;EACA,mDAAA;EACA,mDAAA;EACA,qDAAA;EACA,4FAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,2EAAA;EACA,sCAAA;EACA,mCAAA;EACA,4DAAA;EACA,qDAAA;AvDkgZF;;AuD9/YA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EpC4PI,eALI;EoCrPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EhCrBE,gBAAA;EgCuBF,qBAAA;EjB1BI,0CiB2BJ;AvDigZF;AsCxhZM;EiBUN;IjBTQ,gBAAA;EtC2hZN;AACF;AuDpgZE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AvDsgZJ;AuDpgZI;EACE,qDAAA;EACA,iDAAA;AvDsgZN;AuDjgZE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBjDE,mDiBkDF;AvDmgZJ;AsCjjZM;EiBqCJ;IjBpCM,gBAAA;EtCojZN;AACF;AuDrgZE;EACE,UAAA;AvDugZJ;AuDpgZE;EACE,UAAA;EACA,UAAA;EACA,oDAAA;AvDsgZJ;;AuDlgZA;EACE,gBAAA;AvDqgZF;;AuDlgZA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AvDqgZF;AuDngZE;EhC7DE,yDAAA;EACA,0DAAA;AvBmkZJ;AuDpgZI;EhChEA,+DAAA;EACA,gEAAA;AvBukZJ;AuDngZE;EACE,aAAA;AvDqgZJ;AuDjgZE;EhC5DE,6DAAA;EACA,4DAAA;AvBgkZJ;AuDjgZM;EhChEF,mEAAA;EACA,kEAAA;AvBokZJ;AuDhgZI;EhCrEA,6DAAA;EACA,4DAAA;AvBwkZJ;;AuD9/YA;EACE,8EAAA;AvDigZF;;AuDx/YE;EACE,eAAA;EACA,cAAA;EhC9GA,gBAAA;AvB0mZJ;AuDz/YI;EAAgB,aAAA;AvD4/YpB;AuD3/YI;EAAe,gBAAA;AvD8/YnB;AuD1/YM;EhCtHF,gBAAA;AvBmnZJ;AuDt/YI;EhC7HA,gBAAA;AvBsnZJ;;AuDj/YI;EACE,iEAAA;EACA,wEAAA;AvDo/YN;;AwD9oZA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,wDAAA;EACA,sCAAA;EACA,4DAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;ErC+QI,yCALI;EqCxQR,gBAAA;EACA,yCAAA;EjCAE,iDAAA;AvB8oZJ;;AwDxoZE;EACE,iDAAA;AxD2oZJ;AwDzoZI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,uFAAA;AxD2oZN;AwDvoZE;EACE,6CAAA;AxDyoZJ;;AyD9qZA;EAEE,kCAAA;EACA,mCAAA;EtC4RI,+BALI;EsCrRR,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,uDAAA;EACA,+CAAA;EACA,0DAAA;EACA,uDAAA;EACA,gDAAA;EACA,wEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,yDAAA;EACA,mDAAA;EACA,6DAAA;EAGA,aAAA;EhCpBA,eAAA;EACA,gBAAA;AzBmsZF;;AyD5qZA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EtCgQI,yCALI;EsCzPR,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;EnBpBI,qImBqBJ;AzD+qZF;AsChsZM;EmBQN;InBPQ,gBAAA;EtCmsZN;AACF;AyDlrZE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;AzDmrZJ;AyDhrZE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UnC2uCgC;EmC1uChC,iDAAA;AzDkrZJ;AyD/qZE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;AzDgrZJ;AyD7qZE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;AzD8qZJ;;AyDzqZE;EACE,8CnC8sCgC;AtB89WpC;AyDvqZM;ElC9BF,0DAAA;EACA,6DAAA;AvBwsZJ;AyDrqZM;ElClDF,2DAAA;EACA,8DAAA;AvB0tZJ;;AyDxpZA;EClGE,iCAAA;EACA,kCAAA;EvC0RI,kCALI;EuCnRR,yDAAA;A1D8vZF;;AyD3pZA;ECtGE,iCAAA;EACA,kCAAA;EvC0RI,mCALI;EuCnRR,yDAAA;A1DqwZF;;A2DvwZA;EAEE,4BAAA;EACA,4BAAA;ExCuRI,4BALI;EwChRR,2BAAA;EACA,sBAAA;EACA,iDAAA;EAGA,qBAAA;EACA,4DAAA;ExC+QI,oCALI;EwCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCJE,4CAAA;AvB4wZJ;A2DnwZE;EACE,aAAA;A3DqwZJ;;A2DhwZA;EACE,kBAAA;EACA,SAAA;A3DmwZF;;A4DnyZA;EAEE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,iDAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;ErCHE,4CAAA;AvBuyZJ;;A4D/xZA;EAEE,cAAA;A5DiyZF;;A4D7xZA;EACE,gBtC6kB4B;EsC5kB5B,iCAAA;A5DgyZF;;A4DxxZA;EACE,mBtCs+C8B;AtBqzWhC;A4DxxZE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;A5D0xZJ;;A4DlxZE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A5DqxZJ;;A4DzxZE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A5D4xZJ;;A4DhyZE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A5DmyZJ;;A4DvyZE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A5D0yZJ;;A4D9yZE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A5DizZJ;;A4DrzZE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A5DwzZJ;;A4D5zZE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A5D+zZJ;;A4Dn0ZE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A5Ds0ZJ;;A6Dl4ZE;EACE;IAAK,2BvCyhD2B;EtB62WlC;AACF;A6Dl4ZA;;EAGE,0BAAA;E1CkRI,gCALI;E0C3QR,wCAAA;EACA,oDAAA;EACA,oDAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E1CsQI,uCALI;E0C/PR,uCAAA;EtCRE,+CAAA;AvB04ZJ;;A6D73ZA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBxBI,6CuByBJ;A7Dg4ZF;AsCr5ZM;EuBYN;IvBXQ,gBAAA;EtCw5ZN;AACF;;A6Dl4ZA;EtBAE,qMAAA;EsBEA,oEAAA;A7Dq4ZF;;A6Dl4ZA;EACE,iBAAA;A7Dq4ZF;;A6Dl4ZA;EACE,WAAA;A7Dq4ZF;;A6Dj4ZE;EACE,kDAAA;A7Do4ZJ;A6Dj4ZM;EAJJ;IAKM,eAAA;E7Do4ZN;AACF;;A8Dh8ZA;EAEE,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,sCAAA;EACA,uDAAA;EACA,4DAAA;EACA,sDAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;EACA,8CAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EvCXE,iDAAA;AvB08ZJ;;A8D37ZA;EACE,qBAAA;EACA,sBAAA;A9D87ZF;A8D57ZE;EAEE,oCAAA;EACA,0BAAA;A9D67ZJ;;A8Dp7ZA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;A9Du7ZF;A8Dp7ZE;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;A9Dq7ZJ;A8Dl7ZE;EACE,+CAAA;EACA,uDAAA;A9Do7ZJ;;A8D56ZA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;A9D+6ZF;A8D76ZE;EvCvDE,+BAAA;EACA,gCAAA;AvBu+ZJ;A8D76ZE;EvC7CE,mCAAA;EACA,kCAAA;AvB69ZJ;A8D76ZE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;A9D86ZJ;A8D16ZE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;A9D46ZJ;A8Dx6ZE;EACE,mBAAA;A9D06ZJ;A8Dx6ZI;EACE,wDAAA;EACA,mDAAA;A9D06ZN;;A8D75ZI;EACE,mBAAA;A9Dg6ZN;A8D75ZQ;EvCvDJ,6DAAA;EAZA,0BAAA;AvBo+ZJ;A8D55ZQ;EvCxEJ,2DAAA;EAYA,4BAAA;AvB49ZJ;A8D35ZQ;EACE,aAAA;A9D65ZV;A8D15ZQ;EACE,mDAAA;EACA,oBAAA;A9D45ZV;A8D15ZU;EACE,yDAAA;EACA,oDAAA;A9D45ZZ;;A8Bl/ZI;EgC8DA;IACE,mBAAA;E9Dw7ZJ;E8Dr7ZM;IvCvDJ,6DAAA;IAZA,0BAAA;EvB4/ZF;E8Dp7ZM;IvCxEJ,2DAAA;IAYA,4BAAA;EvBo/ZF;E8Dn7ZM;IACE,aAAA;E9Dq7ZR;E8Dl7ZM;IACE,mDAAA;IACA,oBAAA;E9Do7ZR;E8Dl7ZQ;IACE,yDAAA;IACA,oDAAA;E9Do7ZV;AACF;A8B3gaI;EgC8DA;IACE,mBAAA;E9Dg9ZJ;E8D78ZM;IvCvDJ,6DAAA;IAZA,0BAAA;EvBohaF;E8D58ZM;IvCxEJ,2DAAA;IAYA,4BAAA;EvB4gaF;E8D38ZM;IACE,aAAA;E9D68ZR;E8D18ZM;IACE,mDAAA;IACA,oBAAA;E9D48ZR;E8D18ZQ;IACE,yDAAA;IACA,oDAAA;E9D48ZV;AACF;A8BniaI;EgC8DA;IACE,mBAAA;E9Dw+ZJ;E8Dr+ZM;IvCvDJ,6DAAA;IAZA,0BAAA;EvB4iaF;E8Dp+ZM;IvCxEJ,2DAAA;IAYA,4BAAA;EvBoiaF;E8Dn+ZM;IACE,aAAA;E9Dq+ZR;E8Dl+ZM;IACE,mDAAA;IACA,oBAAA;E9Do+ZR;E8Dl+ZQ;IACE,yDAAA;IACA,oDAAA;E9Do+ZV;AACF;A8B3jaI;EgC8DA;IACE,mBAAA;E9DggaJ;E8D7/ZM;IvCvDJ,6DAAA;IAZA,0BAAA;EvBokaF;E8D5/ZM;IvCxEJ,2DAAA;IAYA,4BAAA;EvB4jaF;E8D3/ZM;IACE,aAAA;E9D6/ZR;E8D1/ZM;IACE,mDAAA;IACA,oBAAA;E9D4/ZR;E8D1/ZQ;IACE,yDAAA;IACA,oDAAA;E9D4/ZV;AACF;A8BnlaI;EgC8DA;IACE,mBAAA;E9DwhaJ;E8DrhaM;IvCvDJ,6DAAA;IAZA,0BAAA;EvB4laF;E8DphaM;IvCxEJ,2DAAA;IAYA,4BAAA;EvBolaF;E8DnhaM;IACE,aAAA;E9DqhaR;E8DlhaM;IACE,mDAAA;IACA,oBAAA;E9DohaR;E8DlhaQ;IACE,yDAAA;IACA,oDAAA;E9DohaV;AACF;A8DvgaA;EvChJI,gBAAA;AvB0paJ;A8DvgaE;EACE,mDAAA;A9DygaJ;A8DvgaI;EACE,sBAAA;A9DygaN;;A8D5/ZE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A9D+/ZJ;;A8DzgaE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;A9D4gaJ;;A8DthaE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A9DyhaJ;;A8DniaE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A9DsiaJ;;A8DhjaE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A9DmjaJ;;A8D7jaE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;A9DgkaJ;;A8D1kaE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;A9D6kaJ;;A8DvlaE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A9D0laJ;;A+DtxaA;EAEE,sCAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,mEAAA;EACA,+BAAA;EACA,qCAAA;EACA,uEAAA;EAGA,uBAAA;EACA,UzCqpD2B;EyCppD3B,WzCopD2B;EyCnpD3B,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,SAAA;ExCJE,uBAAA;EwCMF,oCAAA;A/DsxaF;A+DnxaE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;A/DqxaJ;A+DlxaE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;A/DoxaJ;A+DjxaE;EAEE,oBAAA;EACA,iBAAA;EACA,6CAAA;A/DkxaJ;;A+D1waA;EAHE,wCAAA;A/DixaF;;A+DxwaI;EATF,wCAAA;A/DqxaF;;AgEt0aA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;E7CyRI,8BALI;E6ClRR,kBAAA;EACA,gDAAA;EACA,+CAAA;EACA,2DAAA;EACA,iDAAA;EACA,2CAAA;EACA,kDAAA;EACA,uDAAA;EACA,kEAAA;EAGA,gCAAA;EACA,eAAA;E7C2QI,oCALI;E6CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EzCRE,4CAAA;AvB+0aJ;AgEp0aE;EACE,UAAA;AhEs0aJ;AgEn0aE;EACE,aAAA;AhEq0aJ;;AgEj0aA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AhEm0aF;AgEj0aE;EACE,sCAAA;AhEm0aJ;;AgE/zaA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EzChCE,0FAAA;EACA,2FAAA;AvBm2aJ;AgEj0aE;EACE,oDAAA;EACA,sCAAA;AhEm0aJ;;AgE/zaA;EACE,kCAAA;EACA,qBAAA;AhEk0aF;;AiEh4aA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,2DAAA;EACA,+CAAA;EACA,oDAAA;EACA,8CAAA;EACA,2FAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sDAAA;EACA,sDAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,sDAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AjE83aF;;AiEv3aA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AjEy3aF;AiEt3aE;E3B5CI,mC2B6CF;EACA,8B3Ck8CgC;AtBs7XpC;AsCl6aM;E2BwCJ;I3BvCM,gBAAA;EtCq6aN;AACF;AiE33aE;EACE,e3Cg8CgC;AtB67XpC;AiEz3aE;EACE,sB3C67CgC;AtB87XpC;;AiEv3aA;EACE,+CAAA;AjE03aF;AiEx3aE;EACE,gBAAA;EACA,gBAAA;AjE03aJ;AiEv3aE;EACE,gBAAA;AjEy3aJ;;AiEr3aA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AjEw3aF;;AiEp3aA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E1CrFE,4CAAA;E0CyFF,UAAA;AjEo3aF;;AiEh3aA;EAEE,0BAAA;EACA,kCAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AjEs3a9D;AkEl+aE;EAAS,UAAA;AlEq+aX;AkEp+aE;EAAS,mCD2GiF;AjE43a5F;;AiEv3aA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,4FAAA;E1CrGE,2DAAA;EACA,4DAAA;AvBg+aJ;AiEz3aE;EACE,kGAAA;EACA,sJAAA;AjE23aJ;;AiEt3aA;EACE,gBAAA;EACA,8CAAA;AjEy3aF;;AiEp3aA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AjEq3aF;;AiEj3aA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E1CzHE,+DAAA;EACA,8DAAA;AvB8+aJ;AiEh3aE;EACE,8CAAA;AjEk3aJ;;A8B79aI;EmCiHF;IACE,0BAAA;IACA,2CAAA;EjEg3aF;EiE52aA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EjE82aF;EiE32aA;IACE,uBAAA;EjE62aF;AACF;A8B5+aI;EmCmIF;;IAEE,uBAAA;EjE42aF;AACF;A8Bl/aI;EmC0IF;IACE,wBAAA;EjE22aF;AACF;AiEl2aI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AjEo2aN;AiEl2aM;EACE,YAAA;EACA,SAAA;E1CzMJ,gBAAA;AvB8ibJ;AiEj2aM;;E1C7MF,gBAAA;AvBkjbJ;AiEh2aM;EACE,gBAAA;AjEk2aR;;A8B5/aI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjEw3aJ;EiEt3aI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;EvBkkbF;EiEr3aI;;I1C7MF,gBAAA;EvBskbF;EiEp3aI;IACE,gBAAA;EjEs3aN;AACF;A8BjhbI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjE44aJ;EiE14aI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;EvBslbF;EiEz4aI;;I1C7MF,gBAAA;EvB0lbF;EiEx4aI;IACE,gBAAA;EjE04aN;AACF;A8BribI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjEg6aJ;EiE95aI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;EvB0mbF;EiE75aI;;I1C7MF,gBAAA;EvB8mbF;EiE55aI;IACE,gBAAA;EjE85aN;AACF;A8BzjbI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjEo7aJ;EiEl7aI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;EvB8nbF;EiEj7aI;;I1C7MF,gBAAA;EvBkobF;EiEh7aI;IACE,gBAAA;EjEk7aN;AACF;A8B7kbI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjEw8aJ;EiEt8aI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;EvBkpbF;EiEr8aI;;I1C7MF,gBAAA;EvBspbF;EiEp8aI;IACE,gBAAA;EjEs8aN;AACF;AmE5qbA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,qBAAA;EhDwRI,gCALI;EgDjRR,qCAAA;EACA,yCAAA;EACA,mDAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gB9CwmB4B;E8CvmB5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EgDhQR,qBAAA;EACA,UAAA;AnEorbF;AmElrbE;EAAS,kCAAA;AnEqrbX;AmEnrbE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AnEqrbJ;AmEnrbI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AnEqrbN;;AmEhrbA;EACE,iDAAA;AnEmrbF;AmEjrbE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;AnEmrbJ;;AmE/qbA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;AnEkrbF;AmEhrbE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;AnEkrbJ;;AmE9qbA,mBAAA;AAEA;EACE,8CAAA;AnEgrbF;AmE9qbE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;AnEgrbJ;;AmE5qbA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;AnE+qbF;AmE7qbE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;AnE+qbJ;;AmE3qbA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E5CjGE,8CAAA;AvB+vbJ;;AqElxbA;EAEE,yBAAA;EACA,6BAAA;ElD4RI,gCALI;EkDrRR,kCAAA;EACA,iDAAA;EACA,6DAAA;EACA,sDAAA;EACA,2FAAA;EACA,6CAAA;EACA,mCAAA;EACA,qCAAA;ElDmRI,mCALI;EkD5QR,kCAAA;EACA,8CAAA;EACA,iCAAA;EACA,iCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gB9CwmB4B;E8CvmB5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EkD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E9ChBE,8CAAA;AvB6ybJ;AqEzxbE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;ArE2xbJ;AqEzxbI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;ArE0xbN;;AqEpxbE;EACE,oFAAA;ArEuxbJ;AqErxbI;EAEE,wFAAA;ArEsxbN;AqEnxbI;EACE,SAAA;EACA,gDAAA;ArEqxbN;AqElxbI;EACE,sCAAA;EACA,sCAAA;ArEoxbN;;AqE/wbA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;ArEixbJ;AqE/wbI;EAEE,kIAAA;ArEgxbN;AqE7wbI;EACE,OAAA;EACA,kDAAA;ArE+wbN;AqE5wbI;EACE,oCAAA;EACA,wCAAA;ArE8wbN;;AqEzwbA,mBAAA;AAGE;EACE,iFAAA;ArE0wbJ;AqExwbI;EAEE,wFAAA;ArEywbN;AqEtwbI;EACE,MAAA;EACA,mDAAA;ArEwwbN;AqErwbI;EACE,mCAAA;EACA,yCAAA;ArEuwbN;AqElwbE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;ArEowbJ;;AqEhwbA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;ArEkwbJ;AqEhwbI;EAEE,kIAAA;ArEiwbN;AqE9vbI;EACE,QAAA;EACA,iDAAA;ArEgwbN;AqE7vbI;EACE,qCAAA;EACA,uCAAA;ArE+vbN;;AqE1vbA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;ElD2GI,6CALI;EkDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E9C5JE,6DAAA;EACA,8DAAA;AvBy4bJ;AqE3ubE;EACE,aAAA;ArE6ubJ;;AqEzubA;EACE,0EAAA;EACA,mCAAA;ArE4ubF;;AsEj6bA;EACE,kBAAA;AtEo6bF;;AsEj6bA;EACE,mBAAA;AtEo6bF;;AsEj6bA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AtEo6bF;AuE17bE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvE47bJ;;AsEr6bA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EhClBI,sCgCmBJ;AtEw6bF;AsCv7bM;EgCQN;IhCPQ,gBAAA;EtC07bN;AACF;;AsE16bA;;;EAGE,cAAA;AtE66bF;;AsE16bA;;EAEE,2BAAA;AtE66bF;;AsE16bA;;EAEE,4BAAA;AtE66bF;;AsEp6bE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AtEu6bJ;AsEp6bE;;;EAGE,UAAA;EACA,UAAA;AtEs6bJ;AsEn6bE;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;AtEq6bJ;AsC99bM;EgCqDJ;;IhCpDM,gBAAA;EtCk+bN;AACF;;AsEl6bA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhDkhDmC;EgDjhDnC,UAAA;EACA,WhD1FS;EgD2FT,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YhD6gDmC;EgBnmD/B,8BgCuFJ;AtEo6bF;AsCv/bM;EgCkEN;;IhCjEQ,gBAAA;EtC2/bN;AACF;AsEv6bE;;;EAEE,WhDpGO;EgDqGP,qBAAA;EACA,UAAA;EACA,YhDqgDiC;AtBq6YrC;;AsEv6bA;EACE,OAAA;AtE06bF;;AsEv6bA;EACE,QAAA;AtE06bF;;AsEr6bA;;EAEE,qBAAA;EACA,WhDsgDmC;EgDrgDnC,YhDqgDmC;EgDpgDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AtEw6bF;;AsEr6bA;EACE,2TAAA;AtEw6bF;;AsEt6bA;EACE,0TAAA;AtEy6bF;;AsEj6bA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBhDs9CmC;EgDr9CnC,mBAAA;EACA,gBhDo9CmC;AtB+8YrC;AsEj6bE;EACE,uBAAA;EACA,cAAA;EACA,WhDo9CiC;EgDn9CjC,WhDo9CiC;EgDn9CjC,UAAA;EACA,iBhDo9CiC;EgDn9CjC,gBhDm9CiC;EgDl9CjC,mBAAA;EACA,eAAA;EACA,sBhDlKO;EgDmKP,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YhD28CiC;EgB3mD/B,6BgCiKF;AtEk6bJ;AsC/jcM;EgC4IJ;IhC3IM,gBAAA;EtCkkcN;AACF;AsEp6bE;EACE,UhDw8CiC;AtB89YrC;;AsE75bA;EACE,kBAAA;EACA,UAAA;EACA,ehDk8CmC;EgDj8CnC,SAAA;EACA,oBhD+7CmC;EgD97CnC,uBhD87CmC;EgD77CnC,WhD7LS;EgD8LT,kBAAA;AtEg6bF;;AsE15bE;;EAEE,gChDm8CiC;AtB09YrC;AsE15bE;EACE,kCEhNI;AxE4mcR;AsEz5bE;EACE,uBEpNI;AxE+mcR;;AsEr6bE;;;EAEE,gChDm8CiC;AtBs+YrC;AsEt6bE;EACE,kCEhNI;AxEwncR;AsEr6bE;EACE,uBEpNI;AxE2ncR;;AyEzncA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;AzE2ncF;;AyEvncA;EACE;IAAK,0CAAA;EzE2ncL;AACF;AyExncA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;AzEuncF;;AyEpncA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;AzEsncF;;AyE7mcA;EACE;IACE,mBAAA;EzEgncF;EyE9mcA;IACE,UAAA;IACA,eAAA;EzEgncF;AACF;AyE5mcA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;AzE2mcF;;AyExmcA;EACE,wBAAA;EACA,yBAAA;AzE2mcF;;AyEvmcE;EACE;;IAEE,kCAAA;EzE0mcJ;AACF;A0E1rcA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,kDAAA;EACA,qDAAA;EACA,qCAAA;A1E2rcF;;A8B9ncI;E4C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IpC5BA,0CoC8BA;E1E4qcJ;AACF;AsCvscM;EoCYJ;IpCXM,gBAAA;EtC0scN;AACF;A8BppcI;E4C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1EmrcN;E0EhrcI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1EkrcN;E0E/qcI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1EircN;E0E9qcI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1EgrcN;E0E7qcI;IAEE,eAAA;E1E8qcN;E0E3qcI;IAGE,mBAAA;E1E2qcN;AACF;A8BxscI;E4C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1E0qcN;E0ExqcM;IACE,aAAA;E1E0qcR;E0EvqcM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1EwqcR;AACF;;A8B5scI;E4C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IpC5BA,0CoC8BA;E1E0vcJ;AACF;AsCrxcM;EoCYJ;IpCXM,gBAAA;EtCwxcN;AACF;A8BlucI;E4C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1EiwcN;E0E9vcI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1EgwcN;E0E7vcI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1E+vcN;E0E5vcI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1E8vcN;E0E3vcI;IAEE,eAAA;E1E4vcN;E0EzvcI;IAGE,mBAAA;E1EyvcN;AACF;A8BtxcI;E4C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1EwvcN;E0EtvcM;IACE,aAAA;E1EwvcR;E0ErvcM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1EsvcR;AACF;;A8B1xcI;E4C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IpC5BA,0CoC8BA;E1Ew0cJ;AACF;AsCn2cM;EoCYJ;IpCXM,gBAAA;EtCs2cN;AACF;A8BhzcI;E4C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1E+0cN;E0E50cI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1E80cN;E0E30cI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1E60cN;E0E10cI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1E40cN;E0Ez0cI;IAEE,eAAA;E1E00cN;E0Ev0cI;IAGE,mBAAA;E1Eu0cN;AACF;A8Bp2cI;E4C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1Es0cN;E0Ep0cM;IACE,aAAA;E1Es0cR;E0En0cM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1Eo0cR;AACF;;A8Bx2cI;E4C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IpC5BA,0CoC8BA;E1Es5cJ;AACF;AsCj7cM;EoCYJ;IpCXM,gBAAA;EtCo7cN;AACF;A8B93cI;E4C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1E65cN;E0E15cI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1E45cN;E0Ez5cI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1E25cN;E0Ex5cI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1E05cN;E0Ev5cI;IAEE,eAAA;E1Ew5cN;E0Er5cI;IAGE,mBAAA;E1Eq5cN;AACF;A8Bl7cI;E4C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1Eo5cN;E0El5cM;IACE,aAAA;E1Eo5cR;E0Ej5cM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1Ek5cR;AACF;;A8Bt7cI;E4C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IpC5BA,0CoC8BA;E1Eo+cJ;AACF;AsC//cM;EoCYJ;IpCXM,gBAAA;EtCkgdN;AACF;A8B58cI;E4C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1E2+cN;E0Ex+cI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1E0+cN;E0Ev+cI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1Ey+cN;E0Et+cI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1Ew+cN;E0Er+cI;IAEE,eAAA;E1Es+cN;E0En+cI;IAGE,mBAAA;E1Em+cN;AACF;A8BhgdI;E4C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1Ek+cN;E0Eh+cM;IACE,aAAA;E1Ek+cR;E0E/9cM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1Eg+cR;AACF;;A0EhjdE;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EpC5BA,0CoC8BA;A1EijdN;AsC3kdM;EoCYJ;IpCXM,gBAAA;EtC8kdN;AACF;A0EpjdM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;A1EsjdR;A0EnjdM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;A1EqjdR;A0EljdM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;A1EojdR;A0EjjdM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;A1EmjdR;A0EhjdM;EAEE,eAAA;A1EijdR;A0E9idM;EAGE,mBAAA;A1E8idR;;A0EnhdA;ERpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5C0mCkC;E4CzmClC,YAAA;EACA,aAAA;EACA,kCMNM;AxEipdR;AkExodE;EAAS,UAAA;AlE2odX;AkE1odE;EAAS,Y5Cm+CyB;AtB0qapC;;A0E/hdA;EACE,aAAA;EACA,mBAAA;EACA,oEAAA;A1EkidF;A0EhidE;EACE,4FAAA;EACA,6IAAA;A1EkidJ;;A0E9hdA;EACE,gBAAA;EACA,kDAAA;A1EiidF;;A0E9hdA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;A1EiidF;;A2E9qdA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YrDgzCkC;AtBi4apC;A2E/qdE;EACE,qBAAA;EACA,WAAA;A3EirdJ;;A2E5qdA;EACE,iBAAA;A3E+qdF;;A2E5qdA;EACE,iBAAA;A3E+qdF;;A2E5qdA;EACE,iBAAA;A3E+qdF;;A2E1qdE;EACE,mDAAA;A3E6qdJ;;A2EzqdA;EACE;IACE,YrDmxCgC;EtBy5alC;AACF;A2EzqdA;EACE,uGAAA;EACA,oBAAA;EACA,8CAAA;A3E2qdF;;A2ExqdA;EACE;IACE,uBAAA;E3E2qdF;AACF;AuE1tdE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvE4tdJ;;A4E/tdE;EACE,sBAAA;EACA,iFAAA;A5EkudJ;;A4EpudE;EACE,sBAAA;EACA,mFAAA;A5EuudJ;;A4EzudE;EACE,sBAAA;EACA,iFAAA;A5E4udJ;;A4E9udE;EACE,sBAAA;EACA,8EAAA;A5EivdJ;;A4EnvdE;EACE,sBAAA;EACA,iFAAA;A5EsvdJ;;A4ExvdE;EACE,sBAAA;EACA,gFAAA;A5E2vdJ;;A4E7vdE;EACE,sBAAA;EACA,+EAAA;A5EgwdJ;;A4ElwdE;EACE,sBAAA;EACA,8EAAA;A5EqwdJ;;A6EvwdE;EACE,wEAAA;EACA,kGAAA;A7E0wdJ;A6EvwdM;EAGE,8DAAA;EACA,wFAAA;A7EuwdR;;A6EhxdE;EACE,0EAAA;EACA,oGAAA;A7EmxdJ;A6EhxdM;EAGE,8DAAA;EACA,wFAAA;A7EgxdR;;A6EzxdE;EACE,wEAAA;EACA,kGAAA;A7E4xdJ;A6EzxdM;EAGE,8DAAA;EACA,wFAAA;A7EyxdR;;A6ElydE;EACE,qEAAA;EACA,+FAAA;A7EqydJ;A6ElydM;EAGE,+DAAA;EACA,yFAAA;A7EkydR;;A6E3ydE;EACE,wEAAA;EACA,kGAAA;A7E8ydJ;A6E3ydM;EAGE,8DAAA;EACA,wFAAA;A7E2ydR;;A6EpzdE;EACE,uEAAA;EACA,iGAAA;A7EuzdJ;A6EpzdM;EAGE,8DAAA;EACA,wFAAA;A7EozdR;;A6E7zdE;EACE,sEAAA;EACA,gGAAA;A7Eg0dJ;A6E7zdM;EAGE,gEAAA;EACA,0FAAA;A7E6zdR;;A6Et0dE;EACE,qEAAA;EACA,+FAAA;A7Ey0dJ;A6Et0dM;EAGE,6DAAA;EACA,uFAAA;A7Es0dR;;A6E/zdA;EACE,+EAAA;EACA,yGAAA;A7Ek0dF;A6E/zdI;EAEE,kFAAA;EACA,4GAAA;A7Eg0dN;;A8E11dA;EACE,UAAA;EAEA,kJAAA;A9E41dF;;A+E/1dA;EACE,oBAAA;EACA,azD6c4B;EyD5c5B,mBAAA;EACA,kFAAA;EACA,6BzD2c4B;EyD1c5B,2BAAA;A/Ek2dF;A+Eh2dE;EACE,cAAA;EACA,UzDuc0B;EyDtc1B,WzDsc0B;EyDrc1B,kBAAA;EzCIE,sCyCHF;A/Ek2dJ;AsC31dM;EyCZJ;IzCaM,gBAAA;EtC81dN;AACF;;A+Eh2dI;EACE,mEAAA;A/Em2dN;;AgFt3dA;EACE,kBAAA;EACA,WAAA;AhFy3dF;AgFv3dE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;AhFy3dJ;AgFt3dE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AhFw3dJ;;AgFn3dE;EACE,uBAAA;AhFs3dJ;;AgFv3dE;EACE,sBAAA;AhF03dJ;;AgF33dE;EACE,yBAAA;AhF83dJ;;AgF/3dE;EACE,iCAAA;AhFk4dJ;;AiFv5dA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a3DumCkC;AtBmzbpC;;AiFv5dA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a3D+lCkC;AtB2zbpC;;AiFl5dI;EACE,gBAAA;EACA,MAAA;EACA,a3DmlC8B;AtBk0bpC;;AiFl5dI;EACE,gBAAA;EACA,SAAA;EACA,a3D6kC8B;AtBw0bpC;;A8Bt3dI;EmDxCA;IACE,gBAAA;IACA,MAAA;IACA,a3DmlC8B;EtB+0blC;EiF/5dE;IACE,gBAAA;IACA,SAAA;IACA,a3D6kC8B;EtBo1blC;AACF;A8Bn4dI;EmDxCA;IACE,gBAAA;IACA,MAAA;IACA,a3DmlC8B;EtB21blC;EiF36dE;IACE,gBAAA;IACA,SAAA;IACA,a3D6kC8B;EtBg2blC;AACF;A8B/4dI;EmDxCA;IACE,gBAAA;IACA,MAAA;IACA,a3DmlC8B;EtBu2blC;EiFv7dE;IACE,gBAAA;IACA,SAAA;IACA,a3D6kC8B;EtB42blC;AACF;A8B35dI;EmDxCA;IACE,gBAAA;IACA,MAAA;IACA,a3DmlC8B;EtBm3blC;EiFn8dE;IACE,gBAAA;IACA,SAAA;IACA,a3D6kC8B;EtBw3blC;AACF;A8Bv6dI;EmDxCA;IACE,gBAAA;IACA,MAAA;IACA,a3DmlC8B;EtB+3blC;EiF/8dE;IACE,gBAAA;IACA,SAAA;IACA,a3D6kC8B;EtBo4blC;AACF;AkFj/dA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AlFm/dF;;AkFh/dA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AlFm/dF;;AmF3/dA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;ApF4/dF;AoFz/dE;;EACE,6BAAA;ApF4/dJ;;AqF1geE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U/DgcsC;E+D/btC,WAAA;ArF6geJ;;AsFrheA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AvFyheF;;AwF/heA;EACE,qBAAA;EACA,mBAAA;EACA,6BlEisB4B;EkEhsB5B,eAAA;EACA,8BAAA;EACA,alE2rB4B;AtBu2c9B;;AyFt+dQ;EAOI,mCAAA;AzFm+dZ;;AyF1+dQ;EAOI,8BAAA;AzFu+dZ;;AyF9+dQ;EAOI,iCAAA;AzF2+dZ;;AyFl/dQ;EAOI,iCAAA;AzF++dZ;;AyFt/dQ;EAOI,sCAAA;AzFm/dZ;;AyF1/dQ;EAOI,mCAAA;AzFu/dZ;;AyF9/dQ;EAOI,sBAAA;AzF2/dZ;;AyFlgeQ;EAOI,uBAAA;AzF+/dZ;;AyFtgeQ;EAOI,sBAAA;AzFmgeZ;;AyF1geQ;EAOI,8BAAA;AzFugeZ;;AyF9geQ;EAOI,4BAAA;AzF2geZ;;AyFlheQ;EAOI,2BAAA;AzF+geZ;;AyFtheQ;EAOI,iCAAA;AzFmheZ;;AyF1heQ;EAOI,2BAAA;AzFuheZ;;AyF9heQ;EAOI,qBAAA;AzF2heZ;;AyFlieQ;EAOI,wBAAA;AzF+heZ;;AyFtieQ;EAOI,uBAAA;AzFmieZ;;AyF1ieQ;EAOI,wBAAA;AzFuieZ;;AyF9ieQ;EAOI,qBAAA;AzF2ieZ;;AyFljeQ;EAOI,yBAAA;AzF+ieZ;;AyFtjeQ;EAOI,2BAAA;AzFmjeZ;;AyF1jeQ;EAOI,4BAAA;AzFujeZ;;AyF9jeQ;EAOI,2BAAA;AzF2jeZ;;AyFlkeQ;EAOI,2BAAA;AzF+jeZ;;AyFtkeQ;EAOI,6BAAA;AzFmkeZ;;AyF1keQ;EAOI,8BAAA;AzFukeZ;;AyF9keQ;EAOI,6BAAA;AzF2keZ;;AyFlleQ;EAOI,2BAAA;AzF+keZ;;AyFtleQ;EAOI,6BAAA;AzFmleZ;;AyF1leQ;EAOI,8BAAA;AzFuleZ;;AyF9leQ;EAOI,6BAAA;AzF2leZ;;AyFlmeQ;EAOI,0BAAA;AzF+leZ;;AyFtmeQ;EAOI,gCAAA;AzFmmeZ;;AyF1meQ;EAOI,yBAAA;AzFumeZ;;AyF9meQ;EAOI,wBAAA;AzF2meZ;;AyFlneQ;EAOI,+BAAA;AzF+meZ;;AyFtneQ;EAOI,yBAAA;AzFmneZ;;AyF1neQ;EAOI,6BAAA;AzFuneZ;;AyF9neQ;EAOI,8BAAA;AzF2neZ;;AyFloeQ;EAOI,wBAAA;AzF+neZ;;AyFtoeQ;EAOI,+BAAA;AzFmoeZ;;AyF1oeQ;EAOI,wBAAA;AzFuoeZ;;AyF9oeQ;EAOI,2CAAA;AzF2oeZ;;AyFlpeQ;EAOI,8CAAA;AzF+oeZ;;AyFtpeQ;EAOI,8CAAA;AzFmpeZ;;AyF1peQ;EAOI,2BAAA;AzFupeZ;;AyFxqeQ;EACE,gFAAA;AzF2qeV;;AyF5qeQ;EACE,kFAAA;AzF+qeV;;AyFhreQ;EACE,gFAAA;AzFmreV;;AyFpreQ;EACE,6EAAA;AzFureV;;AyFxreQ;EACE,gFAAA;AzF2reV;;AyF5reQ;EACE,+EAAA;AzF+reV;;AyFhseQ;EACE,8EAAA;AzFmseV;;AyFpseQ;EACE,6EAAA;AzFuseV;;AyF9reQ;EAOI,2BAAA;AzF2reZ;;AyFlseQ;EAOI,6BAAA;AzF+reZ;;AyFtseQ;EAOI,6BAAA;AzFmseZ;;AyF1seQ;EAOI,0BAAA;AzFuseZ;;AyF9seQ;EAOI,2BAAA;AzF2seZ;;AyFlteQ;EAOI,iBAAA;AzF+seZ;;AyFtteQ;EAOI,mBAAA;AzFmteZ;;AyF1teQ;EAOI,oBAAA;AzFuteZ;;AyF9teQ;EAOI,oBAAA;AzF2teZ;;AyFlueQ;EAOI,sBAAA;AzF+teZ;;AyFtueQ;EAOI,uBAAA;AzFmueZ;;AyF1ueQ;EAOI,kBAAA;AzFuueZ;;AyF9ueQ;EAOI,oBAAA;AzF2ueZ;;AyFlveQ;EAOI,qBAAA;AzF+ueZ;;AyFtveQ;EAOI,mBAAA;AzFmveZ;;AyF1veQ;EAOI,qBAAA;AzFuveZ;;AyF9veQ;EAOI,sBAAA;AzF2veZ;;AyFlweQ;EAOI,2CAAA;AzF+veZ;;AyFtweQ;EAOI,sCAAA;AzFmweZ;;AyF1weQ;EAOI,sCAAA;AzFuweZ;;AyF9weQ;EAOI,uFAAA;AzF2weZ;;AyFlxeQ;EAOI,oBAAA;AzF+weZ;;AyFtxeQ;EAOI,2FAAA;AzFmxeZ;;AyF1xeQ;EAOI,wBAAA;AzFuxeZ;;AyF9xeQ;EAOI,6FAAA;AzF2xeZ;;AyFlyeQ;EAOI,0BAAA;AzF+xeZ;;AyFtyeQ;EAOI,8FAAA;AzFmyeZ;;AyF1yeQ;EAOI,2BAAA;AzFuyeZ;;AyF9yeQ;EAOI,4FAAA;AzF2yeZ;;AyFlzeQ;EAOI,yBAAA;AzF+yeZ;;AyFtzeQ;EAIQ,sBAAA;EAGJ,8EAAA;AzFozeZ;;AyF3zeQ;EAIQ,sBAAA;EAGJ,gFAAA;AzFyzeZ;;AyFh0eQ;EAIQ,sBAAA;EAGJ,8EAAA;AzF8zeZ;;AyFr0eQ;EAIQ,sBAAA;EAGJ,2EAAA;AzFm0eZ;;AyF10eQ;EAIQ,sBAAA;EAGJ,8EAAA;AzFw0eZ;;AyF/0eQ;EAIQ,sBAAA;EAGJ,6EAAA;AzF60eZ;;AyFp1eQ;EAIQ,sBAAA;EAGJ,4EAAA;AzFk1eZ;;AyFz1eQ;EAIQ,sBAAA;EAGJ,2EAAA;AzFu1eZ;;AyF91eQ;EAIQ,sBAAA;EAGJ,4EAAA;AzF41eZ;;AyFn2eQ;EAIQ,sBAAA;EAGJ,4EAAA;AzFi2eZ;;AyFx2eQ;EAOI,wDAAA;AzFq2eZ;;AyF52eQ;EAOI,0DAAA;AzFy2eZ;;AyFh3eQ;EAOI,wDAAA;AzF62eZ;;AyFp3eQ;EAOI,qDAAA;AzFi3eZ;;AyFx3eQ;EAOI,wDAAA;AzFq3eZ;;AyF53eQ;EAOI,uDAAA;AzFy3eZ;;AyFh4eQ;EAOI,sDAAA;AzF63eZ;;AyFp4eQ;EAOI,qDAAA;AzFi4eZ;;AyFx4eQ;EAOI,4BAAA;AzFq4eZ;;AyF54eQ;EAOI,4BAAA;AzFy4eZ;;AyFh5eQ;EAOI,4BAAA;AzF64eZ;;AyFp5eQ;EAOI,4BAAA;AzFi5eZ;;AyFx5eQ;EAOI,4BAAA;AzFq5eZ;;AyFt6eQ;EACE,wBAAA;AzFy6eV;;AyF16eQ;EACE,yBAAA;AzF66eV;;AyF96eQ;EACE,wBAAA;AzFi7eV;;AyFl7eQ;EACE,yBAAA;AzFq7eV;;AyFt7eQ;EACE,sBAAA;AzFy7eV;;AyFh7eQ;EAOI,qBAAA;AzF66eZ;;AyFp7eQ;EAOI,qBAAA;AzFi7eZ;;AyFx7eQ;EAOI,qBAAA;AzFq7eZ;;AyF57eQ;EAOI,sBAAA;AzFy7eZ;;AyFh8eQ;EAOI,sBAAA;AzF67eZ;;AyFp8eQ;EAOI,0BAAA;AzFi8eZ;;AyFx8eQ;EAOI,uBAAA;AzFq8eZ;;AyF58eQ;EAOI,2BAAA;AzFy8eZ;;AyFh9eQ;EAOI,sBAAA;AzF68eZ;;AyFp9eQ;EAOI,sBAAA;AzFi9eZ;;AyFx9eQ;EAOI,sBAAA;AzFq9eZ;;AyF59eQ;EAOI,uBAAA;AzFy9eZ;;AyFh+eQ;EAOI,uBAAA;AzF69eZ;;AyFp+eQ;EAOI,2BAAA;AzFi+eZ;;AyFx+eQ;EAOI,wBAAA;AzFq+eZ;;AyF5+eQ;EAOI,4BAAA;AzFy+eZ;;AyFh/eQ;EAOI,yBAAA;AzF6+eZ;;AyFp/eQ;EAOI,8BAAA;AzFi/eZ;;AyFx/eQ;EAOI,iCAAA;AzFq/eZ;;AyF5/eQ;EAOI,sCAAA;AzFy/eZ;;AyFhgfQ;EAOI,yCAAA;AzF6/eZ;;AyFpgfQ;EAOI,uBAAA;AzFigfZ;;AyFxgfQ;EAOI,uBAAA;AzFqgfZ;;AyF5gfQ;EAOI,yBAAA;AzFygfZ;;AyFhhfQ;EAOI,yBAAA;AzF6gfZ;;AyFphfQ;EAOI,0BAAA;AzFihfZ;;AyFxhfQ;EAOI,4BAAA;AzFqhfZ;;AyF5hfQ;EAOI,kCAAA;AzFyhfZ;;AyFhifQ;EAOI,sCAAA;AzF6hfZ;;AyFpifQ;EAOI,oCAAA;AzFiifZ;;AyFxifQ;EAOI,kCAAA;AzFqifZ;;AyF5ifQ;EAOI,yCAAA;AzFyifZ;;AyFhjfQ;EAOI,wCAAA;AzF6ifZ;;AyFpjfQ;EAOI,wCAAA;AzFijfZ;;AyFxjfQ;EAOI,kCAAA;AzFqjfZ;;AyF5jfQ;EAOI,gCAAA;AzFyjfZ;;AyFhkfQ;EAOI,8BAAA;AzF6jfZ;;AyFpkfQ;EAOI,gCAAA;AzFikfZ;;AyFxkfQ;EAOI,+BAAA;AzFqkfZ;;AyF5kfQ;EAOI,oCAAA;AzFykfZ;;AyFhlfQ;EAOI,kCAAA;AzF6kfZ;;AyFplfQ;EAOI,gCAAA;AzFilfZ;;AyFxlfQ;EAOI,uCAAA;AzFqlfZ;;AyF5lfQ;EAOI,sCAAA;AzFylfZ;;AyFhmfQ;EAOI,iCAAA;AzF6lfZ;;AyFpmfQ;EAOI,2BAAA;AzFimfZ;;AyFxmfQ;EAOI,iCAAA;AzFqmfZ;;AyF5mfQ;EAOI,+BAAA;AzFymfZ;;AyFhnfQ;EAOI,6BAAA;AzF6mfZ;;AyFpnfQ;EAOI,+BAAA;AzFinfZ;;AyFxnfQ;EAOI,8BAAA;AzFqnfZ;;AyF5nfQ;EAOI,oBAAA;AzFynfZ;;AyFhofQ;EAOI,mBAAA;AzF6nfZ;;AyFpofQ;EAOI,mBAAA;AzFiofZ;;AyFxofQ;EAOI,mBAAA;AzFqofZ;;AyF5ofQ;EAOI,mBAAA;AzFyofZ;;AyFhpfQ;EAOI,mBAAA;AzF6ofZ;;AyFppfQ;EAOI,mBAAA;AzFipfZ;;AyFxpfQ;EAOI,mBAAA;AzFqpfZ;;AyF5pfQ;EAOI,oBAAA;AzFypfZ;;AyFhqfQ;EAOI,0BAAA;AzF6pfZ;;AyFpqfQ;EAOI,yBAAA;AzFiqfZ;;AyFxqfQ;EAOI,uBAAA;AzFqqfZ;;AyF5qfQ;EAOI,yBAAA;AzFyqfZ;;AyFhrfQ;EAOI,uBAAA;AzF6qfZ;;AyFprfQ;EAOI,uBAAA;AzFirfZ;;AyFxrfQ;EAOI,0BAAA;EAAA,yBAAA;AzFsrfZ;;AyF7rfQ;EAOI,gCAAA;EAAA,+BAAA;AzF2rfZ;;AyFlsfQ;EAOI,+BAAA;EAAA,8BAAA;AzFgsfZ;;AyFvsfQ;EAOI,6BAAA;EAAA,4BAAA;AzFqsfZ;;AyF5sfQ;EAOI,+BAAA;EAAA,8BAAA;AzF0sfZ;;AyFjtfQ;EAOI,6BAAA;EAAA,4BAAA;AzF+sfZ;;AyFttfQ;EAOI,6BAAA;EAAA,4BAAA;AzFotfZ;;AyF3tfQ;EAOI,wBAAA;EAAA,2BAAA;AzFytfZ;;AyFhufQ;EAOI,8BAAA;EAAA,iCAAA;AzF8tfZ;;AyFrufQ;EAOI,6BAAA;EAAA,gCAAA;AzFmufZ;;AyF1ufQ;EAOI,2BAAA;EAAA,8BAAA;AzFwufZ;;AyF/ufQ;EAOI,6BAAA;EAAA,gCAAA;AzF6ufZ;;AyFpvfQ;EAOI,2BAAA;EAAA,8BAAA;AzFkvfZ;;AyFzvfQ;EAOI,2BAAA;EAAA,8BAAA;AzFuvfZ;;AyF9vfQ;EAOI,wBAAA;AzF2vfZ;;AyFlwfQ;EAOI,8BAAA;AzF+vfZ;;AyFtwfQ;EAOI,6BAAA;AzFmwfZ;;AyF1wfQ;EAOI,2BAAA;AzFuwfZ;;AyF9wfQ;EAOI,6BAAA;AzF2wfZ;;AyFlxfQ;EAOI,2BAAA;AzF+wfZ;;AyFtxfQ;EAOI,2BAAA;AzFmxfZ;;AyF1xfQ;EAOI,0BAAA;AzFuxfZ;;AyF9xfQ;EAOI,gCAAA;AzF2xfZ;;AyFlyfQ;EAOI,+BAAA;AzF+xfZ;;AyFtyfQ;EAOI,6BAAA;AzFmyfZ;;AyF1yfQ;EAOI,+BAAA;AzFuyfZ;;AyF9yfQ;EAOI,6BAAA;AzF2yfZ;;AyFlzfQ;EAOI,6BAAA;AzF+yfZ;;AyFtzfQ;EAOI,2BAAA;AzFmzfZ;;AyF1zfQ;EAOI,iCAAA;AzFuzfZ;;AyF9zfQ;EAOI,gCAAA;AzF2zfZ;;AyFl0fQ;EAOI,8BAAA;AzF+zfZ;;AyFt0fQ;EAOI,gCAAA;AzFm0fZ;;AyF10fQ;EAOI,8BAAA;AzFu0fZ;;AyF90fQ;EAOI,8BAAA;AzF20fZ;;AyFl1fQ;EAOI,yBAAA;AzF+0fZ;;AyFt1fQ;EAOI,+BAAA;AzFm1fZ;;AyF11fQ;EAOI,8BAAA;AzFu1fZ;;AyF91fQ;EAOI,4BAAA;AzF21fZ;;AyFl2fQ;EAOI,8BAAA;AzF+1fZ;;AyFt2fQ;EAOI,4BAAA;AzFm2fZ;;AyF12fQ;EAOI,4BAAA;AzFu2fZ;;AyF92fQ;EAOI,qBAAA;AzF22fZ;;AyFl3fQ;EAOI,2BAAA;AzF+2fZ;;AyFt3fQ;EAOI,0BAAA;AzFm3fZ;;AyF13fQ;EAOI,wBAAA;AzFu3fZ;;AyF93fQ;EAOI,0BAAA;AzF23fZ;;AyFl4fQ;EAOI,wBAAA;AzF+3fZ;;AyFt4fQ;EAOI,2BAAA;EAAA,0BAAA;AzFo4fZ;;AyF34fQ;EAOI,iCAAA;EAAA,gCAAA;AzFy4fZ;;AyFh5fQ;EAOI,gCAAA;EAAA,+BAAA;AzF84fZ;;AyFr5fQ;EAOI,8BAAA;EAAA,6BAAA;AzFm5fZ;;AyF15fQ;EAOI,gCAAA;EAAA,+BAAA;AzFw5fZ;;AyF/5fQ;EAOI,8BAAA;EAAA,6BAAA;AzF65fZ;;AyFp6fQ;EAOI,yBAAA;EAAA,4BAAA;AzFk6fZ;;AyFz6fQ;EAOI,+BAAA;EAAA,kCAAA;AzFu6fZ;;AyF96fQ;EAOI,8BAAA;EAAA,iCAAA;AzF46fZ;;AyFn7fQ;EAOI,4BAAA;EAAA,+BAAA;AzFi7fZ;;AyFx7fQ;EAOI,8BAAA;EAAA,iCAAA;AzFs7fZ;;AyF77fQ;EAOI,4BAAA;EAAA,+BAAA;AzF27fZ;;AyFl8fQ;EAOI,yBAAA;AzF+7fZ;;AyFt8fQ;EAOI,+BAAA;AzFm8fZ;;AyF18fQ;EAOI,8BAAA;AzFu8fZ;;AyF98fQ;EAOI,4BAAA;AzF28fZ;;AyFl9fQ;EAOI,8BAAA;AzF+8fZ;;AyFt9fQ;EAOI,4BAAA;AzFm9fZ;;AyF19fQ;EAOI,2BAAA;AzFu9fZ;;AyF99fQ;EAOI,iCAAA;AzF29fZ;;AyFl+fQ;EAOI,gCAAA;AzF+9fZ;;AyFt+fQ;EAOI,8BAAA;AzFm+fZ;;AyF1+fQ;EAOI,gCAAA;AzFu+fZ;;AyF9+fQ;EAOI,8BAAA;AzF2+fZ;;AyFl/fQ;EAOI,4BAAA;AzF++fZ;;AyFt/fQ;EAOI,kCAAA;AzFm/fZ;;AyF1/fQ;EAOI,iCAAA;AzFu/fZ;;AyF9/fQ;EAOI,+BAAA;AzF2/fZ;;AyFlggBQ;EAOI,iCAAA;AzF+/fZ;;AyFtggBQ;EAOI,+BAAA;AzFmggBZ;;AyF1ggBQ;EAOI,0BAAA;AzFuggBZ;;AyF9ggBQ;EAOI,gCAAA;AzF2ggBZ;;AyFlhgBQ;EAOI,+BAAA;AzF+ggBZ;;AyFthgBQ;EAOI,6BAAA;AzFmhgBZ;;AyF1hgBQ;EAOI,+BAAA;AzFuhgBZ;;AyF9hgBQ;EAOI,6BAAA;AzF2hgBZ;;AyFligBQ;EAOI,iBAAA;AzF+hgBZ;;AyFtigBQ;EAOI,uBAAA;AzFmigBZ;;AyF1igBQ;EAOI,sBAAA;AzFuigBZ;;AyF9igBQ;EAOI,oBAAA;AzF2igBZ;;AyFljgBQ;EAOI,sBAAA;AzF+igBZ;;AyFtjgBQ;EAOI,oBAAA;AzFmjgBZ;;AyF1jgBQ;EAOI,qBAAA;AzFujgBZ;;AyF9jgBQ;EAOI,2BAAA;AzF2jgBZ;;AyFlkgBQ;EAOI,0BAAA;AzF+jgBZ;;AyFtkgBQ;EAOI,wBAAA;AzFmkgBZ;;AyF1kgBQ;EAOI,0BAAA;AzFukgBZ;;AyF9kgBQ;EAOI,wBAAA;AzF2kgBZ;;AyFllgBQ;EAOI,wBAAA;AzF+kgBZ;;AyFtlgBQ;EAOI,8BAAA;AzFmlgBZ;;AyF1lgBQ;EAOI,6BAAA;AzFulgBZ;;AyF9lgBQ;EAOI,2BAAA;AzF2lgBZ;;AyFlmgBQ;EAOI,6BAAA;AzF+lgBZ;;AyFtmgBQ;EAOI,2BAAA;AzFmmgBZ;;AyF1mgBQ;EAOI,gDAAA;AzFumgBZ;;AyF9mgBQ;EAOI,4CAAA;AzF2mgBZ;;AyFlngBQ;EAOI,4CAAA;AzF+mgBZ;;AyFtngBQ;EAOI,0CAAA;AzFmngBZ;;AyF1ngBQ;EAOI,4CAAA;AzFungBZ;;AyF9ngBQ;EAOI,6BAAA;AzF2ngBZ;;AyFlogBQ;EAOI,0BAAA;AzF+ngBZ;;AyFtogBQ;EAOI,6BAAA;AzFmogBZ;;AyF1ogBQ;EAOI,6BAAA;AzFuogBZ;;AyF9ogBQ;EAOI,+BAAA;AzF2ogBZ;;AyFlpgBQ;EAOI,2BAAA;AzF+ogBZ;;AyFtpgBQ;EAOI,2BAAA;AzFmpgBZ;;AyF1pgBQ;EAOI,2BAAA;AzFupgBZ;;AyF9pgBQ;EAOI,2BAAA;AzF2pgBZ;;AyFlqgBQ;EAOI,2BAAA;AzF+pgBZ;;AyFtqgBQ;EAOI,8BAAA;AzFmqgBZ;;AyF1qgBQ;EAOI,yBAAA;AzFuqgBZ;;AyF9qgBQ;EAOI,4BAAA;AzF2qgBZ;;AyFlrgBQ;EAOI,2BAAA;AzF+qgBZ;;AyFtrgBQ;EAOI,yBAAA;AzFmrgBZ;;AyF1rgBQ;EAOI,2BAAA;AzFurgBZ;;AyF9rgBQ;EAOI,4BAAA;AzF2rgBZ;;AyFlsgBQ;EAOI,6BAAA;AzF+rgBZ;;AyFtsgBQ;EAOI,gCAAA;AzFmsgBZ;;AyF1sgBQ;EAOI,qCAAA;AzFusgBZ;;AyF9sgBQ;EAOI,wCAAA;AzF2sgBZ;;AyFltgBQ;EAOI,oCAAA;AzF+sgBZ;;AyFttgBQ;EAOI,oCAAA;AzFmtgBZ;;AyF1tgBQ;EAOI,qCAAA;AzFutgBZ;;AyF9tgBQ;EAOI,8BAAA;AzF2tgBZ;;AyFlugBQ;EAOI,8BAAA;AzF+tgBZ;;AyFpvgBQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;AzFqugBZ;;AyFltgBQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;AzF2ugBZ;;AyFlvgBQ;EAIQ,oBAAA;EAGJ,uEAAA;AzFgvgBZ;;AyFvvgBQ;EAIQ,oBAAA;EAGJ,qEAAA;AzFqvgBZ;;AyF5vgBQ;EAIQ,oBAAA;EAGJ,kEAAA;AzF0vgBZ;;AyFjwgBQ;EAIQ,oBAAA;EAGJ,qEAAA;AzF+vgBZ;;AyFtwgBQ;EAIQ,oBAAA;EAGJ,oEAAA;AzFowgBZ;;AyF3wgBQ;EAIQ,oBAAA;EAGJ,mEAAA;AzFywgBZ;;AyFhxgBQ;EAIQ,oBAAA;EAGJ,kEAAA;AzF8wgBZ;;AyFrxgBQ;EAIQ,oBAAA;EAGJ,mEAAA;AzFmxgBZ;;AyF1xgBQ;EAIQ,oBAAA;EAGJ,mEAAA;AzFwxgBZ;;AyF/xgBQ;EAIQ,oBAAA;EAGJ,wEAAA;AzF6xgBZ;;AyFpygBQ;EAIQ,oBAAA;EAGJ,2CAAA;AzFkygBZ;;AyFzygBQ;EAIQ,oBAAA;EAGJ,oCAAA;AzFuygBZ;;AyF9ygBQ;EAIQ,oBAAA;EAGJ,0CAAA;AzF4ygBZ;;AyFnzgBQ;EAIQ,oBAAA;EAGJ,2CAAA;AzFizgBZ;;AyFxzgBQ;EAIQ,oBAAA;EAGJ,0CAAA;AzFszgBZ;;AyF7zgBQ;EAIQ,oBAAA;EAGJ,0CAAA;AzF2zgBZ;;AyFl0gBQ;EAIQ,oBAAA;EAGJ,yBAAA;AzFg0gBZ;;AyFj1gBQ;EACE,uBAAA;AzFo1gBV;;AyFr1gBQ;EACE,sBAAA;AzFw1gBV;;AyFz1gBQ;EACE,uBAAA;AzF41gBV;;AyF71gBQ;EACE,oBAAA;AzFg2gBV;;AyFv1gBQ;EAOI,iDAAA;AzFo1gBZ;;AyF31gBQ;EAOI,mDAAA;AzFw1gBZ;;AyF/1gBQ;EAOI,iDAAA;AzF41gBZ;;AyFn2gBQ;EAOI,8CAAA;AzFg2gBZ;;AyFv2gBQ;EAOI,iDAAA;AzFo2gBZ;;AyF32gBQ;EAOI,gDAAA;AzFw2gBZ;;AyF/2gBQ;EAOI,+CAAA;AzF42gBZ;;AyFn3gBQ;EAOI,8CAAA;AzFg3gBZ;;AyFj4gBQ;EACE,sBAAA;AzFo4gBV;;AyFh4gBU;EACE,sBAAA;AzFm4gBZ;;AyFz4gBQ;EACE,uBAAA;AzF44gBV;;AyFx4gBU;EACE,uBAAA;AzF24gBZ;;AyFj5gBQ;EACE,sBAAA;AzFo5gBV;;AyFh5gBU;EACE,sBAAA;AzFm5gBZ;;AyFz5gBQ;EACE,uBAAA;AzF45gBV;;AyFx5gBU;EACE,uBAAA;AzF25gBZ;;AyFj6gBQ;EACE,oBAAA;AzFo6gBV;;AyFh6gBU;EACE,oBAAA;AzFm6gBZ;;AyF/5gBQ;EAOI,yCAAA;AzF45gBZ;;AyFv5gBU;EAOI,yCAAA;AzFo5gBd;;AyFv6gBQ;EAOI,wCAAA;AzFo6gBZ;;AyF/5gBU;EAOI,wCAAA;AzF45gBd;;AyF/6gBQ;EAOI,yCAAA;AzF46gBZ;;AyFv6gBU;EAOI,yCAAA;AzFo6gBd;;AyFv7gBQ;EAIQ,8BAAA;EAGJ,+FAAA;AzFq7gBZ;;AyF57gBQ;EAIQ,8BAAA;EAGJ,iGAAA;AzF07gBZ;;AyFj8gBQ;EAIQ,8BAAA;EAGJ,+FAAA;AzF+7gBZ;;AyFt8gBQ;EAIQ,8BAAA;EAGJ,4FAAA;AzFo8gBZ;;AyF38gBQ;EAIQ,8BAAA;EAGJ,+FAAA;AzFy8gBZ;;AyFh9gBQ;EAIQ,8BAAA;EAGJ,8FAAA;AzF88gBZ;;AyFr9gBQ;EAIQ,8BAAA;EAGJ,6FAAA;AzFm9gBZ;;AyF19gBQ;EAIQ,8BAAA;EAGJ,4FAAA;AzFw9gBZ;;AyF/9gBQ;EAIQ,8BAAA;EAGJ,qGAAA;AzF69gBZ;;AyF9+gBQ;EACE,8BAAA;AzFi/gBV;;AyF7+gBU;EACE,8BAAA;AzFg/gBZ;;AyFt/gBQ;EACE,gCAAA;AzFy/gBV;;AyFr/gBU;EACE,gCAAA;AzFw/gBZ;;AyF9/gBQ;EACE,iCAAA;AzFighBV;;AyF7/gBU;EACE,iCAAA;AzFgghBZ;;AyFtghBQ;EACE,gCAAA;AzFyghBV;;AyFrghBU;EACE,gCAAA;AzFwghBZ;;AyF9ghBQ;EACE,iCAAA;AzFihhBV;;AyF7ghBU;EACE,iCAAA;AzFghhBZ;;AyFthhBQ;EACE,8BAAA;AzFyhhBV;;AyFrhhBU;EACE,8BAAA;AzFwhhBZ;;AyFphhBQ;EAIQ,kBAAA;EAGJ,8EAAA;AzFkhhBZ;;AyFzhhBQ;EAIQ,kBAAA;EAGJ,gFAAA;AzFuhhBZ;;AyF9hhBQ;EAIQ,kBAAA;EAGJ,8EAAA;AzF4hhBZ;;AyFnihBQ;EAIQ,kBAAA;EAGJ,2EAAA;AzFiihBZ;;AyFxihBQ;EAIQ,kBAAA;EAGJ,8EAAA;AzFsihBZ;;AyF7ihBQ;EAIQ,kBAAA;EAGJ,6EAAA;AzF2ihBZ;;AyFljhBQ;EAIQ,kBAAA;EAGJ,4EAAA;AzFgjhBZ;;AyFvjhBQ;EAIQ,kBAAA;EAGJ,2EAAA;AzFqjhBZ;;AyF5jhBQ;EAIQ,kBAAA;EAGJ,4EAAA;AzF0jhBZ;;AyFjkhBQ;EAIQ,kBAAA;EAGJ,4EAAA;AzF+jhBZ;;AyFtkhBQ;EAIQ,kBAAA;EAGJ,8EAAA;AzFokhBZ;;AyF3khBQ;EAIQ,kBAAA;EAGJ,wCAAA;AzFykhBZ;;AyFhlhBQ;EAIQ,kBAAA;EAGJ,mFAAA;AzF8khBZ;;AyFrlhBQ;EAIQ,kBAAA;EAGJ,kFAAA;AzFmlhBZ;;AyFpmhBQ;EACE,oBAAA;AzFumhBV;;AyFxmhBQ;EACE,qBAAA;AzF2mhBV;;AyF5mhBQ;EACE,oBAAA;AzF+mhBV;;AyFhnhBQ;EACE,qBAAA;AzFmnhBV;;AyFpnhBQ;EACE,kBAAA;AzFunhBV;;AyF9mhBQ;EAOI,wDAAA;AzF2mhBZ;;AyFlnhBQ;EAOI,0DAAA;AzF+mhBZ;;AyFtnhBQ;EAOI,wDAAA;AzFmnhBZ;;AyF1nhBQ;EAOI,qDAAA;AzFunhBZ;;AyF9nhBQ;EAOI,wDAAA;AzF2nhBZ;;AyFlohBQ;EAOI,uDAAA;AzF+nhBZ;;AyFtohBQ;EAOI,sDAAA;AzFmohBZ;;AyF1ohBQ;EAOI,qDAAA;AzFuohBZ;;AyF9ohBQ;EAOI,+CAAA;AzF2ohBZ;;AyFlphBQ;EAOI,2BAAA;AzF+ohBZ;;AyFtphBQ;EAOI,4BAAA;AzFmphBZ;;AyF1phBQ;EAOI,4BAAA;AzFuphBZ;;AyF9phBQ;EAOI,+BAAA;AzF2phBZ;;AyFlqhBQ;EAOI,+BAAA;AzF+phBZ;;AyFtqhBQ;EAOI,iDAAA;AzFmqhBZ;;AyF1qhBQ;EAOI,2BAAA;AzFuqhBZ;;AyF9qhBQ;EAOI,oDAAA;AzF2qhBZ;;AyFlrhBQ;EAOI,iDAAA;AzF+qhBZ;;AyFtrhBQ;EAOI,oDAAA;AzFmrhBZ;;AyF1rhBQ;EAOI,oDAAA;AzFurhBZ;;AyF9rhBQ;EAOI,qDAAA;AzF2rhBZ;;AyFlshBQ;EAOI,6BAAA;AzF+rhBZ;;AyFtshBQ;EAOI,sDAAA;AzFmshBZ;;AyF1shBQ;EAOI,0DAAA;EAAA,2DAAA;AzFwshBZ;;AyF/shBQ;EAOI,oCAAA;EAAA,qCAAA;AzF6shBZ;;AyFpthBQ;EAOI,6DAAA;EAAA,8DAAA;AzFkthBZ;;AyFzthBQ;EAOI,0DAAA;EAAA,2DAAA;AzFuthBZ;;AyF9thBQ;EAOI,6DAAA;EAAA,8DAAA;AzF4thBZ;;AyFnuhBQ;EAOI,6DAAA;EAAA,8DAAA;AzFiuhBZ;;AyFxuhBQ;EAOI,8DAAA;EAAA,+DAAA;AzFsuhBZ;;AyF7uhBQ;EAOI,sCAAA;EAAA,uCAAA;AzF2uhBZ;;AyFlvhBQ;EAOI,+DAAA;EAAA,gEAAA;AzFgvhBZ;;AyFvvhBQ;EAOI,2DAAA;EAAA,8DAAA;AzFqvhBZ;;AyF5vhBQ;EAOI,qCAAA;EAAA,wCAAA;AzF0vhBZ;;AyFjwhBQ;EAOI,8DAAA;EAAA,iEAAA;AzF+vhBZ;;AyFtwhBQ;EAOI,2DAAA;EAAA,8DAAA;AzFowhBZ;;AyF3whBQ;EAOI,8DAAA;EAAA,iEAAA;AzFywhBZ;;AyFhxhBQ;EAOI,8DAAA;EAAA,iEAAA;AzF8whBZ;;AyFrxhBQ;EAOI,+DAAA;EAAA,kEAAA;AzFmxhBZ;;AyF1xhBQ;EAOI,uCAAA;EAAA,0CAAA;AzFwxhBZ;;AyF/xhBQ;EAOI,gEAAA;EAAA,mEAAA;AzF6xhBZ;;AyFpyhBQ;EAOI,8DAAA;EAAA,6DAAA;AzFkyhBZ;;AyFzyhBQ;EAOI,wCAAA;EAAA,uCAAA;AzFuyhBZ;;AyF9yhBQ;EAOI,iEAAA;EAAA,gEAAA;AzF4yhBZ;;AyFnzhBQ;EAOI,8DAAA;EAAA,6DAAA;AzFizhBZ;;AyFxzhBQ;EAOI,iEAAA;EAAA,gEAAA;AzFszhBZ;;AyF7zhBQ;EAOI,iEAAA;EAAA,gEAAA;AzF2zhBZ;;AyFl0hBQ;EAOI,kEAAA;EAAA,iEAAA;AzFg0hBZ;;AyFv0hBQ;EAOI,0CAAA;EAAA,yCAAA;AzFq0hBZ;;AyF50hBQ;EAOI,mEAAA;EAAA,kEAAA;AzF00hBZ;;AyFj1hBQ;EAOI,6DAAA;EAAA,0DAAA;AzF+0hBZ;;AyFt1hBQ;EAOI,uCAAA;EAAA,oCAAA;AzFo1hBZ;;AyF31hBQ;EAOI,gEAAA;EAAA,6DAAA;AzFy1hBZ;;AyFh2hBQ;EAOI,6DAAA;EAAA,0DAAA;AzF81hBZ;;AyFr2hBQ;EAOI,gEAAA;EAAA,6DAAA;AzFm2hBZ;;AyF12hBQ;EAOI,gEAAA;EAAA,6DAAA;AzFw2hBZ;;AyF/2hBQ;EAOI,iEAAA;EAAA,8DAAA;AzF62hBZ;;AyFp3hBQ;EAOI,yCAAA;EAAA,sCAAA;AzFk3hBZ;;AyFz3hBQ;EAOI,kEAAA;EAAA,+DAAA;AzFu3hBZ;;AyF93hBQ;EAOI,8BAAA;AzF23hBZ;;AyFl4hBQ;EAOI,6BAAA;AzF+3hBZ;;AyFt4hBQ;EAOI,sBAAA;AzFm4hBZ;;AyF14hBQ;EAOI,qBAAA;AzFu4hBZ;;AyF94hBQ;EAOI,qBAAA;AzF24hBZ;;AyFl5hBQ;EAOI,qBAAA;AzF+4hBZ;;AyFt5hBQ;EAOI,qBAAA;AzFm5hBZ;;A8B75hBI;E2DGI;IAOI,sBAAA;EzFw5hBV;EyF/5hBM;IAOI,uBAAA;EzF25hBV;EyFl6hBM;IAOI,sBAAA;EzF85hBV;EyFr6hBM;IAOI,8BAAA;EzFi6hBV;EyFx6hBM;IAOI,4BAAA;EzFo6hBV;EyF36hBM;IAOI,2BAAA;EzFu6hBV;EyF96hBM;IAOI,iCAAA;EzF06hBV;EyFj7hBM;IAOI,2BAAA;EzF66hBV;EyFp7hBM;IAOI,0BAAA;EzFg7hBV;EyFv7hBM;IAOI,gCAAA;EzFm7hBV;EyF17hBM;IAOI,yBAAA;EzFs7hBV;EyF77hBM;IAOI,wBAAA;EzFy7hBV;EyFh8hBM;IAOI,+BAAA;EzF47hBV;EyFn8hBM;IAOI,yBAAA;EzF+7hBV;EyFt8hBM;IAOI,6BAAA;EzFk8hBV;EyFz8hBM;IAOI,8BAAA;EzFq8hBV;EyF58hBM;IAOI,wBAAA;EzFw8hBV;EyF/8hBM;IAOI,+BAAA;EzF28hBV;EyFl9hBM;IAOI,wBAAA;EzF88hBV;EyFr9hBM;IAOI,yBAAA;EzFi9hBV;EyFx9hBM;IAOI,8BAAA;EzFo9hBV;EyF39hBM;IAOI,iCAAA;EzFu9hBV;EyF99hBM;IAOI,sCAAA;EzF09hBV;EyFj+hBM;IAOI,yCAAA;EzF69hBV;EyFp+hBM;IAOI,uBAAA;EzFg+hBV;EyFv+hBM;IAOI,uBAAA;EzFm+hBV;EyF1+hBM;IAOI,yBAAA;EzFs+hBV;EyF7+hBM;IAOI,yBAAA;EzFy+hBV;EyFh/hBM;IAOI,0BAAA;EzF4+hBV;EyFn/hBM;IAOI,4BAAA;EzF++hBV;EyFt/hBM;IAOI,kCAAA;EzFk/hBV;EyFz/hBM;IAOI,sCAAA;EzFq/hBV;EyF5/hBM;IAOI,oCAAA;EzFw/hBV;EyF//hBM;IAOI,kCAAA;EzF2/hBV;EyFlgiBM;IAOI,yCAAA;EzF8/hBV;EyFrgiBM;IAOI,wCAAA;EzFigiBV;EyFxgiBM;IAOI,wCAAA;EzFogiBV;EyF3giBM;IAOI,kCAAA;EzFugiBV;EyF9giBM;IAOI,gCAAA;EzF0giBV;EyFjhiBM;IAOI,8BAAA;EzF6giBV;EyFphiBM;IAOI,gCAAA;EzFghiBV;EyFvhiBM;IAOI,+BAAA;EzFmhiBV;EyF1hiBM;IAOI,oCAAA;EzFshiBV;EyF7hiBM;IAOI,kCAAA;EzFyhiBV;EyFhiiBM;IAOI,gCAAA;EzF4hiBV;EyFniiBM;IAOI,uCAAA;EzF+hiBV;EyFtiiBM;IAOI,sCAAA;EzFkiiBV;EyFziiBM;IAOI,iCAAA;EzFqiiBV;EyF5iiBM;IAOI,2BAAA;EzFwiiBV;EyF/iiBM;IAOI,iCAAA;EzF2iiBV;EyFljiBM;IAOI,+BAAA;EzF8iiBV;EyFrjiBM;IAOI,6BAAA;EzFijiBV;EyFxjiBM;IAOI,+BAAA;EzFojiBV;EyF3jiBM;IAOI,8BAAA;EzFujiBV;EyF9jiBM;IAOI,oBAAA;EzF0jiBV;EyFjkiBM;IAOI,mBAAA;EzF6jiBV;EyFpkiBM;IAOI,mBAAA;EzFgkiBV;EyFvkiBM;IAOI,mBAAA;EzFmkiBV;EyF1kiBM;IAOI,mBAAA;EzFskiBV;EyF7kiBM;IAOI,mBAAA;EzFykiBV;EyFhliBM;IAOI,mBAAA;EzF4kiBV;EyFnliBM;IAOI,mBAAA;EzF+kiBV;EyFtliBM;IAOI,oBAAA;EzFkliBV;EyFzliBM;IAOI,0BAAA;EzFqliBV;EyF5liBM;IAOI,yBAAA;EzFwliBV;EyF/liBM;IAOI,uBAAA;EzF2liBV;EyFlmiBM;IAOI,yBAAA;EzF8liBV;EyFrmiBM;IAOI,uBAAA;EzFimiBV;EyFxmiBM;IAOI,uBAAA;EzFomiBV;EyF3miBM;IAOI,0BAAA;IAAA,yBAAA;EzFwmiBV;EyF/miBM;IAOI,gCAAA;IAAA,+BAAA;EzF4miBV;EyFnniBM;IAOI,+BAAA;IAAA,8BAAA;EzFgniBV;EyFvniBM;IAOI,6BAAA;IAAA,4BAAA;EzFoniBV;EyF3niBM;IAOI,+BAAA;IAAA,8BAAA;EzFwniBV;EyF/niBM;IAOI,6BAAA;IAAA,4BAAA;EzF4niBV;EyFnoiBM;IAOI,6BAAA;IAAA,4BAAA;EzFgoiBV;EyFvoiBM;IAOI,wBAAA;IAAA,2BAAA;EzFooiBV;EyF3oiBM;IAOI,8BAAA;IAAA,iCAAA;EzFwoiBV;EyF/oiBM;IAOI,6BAAA;IAAA,gCAAA;EzF4oiBV;EyFnpiBM;IAOI,2BAAA;IAAA,8BAAA;EzFgpiBV;EyFvpiBM;IAOI,6BAAA;IAAA,gCAAA;EzFopiBV;EyF3piBM;IAOI,2BAAA;IAAA,8BAAA;EzFwpiBV;EyF/piBM;IAOI,2BAAA;IAAA,8BAAA;EzF4piBV;EyFnqiBM;IAOI,wBAAA;EzF+piBV;EyFtqiBM;IAOI,8BAAA;EzFkqiBV;EyFzqiBM;IAOI,6BAAA;EzFqqiBV;EyF5qiBM;IAOI,2BAAA;EzFwqiBV;EyF/qiBM;IAOI,6BAAA;EzF2qiBV;EyFlriBM;IAOI,2BAAA;EzF8qiBV;EyFrriBM;IAOI,2BAAA;EzFiriBV;EyFxriBM;IAOI,0BAAA;EzForiBV;EyF3riBM;IAOI,gCAAA;EzFuriBV;EyF9riBM;IAOI,+BAAA;EzF0riBV;EyFjsiBM;IAOI,6BAAA;EzF6riBV;EyFpsiBM;IAOI,+BAAA;EzFgsiBV;EyFvsiBM;IAOI,6BAAA;EzFmsiBV;EyF1siBM;IAOI,6BAAA;EzFssiBV;EyF7siBM;IAOI,2BAAA;EzFysiBV;EyFhtiBM;IAOI,iCAAA;EzF4siBV;EyFntiBM;IAOI,gCAAA;EzF+siBV;EyFttiBM;IAOI,8BAAA;EzFktiBV;EyFztiBM;IAOI,gCAAA;EzFqtiBV;EyF5tiBM;IAOI,8BAAA;EzFwtiBV;EyF/tiBM;IAOI,8BAAA;EzF2tiBV;EyFluiBM;IAOI,yBAAA;EzF8tiBV;EyFruiBM;IAOI,+BAAA;EzFiuiBV;EyFxuiBM;IAOI,8BAAA;EzFouiBV;EyF3uiBM;IAOI,4BAAA;EzFuuiBV;EyF9uiBM;IAOI,8BAAA;EzF0uiBV;EyFjviBM;IAOI,4BAAA;EzF6uiBV;EyFpviBM;IAOI,4BAAA;EzFgviBV;EyFvviBM;IAOI,qBAAA;EzFmviBV;EyF1viBM;IAOI,2BAAA;EzFsviBV;EyF7viBM;IAOI,0BAAA;EzFyviBV;EyFhwiBM;IAOI,wBAAA;EzF4viBV;EyFnwiBM;IAOI,0BAAA;EzF+viBV;EyFtwiBM;IAOI,wBAAA;EzFkwiBV;EyFzwiBM;IAOI,2BAAA;IAAA,0BAAA;EzFswiBV;EyF7wiBM;IAOI,iCAAA;IAAA,gCAAA;EzF0wiBV;EyFjxiBM;IAOI,gCAAA;IAAA,+BAAA;EzF8wiBV;EyFrxiBM;IAOI,8BAAA;IAAA,6BAAA;EzFkxiBV;EyFzxiBM;IAOI,gCAAA;IAAA,+BAAA;EzFsxiBV;EyF7xiBM;IAOI,8BAAA;IAAA,6BAAA;EzF0xiBV;EyFjyiBM;IAOI,yBAAA;IAAA,4BAAA;EzF8xiBV;EyFryiBM;IAOI,+BAAA;IAAA,kCAAA;EzFkyiBV;EyFzyiBM;IAOI,8BAAA;IAAA,iCAAA;EzFsyiBV;EyF7yiBM;IAOI,4BAAA;IAAA,+BAAA;EzF0yiBV;EyFjziBM;IAOI,8BAAA;IAAA,iCAAA;EzF8yiBV;EyFrziBM;IAOI,4BAAA;IAAA,+BAAA;EzFkziBV;EyFzziBM;IAOI,yBAAA;EzFqziBV;EyF5ziBM;IAOI,+BAAA;EzFwziBV;EyF/ziBM;IAOI,8BAAA;EzF2ziBV;EyFl0iBM;IAOI,4BAAA;EzF8ziBV;EyFr0iBM;IAOI,8BAAA;EzFi0iBV;EyFx0iBM;IAOI,4BAAA;EzFo0iBV;EyF30iBM;IAOI,2BAAA;EzFu0iBV;EyF90iBM;IAOI,iCAAA;EzF00iBV;EyFj1iBM;IAOI,gCAAA;EzF60iBV;EyFp1iBM;IAOI,8BAAA;EzFg1iBV;EyFv1iBM;IAOI,gCAAA;EzFm1iBV;EyF11iBM;IAOI,8BAAA;EzFs1iBV;EyF71iBM;IAOI,4BAAA;EzFy1iBV;EyFh2iBM;IAOI,kCAAA;EzF41iBV;EyFn2iBM;IAOI,iCAAA;EzF+1iBV;EyFt2iBM;IAOI,+BAAA;EzFk2iBV;EyFz2iBM;IAOI,iCAAA;EzFq2iBV;EyF52iBM;IAOI,+BAAA;EzFw2iBV;EyF/2iBM;IAOI,0BAAA;EzF22iBV;EyFl3iBM;IAOI,gCAAA;EzF82iBV;EyFr3iBM;IAOI,+BAAA;EzFi3iBV;EyFx3iBM;IAOI,6BAAA;EzFo3iBV;EyF33iBM;IAOI,+BAAA;EzFu3iBV;EyF93iBM;IAOI,6BAAA;EzF03iBV;EyFj4iBM;IAOI,iBAAA;EzF63iBV;EyFp4iBM;IAOI,uBAAA;EzFg4iBV;EyFv4iBM;IAOI,sBAAA;EzFm4iBV;EyF14iBM;IAOI,oBAAA;EzFs4iBV;EyF74iBM;IAOI,sBAAA;EzFy4iBV;EyFh5iBM;IAOI,oBAAA;EzF44iBV;EyFn5iBM;IAOI,qBAAA;EzF+4iBV;EyFt5iBM;IAOI,2BAAA;EzFk5iBV;EyFz5iBM;IAOI,0BAAA;EzFq5iBV;EyF55iBM;IAOI,wBAAA;EzFw5iBV;EyF/5iBM;IAOI,0BAAA;EzF25iBV;EyFl6iBM;IAOI,wBAAA;EzF85iBV;EyFr6iBM;IAOI,wBAAA;EzFi6iBV;EyFx6iBM;IAOI,8BAAA;EzFo6iBV;EyF36iBM;IAOI,6BAAA;EzFu6iBV;EyF96iBM;IAOI,2BAAA;EzF06iBV;EyFj7iBM;IAOI,6BAAA;EzF66iBV;EyFp7iBM;IAOI,2BAAA;EzFg7iBV;EyFv7iBM;IAOI,2BAAA;EzFm7iBV;EyF17iBM;IAOI,4BAAA;EzFs7iBV;EyF77iBM;IAOI,6BAAA;EzFy7iBV;AACF;A8Bp8iBI;E2DGI;IAOI,sBAAA;EzF87iBV;EyFr8iBM;IAOI,uBAAA;EzFi8iBV;EyFx8iBM;IAOI,sBAAA;EzFo8iBV;EyF38iBM;IAOI,8BAAA;EzFu8iBV;EyF98iBM;IAOI,4BAAA;EzF08iBV;EyFj9iBM;IAOI,2BAAA;EzF68iBV;EyFp9iBM;IAOI,iCAAA;EzFg9iBV;EyFv9iBM;IAOI,2BAAA;EzFm9iBV;EyF19iBM;IAOI,0BAAA;EzFs9iBV;EyF79iBM;IAOI,gCAAA;EzFy9iBV;EyFh+iBM;IAOI,yBAAA;EzF49iBV;EyFn+iBM;IAOI,wBAAA;EzF+9iBV;EyFt+iBM;IAOI,+BAAA;EzFk+iBV;EyFz+iBM;IAOI,yBAAA;EzFq+iBV;EyF5+iBM;IAOI,6BAAA;EzFw+iBV;EyF/+iBM;IAOI,8BAAA;EzF2+iBV;EyFl/iBM;IAOI,wBAAA;EzF8+iBV;EyFr/iBM;IAOI,+BAAA;EzFi/iBV;EyFx/iBM;IAOI,wBAAA;EzFo/iBV;EyF3/iBM;IAOI,yBAAA;EzFu/iBV;EyF9/iBM;IAOI,8BAAA;EzF0/iBV;EyFjgjBM;IAOI,iCAAA;EzF6/iBV;EyFpgjBM;IAOI,sCAAA;EzFggjBV;EyFvgjBM;IAOI,yCAAA;EzFmgjBV;EyF1gjBM;IAOI,uBAAA;EzFsgjBV;EyF7gjBM;IAOI,uBAAA;EzFygjBV;EyFhhjBM;IAOI,yBAAA;EzF4gjBV;EyFnhjBM;IAOI,yBAAA;EzF+gjBV;EyFthjBM;IAOI,0BAAA;EzFkhjBV;EyFzhjBM;IAOI,4BAAA;EzFqhjBV;EyF5hjBM;IAOI,kCAAA;EzFwhjBV;EyF/hjBM;IAOI,sCAAA;EzF2hjBV;EyFlijBM;IAOI,oCAAA;EzF8hjBV;EyFrijBM;IAOI,kCAAA;EzFiijBV;EyFxijBM;IAOI,yCAAA;EzFoijBV;EyF3ijBM;IAOI,wCAAA;EzFuijBV;EyF9ijBM;IAOI,wCAAA;EzF0ijBV;EyFjjjBM;IAOI,kCAAA;EzF6ijBV;EyFpjjBM;IAOI,gCAAA;EzFgjjBV;EyFvjjBM;IAOI,8BAAA;EzFmjjBV;EyF1jjBM;IAOI,gCAAA;EzFsjjBV;EyF7jjBM;IAOI,+BAAA;EzFyjjBV;EyFhkjBM;IAOI,oCAAA;EzF4jjBV;EyFnkjBM;IAOI,kCAAA;EzF+jjBV;EyFtkjBM;IAOI,gCAAA;EzFkkjBV;EyFzkjBM;IAOI,uCAAA;EzFqkjBV;EyF5kjBM;IAOI,sCAAA;EzFwkjBV;EyF/kjBM;IAOI,iCAAA;EzF2kjBV;EyFlljBM;IAOI,2BAAA;EzF8kjBV;EyFrljBM;IAOI,iCAAA;EzFiljBV;EyFxljBM;IAOI,+BAAA;EzFoljBV;EyF3ljBM;IAOI,6BAAA;EzFuljBV;EyF9ljBM;IAOI,+BAAA;EzF0ljBV;EyFjmjBM;IAOI,8BAAA;EzF6ljBV;EyFpmjBM;IAOI,oBAAA;EzFgmjBV;EyFvmjBM;IAOI,mBAAA;EzFmmjBV;EyF1mjBM;IAOI,mBAAA;EzFsmjBV;EyF7mjBM;IAOI,mBAAA;EzFymjBV;EyFhnjBM;IAOI,mBAAA;EzF4mjBV;EyFnnjBM;IAOI,mBAAA;EzF+mjBV;EyFtnjBM;IAOI,mBAAA;EzFknjBV;EyFznjBM;IAOI,mBAAA;EzFqnjBV;EyF5njBM;IAOI,oBAAA;EzFwnjBV;EyF/njBM;IAOI,0BAAA;EzF2njBV;EyFlojBM;IAOI,yBAAA;EzF8njBV;EyFrojBM;IAOI,uBAAA;EzFiojBV;EyFxojBM;IAOI,yBAAA;EzFoojBV;EyF3ojBM;IAOI,uBAAA;EzFuojBV;EyF9ojBM;IAOI,uBAAA;EzF0ojBV;EyFjpjBM;IAOI,0BAAA;IAAA,yBAAA;EzF8ojBV;EyFrpjBM;IAOI,gCAAA;IAAA,+BAAA;EzFkpjBV;EyFzpjBM;IAOI,+BAAA;IAAA,8BAAA;EzFspjBV;EyF7pjBM;IAOI,6BAAA;IAAA,4BAAA;EzF0pjBV;EyFjqjBM;IAOI,+BAAA;IAAA,8BAAA;EzF8pjBV;EyFrqjBM;IAOI,6BAAA;IAAA,4BAAA;EzFkqjBV;EyFzqjBM;IAOI,6BAAA;IAAA,4BAAA;EzFsqjBV;EyF7qjBM;IAOI,wBAAA;IAAA,2BAAA;EzF0qjBV;EyFjrjBM;IAOI,8BAAA;IAAA,iCAAA;EzF8qjBV;EyFrrjBM;IAOI,6BAAA;IAAA,gCAAA;EzFkrjBV;EyFzrjBM;IAOI,2BAAA;IAAA,8BAAA;EzFsrjBV;EyF7rjBM;IAOI,6BAAA;IAAA,gCAAA;EzF0rjBV;EyFjsjBM;IAOI,2BAAA;IAAA,8BAAA;EzF8rjBV;EyFrsjBM;IAOI,2BAAA;IAAA,8BAAA;EzFksjBV;EyFzsjBM;IAOI,wBAAA;EzFqsjBV;EyF5sjBM;IAOI,8BAAA;EzFwsjBV;EyF/sjBM;IAOI,6BAAA;EzF2sjBV;EyFltjBM;IAOI,2BAAA;EzF8sjBV;EyFrtjBM;IAOI,6BAAA;EzFitjBV;EyFxtjBM;IAOI,2BAAA;EzFotjBV;EyF3tjBM;IAOI,2BAAA;EzFutjBV;EyF9tjBM;IAOI,0BAAA;EzF0tjBV;EyFjujBM;IAOI,gCAAA;EzF6tjBV;EyFpujBM;IAOI,+BAAA;EzFgujBV;EyFvujBM;IAOI,6BAAA;EzFmujBV;EyF1ujBM;IAOI,+BAAA;EzFsujBV;EyF7ujBM;IAOI,6BAAA;EzFyujBV;EyFhvjBM;IAOI,6BAAA;EzF4ujBV;EyFnvjBM;IAOI,2BAAA;EzF+ujBV;EyFtvjBM;IAOI,iCAAA;EzFkvjBV;EyFzvjBM;IAOI,gCAAA;EzFqvjBV;EyF5vjBM;IAOI,8BAAA;EzFwvjBV;EyF/vjBM;IAOI,gCAAA;EzF2vjBV;EyFlwjBM;IAOI,8BAAA;EzF8vjBV;EyFrwjBM;IAOI,8BAAA;EzFiwjBV;EyFxwjBM;IAOI,yBAAA;EzFowjBV;EyF3wjBM;IAOI,+BAAA;EzFuwjBV;EyF9wjBM;IAOI,8BAAA;EzF0wjBV;EyFjxjBM;IAOI,4BAAA;EzF6wjBV;EyFpxjBM;IAOI,8BAAA;EzFgxjBV;EyFvxjBM;IAOI,4BAAA;EzFmxjBV;EyF1xjBM;IAOI,4BAAA;EzFsxjBV;EyF7xjBM;IAOI,qBAAA;EzFyxjBV;EyFhyjBM;IAOI,2BAAA;EzF4xjBV;EyFnyjBM;IAOI,0BAAA;EzF+xjBV;EyFtyjBM;IAOI,wBAAA;EzFkyjBV;EyFzyjBM;IAOI,0BAAA;EzFqyjBV;EyF5yjBM;IAOI,wBAAA;EzFwyjBV;EyF/yjBM;IAOI,2BAAA;IAAA,0BAAA;EzF4yjBV;EyFnzjBM;IAOI,iCAAA;IAAA,gCAAA;EzFgzjBV;EyFvzjBM;IAOI,gCAAA;IAAA,+BAAA;EzFozjBV;EyF3zjBM;IAOI,8BAAA;IAAA,6BAAA;EzFwzjBV;EyF/zjBM;IAOI,gCAAA;IAAA,+BAAA;EzF4zjBV;EyFn0jBM;IAOI,8BAAA;IAAA,6BAAA;EzFg0jBV;EyFv0jBM;IAOI,yBAAA;IAAA,4BAAA;EzFo0jBV;EyF30jBM;IAOI,+BAAA;IAAA,kCAAA;EzFw0jBV;EyF/0jBM;IAOI,8BAAA;IAAA,iCAAA;EzF40jBV;EyFn1jBM;IAOI,4BAAA;IAAA,+BAAA;EzFg1jBV;EyFv1jBM;IAOI,8BAAA;IAAA,iCAAA;EzFo1jBV;EyF31jBM;IAOI,4BAAA;IAAA,+BAAA;EzFw1jBV;EyF/1jBM;IAOI,yBAAA;EzF21jBV;EyFl2jBM;IAOI,+BAAA;EzF81jBV;EyFr2jBM;IAOI,8BAAA;EzFi2jBV;EyFx2jBM;IAOI,4BAAA;EzFo2jBV;EyF32jBM;IAOI,8BAAA;EzFu2jBV;EyF92jBM;IAOI,4BAAA;EzF02jBV;EyFj3jBM;IAOI,2BAAA;EzF62jBV;EyFp3jBM;IAOI,iCAAA;EzFg3jBV;EyFv3jBM;IAOI,gCAAA;EzFm3jBV;EyF13jBM;IAOI,8BAAA;EzFs3jBV;EyF73jBM;IAOI,gCAAA;EzFy3jBV;EyFh4jBM;IAOI,8BAAA;EzF43jBV;EyFn4jBM;IAOI,4BAAA;EzF+3jBV;EyFt4jBM;IAOI,kCAAA;EzFk4jBV;EyFz4jBM;IAOI,iCAAA;EzFq4jBV;EyF54jBM;IAOI,+BAAA;EzFw4jBV;EyF/4jBM;IAOI,iCAAA;EzF24jBV;EyFl5jBM;IAOI,+BAAA;EzF84jBV;EyFr5jBM;IAOI,0BAAA;EzFi5jBV;EyFx5jBM;IAOI,gCAAA;EzFo5jBV;EyF35jBM;IAOI,+BAAA;EzFu5jBV;EyF95jBM;IAOI,6BAAA;EzF05jBV;EyFj6jBM;IAOI,+BAAA;EzF65jBV;EyFp6jBM;IAOI,6BAAA;EzFg6jBV;EyFv6jBM;IAOI,iBAAA;EzFm6jBV;EyF16jBM;IAOI,uBAAA;EzFs6jBV;EyF76jBM;IAOI,sBAAA;EzFy6jBV;EyFh7jBM;IAOI,oBAAA;EzF46jBV;EyFn7jBM;IAOI,sBAAA;EzF+6jBV;EyFt7jBM;IAOI,oBAAA;EzFk7jBV;EyFz7jBM;IAOI,qBAAA;EzFq7jBV;EyF57jBM;IAOI,2BAAA;EzFw7jBV;EyF/7jBM;IAOI,0BAAA;EzF27jBV;EyFl8jBM;IAOI,wBAAA;EzF87jBV;EyFr8jBM;IAOI,0BAAA;EzFi8jBV;EyFx8jBM;IAOI,wBAAA;EzFo8jBV;EyF38jBM;IAOI,wBAAA;EzFu8jBV;EyF98jBM;IAOI,8BAAA;EzF08jBV;EyFj9jBM;IAOI,6BAAA;EzF68jBV;EyFp9jBM;IAOI,2BAAA;EzFg9jBV;EyFv9jBM;IAOI,6BAAA;EzFm9jBV;EyF19jBM;IAOI,2BAAA;EzFs9jBV;EyF79jBM;IAOI,2BAAA;EzFy9jBV;EyFh+jBM;IAOI,4BAAA;EzF49jBV;EyFn+jBM;IAOI,6BAAA;EzF+9jBV;AACF;A8B1+jBI;E2DGI;IAOI,sBAAA;EzFo+jBV;EyF3+jBM;IAOI,uBAAA;EzFu+jBV;EyF9+jBM;IAOI,sBAAA;EzF0+jBV;EyFj/jBM;IAOI,8BAAA;EzF6+jBV;EyFp/jBM;IAOI,4BAAA;EzFg/jBV;EyFv/jBM;IAOI,2BAAA;EzFm/jBV;EyF1/jBM;IAOI,iCAAA;EzFs/jBV;EyF7/jBM;IAOI,2BAAA;EzFy/jBV;EyFhgkBM;IAOI,0BAAA;EzF4/jBV;EyFngkBM;IAOI,gCAAA;EzF+/jBV;EyFtgkBM;IAOI,yBAAA;EzFkgkBV;EyFzgkBM;IAOI,wBAAA;EzFqgkBV;EyF5gkBM;IAOI,+BAAA;EzFwgkBV;EyF/gkBM;IAOI,yBAAA;EzF2gkBV;EyFlhkBM;IAOI,6BAAA;EzF8gkBV;EyFrhkBM;IAOI,8BAAA;EzFihkBV;EyFxhkBM;IAOI,wBAAA;EzFohkBV;EyF3hkBM;IAOI,+BAAA;EzFuhkBV;EyF9hkBM;IAOI,wBAAA;EzF0hkBV;EyFjikBM;IAOI,yBAAA;EzF6hkBV;EyFpikBM;IAOI,8BAAA;EzFgikBV;EyFvikBM;IAOI,iCAAA;EzFmikBV;EyF1ikBM;IAOI,sCAAA;EzFsikBV;EyF7ikBM;IAOI,yCAAA;EzFyikBV;EyFhjkBM;IAOI,uBAAA;EzF4ikBV;EyFnjkBM;IAOI,uBAAA;EzF+ikBV;EyFtjkBM;IAOI,yBAAA;EzFkjkBV;EyFzjkBM;IAOI,yBAAA;EzFqjkBV;EyF5jkBM;IAOI,0BAAA;EzFwjkBV;EyF/jkBM;IAOI,4BAAA;EzF2jkBV;EyFlkkBM;IAOI,kCAAA;EzF8jkBV;EyFrkkBM;IAOI,sCAAA;EzFikkBV;EyFxkkBM;IAOI,oCAAA;EzFokkBV;EyF3kkBM;IAOI,kCAAA;EzFukkBV;EyF9kkBM;IAOI,yCAAA;EzF0kkBV;EyFjlkBM;IAOI,wCAAA;EzF6kkBV;EyFplkBM;IAOI,wCAAA;EzFglkBV;EyFvlkBM;IAOI,kCAAA;EzFmlkBV;EyF1lkBM;IAOI,gCAAA;EzFslkBV;EyF7lkBM;IAOI,8BAAA;EzFylkBV;EyFhmkBM;IAOI,gCAAA;EzF4lkBV;EyFnmkBM;IAOI,+BAAA;EzF+lkBV;EyFtmkBM;IAOI,oCAAA;EzFkmkBV;EyFzmkBM;IAOI,kCAAA;EzFqmkBV;EyF5mkBM;IAOI,gCAAA;EzFwmkBV;EyF/mkBM;IAOI,uCAAA;EzF2mkBV;EyFlnkBM;IAOI,sCAAA;EzF8mkBV;EyFrnkBM;IAOI,iCAAA;EzFinkBV;EyFxnkBM;IAOI,2BAAA;EzFonkBV;EyF3nkBM;IAOI,iCAAA;EzFunkBV;EyF9nkBM;IAOI,+BAAA;EzF0nkBV;EyFjokBM;IAOI,6BAAA;EzF6nkBV;EyFpokBM;IAOI,+BAAA;EzFgokBV;EyFvokBM;IAOI,8BAAA;EzFmokBV;EyF1okBM;IAOI,oBAAA;EzFsokBV;EyF7okBM;IAOI,mBAAA;EzFyokBV;EyFhpkBM;IAOI,mBAAA;EzF4okBV;EyFnpkBM;IAOI,mBAAA;EzF+okBV;EyFtpkBM;IAOI,mBAAA;EzFkpkBV;EyFzpkBM;IAOI,mBAAA;EzFqpkBV;EyF5pkBM;IAOI,mBAAA;EzFwpkBV;EyF/pkBM;IAOI,mBAAA;EzF2pkBV;EyFlqkBM;IAOI,oBAAA;EzF8pkBV;EyFrqkBM;IAOI,0BAAA;EzFiqkBV;EyFxqkBM;IAOI,yBAAA;EzFoqkBV;EyF3qkBM;IAOI,uBAAA;EzFuqkBV;EyF9qkBM;IAOI,yBAAA;EzF0qkBV;EyFjrkBM;IAOI,uBAAA;EzF6qkBV;EyFprkBM;IAOI,uBAAA;EzFgrkBV;EyFvrkBM;IAOI,0BAAA;IAAA,yBAAA;EzForkBV;EyF3rkBM;IAOI,gCAAA;IAAA,+BAAA;EzFwrkBV;EyF/rkBM;IAOI,+BAAA;IAAA,8BAAA;EzF4rkBV;EyFnskBM;IAOI,6BAAA;IAAA,4BAAA;EzFgskBV;EyFvskBM;IAOI,+BAAA;IAAA,8BAAA;EzFoskBV;EyF3skBM;IAOI,6BAAA;IAAA,4BAAA;EzFwskBV;EyF/skBM;IAOI,6BAAA;IAAA,4BAAA;EzF4skBV;EyFntkBM;IAOI,wBAAA;IAAA,2BAAA;EzFgtkBV;EyFvtkBM;IAOI,8BAAA;IAAA,iCAAA;EzFotkBV;EyF3tkBM;IAOI,6BAAA;IAAA,gCAAA;EzFwtkBV;EyF/tkBM;IAOI,2BAAA;IAAA,8BAAA;EzF4tkBV;EyFnukBM;IAOI,6BAAA;IAAA,gCAAA;EzFgukBV;EyFvukBM;IAOI,2BAAA;IAAA,8BAAA;EzFoukBV;EyF3ukBM;IAOI,2BAAA;IAAA,8BAAA;EzFwukBV;EyF/ukBM;IAOI,wBAAA;EzF2ukBV;EyFlvkBM;IAOI,8BAAA;EzF8ukBV;EyFrvkBM;IAOI,6BAAA;EzFivkBV;EyFxvkBM;IAOI,2BAAA;EzFovkBV;EyF3vkBM;IAOI,6BAAA;EzFuvkBV;EyF9vkBM;IAOI,2BAAA;EzF0vkBV;EyFjwkBM;IAOI,2BAAA;EzF6vkBV;EyFpwkBM;IAOI,0BAAA;EzFgwkBV;EyFvwkBM;IAOI,gCAAA;EzFmwkBV;EyF1wkBM;IAOI,+BAAA;EzFswkBV;EyF7wkBM;IAOI,6BAAA;EzFywkBV;EyFhxkBM;IAOI,+BAAA;EzF4wkBV;EyFnxkBM;IAOI,6BAAA;EzF+wkBV;EyFtxkBM;IAOI,6BAAA;EzFkxkBV;EyFzxkBM;IAOI,2BAAA;EzFqxkBV;EyF5xkBM;IAOI,iCAAA;EzFwxkBV;EyF/xkBM;IAOI,gCAAA;EzF2xkBV;EyFlykBM;IAOI,8BAAA;EzF8xkBV;EyFrykBM;IAOI,gCAAA;EzFiykBV;EyFxykBM;IAOI,8BAAA;EzFoykBV;EyF3ykBM;IAOI,8BAAA;EzFuykBV;EyF9ykBM;IAOI,yBAAA;EzF0ykBV;EyFjzkBM;IAOI,+BAAA;EzF6ykBV;EyFpzkBM;IAOI,8BAAA;EzFgzkBV;EyFvzkBM;IAOI,4BAAA;EzFmzkBV;EyF1zkBM;IAOI,8BAAA;EzFszkBV;EyF7zkBM;IAOI,4BAAA;EzFyzkBV;EyFh0kBM;IAOI,4BAAA;EzF4zkBV;EyFn0kBM;IAOI,qBAAA;EzF+zkBV;EyFt0kBM;IAOI,2BAAA;EzFk0kBV;EyFz0kBM;IAOI,0BAAA;EzFq0kBV;EyF50kBM;IAOI,wBAAA;EzFw0kBV;EyF/0kBM;IAOI,0BAAA;EzF20kBV;EyFl1kBM;IAOI,wBAAA;EzF80kBV;EyFr1kBM;IAOI,2BAAA;IAAA,0BAAA;EzFk1kBV;EyFz1kBM;IAOI,iCAAA;IAAA,gCAAA;EzFs1kBV;EyF71kBM;IAOI,gCAAA;IAAA,+BAAA;EzF01kBV;EyFj2kBM;IAOI,8BAAA;IAAA,6BAAA;EzF81kBV;EyFr2kBM;IAOI,gCAAA;IAAA,+BAAA;EzFk2kBV;EyFz2kBM;IAOI,8BAAA;IAAA,6BAAA;EzFs2kBV;EyF72kBM;IAOI,yBAAA;IAAA,4BAAA;EzF02kBV;EyFj3kBM;IAOI,+BAAA;IAAA,kCAAA;EzF82kBV;EyFr3kBM;IAOI,8BAAA;IAAA,iCAAA;EzFk3kBV;EyFz3kBM;IAOI,4BAAA;IAAA,+BAAA;EzFs3kBV;EyF73kBM;IAOI,8BAAA;IAAA,iCAAA;EzF03kBV;EyFj4kBM;IAOI,4BAAA;IAAA,+BAAA;EzF83kBV;EyFr4kBM;IAOI,yBAAA;EzFi4kBV;EyFx4kBM;IAOI,+BAAA;EzFo4kBV;EyF34kBM;IAOI,8BAAA;EzFu4kBV;EyF94kBM;IAOI,4BAAA;EzF04kBV;EyFj5kBM;IAOI,8BAAA;EzF64kBV;EyFp5kBM;IAOI,4BAAA;EzFg5kBV;EyFv5kBM;IAOI,2BAAA;EzFm5kBV;EyF15kBM;IAOI,iCAAA;EzFs5kBV;EyF75kBM;IAOI,gCAAA;EzFy5kBV;EyFh6kBM;IAOI,8BAAA;EzF45kBV;EyFn6kBM;IAOI,gCAAA;EzF+5kBV;EyFt6kBM;IAOI,8BAAA;EzFk6kBV;EyFz6kBM;IAOI,4BAAA;EzFq6kBV;EyF56kBM;IAOI,kCAAA;EzFw6kBV;EyF/6kBM;IAOI,iCAAA;EzF26kBV;EyFl7kBM;IAOI,+BAAA;EzF86kBV;EyFr7kBM;IAOI,iCAAA;EzFi7kBV;EyFx7kBM;IAOI,+BAAA;EzFo7kBV;EyF37kBM;IAOI,0BAAA;EzFu7kBV;EyF97kBM;IAOI,gCAAA;EzF07kBV;EyFj8kBM;IAOI,+BAAA;EzF67kBV;EyFp8kBM;IAOI,6BAAA;EzFg8kBV;EyFv8kBM;IAOI,+BAAA;EzFm8kBV;EyF18kBM;IAOI,6BAAA;EzFs8kBV;EyF78kBM;IAOI,iBAAA;EzFy8kBV;EyFh9kBM;IAOI,uBAAA;EzF48kBV;EyFn9kBM;IAOI,sBAAA;EzF+8kBV;EyFt9kBM;IAOI,oBAAA;EzFk9kBV;EyFz9kBM;IAOI,sBAAA;EzFq9kBV;EyF59kBM;IAOI,oBAAA;EzFw9kBV;EyF/9kBM;IAOI,qBAAA;EzF29kBV;EyFl+kBM;IAOI,2BAAA;EzF89kBV;EyFr+kBM;IAOI,0BAAA;EzFi+kBV;EyFx+kBM;IAOI,wBAAA;EzFo+kBV;EyF3+kBM;IAOI,0BAAA;EzFu+kBV;EyF9+kBM;IAOI,wBAAA;EzF0+kBV;EyFj/kBM;IAOI,wBAAA;EzF6+kBV;EyFp/kBM;IAOI,8BAAA;EzFg/kBV;EyFv/kBM;IAOI,6BAAA;EzFm/kBV;EyF1/kBM;IAOI,2BAAA;EzFs/kBV;EyF7/kBM;IAOI,6BAAA;EzFy/kBV;EyFhglBM;IAOI,2BAAA;EzF4/kBV;EyFnglBM;IAOI,2BAAA;EzF+/kBV;EyFtglBM;IAOI,4BAAA;EzFkglBV;EyFzglBM;IAOI,6BAAA;EzFqglBV;AACF;A8BhhlBI;E2DGI;IAOI,sBAAA;EzF0glBV;EyFjhlBM;IAOI,uBAAA;EzF6glBV;EyFphlBM;IAOI,sBAAA;EzFghlBV;EyFvhlBM;IAOI,8BAAA;EzFmhlBV;EyF1hlBM;IAOI,4BAAA;EzFshlBV;EyF7hlBM;IAOI,2BAAA;EzFyhlBV;EyFhilBM;IAOI,iCAAA;EzF4hlBV;EyFnilBM;IAOI,2BAAA;EzF+hlBV;EyFtilBM;IAOI,0BAAA;EzFkilBV;EyFzilBM;IAOI,gCAAA;EzFqilBV;EyF5ilBM;IAOI,yBAAA;EzFwilBV;EyF/ilBM;IAOI,wBAAA;EzF2ilBV;EyFljlBM;IAOI,+BAAA;EzF8ilBV;EyFrjlBM;IAOI,yBAAA;EzFijlBV;EyFxjlBM;IAOI,6BAAA;EzFojlBV;EyF3jlBM;IAOI,8BAAA;EzFujlBV;EyF9jlBM;IAOI,wBAAA;EzF0jlBV;EyFjklBM;IAOI,+BAAA;EzF6jlBV;EyFpklBM;IAOI,wBAAA;EzFgklBV;EyFvklBM;IAOI,yBAAA;EzFmklBV;EyF1klBM;IAOI,8BAAA;EzFsklBV;EyF7klBM;IAOI,iCAAA;EzFyklBV;EyFhllBM;IAOI,sCAAA;EzF4klBV;EyFnllBM;IAOI,yCAAA;EzF+klBV;EyFtllBM;IAOI,uBAAA;EzFkllBV;EyFzllBM;IAOI,uBAAA;EzFqllBV;EyF5llBM;IAOI,yBAAA;EzFwllBV;EyF/llBM;IAOI,yBAAA;EzF2llBV;EyFlmlBM;IAOI,0BAAA;EzF8llBV;EyFrmlBM;IAOI,4BAAA;EzFimlBV;EyFxmlBM;IAOI,kCAAA;EzFomlBV;EyF3mlBM;IAOI,sCAAA;EzFumlBV;EyF9mlBM;IAOI,oCAAA;EzF0mlBV;EyFjnlBM;IAOI,kCAAA;EzF6mlBV;EyFpnlBM;IAOI,yCAAA;EzFgnlBV;EyFvnlBM;IAOI,wCAAA;EzFmnlBV;EyF1nlBM;IAOI,wCAAA;EzFsnlBV;EyF7nlBM;IAOI,kCAAA;EzFynlBV;EyFholBM;IAOI,gCAAA;EzF4nlBV;EyFnolBM;IAOI,8BAAA;EzF+nlBV;EyFtolBM;IAOI,gCAAA;EzFkolBV;EyFzolBM;IAOI,+BAAA;EzFqolBV;EyF5olBM;IAOI,oCAAA;EzFwolBV;EyF/olBM;IAOI,kCAAA;EzF2olBV;EyFlplBM;IAOI,gCAAA;EzF8olBV;EyFrplBM;IAOI,uCAAA;EzFiplBV;EyFxplBM;IAOI,sCAAA;EzFoplBV;EyF3plBM;IAOI,iCAAA;EzFuplBV;EyF9plBM;IAOI,2BAAA;EzF0plBV;EyFjqlBM;IAOI,iCAAA;EzF6plBV;EyFpqlBM;IAOI,+BAAA;EzFgqlBV;EyFvqlBM;IAOI,6BAAA;EzFmqlBV;EyF1qlBM;IAOI,+BAAA;EzFsqlBV;EyF7qlBM;IAOI,8BAAA;EzFyqlBV;EyFhrlBM;IAOI,oBAAA;EzF4qlBV;EyFnrlBM;IAOI,mBAAA;EzF+qlBV;EyFtrlBM;IAOI,mBAAA;EzFkrlBV;EyFzrlBM;IAOI,mBAAA;EzFqrlBV;EyF5rlBM;IAOI,mBAAA;EzFwrlBV;EyF/rlBM;IAOI,mBAAA;EzF2rlBV;EyFlslBM;IAOI,mBAAA;EzF8rlBV;EyFrslBM;IAOI,mBAAA;EzFislBV;EyFxslBM;IAOI,oBAAA;EzFoslBV;EyF3slBM;IAOI,0BAAA;EzFuslBV;EyF9slBM;IAOI,yBAAA;EzF0slBV;EyFjtlBM;IAOI,uBAAA;EzF6slBV;EyFptlBM;IAOI,yBAAA;EzFgtlBV;EyFvtlBM;IAOI,uBAAA;EzFmtlBV;EyF1tlBM;IAOI,uBAAA;EzFstlBV;EyF7tlBM;IAOI,0BAAA;IAAA,yBAAA;EzF0tlBV;EyFjulBM;IAOI,gCAAA;IAAA,+BAAA;EzF8tlBV;EyFrulBM;IAOI,+BAAA;IAAA,8BAAA;EzFkulBV;EyFzulBM;IAOI,6BAAA;IAAA,4BAAA;EzFsulBV;EyF7ulBM;IAOI,+BAAA;IAAA,8BAAA;EzF0ulBV;EyFjvlBM;IAOI,6BAAA;IAAA,4BAAA;EzF8ulBV;EyFrvlBM;IAOI,6BAAA;IAAA,4BAAA;EzFkvlBV;EyFzvlBM;IAOI,wBAAA;IAAA,2BAAA;EzFsvlBV;EyF7vlBM;IAOI,8BAAA;IAAA,iCAAA;EzF0vlBV;EyFjwlBM;IAOI,6BAAA;IAAA,gCAAA;EzF8vlBV;EyFrwlBM;IAOI,2BAAA;IAAA,8BAAA;EzFkwlBV;EyFzwlBM;IAOI,6BAAA;IAAA,gCAAA;EzFswlBV;EyF7wlBM;IAOI,2BAAA;IAAA,8BAAA;EzF0wlBV;EyFjxlBM;IAOI,2BAAA;IAAA,8BAAA;EzF8wlBV;EyFrxlBM;IAOI,wBAAA;EzFixlBV;EyFxxlBM;IAOI,8BAAA;EzFoxlBV;EyF3xlBM;IAOI,6BAAA;EzFuxlBV;EyF9xlBM;IAOI,2BAAA;EzF0xlBV;EyFjylBM;IAOI,6BAAA;EzF6xlBV;EyFpylBM;IAOI,2BAAA;EzFgylBV;EyFvylBM;IAOI,2BAAA;EzFmylBV;EyF1ylBM;IAOI,0BAAA;EzFsylBV;EyF7ylBM;IAOI,gCAAA;EzFyylBV;EyFhzlBM;IAOI,+BAAA;EzF4ylBV;EyFnzlBM;IAOI,6BAAA;EzF+ylBV;EyFtzlBM;IAOI,+BAAA;EzFkzlBV;EyFzzlBM;IAOI,6BAAA;EzFqzlBV;EyF5zlBM;IAOI,6BAAA;EzFwzlBV;EyF/zlBM;IAOI,2BAAA;EzF2zlBV;EyFl0lBM;IAOI,iCAAA;EzF8zlBV;EyFr0lBM;IAOI,gCAAA;EzFi0lBV;EyFx0lBM;IAOI,8BAAA;EzFo0lBV;EyF30lBM;IAOI,gCAAA;EzFu0lBV;EyF90lBM;IAOI,8BAAA;EzF00lBV;EyFj1lBM;IAOI,8BAAA;EzF60lBV;EyFp1lBM;IAOI,yBAAA;EzFg1lBV;EyFv1lBM;IAOI,+BAAA;EzFm1lBV;EyF11lBM;IAOI,8BAAA;EzFs1lBV;EyF71lBM;IAOI,4BAAA;EzFy1lBV;EyFh2lBM;IAOI,8BAAA;EzF41lBV;EyFn2lBM;IAOI,4BAAA;EzF+1lBV;EyFt2lBM;IAOI,4BAAA;EzFk2lBV;EyFz2lBM;IAOI,qBAAA;EzFq2lBV;EyF52lBM;IAOI,2BAAA;EzFw2lBV;EyF/2lBM;IAOI,0BAAA;EzF22lBV;EyFl3lBM;IAOI,wBAAA;EzF82lBV;EyFr3lBM;IAOI,0BAAA;EzFi3lBV;EyFx3lBM;IAOI,wBAAA;EzFo3lBV;EyF33lBM;IAOI,2BAAA;IAAA,0BAAA;EzFw3lBV;EyF/3lBM;IAOI,iCAAA;IAAA,gCAAA;EzF43lBV;EyFn4lBM;IAOI,gCAAA;IAAA,+BAAA;EzFg4lBV;EyFv4lBM;IAOI,8BAAA;IAAA,6BAAA;EzFo4lBV;EyF34lBM;IAOI,gCAAA;IAAA,+BAAA;EzFw4lBV;EyF/4lBM;IAOI,8BAAA;IAAA,6BAAA;EzF44lBV;EyFn5lBM;IAOI,yBAAA;IAAA,4BAAA;EzFg5lBV;EyFv5lBM;IAOI,+BAAA;IAAA,kCAAA;EzFo5lBV;EyF35lBM;IAOI,8BAAA;IAAA,iCAAA;EzFw5lBV;EyF/5lBM;IAOI,4BAAA;IAAA,+BAAA;EzF45lBV;EyFn6lBM;IAOI,8BAAA;IAAA,iCAAA;EzFg6lBV;EyFv6lBM;IAOI,4BAAA;IAAA,+BAAA;EzFo6lBV;EyF36lBM;IAOI,yBAAA;EzFu6lBV;EyF96lBM;IAOI,+BAAA;EzF06lBV;EyFj7lBM;IAOI,8BAAA;EzF66lBV;EyFp7lBM;IAOI,4BAAA;EzFg7lBV;EyFv7lBM;IAOI,8BAAA;EzFm7lBV;EyF17lBM;IAOI,4BAAA;EzFs7lBV;EyF77lBM;IAOI,2BAAA;EzFy7lBV;EyFh8lBM;IAOI,iCAAA;EzF47lBV;EyFn8lBM;IAOI,gCAAA;EzF+7lBV;EyFt8lBM;IAOI,8BAAA;EzFk8lBV;EyFz8lBM;IAOI,gCAAA;EzFq8lBV;EyF58lBM;IAOI,8BAAA;EzFw8lBV;EyF/8lBM;IAOI,4BAAA;EzF28lBV;EyFl9lBM;IAOI,kCAAA;EzF88lBV;EyFr9lBM;IAOI,iCAAA;EzFi9lBV;EyFx9lBM;IAOI,+BAAA;EzFo9lBV;EyF39lBM;IAOI,iCAAA;EzFu9lBV;EyF99lBM;IAOI,+BAAA;EzF09lBV;EyFj+lBM;IAOI,0BAAA;EzF69lBV;EyFp+lBM;IAOI,gCAAA;EzFg+lBV;EyFv+lBM;IAOI,+BAAA;EzFm+lBV;EyF1+lBM;IAOI,6BAAA;EzFs+lBV;EyF7+lBM;IAOI,+BAAA;EzFy+lBV;EyFh/lBM;IAOI,6BAAA;EzF4+lBV;EyFn/lBM;IAOI,iBAAA;EzF++lBV;EyFt/lBM;IAOI,uBAAA;EzFk/lBV;EyFz/lBM;IAOI,sBAAA;EzFq/lBV;EyF5/lBM;IAOI,oBAAA;EzFw/lBV;EyF//lBM;IAOI,sBAAA;EzF2/lBV;EyFlgmBM;IAOI,oBAAA;EzF8/lBV;EyFrgmBM;IAOI,qBAAA;EzFigmBV;EyFxgmBM;IAOI,2BAAA;EzFogmBV;EyF3gmBM;IAOI,0BAAA;EzFugmBV;EyF9gmBM;IAOI,wBAAA;EzF0gmBV;EyFjhmBM;IAOI,0BAAA;EzF6gmBV;EyFphmBM;IAOI,wBAAA;EzFghmBV;EyFvhmBM;IAOI,wBAAA;EzFmhmBV;EyF1hmBM;IAOI,8BAAA;EzFshmBV;EyF7hmBM;IAOI,6BAAA;EzFyhmBV;EyFhimBM;IAOI,2BAAA;EzF4hmBV;EyFnimBM;IAOI,6BAAA;EzF+hmBV;EyFtimBM;IAOI,2BAAA;EzFkimBV;EyFzimBM;IAOI,2BAAA;EzFqimBV;EyF5imBM;IAOI,4BAAA;EzFwimBV;EyF/imBM;IAOI,6BAAA;EzF2imBV;AACF;A8BtjmBI;E2DGI;IAOI,sBAAA;EzFgjmBV;EyFvjmBM;IAOI,uBAAA;EzFmjmBV;EyF1jmBM;IAOI,sBAAA;EzFsjmBV;EyF7jmBM;IAOI,8BAAA;EzFyjmBV;EyFhkmBM;IAOI,4BAAA;EzF4jmBV;EyFnkmBM;IAOI,2BAAA;EzF+jmBV;EyFtkmBM;IAOI,iCAAA;EzFkkmBV;EyFzkmBM;IAOI,2BAAA;EzFqkmBV;EyF5kmBM;IAOI,0BAAA;EzFwkmBV;EyF/kmBM;IAOI,gCAAA;EzF2kmBV;EyFllmBM;IAOI,yBAAA;EzF8kmBV;EyFrlmBM;IAOI,wBAAA;EzFilmBV;EyFxlmBM;IAOI,+BAAA;EzFolmBV;EyF3lmBM;IAOI,yBAAA;EzFulmBV;EyF9lmBM;IAOI,6BAAA;EzF0lmBV;EyFjmmBM;IAOI,8BAAA;EzF6lmBV;EyFpmmBM;IAOI,wBAAA;EzFgmmBV;EyFvmmBM;IAOI,+BAAA;EzFmmmBV;EyF1mmBM;IAOI,wBAAA;EzFsmmBV;EyF7mmBM;IAOI,yBAAA;EzFymmBV;EyFhnmBM;IAOI,8BAAA;EzF4mmBV;EyFnnmBM;IAOI,iCAAA;EzF+mmBV;EyFtnmBM;IAOI,sCAAA;EzFknmBV;EyFznmBM;IAOI,yCAAA;EzFqnmBV;EyF5nmBM;IAOI,uBAAA;EzFwnmBV;EyF/nmBM;IAOI,uBAAA;EzF2nmBV;EyFlomBM;IAOI,yBAAA;EzF8nmBV;EyFromBM;IAOI,yBAAA;EzFiomBV;EyFxomBM;IAOI,0BAAA;EzFoomBV;EyF3omBM;IAOI,4BAAA;EzFuomBV;EyF9omBM;IAOI,kCAAA;EzF0omBV;EyFjpmBM;IAOI,sCAAA;EzF6omBV;EyFppmBM;IAOI,oCAAA;EzFgpmBV;EyFvpmBM;IAOI,kCAAA;EzFmpmBV;EyF1pmBM;IAOI,yCAAA;EzFspmBV;EyF7pmBM;IAOI,wCAAA;EzFypmBV;EyFhqmBM;IAOI,wCAAA;EzF4pmBV;EyFnqmBM;IAOI,kCAAA;EzF+pmBV;EyFtqmBM;IAOI,gCAAA;EzFkqmBV;EyFzqmBM;IAOI,8BAAA;EzFqqmBV;EyF5qmBM;IAOI,gCAAA;EzFwqmBV;EyF/qmBM;IAOI,+BAAA;EzF2qmBV;EyFlrmBM;IAOI,oCAAA;EzF8qmBV;EyFrrmBM;IAOI,kCAAA;EzFirmBV;EyFxrmBM;IAOI,gCAAA;EzFormBV;EyF3rmBM;IAOI,uCAAA;EzFurmBV;EyF9rmBM;IAOI,sCAAA;EzF0rmBV;EyFjsmBM;IAOI,iCAAA;EzF6rmBV;EyFpsmBM;IAOI,2BAAA;EzFgsmBV;EyFvsmBM;IAOI,iCAAA;EzFmsmBV;EyF1smBM;IAOI,+BAAA;EzFssmBV;EyF7smBM;IAOI,6BAAA;EzFysmBV;EyFhtmBM;IAOI,+BAAA;EzF4smBV;EyFntmBM;IAOI,8BAAA;EzF+smBV;EyFttmBM;IAOI,oBAAA;EzFktmBV;EyFztmBM;IAOI,mBAAA;EzFqtmBV;EyF5tmBM;IAOI,mBAAA;EzFwtmBV;EyF/tmBM;IAOI,mBAAA;EzF2tmBV;EyFlumBM;IAOI,mBAAA;EzF8tmBV;EyFrumBM;IAOI,mBAAA;EzFiumBV;EyFxumBM;IAOI,mBAAA;EzFoumBV;EyF3umBM;IAOI,mBAAA;EzFuumBV;EyF9umBM;IAOI,oBAAA;EzF0umBV;EyFjvmBM;IAOI,0BAAA;EzF6umBV;EyFpvmBM;IAOI,yBAAA;EzFgvmBV;EyFvvmBM;IAOI,uBAAA;EzFmvmBV;EyF1vmBM;IAOI,yBAAA;EzFsvmBV;EyF7vmBM;IAOI,uBAAA;EzFyvmBV;EyFhwmBM;IAOI,uBAAA;EzF4vmBV;EyFnwmBM;IAOI,0BAAA;IAAA,yBAAA;EzFgwmBV;EyFvwmBM;IAOI,gCAAA;IAAA,+BAAA;EzFowmBV;EyF3wmBM;IAOI,+BAAA;IAAA,8BAAA;EzFwwmBV;EyF/wmBM;IAOI,6BAAA;IAAA,4BAAA;EzF4wmBV;EyFnxmBM;IAOI,+BAAA;IAAA,8BAAA;EzFgxmBV;EyFvxmBM;IAOI,6BAAA;IAAA,4BAAA;EzFoxmBV;EyF3xmBM;IAOI,6BAAA;IAAA,4BAAA;EzFwxmBV;EyF/xmBM;IAOI,wBAAA;IAAA,2BAAA;EzF4xmBV;EyFnymBM;IAOI,8BAAA;IAAA,iCAAA;EzFgymBV;EyFvymBM;IAOI,6BAAA;IAAA,gCAAA;EzFoymBV;EyF3ymBM;IAOI,2BAAA;IAAA,8BAAA;EzFwymBV;EyF/ymBM;IAOI,6BAAA;IAAA,gCAAA;EzF4ymBV;EyFnzmBM;IAOI,2BAAA;IAAA,8BAAA;EzFgzmBV;EyFvzmBM;IAOI,2BAAA;IAAA,8BAAA;EzFozmBV;EyF3zmBM;IAOI,wBAAA;EzFuzmBV;EyF9zmBM;IAOI,8BAAA;EzF0zmBV;EyFj0mBM;IAOI,6BAAA;EzF6zmBV;EyFp0mBM;IAOI,2BAAA;EzFg0mBV;EyFv0mBM;IAOI,6BAAA;EzFm0mBV;EyF10mBM;IAOI,2BAAA;EzFs0mBV;EyF70mBM;IAOI,2BAAA;EzFy0mBV;EyFh1mBM;IAOI,0BAAA;EzF40mBV;EyFn1mBM;IAOI,gCAAA;EzF+0mBV;EyFt1mBM;IAOI,+BAAA;EzFk1mBV;EyFz1mBM;IAOI,6BAAA;EzFq1mBV;EyF51mBM;IAOI,+BAAA;EzFw1mBV;EyF/1mBM;IAOI,6BAAA;EzF21mBV;EyFl2mBM;IAOI,6BAAA;EzF81mBV;EyFr2mBM;IAOI,2BAAA;EzFi2mBV;EyFx2mBM;IAOI,iCAAA;EzFo2mBV;EyF32mBM;IAOI,gCAAA;EzFu2mBV;EyF92mBM;IAOI,8BAAA;EzF02mBV;EyFj3mBM;IAOI,gCAAA;EzF62mBV;EyFp3mBM;IAOI,8BAAA;EzFg3mBV;EyFv3mBM;IAOI,8BAAA;EzFm3mBV;EyF13mBM;IAOI,yBAAA;EzFs3mBV;EyF73mBM;IAOI,+BAAA;EzFy3mBV;EyFh4mBM;IAOI,8BAAA;EzF43mBV;EyFn4mBM;IAOI,4BAAA;EzF+3mBV;EyFt4mBM;IAOI,8BAAA;EzFk4mBV;EyFz4mBM;IAOI,4BAAA;EzFq4mBV;EyF54mBM;IAOI,4BAAA;EzFw4mBV;EyF/4mBM;IAOI,qBAAA;EzF24mBV;EyFl5mBM;IAOI,2BAAA;EzF84mBV;EyFr5mBM;IAOI,0BAAA;EzFi5mBV;EyFx5mBM;IAOI,wBAAA;EzFo5mBV;EyF35mBM;IAOI,0BAAA;EzFu5mBV;EyF95mBM;IAOI,wBAAA;EzF05mBV;EyFj6mBM;IAOI,2BAAA;IAAA,0BAAA;EzF85mBV;EyFr6mBM;IAOI,iCAAA;IAAA,gCAAA;EzFk6mBV;EyFz6mBM;IAOI,gCAAA;IAAA,+BAAA;EzFs6mBV;EyF76mBM;IAOI,8BAAA;IAAA,6BAAA;EzF06mBV;EyFj7mBM;IAOI,gCAAA;IAAA,+BAAA;EzF86mBV;EyFr7mBM;IAOI,8BAAA;IAAA,6BAAA;EzFk7mBV;EyFz7mBM;IAOI,yBAAA;IAAA,4BAAA;EzFs7mBV;EyF77mBM;IAOI,+BAAA;IAAA,kCAAA;EzF07mBV;EyFj8mBM;IAOI,8BAAA;IAAA,iCAAA;EzF87mBV;EyFr8mBM;IAOI,4BAAA;IAAA,+BAAA;EzFk8mBV;EyFz8mBM;IAOI,8BAAA;IAAA,iCAAA;EzFs8mBV;EyF78mBM;IAOI,4BAAA;IAAA,+BAAA;EzF08mBV;EyFj9mBM;IAOI,yBAAA;EzF68mBV;EyFp9mBM;IAOI,+BAAA;EzFg9mBV;EyFv9mBM;IAOI,8BAAA;EzFm9mBV;EyF19mBM;IAOI,4BAAA;EzFs9mBV;EyF79mBM;IAOI,8BAAA;EzFy9mBV;EyFh+mBM;IAOI,4BAAA;EzF49mBV;EyFn+mBM;IAOI,2BAAA;EzF+9mBV;EyFt+mBM;IAOI,iCAAA;EzFk+mBV;EyFz+mBM;IAOI,gCAAA;EzFq+mBV;EyF5+mBM;IAOI,8BAAA;EzFw+mBV;EyF/+mBM;IAOI,gCAAA;EzF2+mBV;EyFl/mBM;IAOI,8BAAA;EzF8+mBV;EyFr/mBM;IAOI,4BAAA;EzFi/mBV;EyFx/mBM;IAOI,kCAAA;EzFo/mBV;EyF3/mBM;IAOI,iCAAA;EzFu/mBV;EyF9/mBM;IAOI,+BAAA;EzF0/mBV;EyFjgnBM;IAOI,iCAAA;EzF6/mBV;EyFpgnBM;IAOI,+BAAA;EzFggnBV;EyFvgnBM;IAOI,0BAAA;EzFmgnBV;EyF1gnBM;IAOI,gCAAA;EzFsgnBV;EyF7gnBM;IAOI,+BAAA;EzFygnBV;EyFhhnBM;IAOI,6BAAA;EzF4gnBV;EyFnhnBM;IAOI,+BAAA;EzF+gnBV;EyFthnBM;IAOI,6BAAA;EzFkhnBV;EyFzhnBM;IAOI,iBAAA;EzFqhnBV;EyF5hnBM;IAOI,uBAAA;EzFwhnBV;EyF/hnBM;IAOI,sBAAA;EzF2hnBV;EyFlinBM;IAOI,oBAAA;EzF8hnBV;EyFrinBM;IAOI,sBAAA;EzFiinBV;EyFxinBM;IAOI,oBAAA;EzFoinBV;EyF3inBM;IAOI,qBAAA;EzFuinBV;EyF9inBM;IAOI,2BAAA;EzF0inBV;EyFjjnBM;IAOI,0BAAA;EzF6inBV;EyFpjnBM;IAOI,wBAAA;EzFgjnBV;EyFvjnBM;IAOI,0BAAA;EzFmjnBV;EyF1jnBM;IAOI,wBAAA;EzFsjnBV;EyF7jnBM;IAOI,wBAAA;EzFyjnBV;EyFhknBM;IAOI,8BAAA;EzF4jnBV;EyFnknBM;IAOI,6BAAA;EzF+jnBV;EyFtknBM;IAOI,2BAAA;EzFkknBV;EyFzknBM;IAOI,6BAAA;EzFqknBV;EyF5knBM;IAOI,2BAAA;EzFwknBV;EyF/knBM;IAOI,2BAAA;EzF2knBV;EyFllnBM;IAOI,4BAAA;EzF8knBV;EyFrlnBM;IAOI,6BAAA;EzFilnBV;AACF;A0FxonBA;ED+CQ;IAOI,4BAAA;EzFslnBV;EyF7lnBM;IAOI,0BAAA;EzFylnBV;EyFhmnBM;IAOI,6BAAA;EzF4lnBV;EyFnmnBM;IAOI,4BAAA;EzF+lnBV;AACF;A0FnonBA;ED4BQ;IAOI,0BAAA;EzFomnBV;EyF3mnBM;IAOI,gCAAA;EzFumnBV;EyF9mnBM;IAOI,yBAAA;EzF0mnBV;EyFjnnBM;IAOI,wBAAA;EzF6mnBV;EyFpnnBM;IAOI,+BAAA;EzFgnnBV;EyFvnnBM;IAOI,yBAAA;EzFmnnBV;EyF1nnBM;IAOI,6BAAA;EzFsnnBV;EyF7nnBM;IAOI,8BAAA;EzFynnBV;EyFhonBM;IAOI,wBAAA;EzF4nnBV;EyFnonBM;IAOI,+BAAA;EzF+nnBV;EyFtonBM;IAOI,wBAAA;EzFkonBV;AACF;AArsnBA;EACE,2CwEgBW;AxEurnBb;;AApsnBA;EACE,WAAA;EACA,uBAAA;AAusnBF;;AApsnBA;EACE,uBAAA;AAusnBF;;AApsnBA;EACE,yBAAA;EACA,yBAAA;EACA,mBAAA;AAusnBF;;AApsnBA;EACE,sBAAA;EACA,gCAAA;AAusnBF;AArsnBE;EACE,sBAAA;AAusnBJ;;AAnsnBA;EACE,WAAA;AAssnBF;;AAnsnBA;EACE,yBAAA;AAssnBF;;AAnsnBA;;EAEE,aAAA;EACA,kBAAA;EAEA,8BAAA;AAqsnBF;;AAlsnBA;EACE,aAAA;AAqsnBF;;AAlsnBA;EACE,WAAA;AAqsnBF;;AAlsnBA;EACE,aAAA;EACA,gBAAA;AAqsnBF;;AAlsnBA;EACE,WAAA;AAqsnBF;;AAlsnBA;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;AAqsnBF;;AAlsnBA;EACE,6DAAA;EACA,uCAAA;EACA,iCAAA;EACA,yBAAA;AAqsnBF;AAnsnBE;EACE,YAAA;EACA,YAAA;AAqsnBJ;AAlsnBE;EACE,WAAA;EACA,eAAA;EACA,8CwE9Da;ExE+Db,iBAAA;EACA,kBAAA;AAosnBJ;AAjsnBE;EACE,gBAAA;EACA,2BAAA;EACA,WAAA;EACA,eAAA;EACA,2CwE1ES;ExE2ET,iBAAA;EACA,kBAAA;AAmsnBJ;AAjsnBI;EACE,cAAA;AAmsnBN;AA/rnBE;EACE,UAAA;AAisnBJ;AA9rnBE;EACE,WAAA;EACA,eAAA;EACA,2CwE1FS;ExE2FT,iBAAA;AAgsnBJ;;AA5rnBA;EAEI;IACE,YAAA;IACA,YAAA;EA8rnBJ;EA3rnBE;IACE,eAAA;EA6rnBJ;EA1rnBE;IACE,eAAA;EA4rnBJ;EAzrnBE;IACE,UAAA;EA2rnBJ;AACF;AAvrnBA;EAEI;IACE,UAAA;EAwrnBJ;AACF;AAprnBA;EACE;IACE,6GACE;IAEF,uCAAA;IACA,iCAAA;IACA,+BAAA;EAornBF;AACF;AAjrnBA;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AAmrnBF;;AAhrnBA;EACE,2BAAA;EACA,mBAAA;EACA,cAAA;AAmrnBF;A8BjxnBI;E9B2FJ;IAMI,0BAAA;EAornBF;AACF;;AAjrnBA;EACE,0BAAA;EACA,2CAAA;AAornBF;;AAjrnBA;EACE,iBAAA;EACA,2CAAA;AAornBF;;AAjrnBA;EACE,YAAA;EACA,yBAAA;EACA,8BAAA;EACA,8BAAA;AAornBF;;AAjrnBA;EACE,yBAAA;EACA,8BAAA;EACA,8BAAA;EACA,eAAA;EACA,4BAAA;AAornBF;AAlrnBE;EACE,iCAAA;AAornBJ;;AAhrnBA;EACE,4BAAA;AAmrnBF;;AAhrnBA;EACE,yBAAA;EACA,8BAAA;EACA,8BAAA;EACA,4BAAA;AAmrnBF;AAjrnBE;EACE,iCAAA;AAmrnBJ;;AA/qnBA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;AAkrnBF;;AA/qnBA;EACE,sBAAA;EACA,YAAA;EACA,4BAAA;AAkrnBF;;AA/qnBA;EACE,sBAAA;EACA,YAAA;EACA,4BAAA;AAkrnBF;;AA/qnBA;EACE,4BAAA;AAkrnBF;;AA/qnBA;EACE;IACE,0BAAA;IACA,6BAAA;EAkrnBF;AACF;A8B71nBI;E9B+KF;IACE,4BAAA;IACA,2BAAA;EAirnBF;AACF;AA9qnBA;EACE,iBAAA;AAgrnBF;;AA7qnBA;EACE,2BAAA;AAgrnBF;;AA7qnBA;EACE,eAAA;AAgrnBF;;AA7qnBA;EACE,8BAAA;EACA,4BAAA;EACA,8BAAA;AAgrnBF;;AA5qnBE;EACE,iBAAA;EACA,mBAAA;AA+qnBJ;AA5qnBE;EACE,uBAAA;EACA,mBAAA;AA8qnBJ;;A8B73nBI;E9BoNF;IACE,gBAAA;EA6qnBF;AACF;AA1qnBA;EACE,iBAAA;AA4qnBF;A8Bt4nBI;E9ByNJ;IAII,iBAAA;EA6qnBF;AACF;;AA1qnBA;EACE,aAAA;EACA,yBAAA;AA6qnBF;;AA1qnBA;;EAEE,aAAA;AA6qnBF;;AA1qnBA;EACE,2BAAA;AA6qnBF;A8Bz5nBI;E9B2OJ;IAII,YAAA;IACA,0CAAA;EA8qnBF;AACF;;AA3qnBA;EACE,0BAAA;AA8qnBF;;AA3qnBA;EACE,0BAAA;AA8qnBF;;AA3qnBA;EACE,6BAAA;AA8qnBF;;AA3qnBA;EACE,0BAAA;AA8qnBF;;AA3qnBA;EACE,0BAAA;AA8qnBF;;AA3qnBA;EACE,0BAAA;AA8qnBF;;AA3qnBA;EACE,0BAAA;AA8qnBF;;AA3qnBA;EACE,UAAA;AA8qnBF;;AA3qnBA;EACE,2BAAA;EACA,2BAAA;AA8qnBF;AA5qnBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AA8qnBJ;;AA1qnBA;EACE,yCAAA;AA6qnBF;;AA1qnBA;EACE,+BAAA;EACA,gBAAA;EACA,cAAA;AA6qnBF;;AA1qnBA;EACE,mBAAA;AA6qnBF;;AA1qnBA;EACE,YAAA;AA6qnBF;AA3qnBE;EACE,sBAAA;AA6qnBJ;AA3qnBI;EACE,qBAAA;EACA,sBAAA;EACA,yCAAA;EACA,8BAAA;AA6qnBN;AAzqnBE;EACE,sBAAA;AA2qnBJ;AAzqnBI;EACE,qBAAA;EACA,sBAAA;EACA,2BAAA;EACA,8BAAA;AA2qnBN;AAvqnBE;EACE,YAAA;AAyqnBJ;AAtqnBE;EACE,wBAAA;AAwqnBJ;;AApqnBA;EACE,WAAA;AAuqnBF;;AApqnBA;EACE,4BAAA;AAuqnBF;;AApqnBA;EACE,oCAAA;AAuqnBF;;AApqnBA;EACE,0BAAA;AAuqnBF","sourcesContent":["@import './fonts';\n@import './variables';\n@import '~@fortawesome/fontawesome-free/scss/fontawesome';\n@import '~@fortawesome/fontawesome-free/scss/regular';\n@import '~@fortawesome/fontawesome-free/scss/solid';\n@import '~bootstrap/scss/bootstrap';\n\n* {\n  font-family: $pl-regular;\n}\n\niframe ::-webkit-scrollbar {\n  width: 16px;\n  background: transparent;\n}\n\niframe::-webkit-scrollbar-track {\n  background: transparent;\n}\n\niframe::-webkit-scrollbar-thumb {\n  background-color: #787878;\n  border: 3px solid #f7f7f7;\n  border-radius: 10px;\n}\n\na {\n  color: #000 !important;\n  text-decoration: none !important;\n\n  .anticon {\n    vertical-align: middle;\n  }\n}\n\n.text-white {\n  color: #fff;\n}\n\n.text-pink {\n  color: #e2407e !important;\n}\n\nbody,\nhtml {\n  height: 100vh;\n  overflow-x: hidden;\n  // overflow-y: hidden;\n  background: $body-bg !important;\n}\n\n.full-height {\n  height: 100vh;\n}\n\n.nav-logo {\n  float: left;\n}\n\n.nav-bar {\n  height: 130px;\n  padding: 0 140px;\n}\n\n.ant-col {\n  width: 100%;\n}\n\n.about-scrollable {\n  height: 400px;\n  padding-top: 24px;\n  overflow-y: auto;\n}\n\n.login-bg {\n  background: $login-bg, #37033c;\n  background-repeat: no-repeat, no-repeat;\n  background-position: right center;\n  background-size: auto 75%;\n\n  .logo {\n    width: 200px;\n    height: auto;\n  }\n\n  h1 {\n    color: #fff;\n    font-size: 34px;\n    font-family: $pl-bold-italic;\n    line-height: 46px;\n    text-align: center;\n  }\n\n  p {\n    max-width: 480px;\n    margin-bottom: 0 !important;\n    color: #fff;\n    font-size: 16px;\n    font-family: $pl-regular;\n    line-height: 22px;\n    text-align: center;\n\n    a {\n      color: #e2407e;\n    }\n  }\n\n  .login_button_container {\n    width: 56%;\n  }\n\n  small {\n    color: #fff;\n    font-size: 12px;\n    font-family: $pl-regular;\n    line-height: 22px;\n  }\n}\n\n@media only screen and (max-width: 576px) {\n  .login-bg {\n    .logo {\n      width: 150px;\n      height: auto;\n    }\n\n    h1 {\n      font-size: 28px;\n    }\n\n    p {\n      font-size: 14px;\n    }\n\n    .login_button_container {\n      width: 89%;\n    }\n  }\n}\n\n@media only screen and (min-width: 577px) and (max-width: 768px) {\n  .login-bg {\n    .login_button_container {\n      width: 64%;\n    }\n  }\n}\n\n@media only screen and (max-width: 992px) {\n  .login-bg {\n    background:\n      url(../asset/img/login-bg.png),\n      linear-gradient(140deg, #37033c 0%, #e2407e 100%) 0% 0%;\n    background-repeat: no-repeat, no-repeat;\n    background-position: bottom right;\n    background-size: cover, contain;\n  }\n}\n\n.card_shadow {\n  width: 100%;\n  margin-bottom: 32px;\n  padding: 20px;\n  background: #fff;\n  border-radius: 12px;\n}\n\n.card_shadow_posts {\n  height: calc(100vh - 390px);\n  margin-bottom: 16px;\n  overflow: auto;\n\n  @include media-breakpoint-down(lg) {\n    height: calc(50vh - 140px);\n  }\n}\n\nh4 {\n  font-size: 12px !important;\n  font-family: PremierLeague-Bold, sans-serif;\n}\n\n.bold {\n  font-weight: bold;\n  font-family: PremierLeague-Bold, sans-serif;\n}\n\n.avatar-insight {\n  float: right;\n  color: #490c4e !important;\n  background: #dacddb !important;\n  border-radius: 12px !important;\n}\n\n.avatar {\n  color: #490c4e !important;\n  background: #dacddb !important;\n  border-radius: 12px !important;\n  cursor: pointer;\n  transition: 0.3s ease-in-out;\n\n  .anticon {\n    vertical-align: middle !important;\n  }\n}\n\n.anticon {\n  vertical-align: 0 !important;\n}\n\n.avatar-initials {\n  color: #490c4e !important;\n  background: #dacddb !important;\n  border-radius: 12px !important;\n  transition: 0.3s ease-in-out;\n\n  .anticon {\n    vertical-align: middle !important;\n  }\n}\n\n.ant-menu .anticon {\n  width: 14px;\n  height: 14px;\n  vertical-align: middle;\n}\n\n.avatar:hover {\n  transform: scale(1.02);\n  opacity: 0.8;\n  transition: 0.3s ease-in-out;\n}\n\n.avatar-insight:hover {\n  transform: scale(1.02);\n  opacity: 0.8;\n  transition: 0.3s ease-in-out;\n}\n\n.first-avatar {\n  margin-right: 5px !important;\n}\n\n@media only screen and (max-width: 1305px) {\n  .first-avatar {\n    margin-right: 0 !important;\n    margin-bottom: 5px !important;\n  }\n}\n\n@include media-breakpoint-down(lg) {\n  .first-avatar {\n    margin-right: 5px !important;\n    margin-bottom: 0 !important;\n  }\n}\n\n.text-right {\n  text-align: right;\n}\n\np:last-child {\n  margin-bottom: 0 !important;\n}\n\n.font-fourteen {\n  font-size: 12px;\n}\n\n.flex-flow {\n  flex-direction: row !important;\n  flex-flow: nowrap !important;\n  justify-content: space-between;\n}\n\n.ant-row {\n  *::-webkit-scrollbar-track {\n    background: white;\n    border-radius: 10px;\n  }\n\n  *::-webkit-scrollbar-thumb {\n    border: 3px solid white;\n    border-radius: 10px;\n  }\n}\n\n@include media-breakpoint-down(lg) {\n  .article_meta {\n    margin-top: 32px;\n  }\n}\n\n.site_padding {\n  padding-top: 26px;\n\n  @include media-breakpoint-down(lg) {\n    padding-top: 10px;\n  }\n}\n\n.ant-tabs-tabpane {\n  padding: 20px;\n  background-color: #f7f7f7;\n}\n\n.ant-tabs > .ant-tabs-nav,\n.ant-tabs > div > .ant-tabs-nav {\n  padding: 20px;\n}\n\n.ant-table-body {\n  height: calc(100vh - 452px);\n\n  @include media-breakpoint-down(md) {\n    height: auto;\n    max-height: calc(100vh - 415px) !important;\n  }\n}\n\n.ant-table {\n  font-size: 12px !important;\n}\n\n.ant-menu {\n  font-size: 12px !important;\n}\n\n.ant-table-cell {\n  padding: 13px 16px !important;\n}\n\n.font-12 {\n  font-size: 12px !important;\n}\n\n.ant-form {\n  font-size: 12px !important;\n}\n\n.ant-form label {\n  font-size: 12px !important;\n}\n\n.ant-select-lg {\n  font-size: 12px !important;\n}\n\n.ant-table .ant-table-thead .ant-table-column-sorters {\n  padding: 0;\n}\n\n.ant-table-pagination.ant-pagination {\n  margin-top: 16px !important;\n  margin-bottom: 0 !important;\n\n  .ant-pagination-item-link {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n.ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table {\n  margin: -13px -16px -16px 34px !important;\n}\n\n.max-height {\n  max-height: calc(100vh - 530px);\n  margin-bottom: 0;\n  overflow: auto;\n}\n\n.about-tables {\n  padding-right: 24px;\n}\n\n.ant-carousel {\n  height: 100%;\n\n  .slick-dots li {\n    width: 10px !important;\n\n    button {\n      width: 7px !important;\n      height: 7px !important;\n      background: rgba(0, 0, 0, 0.8) !important;\n      border-radius: 100% !important;\n    }\n  }\n\n  .slick-dots li.slick-active {\n    width: 10px !important;\n\n    button {\n      width: 7px !important;\n      height: 7px !important;\n      background: #000 !important;\n      border-radius: 100% !important;\n    }\n  }\n\n  .slick-slider {\n    height: 100%;\n  }\n\n  .slick-dots-bottom {\n    bottom: -38px !important;\n  }\n}\n\n.mce-preview-object {\n  width: 100%;\n}\n\nh2 {\n  font-size: 1.5rem !important;\n}\n\n.bg-purple {\n  background-color: #490c4e !important;\n}\n\n.plcp-bg-height {\n  height: calc(100vh - 60px);\n}\n","@font-face {\n  font-family: 'PremierLeague-Regular';\n  src: url('../asset/font/PremierLeagueW01-Regular.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-Regular.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-Regular.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-Regular.woff') format('woff'), url('../asset/font/PremierLeagueW01-Regular.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'PremierLeague-Light';\n  src: url('../asset/font/PremierLeagueW01-Light.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-Light.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-Light.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-Light.woff') format('woff'), url('../asset/font/PremierLeagueW01-Light.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'PremierLeague-Bold';\n  src: url('../asset/font/PremierLeagueW01-Bold.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-Bold.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-Bold.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-Bold.woff') format('woff'), url('../asset/font/PremierLeagueW01-Bold.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'PremierLeague-Condensed';\n  src: url('../asset/font/PremierLeagueW01-Condensed.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-Condensed.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-Condensed.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-Condensed.woff') format('woff'), url('../asset/font/PremierLeagueW01-Condensed.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'PremierLeague-CondBold';\n  src: url('../asset/font/PremierLeagueW01-CondBold.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-CondBold.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-CondBold.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-CondBold.woff') format('woff'), url('../asset/font/PremierLeagueW01-CondBold.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'PremierLeague-Italic';\n  src: url('../asset/font/PremierLeagueW01-Italic.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-Italic.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-Italic.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-Italic.woff') format('woff'), url('../asset/font/PremierLeagueW01-Italic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'PremierLeague-LightIt';\n  src: url('../asset/font/PremierLeagueW01-LightIt.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-LightIt.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-LightIt.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-LightIt.woff') format('woff'), url('../asset/font/PremierLeagueW01-LightIt.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'PremierLeague-BoldItalic';\n  src: url('../asset/font/PremierLeagueW01-BoldItalic.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-BoldItalic.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-BoldItalic.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-BoldItalic.woff') format('woff'), url('../asset/font/PremierLeagueW01-BoldItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'PremierLeague-Heavy';\n  src: url('../asset/font/PremierLeagueW01-Heavy.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-Heavy.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-Heavy.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-Heavy.woff') format('woff'), url('../asset/font/PremierLeagueW01-Heavy.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'PremierLeague-HeavyIt';\n  src: url('../asset/font/PremierLeagueW01-HeavyIt.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-HeavyIt.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-HeavyIt.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-HeavyIt.woff') format('woff'), url('../asset/font/PremierLeagueW01-HeavyIt.ttf') format('truetype');\n}\n","/*!\n * Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n * Copyright 2024 Fonticons, Inc.\n */\n// Font Awesome core compile (Web Fonts-based)\n// -------------------------\n\n@import 'functions';\n@import 'variables';\n@import 'mixins';\n@import 'core';\n@import 'sizing';\n@import 'fixed-width';\n@import 'list';\n@import 'bordered-pulled';\n@import 'animated';\n@import 'rotated-flipped';\n@import 'stacked';\n@import 'icons';\n@import 'screen-reader';\n","// base icon class definition\n// -------------------------\n\n.#{$fa-css-prefix} {\n  font-family: var(--#{$fa-css-prefix}-style-family, '#{$fa-style-family}');\n  font-weight: var(--#{$fa-css-prefix}-style, #{$fa-style});\n}\n\n.#{$fa-css-prefix},\n.#{$fa-css-prefix}-classic,\n.#{$fa-css-prefix}-sharp,\n.fas,\n.#{$fa-css-prefix}-solid,\n.far,\n.#{$fa-css-prefix}-regular,\n.fab,\n.#{$fa-css-prefix}-brands {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  display: var(--#{$fa-css-prefix}-display, #{$fa-display});\n  font-style: normal;\n  font-variant: normal;\n  line-height: 1;\n  text-rendering: auto;\n}\n\n.fas,\n.#{$fa-css-prefix}-classic,\n.#{$fa-css-prefix}-solid,\n.far,\n.#{$fa-css-prefix}-regular {\n  font-family: 'Font Awesome 6 Free';\n}\n\n.fab,\n.#{$fa-css-prefix}-brands {\n  font-family: 'Font Awesome 6 Brands';\n}\n\n\n%fa-icon {\n  @include fa-icon;\n}\n","// sizing icons\n// -------------------------\n\n// literal magnification scale\n@for $i from 1 through 10 {\n  .#{$fa-css-prefix}-#{$i}x {\n    font-size: $i * 1em;\n  }\n}\n\n// step-based scale (with alignment)\n@each $size, $value in $fa-sizes {\n  .#{$fa-css-prefix}-#{$size} {\n     @include fa-size($value);\n  }\n}\n","// mixins\n// --------------------------\n\n// base rendering for an icon\n@mixin fa-icon {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  display: inline-block;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: normal;\n  line-height: 1;\n}\n\n// sets relative font-sizing and alignment (in _sizing)\n@mixin fa-size ($font-size) {\n  font-size: fa-divide($font-size, $fa-size-scale-base) * 1em; // converts step in sizing scale into an em-based value that's relative to the scale's base\n  line-height: fa-divide(1, $font-size) * 1em; // sets the line-height of the icon back to that of it's parent\n  vertical-align: (fa-divide(6, $font-size) - fa-divide(3, 8)) * 1em; // vertically centers the icon taking into account the surrounding text's descender\n}\n\n// only display content to screen readers\n// see: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// see: https://hugogiraudel.com/2016/10/13/css-hide-and-seek/\n@mixin fa-sr-only() {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n// use in conjunction with .sr-only to only display content when it's focused\n@mixin fa-sr-only-focusable() {\n  &:not(:focus) {\n    @include fa-sr-only();\n  }\n}\n\n// sets a specific icon family to use alongside style + icon mixins\n\n// convenience mixins for declaring pseudo-elements by CSS variable,\n// including all style-specific font properties, and both the ::before\n// and ::after elements in the duotone case.\n@mixin fa-icon-solid($fa-var) {\n  @extend %fa-icon;\n  @extend .fa-solid;\n\n  &::before {\n    content: unquote(\"\\\"#{ $fa-var }\\\"\");\n  }\n}\n@mixin fa-icon-regular($fa-var) {\n  @extend %fa-icon;\n  @extend .fa-regular;\n\n  &::before {\n    content: unquote(\"\\\"#{ $fa-var }\\\"\");\n  }\n}\n@mixin fa-icon-brands($fa-var) {\n  @extend %fa-icon;\n  @extend .fa-brands;\n\n  &::before {\n    content: unquote(\"\\\"#{ $fa-var }\\\"\");\n  }\n}\n","// fixed-width icons\n// -------------------------\n\n.#{$fa-css-prefix}-fw {\n  text-align: center;\n  width: $fa-fw-width;\n}\n","// variables\n// --------------------------\n\n$fa-css-prefix          : fa !default;\n$fa-style               : 900 !default;\n$fa-style-family        : \"Font Awesome 6 Free\" !default;\n\n$fa-display             : inline-block !default;\n\n$fa-fw-width            : fa-divide(20em, 16) !default;\n$fa-inverse             : #fff !default;\n\n$fa-border-color        : #eee !default;\n$fa-border-padding      : .2em .25em .15em !default;\n$fa-border-radius       : .1em !default;\n$fa-border-style        : solid !default;\n$fa-border-width        : .08em !default;\n\n$fa-size-scale-2xs      : 10 !default;\n$fa-size-scale-xs       : 12 !default;\n$fa-size-scale-sm       : 14 !default;\n$fa-size-scale-base     : 16 !default;\n$fa-size-scale-lg       : 20 !default;\n$fa-size-scale-xl       : 24 !default;\n$fa-size-scale-2xl      : 32 !default;\n\n$fa-sizes: (\n  \"2xs\"                 : $fa-size-scale-2xs,\n  \"xs\"                  : $fa-size-scale-xs,\n  \"sm\"                  : $fa-size-scale-sm,\n  \"lg\"                  : $fa-size-scale-lg,\n  \"xl\"                  : $fa-size-scale-xl,\n  \"2xl\"                 : $fa-size-scale-2xl\n) !default;\n\n$fa-li-width            : 2em !default;\n$fa-li-margin           : $fa-li-width * fa-divide(5, 4) !default;\n\n$fa-pull-margin         : .3em !default;\n\n$fa-primary-opacity     : 1 !default;\n$fa-secondary-opacity   : .4 !default;\n\n$fa-stack-vertical-align: middle !default;\n$fa-stack-width         : ($fa-fw-width * 2) !default;\n$fa-stack-z-index       : auto !default;\n\n$fa-font-display        : block !default;\n$fa-font-path           : \"../webfonts\" !default;\n\n$fa-var-0: \\30;\n$fa-var-1: \\31;\n$fa-var-2: \\32;\n$fa-var-3: \\33;\n$fa-var-4: \\34;\n$fa-var-5: \\35;\n$fa-var-6: \\36;\n$fa-var-7: \\37;\n$fa-var-8: \\38;\n$fa-var-9: \\39;\n$fa-var-fill-drip: \\f576;\n$fa-var-arrows-to-circle: \\e4bd;\n$fa-var-circle-chevron-right: \\f138;\n$fa-var-chevron-circle-right: \\f138;\n$fa-var-at: \\40;\n$fa-var-trash-can: \\f2ed;\n$fa-var-trash-alt: \\f2ed;\n$fa-var-text-height: \\f034;\n$fa-var-user-xmark: \\f235;\n$fa-var-user-times: \\f235;\n$fa-var-stethoscope: \\f0f1;\n$fa-var-message: \\f27a;\n$fa-var-comment-alt: \\f27a;\n$fa-var-info: \\f129;\n$fa-var-down-left-and-up-right-to-center: \\f422;\n$fa-var-compress-alt: \\f422;\n$fa-var-explosion: \\e4e9;\n$fa-var-file-lines: \\f15c;\n$fa-var-file-alt: \\f15c;\n$fa-var-file-text: \\f15c;\n$fa-var-wave-square: \\f83e;\n$fa-var-ring: \\f70b;\n$fa-var-building-un: \\e4d9;\n$fa-var-dice-three: \\f527;\n$fa-var-calendar-days: \\f073;\n$fa-var-calendar-alt: \\f073;\n$fa-var-anchor-circle-check: \\e4aa;\n$fa-var-building-circle-arrow-right: \\e4d1;\n$fa-var-volleyball: \\f45f;\n$fa-var-volleyball-ball: \\f45f;\n$fa-var-arrows-up-to-line: \\e4c2;\n$fa-var-sort-down: \\f0dd;\n$fa-var-sort-desc: \\f0dd;\n$fa-var-circle-minus: \\f056;\n$fa-var-minus-circle: \\f056;\n$fa-var-door-open: \\f52b;\n$fa-var-right-from-bracket: \\f2f5;\n$fa-var-sign-out-alt: \\f2f5;\n$fa-var-atom: \\f5d2;\n$fa-var-soap: \\e06e;\n$fa-var-icons: \\f86d;\n$fa-var-heart-music-camera-bolt: \\f86d;\n$fa-var-microphone-lines-slash: \\f539;\n$fa-var-microphone-alt-slash: \\f539;\n$fa-var-bridge-circle-check: \\e4c9;\n$fa-var-pump-medical: \\e06a;\n$fa-var-fingerprint: \\f577;\n$fa-var-hand-point-right: \\f0a4;\n$fa-var-magnifying-glass-location: \\f689;\n$fa-var-search-location: \\f689;\n$fa-var-forward-step: \\f051;\n$fa-var-step-forward: \\f051;\n$fa-var-face-smile-beam: \\f5b8;\n$fa-var-smile-beam: \\f5b8;\n$fa-var-flag-checkered: \\f11e;\n$fa-var-football: \\f44e;\n$fa-var-football-ball: \\f44e;\n$fa-var-school-circle-exclamation: \\e56c;\n$fa-var-crop: \\f125;\n$fa-var-angles-down: \\f103;\n$fa-var-angle-double-down: \\f103;\n$fa-var-users-rectangle: \\e594;\n$fa-var-people-roof: \\e537;\n$fa-var-people-line: \\e534;\n$fa-var-beer-mug-empty: \\f0fc;\n$fa-var-beer: \\f0fc;\n$fa-var-diagram-predecessor: \\e477;\n$fa-var-arrow-up-long: \\f176;\n$fa-var-long-arrow-up: \\f176;\n$fa-var-fire-flame-simple: \\f46a;\n$fa-var-burn: \\f46a;\n$fa-var-person: \\f183;\n$fa-var-male: \\f183;\n$fa-var-laptop: \\f109;\n$fa-var-file-csv: \\f6dd;\n$fa-var-menorah: \\f676;\n$fa-var-truck-plane: \\e58f;\n$fa-var-record-vinyl: \\f8d9;\n$fa-var-face-grin-stars: \\f587;\n$fa-var-grin-stars: \\f587;\n$fa-var-bong: \\f55c;\n$fa-var-spaghetti-monster-flying: \\f67b;\n$fa-var-pastafarianism: \\f67b;\n$fa-var-arrow-down-up-across-line: \\e4af;\n$fa-var-spoon: \\f2e5;\n$fa-var-utensil-spoon: \\f2e5;\n$fa-var-jar-wheat: \\e517;\n$fa-var-envelopes-bulk: \\f674;\n$fa-var-mail-bulk: \\f674;\n$fa-var-file-circle-exclamation: \\e4eb;\n$fa-var-circle-h: \\f47e;\n$fa-var-hospital-symbol: \\f47e;\n$fa-var-pager: \\f815;\n$fa-var-address-book: \\f2b9;\n$fa-var-contact-book: \\f2b9;\n$fa-var-strikethrough: \\f0cc;\n$fa-var-k: \\4b;\n$fa-var-landmark-flag: \\e51c;\n$fa-var-pencil: \\f303;\n$fa-var-pencil-alt: \\f303;\n$fa-var-backward: \\f04a;\n$fa-var-caret-right: \\f0da;\n$fa-var-comments: \\f086;\n$fa-var-paste: \\f0ea;\n$fa-var-file-clipboard: \\f0ea;\n$fa-var-code-pull-request: \\e13c;\n$fa-var-clipboard-list: \\f46d;\n$fa-var-truck-ramp-box: \\f4de;\n$fa-var-truck-loading: \\f4de;\n$fa-var-user-check: \\f4fc;\n$fa-var-vial-virus: \\e597;\n$fa-var-sheet-plastic: \\e571;\n$fa-var-blog: \\f781;\n$fa-var-user-ninja: \\f504;\n$fa-var-person-arrow-up-from-line: \\e539;\n$fa-var-scroll-torah: \\f6a0;\n$fa-var-torah: \\f6a0;\n$fa-var-broom-ball: \\f458;\n$fa-var-quidditch: \\f458;\n$fa-var-quidditch-broom-ball: \\f458;\n$fa-var-toggle-off: \\f204;\n$fa-var-box-archive: \\f187;\n$fa-var-archive: \\f187;\n$fa-var-person-drowning: \\e545;\n$fa-var-arrow-down-9-1: \\f886;\n$fa-var-sort-numeric-desc: \\f886;\n$fa-var-sort-numeric-down-alt: \\f886;\n$fa-var-face-grin-tongue-squint: \\f58a;\n$fa-var-grin-tongue-squint: \\f58a;\n$fa-var-spray-can: \\f5bd;\n$fa-var-truck-monster: \\f63b;\n$fa-var-w: \\57;\n$fa-var-earth-africa: \\f57c;\n$fa-var-globe-africa: \\f57c;\n$fa-var-rainbow: \\f75b;\n$fa-var-circle-notch: \\f1ce;\n$fa-var-tablet-screen-button: \\f3fa;\n$fa-var-tablet-alt: \\f3fa;\n$fa-var-paw: \\f1b0;\n$fa-var-cloud: \\f0c2;\n$fa-var-trowel-bricks: \\e58a;\n$fa-var-face-flushed: \\f579;\n$fa-var-flushed: \\f579;\n$fa-var-hospital-user: \\f80d;\n$fa-var-tent-arrow-left-right: \\e57f;\n$fa-var-gavel: \\f0e3;\n$fa-var-legal: \\f0e3;\n$fa-var-binoculars: \\f1e5;\n$fa-var-microphone-slash: \\f131;\n$fa-var-box-tissue: \\e05b;\n$fa-var-motorcycle: \\f21c;\n$fa-var-bell-concierge: \\f562;\n$fa-var-concierge-bell: \\f562;\n$fa-var-pen-ruler: \\f5ae;\n$fa-var-pencil-ruler: \\f5ae;\n$fa-var-people-arrows: \\e068;\n$fa-var-people-arrows-left-right: \\e068;\n$fa-var-mars-and-venus-burst: \\e523;\n$fa-var-square-caret-right: \\f152;\n$fa-var-caret-square-right: \\f152;\n$fa-var-scissors: \\f0c4;\n$fa-var-cut: \\f0c4;\n$fa-var-sun-plant-wilt: \\e57a;\n$fa-var-toilets-portable: \\e584;\n$fa-var-hockey-puck: \\f453;\n$fa-var-table: \\f0ce;\n$fa-var-magnifying-glass-arrow-right: \\e521;\n$fa-var-tachograph-digital: \\f566;\n$fa-var-digital-tachograph: \\f566;\n$fa-var-users-slash: \\e073;\n$fa-var-clover: \\e139;\n$fa-var-reply: \\f3e5;\n$fa-var-mail-reply: \\f3e5;\n$fa-var-star-and-crescent: \\f699;\n$fa-var-house-fire: \\e50c;\n$fa-var-square-minus: \\f146;\n$fa-var-minus-square: \\f146;\n$fa-var-helicopter: \\f533;\n$fa-var-compass: \\f14e;\n$fa-var-square-caret-down: \\f150;\n$fa-var-caret-square-down: \\f150;\n$fa-var-file-circle-question: \\e4ef;\n$fa-var-laptop-code: \\f5fc;\n$fa-var-swatchbook: \\f5c3;\n$fa-var-prescription-bottle: \\f485;\n$fa-var-bars: \\f0c9;\n$fa-var-navicon: \\f0c9;\n$fa-var-people-group: \\e533;\n$fa-var-hourglass-end: \\f253;\n$fa-var-hourglass-3: \\f253;\n$fa-var-heart-crack: \\f7a9;\n$fa-var-heart-broken: \\f7a9;\n$fa-var-square-up-right: \\f360;\n$fa-var-external-link-square-alt: \\f360;\n$fa-var-face-kiss-beam: \\f597;\n$fa-var-kiss-beam: \\f597;\n$fa-var-film: \\f008;\n$fa-var-ruler-horizontal: \\f547;\n$fa-var-people-robbery: \\e536;\n$fa-var-lightbulb: \\f0eb;\n$fa-var-caret-left: \\f0d9;\n$fa-var-circle-exclamation: \\f06a;\n$fa-var-exclamation-circle: \\f06a;\n$fa-var-school-circle-xmark: \\e56d;\n$fa-var-arrow-right-from-bracket: \\f08b;\n$fa-var-sign-out: \\f08b;\n$fa-var-circle-chevron-down: \\f13a;\n$fa-var-chevron-circle-down: \\f13a;\n$fa-var-unlock-keyhole: \\f13e;\n$fa-var-unlock-alt: \\f13e;\n$fa-var-cloud-showers-heavy: \\f740;\n$fa-var-headphones-simple: \\f58f;\n$fa-var-headphones-alt: \\f58f;\n$fa-var-sitemap: \\f0e8;\n$fa-var-circle-dollar-to-slot: \\f4b9;\n$fa-var-donate: \\f4b9;\n$fa-var-memory: \\f538;\n$fa-var-road-spikes: \\e568;\n$fa-var-fire-burner: \\e4f1;\n$fa-var-flag: \\f024;\n$fa-var-hanukiah: \\f6e6;\n$fa-var-feather: \\f52d;\n$fa-var-volume-low: \\f027;\n$fa-var-volume-down: \\f027;\n$fa-var-comment-slash: \\f4b3;\n$fa-var-cloud-sun-rain: \\f743;\n$fa-var-compress: \\f066;\n$fa-var-wheat-awn: \\e2cd;\n$fa-var-wheat-alt: \\e2cd;\n$fa-var-ankh: \\f644;\n$fa-var-hands-holding-child: \\e4fa;\n$fa-var-asterisk: \\2a;\n$fa-var-square-check: \\f14a;\n$fa-var-check-square: \\f14a;\n$fa-var-peseta-sign: \\e221;\n$fa-var-heading: \\f1dc;\n$fa-var-header: \\f1dc;\n$fa-var-ghost: \\f6e2;\n$fa-var-list: \\f03a;\n$fa-var-list-squares: \\f03a;\n$fa-var-square-phone-flip: \\f87b;\n$fa-var-phone-square-alt: \\f87b;\n$fa-var-cart-plus: \\f217;\n$fa-var-gamepad: \\f11b;\n$fa-var-circle-dot: \\f192;\n$fa-var-dot-circle: \\f192;\n$fa-var-face-dizzy: \\f567;\n$fa-var-dizzy: \\f567;\n$fa-var-egg: \\f7fb;\n$fa-var-house-medical-circle-xmark: \\e513;\n$fa-var-campground: \\f6bb;\n$fa-var-folder-plus: \\f65e;\n$fa-var-futbol: \\f1e3;\n$fa-var-futbol-ball: \\f1e3;\n$fa-var-soccer-ball: \\f1e3;\n$fa-var-paintbrush: \\f1fc;\n$fa-var-paint-brush: \\f1fc;\n$fa-var-lock: \\f023;\n$fa-var-gas-pump: \\f52f;\n$fa-var-hot-tub-person: \\f593;\n$fa-var-hot-tub: \\f593;\n$fa-var-map-location: \\f59f;\n$fa-var-map-marked: \\f59f;\n$fa-var-house-flood-water: \\e50e;\n$fa-var-tree: \\f1bb;\n$fa-var-bridge-lock: \\e4cc;\n$fa-var-sack-dollar: \\f81d;\n$fa-var-pen-to-square: \\f044;\n$fa-var-edit: \\f044;\n$fa-var-car-side: \\f5e4;\n$fa-var-share-nodes: \\f1e0;\n$fa-var-share-alt: \\f1e0;\n$fa-var-heart-circle-minus: \\e4ff;\n$fa-var-hourglass-half: \\f252;\n$fa-var-hourglass-2: \\f252;\n$fa-var-microscope: \\f610;\n$fa-var-sink: \\e06d;\n$fa-var-bag-shopping: \\f290;\n$fa-var-shopping-bag: \\f290;\n$fa-var-arrow-down-z-a: \\f881;\n$fa-var-sort-alpha-desc: \\f881;\n$fa-var-sort-alpha-down-alt: \\f881;\n$fa-var-mitten: \\f7b5;\n$fa-var-person-rays: \\e54d;\n$fa-var-users: \\f0c0;\n$fa-var-eye-slash: \\f070;\n$fa-var-flask-vial: \\e4f3;\n$fa-var-hand: \\f256;\n$fa-var-hand-paper: \\f256;\n$fa-var-om: \\f679;\n$fa-var-worm: \\e599;\n$fa-var-house-circle-xmark: \\e50b;\n$fa-var-plug: \\f1e6;\n$fa-var-chevron-up: \\f077;\n$fa-var-hand-spock: \\f259;\n$fa-var-stopwatch: \\f2f2;\n$fa-var-face-kiss: \\f596;\n$fa-var-kiss: \\f596;\n$fa-var-bridge-circle-xmark: \\e4cb;\n$fa-var-face-grin-tongue: \\f589;\n$fa-var-grin-tongue: \\f589;\n$fa-var-chess-bishop: \\f43a;\n$fa-var-face-grin-wink: \\f58c;\n$fa-var-grin-wink: \\f58c;\n$fa-var-ear-deaf: \\f2a4;\n$fa-var-deaf: \\f2a4;\n$fa-var-deafness: \\f2a4;\n$fa-var-hard-of-hearing: \\f2a4;\n$fa-var-road-circle-check: \\e564;\n$fa-var-dice-five: \\f523;\n$fa-var-square-rss: \\f143;\n$fa-var-rss-square: \\f143;\n$fa-var-land-mine-on: \\e51b;\n$fa-var-i-cursor: \\f246;\n$fa-var-stamp: \\f5bf;\n$fa-var-stairs: \\e289;\n$fa-var-i: \\49;\n$fa-var-hryvnia-sign: \\f6f2;\n$fa-var-hryvnia: \\f6f2;\n$fa-var-pills: \\f484;\n$fa-var-face-grin-wide: \\f581;\n$fa-var-grin-alt: \\f581;\n$fa-var-tooth: \\f5c9;\n$fa-var-v: \\56;\n$fa-var-bangladeshi-taka-sign: \\e2e6;\n$fa-var-bicycle: \\f206;\n$fa-var-staff-snake: \\e579;\n$fa-var-rod-asclepius: \\e579;\n$fa-var-rod-snake: \\e579;\n$fa-var-staff-aesculapius: \\e579;\n$fa-var-head-side-cough-slash: \\e062;\n$fa-var-truck-medical: \\f0f9;\n$fa-var-ambulance: \\f0f9;\n$fa-var-wheat-awn-circle-exclamation: \\e598;\n$fa-var-snowman: \\f7d0;\n$fa-var-mortar-pestle: \\f5a7;\n$fa-var-road-barrier: \\e562;\n$fa-var-school: \\f549;\n$fa-var-igloo: \\f7ae;\n$fa-var-joint: \\f595;\n$fa-var-angle-right: \\f105;\n$fa-var-horse: \\f6f0;\n$fa-var-q: \\51;\n$fa-var-g: \\47;\n$fa-var-notes-medical: \\f481;\n$fa-var-temperature-half: \\f2c9;\n$fa-var-temperature-2: \\f2c9;\n$fa-var-thermometer-2: \\f2c9;\n$fa-var-thermometer-half: \\f2c9;\n$fa-var-dong-sign: \\e169;\n$fa-var-capsules: \\f46b;\n$fa-var-poo-storm: \\f75a;\n$fa-var-poo-bolt: \\f75a;\n$fa-var-face-frown-open: \\f57a;\n$fa-var-frown-open: \\f57a;\n$fa-var-hand-point-up: \\f0a6;\n$fa-var-money-bill: \\f0d6;\n$fa-var-bookmark: \\f02e;\n$fa-var-align-justify: \\f039;\n$fa-var-umbrella-beach: \\f5ca;\n$fa-var-helmet-un: \\e503;\n$fa-var-bullseye: \\f140;\n$fa-var-bacon: \\f7e5;\n$fa-var-hand-point-down: \\f0a7;\n$fa-var-arrow-up-from-bracket: \\e09a;\n$fa-var-folder: \\f07b;\n$fa-var-folder-blank: \\f07b;\n$fa-var-file-waveform: \\f478;\n$fa-var-file-medical-alt: \\f478;\n$fa-var-radiation: \\f7b9;\n$fa-var-chart-simple: \\e473;\n$fa-var-mars-stroke: \\f229;\n$fa-var-vial: \\f492;\n$fa-var-gauge: \\f624;\n$fa-var-dashboard: \\f624;\n$fa-var-gauge-med: \\f624;\n$fa-var-tachometer-alt-average: \\f624;\n$fa-var-wand-magic-sparkles: \\e2ca;\n$fa-var-magic-wand-sparkles: \\e2ca;\n$fa-var-e: \\45;\n$fa-var-pen-clip: \\f305;\n$fa-var-pen-alt: \\f305;\n$fa-var-bridge-circle-exclamation: \\e4ca;\n$fa-var-user: \\f007;\n$fa-var-school-circle-check: \\e56b;\n$fa-var-dumpster: \\f793;\n$fa-var-van-shuttle: \\f5b6;\n$fa-var-shuttle-van: \\f5b6;\n$fa-var-building-user: \\e4da;\n$fa-var-square-caret-left: \\f191;\n$fa-var-caret-square-left: \\f191;\n$fa-var-highlighter: \\f591;\n$fa-var-key: \\f084;\n$fa-var-bullhorn: \\f0a1;\n$fa-var-globe: \\f0ac;\n$fa-var-synagogue: \\f69b;\n$fa-var-person-half-dress: \\e548;\n$fa-var-road-bridge: \\e563;\n$fa-var-location-arrow: \\f124;\n$fa-var-c: \\43;\n$fa-var-tablet-button: \\f10a;\n$fa-var-building-lock: \\e4d6;\n$fa-var-pizza-slice: \\f818;\n$fa-var-money-bill-wave: \\f53a;\n$fa-var-chart-area: \\f1fe;\n$fa-var-area-chart: \\f1fe;\n$fa-var-house-flag: \\e50d;\n$fa-var-person-circle-minus: \\e540;\n$fa-var-ban: \\f05e;\n$fa-var-cancel: \\f05e;\n$fa-var-camera-rotate: \\e0d8;\n$fa-var-spray-can-sparkles: \\f5d0;\n$fa-var-air-freshener: \\f5d0;\n$fa-var-star: \\f005;\n$fa-var-repeat: \\f363;\n$fa-var-cross: \\f654;\n$fa-var-box: \\f466;\n$fa-var-venus-mars: \\f228;\n$fa-var-arrow-pointer: \\f245;\n$fa-var-mouse-pointer: \\f245;\n$fa-var-maximize: \\f31e;\n$fa-var-expand-arrows-alt: \\f31e;\n$fa-var-charging-station: \\f5e7;\n$fa-var-shapes: \\f61f;\n$fa-var-triangle-circle-square: \\f61f;\n$fa-var-shuffle: \\f074;\n$fa-var-random: \\f074;\n$fa-var-person-running: \\f70c;\n$fa-var-running: \\f70c;\n$fa-var-mobile-retro: \\e527;\n$fa-var-grip-lines-vertical: \\f7a5;\n$fa-var-spider: \\f717;\n$fa-var-hands-bound: \\e4f9;\n$fa-var-file-invoice-dollar: \\f571;\n$fa-var-plane-circle-exclamation: \\e556;\n$fa-var-x-ray: \\f497;\n$fa-var-spell-check: \\f891;\n$fa-var-slash: \\f715;\n$fa-var-computer-mouse: \\f8cc;\n$fa-var-mouse: \\f8cc;\n$fa-var-arrow-right-to-bracket: \\f090;\n$fa-var-sign-in: \\f090;\n$fa-var-shop-slash: \\e070;\n$fa-var-store-alt-slash: \\e070;\n$fa-var-server: \\f233;\n$fa-var-virus-covid-slash: \\e4a9;\n$fa-var-shop-lock: \\e4a5;\n$fa-var-hourglass-start: \\f251;\n$fa-var-hourglass-1: \\f251;\n$fa-var-blender-phone: \\f6b6;\n$fa-var-building-wheat: \\e4db;\n$fa-var-person-breastfeeding: \\e53a;\n$fa-var-right-to-bracket: \\f2f6;\n$fa-var-sign-in-alt: \\f2f6;\n$fa-var-venus: \\f221;\n$fa-var-passport: \\f5ab;\n$fa-var-heart-pulse: \\f21e;\n$fa-var-heartbeat: \\f21e;\n$fa-var-people-carry-box: \\f4ce;\n$fa-var-people-carry: \\f4ce;\n$fa-var-temperature-high: \\f769;\n$fa-var-microchip: \\f2db;\n$fa-var-crown: \\f521;\n$fa-var-weight-hanging: \\f5cd;\n$fa-var-xmarks-lines: \\e59a;\n$fa-var-file-prescription: \\f572;\n$fa-var-weight-scale: \\f496;\n$fa-var-weight: \\f496;\n$fa-var-user-group: \\f500;\n$fa-var-user-friends: \\f500;\n$fa-var-arrow-up-a-z: \\f15e;\n$fa-var-sort-alpha-up: \\f15e;\n$fa-var-chess-knight: \\f441;\n$fa-var-face-laugh-squint: \\f59b;\n$fa-var-laugh-squint: \\f59b;\n$fa-var-wheelchair: \\f193;\n$fa-var-circle-arrow-up: \\f0aa;\n$fa-var-arrow-circle-up: \\f0aa;\n$fa-var-toggle-on: \\f205;\n$fa-var-person-walking: \\f554;\n$fa-var-walking: \\f554;\n$fa-var-l: \\4c;\n$fa-var-fire: \\f06d;\n$fa-var-bed-pulse: \\f487;\n$fa-var-procedures: \\f487;\n$fa-var-shuttle-space: \\f197;\n$fa-var-space-shuttle: \\f197;\n$fa-var-face-laugh: \\f599;\n$fa-var-laugh: \\f599;\n$fa-var-folder-open: \\f07c;\n$fa-var-heart-circle-plus: \\e500;\n$fa-var-code-fork: \\e13b;\n$fa-var-city: \\f64f;\n$fa-var-microphone-lines: \\f3c9;\n$fa-var-microphone-alt: \\f3c9;\n$fa-var-pepper-hot: \\f816;\n$fa-var-unlock: \\f09c;\n$fa-var-colon-sign: \\e140;\n$fa-var-headset: \\f590;\n$fa-var-store-slash: \\e071;\n$fa-var-road-circle-xmark: \\e566;\n$fa-var-user-minus: \\f503;\n$fa-var-mars-stroke-up: \\f22a;\n$fa-var-mars-stroke-v: \\f22a;\n$fa-var-champagne-glasses: \\f79f;\n$fa-var-glass-cheers: \\f79f;\n$fa-var-clipboard: \\f328;\n$fa-var-house-circle-exclamation: \\e50a;\n$fa-var-file-arrow-up: \\f574;\n$fa-var-file-upload: \\f574;\n$fa-var-wifi: \\f1eb;\n$fa-var-wifi-3: \\f1eb;\n$fa-var-wifi-strong: \\f1eb;\n$fa-var-bath: \\f2cd;\n$fa-var-bathtub: \\f2cd;\n$fa-var-underline: \\f0cd;\n$fa-var-user-pen: \\f4ff;\n$fa-var-user-edit: \\f4ff;\n$fa-var-signature: \\f5b7;\n$fa-var-stroopwafel: \\f551;\n$fa-var-bold: \\f032;\n$fa-var-anchor-lock: \\e4ad;\n$fa-var-building-ngo: \\e4d7;\n$fa-var-manat-sign: \\e1d5;\n$fa-var-not-equal: \\f53e;\n$fa-var-border-top-left: \\f853;\n$fa-var-border-style: \\f853;\n$fa-var-map-location-dot: \\f5a0;\n$fa-var-map-marked-alt: \\f5a0;\n$fa-var-jedi: \\f669;\n$fa-var-square-poll-vertical: \\f681;\n$fa-var-poll: \\f681;\n$fa-var-mug-hot: \\f7b6;\n$fa-var-car-battery: \\f5df;\n$fa-var-battery-car: \\f5df;\n$fa-var-gift: \\f06b;\n$fa-var-dice-two: \\f528;\n$fa-var-chess-queen: \\f445;\n$fa-var-glasses: \\f530;\n$fa-var-chess-board: \\f43c;\n$fa-var-building-circle-check: \\e4d2;\n$fa-var-person-chalkboard: \\e53d;\n$fa-var-mars-stroke-right: \\f22b;\n$fa-var-mars-stroke-h: \\f22b;\n$fa-var-hand-back-fist: \\f255;\n$fa-var-hand-rock: \\f255;\n$fa-var-square-caret-up: \\f151;\n$fa-var-caret-square-up: \\f151;\n$fa-var-cloud-showers-water: \\e4e4;\n$fa-var-chart-bar: \\f080;\n$fa-var-bar-chart: \\f080;\n$fa-var-hands-bubbles: \\e05e;\n$fa-var-hands-wash: \\e05e;\n$fa-var-less-than-equal: \\f537;\n$fa-var-train: \\f238;\n$fa-var-eye-low-vision: \\f2a8;\n$fa-var-low-vision: \\f2a8;\n$fa-var-crow: \\f520;\n$fa-var-sailboat: \\e445;\n$fa-var-window-restore: \\f2d2;\n$fa-var-square-plus: \\f0fe;\n$fa-var-plus-square: \\f0fe;\n$fa-var-torii-gate: \\f6a1;\n$fa-var-frog: \\f52e;\n$fa-var-bucket: \\e4cf;\n$fa-var-image: \\f03e;\n$fa-var-microphone: \\f130;\n$fa-var-cow: \\f6c8;\n$fa-var-caret-up: \\f0d8;\n$fa-var-screwdriver: \\f54a;\n$fa-var-folder-closed: \\e185;\n$fa-var-house-tsunami: \\e515;\n$fa-var-square-nfi: \\e576;\n$fa-var-arrow-up-from-ground-water: \\e4b5;\n$fa-var-martini-glass: \\f57b;\n$fa-var-glass-martini-alt: \\f57b;\n$fa-var-rotate-left: \\f2ea;\n$fa-var-rotate-back: \\f2ea;\n$fa-var-rotate-backward: \\f2ea;\n$fa-var-undo-alt: \\f2ea;\n$fa-var-table-columns: \\f0db;\n$fa-var-columns: \\f0db;\n$fa-var-lemon: \\f094;\n$fa-var-head-side-mask: \\e063;\n$fa-var-handshake: \\f2b5;\n$fa-var-gem: \\f3a5;\n$fa-var-dolly: \\f472;\n$fa-var-dolly-box: \\f472;\n$fa-var-smoking: \\f48d;\n$fa-var-minimize: \\f78c;\n$fa-var-compress-arrows-alt: \\f78c;\n$fa-var-monument: \\f5a6;\n$fa-var-snowplow: \\f7d2;\n$fa-var-angles-right: \\f101;\n$fa-var-angle-double-right: \\f101;\n$fa-var-cannabis: \\f55f;\n$fa-var-circle-play: \\f144;\n$fa-var-play-circle: \\f144;\n$fa-var-tablets: \\f490;\n$fa-var-ethernet: \\f796;\n$fa-var-euro-sign: \\f153;\n$fa-var-eur: \\f153;\n$fa-var-euro: \\f153;\n$fa-var-chair: \\f6c0;\n$fa-var-circle-check: \\f058;\n$fa-var-check-circle: \\f058;\n$fa-var-circle-stop: \\f28d;\n$fa-var-stop-circle: \\f28d;\n$fa-var-compass-drafting: \\f568;\n$fa-var-drafting-compass: \\f568;\n$fa-var-plate-wheat: \\e55a;\n$fa-var-icicles: \\f7ad;\n$fa-var-person-shelter: \\e54f;\n$fa-var-neuter: \\f22c;\n$fa-var-id-badge: \\f2c1;\n$fa-var-marker: \\f5a1;\n$fa-var-face-laugh-beam: \\f59a;\n$fa-var-laugh-beam: \\f59a;\n$fa-var-helicopter-symbol: \\e502;\n$fa-var-universal-access: \\f29a;\n$fa-var-circle-chevron-up: \\f139;\n$fa-var-chevron-circle-up: \\f139;\n$fa-var-lari-sign: \\e1c8;\n$fa-var-volcano: \\f770;\n$fa-var-person-walking-dashed-line-arrow-right: \\e553;\n$fa-var-sterling-sign: \\f154;\n$fa-var-gbp: \\f154;\n$fa-var-pound-sign: \\f154;\n$fa-var-viruses: \\e076;\n$fa-var-square-person-confined: \\e577;\n$fa-var-user-tie: \\f508;\n$fa-var-arrow-down-long: \\f175;\n$fa-var-long-arrow-down: \\f175;\n$fa-var-tent-arrow-down-to-line: \\e57e;\n$fa-var-certificate: \\f0a3;\n$fa-var-reply-all: \\f122;\n$fa-var-mail-reply-all: \\f122;\n$fa-var-suitcase: \\f0f2;\n$fa-var-person-skating: \\f7c5;\n$fa-var-skating: \\f7c5;\n$fa-var-filter-circle-dollar: \\f662;\n$fa-var-funnel-dollar: \\f662;\n$fa-var-camera-retro: \\f083;\n$fa-var-circle-arrow-down: \\f0ab;\n$fa-var-arrow-circle-down: \\f0ab;\n$fa-var-file-import: \\f56f;\n$fa-var-arrow-right-to-file: \\f56f;\n$fa-var-square-arrow-up-right: \\f14c;\n$fa-var-external-link-square: \\f14c;\n$fa-var-box-open: \\f49e;\n$fa-var-scroll: \\f70e;\n$fa-var-spa: \\f5bb;\n$fa-var-location-pin-lock: \\e51f;\n$fa-var-pause: \\f04c;\n$fa-var-hill-avalanche: \\e507;\n$fa-var-temperature-empty: \\f2cb;\n$fa-var-temperature-0: \\f2cb;\n$fa-var-thermometer-0: \\f2cb;\n$fa-var-thermometer-empty: \\f2cb;\n$fa-var-bomb: \\f1e2;\n$fa-var-registered: \\f25d;\n$fa-var-address-card: \\f2bb;\n$fa-var-contact-card: \\f2bb;\n$fa-var-vcard: \\f2bb;\n$fa-var-scale-unbalanced-flip: \\f516;\n$fa-var-balance-scale-right: \\f516;\n$fa-var-subscript: \\f12c;\n$fa-var-diamond-turn-right: \\f5eb;\n$fa-var-directions: \\f5eb;\n$fa-var-burst: \\e4dc;\n$fa-var-house-laptop: \\e066;\n$fa-var-laptop-house: \\e066;\n$fa-var-face-tired: \\f5c8;\n$fa-var-tired: \\f5c8;\n$fa-var-money-bills: \\e1f3;\n$fa-var-smog: \\f75f;\n$fa-var-crutch: \\f7f7;\n$fa-var-cloud-arrow-up: \\f0ee;\n$fa-var-cloud-upload: \\f0ee;\n$fa-var-cloud-upload-alt: \\f0ee;\n$fa-var-palette: \\f53f;\n$fa-var-arrows-turn-right: \\e4c0;\n$fa-var-vest: \\e085;\n$fa-var-ferry: \\e4ea;\n$fa-var-arrows-down-to-people: \\e4b9;\n$fa-var-seedling: \\f4d8;\n$fa-var-sprout: \\f4d8;\n$fa-var-left-right: \\f337;\n$fa-var-arrows-alt-h: \\f337;\n$fa-var-boxes-packing: \\e4c7;\n$fa-var-circle-arrow-left: \\f0a8;\n$fa-var-arrow-circle-left: \\f0a8;\n$fa-var-group-arrows-rotate: \\e4f6;\n$fa-var-bowl-food: \\e4c6;\n$fa-var-candy-cane: \\f786;\n$fa-var-arrow-down-wide-short: \\f160;\n$fa-var-sort-amount-asc: \\f160;\n$fa-var-sort-amount-down: \\f160;\n$fa-var-cloud-bolt: \\f76c;\n$fa-var-thunderstorm: \\f76c;\n$fa-var-text-slash: \\f87d;\n$fa-var-remove-format: \\f87d;\n$fa-var-face-smile-wink: \\f4da;\n$fa-var-smile-wink: \\f4da;\n$fa-var-file-word: \\f1c2;\n$fa-var-file-powerpoint: \\f1c4;\n$fa-var-arrows-left-right: \\f07e;\n$fa-var-arrows-h: \\f07e;\n$fa-var-house-lock: \\e510;\n$fa-var-cloud-arrow-down: \\f0ed;\n$fa-var-cloud-download: \\f0ed;\n$fa-var-cloud-download-alt: \\f0ed;\n$fa-var-children: \\e4e1;\n$fa-var-chalkboard: \\f51b;\n$fa-var-blackboard: \\f51b;\n$fa-var-user-large-slash: \\f4fa;\n$fa-var-user-alt-slash: \\f4fa;\n$fa-var-envelope-open: \\f2b6;\n$fa-var-handshake-simple-slash: \\e05f;\n$fa-var-handshake-alt-slash: \\e05f;\n$fa-var-mattress-pillow: \\e525;\n$fa-var-guarani-sign: \\e19a;\n$fa-var-arrows-rotate: \\f021;\n$fa-var-refresh: \\f021;\n$fa-var-sync: \\f021;\n$fa-var-fire-extinguisher: \\f134;\n$fa-var-cruzeiro-sign: \\e152;\n$fa-var-greater-than-equal: \\f532;\n$fa-var-shield-halved: \\f3ed;\n$fa-var-shield-alt: \\f3ed;\n$fa-var-book-atlas: \\f558;\n$fa-var-atlas: \\f558;\n$fa-var-virus: \\e074;\n$fa-var-envelope-circle-check: \\e4e8;\n$fa-var-layer-group: \\f5fd;\n$fa-var-arrows-to-dot: \\e4be;\n$fa-var-archway: \\f557;\n$fa-var-heart-circle-check: \\e4fd;\n$fa-var-house-chimney-crack: \\f6f1;\n$fa-var-house-damage: \\f6f1;\n$fa-var-file-zipper: \\f1c6;\n$fa-var-file-archive: \\f1c6;\n$fa-var-square: \\f0c8;\n$fa-var-martini-glass-empty: \\f000;\n$fa-var-glass-martini: \\f000;\n$fa-var-couch: \\f4b8;\n$fa-var-cedi-sign: \\e0df;\n$fa-var-italic: \\f033;\n$fa-var-table-cells-column-lock: \\e678;\n$fa-var-church: \\f51d;\n$fa-var-comments-dollar: \\f653;\n$fa-var-democrat: \\f747;\n$fa-var-z: \\5a;\n$fa-var-person-skiing: \\f7c9;\n$fa-var-skiing: \\f7c9;\n$fa-var-road-lock: \\e567;\n$fa-var-a: \\41;\n$fa-var-temperature-arrow-down: \\e03f;\n$fa-var-temperature-down: \\e03f;\n$fa-var-feather-pointed: \\f56b;\n$fa-var-feather-alt: \\f56b;\n$fa-var-p: \\50;\n$fa-var-snowflake: \\f2dc;\n$fa-var-newspaper: \\f1ea;\n$fa-var-rectangle-ad: \\f641;\n$fa-var-ad: \\f641;\n$fa-var-circle-arrow-right: \\f0a9;\n$fa-var-arrow-circle-right: \\f0a9;\n$fa-var-filter-circle-xmark: \\e17b;\n$fa-var-locust: \\e520;\n$fa-var-sort: \\f0dc;\n$fa-var-unsorted: \\f0dc;\n$fa-var-list-ol: \\f0cb;\n$fa-var-list-1-2: \\f0cb;\n$fa-var-list-numeric: \\f0cb;\n$fa-var-person-dress-burst: \\e544;\n$fa-var-money-check-dollar: \\f53d;\n$fa-var-money-check-alt: \\f53d;\n$fa-var-vector-square: \\f5cb;\n$fa-var-bread-slice: \\f7ec;\n$fa-var-language: \\f1ab;\n$fa-var-face-kiss-wink-heart: \\f598;\n$fa-var-kiss-wink-heart: \\f598;\n$fa-var-filter: \\f0b0;\n$fa-var-question: \\3f;\n$fa-var-file-signature: \\f573;\n$fa-var-up-down-left-right: \\f0b2;\n$fa-var-arrows-alt: \\f0b2;\n$fa-var-house-chimney-user: \\e065;\n$fa-var-hand-holding-heart: \\f4be;\n$fa-var-puzzle-piece: \\f12e;\n$fa-var-money-check: \\f53c;\n$fa-var-star-half-stroke: \\f5c0;\n$fa-var-star-half-alt: \\f5c0;\n$fa-var-code: \\f121;\n$fa-var-whiskey-glass: \\f7a0;\n$fa-var-glass-whiskey: \\f7a0;\n$fa-var-building-circle-exclamation: \\e4d3;\n$fa-var-magnifying-glass-chart: \\e522;\n$fa-var-arrow-up-right-from-square: \\f08e;\n$fa-var-external-link: \\f08e;\n$fa-var-cubes-stacked: \\e4e6;\n$fa-var-won-sign: \\f159;\n$fa-var-krw: \\f159;\n$fa-var-won: \\f159;\n$fa-var-virus-covid: \\e4a8;\n$fa-var-austral-sign: \\e0a9;\n$fa-var-f: \\46;\n$fa-var-leaf: \\f06c;\n$fa-var-road: \\f018;\n$fa-var-taxi: \\f1ba;\n$fa-var-cab: \\f1ba;\n$fa-var-person-circle-plus: \\e541;\n$fa-var-chart-pie: \\f200;\n$fa-var-pie-chart: \\f200;\n$fa-var-bolt-lightning: \\e0b7;\n$fa-var-sack-xmark: \\e56a;\n$fa-var-file-excel: \\f1c3;\n$fa-var-file-contract: \\f56c;\n$fa-var-fish-fins: \\e4f2;\n$fa-var-building-flag: \\e4d5;\n$fa-var-face-grin-beam: \\f582;\n$fa-var-grin-beam: \\f582;\n$fa-var-object-ungroup: \\f248;\n$fa-var-poop: \\f619;\n$fa-var-location-pin: \\f041;\n$fa-var-map-marker: \\f041;\n$fa-var-kaaba: \\f66b;\n$fa-var-toilet-paper: \\f71e;\n$fa-var-helmet-safety: \\f807;\n$fa-var-hard-hat: \\f807;\n$fa-var-hat-hard: \\f807;\n$fa-var-eject: \\f052;\n$fa-var-circle-right: \\f35a;\n$fa-var-arrow-alt-circle-right: \\f35a;\n$fa-var-plane-circle-check: \\e555;\n$fa-var-face-rolling-eyes: \\f5a5;\n$fa-var-meh-rolling-eyes: \\f5a5;\n$fa-var-object-group: \\f247;\n$fa-var-chart-line: \\f201;\n$fa-var-line-chart: \\f201;\n$fa-var-mask-ventilator: \\e524;\n$fa-var-arrow-right: \\f061;\n$fa-var-signs-post: \\f277;\n$fa-var-map-signs: \\f277;\n$fa-var-cash-register: \\f788;\n$fa-var-person-circle-question: \\e542;\n$fa-var-h: \\48;\n$fa-var-tarp: \\e57b;\n$fa-var-screwdriver-wrench: \\f7d9;\n$fa-var-tools: \\f7d9;\n$fa-var-arrows-to-eye: \\e4bf;\n$fa-var-plug-circle-bolt: \\e55b;\n$fa-var-heart: \\f004;\n$fa-var-mars-and-venus: \\f224;\n$fa-var-house-user: \\e1b0;\n$fa-var-home-user: \\e1b0;\n$fa-var-dumpster-fire: \\f794;\n$fa-var-house-crack: \\e3b1;\n$fa-var-martini-glass-citrus: \\f561;\n$fa-var-cocktail: \\f561;\n$fa-var-face-surprise: \\f5c2;\n$fa-var-surprise: \\f5c2;\n$fa-var-bottle-water: \\e4c5;\n$fa-var-circle-pause: \\f28b;\n$fa-var-pause-circle: \\f28b;\n$fa-var-toilet-paper-slash: \\e072;\n$fa-var-apple-whole: \\f5d1;\n$fa-var-apple-alt: \\f5d1;\n$fa-var-kitchen-set: \\e51a;\n$fa-var-r: \\52;\n$fa-var-temperature-quarter: \\f2ca;\n$fa-var-temperature-1: \\f2ca;\n$fa-var-thermometer-1: \\f2ca;\n$fa-var-thermometer-quarter: \\f2ca;\n$fa-var-cube: \\f1b2;\n$fa-var-bitcoin-sign: \\e0b4;\n$fa-var-shield-dog: \\e573;\n$fa-var-solar-panel: \\f5ba;\n$fa-var-lock-open: \\f3c1;\n$fa-var-elevator: \\e16d;\n$fa-var-money-bill-transfer: \\e528;\n$fa-var-money-bill-trend-up: \\e529;\n$fa-var-house-flood-water-circle-arrow-right: \\e50f;\n$fa-var-square-poll-horizontal: \\f682;\n$fa-var-poll-h: \\f682;\n$fa-var-circle: \\f111;\n$fa-var-backward-fast: \\f049;\n$fa-var-fast-backward: \\f049;\n$fa-var-recycle: \\f1b8;\n$fa-var-user-astronaut: \\f4fb;\n$fa-var-plane-slash: \\e069;\n$fa-var-trademark: \\f25c;\n$fa-var-basketball: \\f434;\n$fa-var-basketball-ball: \\f434;\n$fa-var-satellite-dish: \\f7c0;\n$fa-var-circle-up: \\f35b;\n$fa-var-arrow-alt-circle-up: \\f35b;\n$fa-var-mobile-screen-button: \\f3cd;\n$fa-var-mobile-alt: \\f3cd;\n$fa-var-volume-high: \\f028;\n$fa-var-volume-up: \\f028;\n$fa-var-users-rays: \\e593;\n$fa-var-wallet: \\f555;\n$fa-var-clipboard-check: \\f46c;\n$fa-var-file-audio: \\f1c7;\n$fa-var-burger: \\f805;\n$fa-var-hamburger: \\f805;\n$fa-var-wrench: \\f0ad;\n$fa-var-bugs: \\e4d0;\n$fa-var-rupee-sign: \\f156;\n$fa-var-rupee: \\f156;\n$fa-var-file-image: \\f1c5;\n$fa-var-circle-question: \\f059;\n$fa-var-question-circle: \\f059;\n$fa-var-plane-departure: \\f5b0;\n$fa-var-handshake-slash: \\e060;\n$fa-var-book-bookmark: \\e0bb;\n$fa-var-code-branch: \\f126;\n$fa-var-hat-cowboy: \\f8c0;\n$fa-var-bridge: \\e4c8;\n$fa-var-phone-flip: \\f879;\n$fa-var-phone-alt: \\f879;\n$fa-var-truck-front: \\e2b7;\n$fa-var-cat: \\f6be;\n$fa-var-anchor-circle-exclamation: \\e4ab;\n$fa-var-truck-field: \\e58d;\n$fa-var-route: \\f4d7;\n$fa-var-clipboard-question: \\e4e3;\n$fa-var-panorama: \\e209;\n$fa-var-comment-medical: \\f7f5;\n$fa-var-teeth-open: \\f62f;\n$fa-var-file-circle-minus: \\e4ed;\n$fa-var-tags: \\f02c;\n$fa-var-wine-glass: \\f4e3;\n$fa-var-forward-fast: \\f050;\n$fa-var-fast-forward: \\f050;\n$fa-var-face-meh-blank: \\f5a4;\n$fa-var-meh-blank: \\f5a4;\n$fa-var-square-parking: \\f540;\n$fa-var-parking: \\f540;\n$fa-var-house-signal: \\e012;\n$fa-var-bars-progress: \\f828;\n$fa-var-tasks-alt: \\f828;\n$fa-var-faucet-drip: \\e006;\n$fa-var-cart-flatbed: \\f474;\n$fa-var-dolly-flatbed: \\f474;\n$fa-var-ban-smoking: \\f54d;\n$fa-var-smoking-ban: \\f54d;\n$fa-var-terminal: \\f120;\n$fa-var-mobile-button: \\f10b;\n$fa-var-house-medical-flag: \\e514;\n$fa-var-basket-shopping: \\f291;\n$fa-var-shopping-basket: \\f291;\n$fa-var-tape: \\f4db;\n$fa-var-bus-simple: \\f55e;\n$fa-var-bus-alt: \\f55e;\n$fa-var-eye: \\f06e;\n$fa-var-face-sad-cry: \\f5b3;\n$fa-var-sad-cry: \\f5b3;\n$fa-var-audio-description: \\f29e;\n$fa-var-person-military-to-person: \\e54c;\n$fa-var-file-shield: \\e4f0;\n$fa-var-user-slash: \\f506;\n$fa-var-pen: \\f304;\n$fa-var-tower-observation: \\e586;\n$fa-var-file-code: \\f1c9;\n$fa-var-signal: \\f012;\n$fa-var-signal-5: \\f012;\n$fa-var-signal-perfect: \\f012;\n$fa-var-bus: \\f207;\n$fa-var-heart-circle-xmark: \\e501;\n$fa-var-house-chimney: \\e3af;\n$fa-var-home-lg: \\e3af;\n$fa-var-window-maximize: \\f2d0;\n$fa-var-face-frown: \\f119;\n$fa-var-frown: \\f119;\n$fa-var-prescription: \\f5b1;\n$fa-var-shop: \\f54f;\n$fa-var-store-alt: \\f54f;\n$fa-var-floppy-disk: \\f0c7;\n$fa-var-save: \\f0c7;\n$fa-var-vihara: \\f6a7;\n$fa-var-scale-unbalanced: \\f515;\n$fa-var-balance-scale-left: \\f515;\n$fa-var-sort-up: \\f0de;\n$fa-var-sort-asc: \\f0de;\n$fa-var-comment-dots: \\f4ad;\n$fa-var-commenting: \\f4ad;\n$fa-var-plant-wilt: \\e5aa;\n$fa-var-diamond: \\f219;\n$fa-var-face-grin-squint: \\f585;\n$fa-var-grin-squint: \\f585;\n$fa-var-hand-holding-dollar: \\f4c0;\n$fa-var-hand-holding-usd: \\f4c0;\n$fa-var-bacterium: \\e05a;\n$fa-var-hand-pointer: \\f25a;\n$fa-var-drum-steelpan: \\f56a;\n$fa-var-hand-scissors: \\f257;\n$fa-var-hands-praying: \\f684;\n$fa-var-praying-hands: \\f684;\n$fa-var-arrow-rotate-right: \\f01e;\n$fa-var-arrow-right-rotate: \\f01e;\n$fa-var-arrow-rotate-forward: \\f01e;\n$fa-var-redo: \\f01e;\n$fa-var-biohazard: \\f780;\n$fa-var-location-crosshairs: \\f601;\n$fa-var-location: \\f601;\n$fa-var-mars-double: \\f227;\n$fa-var-child-dress: \\e59c;\n$fa-var-users-between-lines: \\e591;\n$fa-var-lungs-virus: \\e067;\n$fa-var-face-grin-tears: \\f588;\n$fa-var-grin-tears: \\f588;\n$fa-var-phone: \\f095;\n$fa-var-calendar-xmark: \\f273;\n$fa-var-calendar-times: \\f273;\n$fa-var-child-reaching: \\e59d;\n$fa-var-head-side-virus: \\e064;\n$fa-var-user-gear: \\f4fe;\n$fa-var-user-cog: \\f4fe;\n$fa-var-arrow-up-1-9: \\f163;\n$fa-var-sort-numeric-up: \\f163;\n$fa-var-door-closed: \\f52a;\n$fa-var-shield-virus: \\e06c;\n$fa-var-dice-six: \\f526;\n$fa-var-mosquito-net: \\e52c;\n$fa-var-bridge-water: \\e4ce;\n$fa-var-person-booth: \\f756;\n$fa-var-text-width: \\f035;\n$fa-var-hat-wizard: \\f6e8;\n$fa-var-pen-fancy: \\f5ac;\n$fa-var-person-digging: \\f85e;\n$fa-var-digging: \\f85e;\n$fa-var-trash: \\f1f8;\n$fa-var-gauge-simple: \\f629;\n$fa-var-gauge-simple-med: \\f629;\n$fa-var-tachometer-average: \\f629;\n$fa-var-book-medical: \\f7e6;\n$fa-var-poo: \\f2fe;\n$fa-var-quote-right: \\f10e;\n$fa-var-quote-right-alt: \\f10e;\n$fa-var-shirt: \\f553;\n$fa-var-t-shirt: \\f553;\n$fa-var-tshirt: \\f553;\n$fa-var-cubes: \\f1b3;\n$fa-var-divide: \\f529;\n$fa-var-tenge-sign: \\f7d7;\n$fa-var-tenge: \\f7d7;\n$fa-var-headphones: \\f025;\n$fa-var-hands-holding: \\f4c2;\n$fa-var-hands-clapping: \\e1a8;\n$fa-var-republican: \\f75e;\n$fa-var-arrow-left: \\f060;\n$fa-var-person-circle-xmark: \\e543;\n$fa-var-ruler: \\f545;\n$fa-var-align-left: \\f036;\n$fa-var-dice-d6: \\f6d1;\n$fa-var-restroom: \\f7bd;\n$fa-var-j: \\4a;\n$fa-var-users-viewfinder: \\e595;\n$fa-var-file-video: \\f1c8;\n$fa-var-up-right-from-square: \\f35d;\n$fa-var-external-link-alt: \\f35d;\n$fa-var-table-cells: \\f00a;\n$fa-var-th: \\f00a;\n$fa-var-file-pdf: \\f1c1;\n$fa-var-book-bible: \\f647;\n$fa-var-bible: \\f647;\n$fa-var-o: \\4f;\n$fa-var-suitcase-medical: \\f0fa;\n$fa-var-medkit: \\f0fa;\n$fa-var-user-secret: \\f21b;\n$fa-var-otter: \\f700;\n$fa-var-person-dress: \\f182;\n$fa-var-female: \\f182;\n$fa-var-comment-dollar: \\f651;\n$fa-var-business-time: \\f64a;\n$fa-var-briefcase-clock: \\f64a;\n$fa-var-table-cells-large: \\f009;\n$fa-var-th-large: \\f009;\n$fa-var-book-tanakh: \\f827;\n$fa-var-tanakh: \\f827;\n$fa-var-phone-volume: \\f2a0;\n$fa-var-volume-control-phone: \\f2a0;\n$fa-var-hat-cowboy-side: \\f8c1;\n$fa-var-clipboard-user: \\f7f3;\n$fa-var-child: \\f1ae;\n$fa-var-lira-sign: \\f195;\n$fa-var-satellite: \\f7bf;\n$fa-var-plane-lock: \\e558;\n$fa-var-tag: \\f02b;\n$fa-var-comment: \\f075;\n$fa-var-cake-candles: \\f1fd;\n$fa-var-birthday-cake: \\f1fd;\n$fa-var-cake: \\f1fd;\n$fa-var-envelope: \\f0e0;\n$fa-var-angles-up: \\f102;\n$fa-var-angle-double-up: \\f102;\n$fa-var-paperclip: \\f0c6;\n$fa-var-arrow-right-to-city: \\e4b3;\n$fa-var-ribbon: \\f4d6;\n$fa-var-lungs: \\f604;\n$fa-var-arrow-up-9-1: \\f887;\n$fa-var-sort-numeric-up-alt: \\f887;\n$fa-var-litecoin-sign: \\e1d3;\n$fa-var-border-none: \\f850;\n$fa-var-circle-nodes: \\e4e2;\n$fa-var-parachute-box: \\f4cd;\n$fa-var-indent: \\f03c;\n$fa-var-truck-field-un: \\e58e;\n$fa-var-hourglass: \\f254;\n$fa-var-hourglass-empty: \\f254;\n$fa-var-mountain: \\f6fc;\n$fa-var-user-doctor: \\f0f0;\n$fa-var-user-md: \\f0f0;\n$fa-var-circle-info: \\f05a;\n$fa-var-info-circle: \\f05a;\n$fa-var-cloud-meatball: \\f73b;\n$fa-var-camera: \\f030;\n$fa-var-camera-alt: \\f030;\n$fa-var-square-virus: \\e578;\n$fa-var-meteor: \\f753;\n$fa-var-car-on: \\e4dd;\n$fa-var-sleigh: \\f7cc;\n$fa-var-arrow-down-1-9: \\f162;\n$fa-var-sort-numeric-asc: \\f162;\n$fa-var-sort-numeric-down: \\f162;\n$fa-var-hand-holding-droplet: \\f4c1;\n$fa-var-hand-holding-water: \\f4c1;\n$fa-var-water: \\f773;\n$fa-var-calendar-check: \\f274;\n$fa-var-braille: \\f2a1;\n$fa-var-prescription-bottle-medical: \\f486;\n$fa-var-prescription-bottle-alt: \\f486;\n$fa-var-landmark: \\f66f;\n$fa-var-truck: \\f0d1;\n$fa-var-crosshairs: \\f05b;\n$fa-var-person-cane: \\e53c;\n$fa-var-tent: \\e57d;\n$fa-var-vest-patches: \\e086;\n$fa-var-check-double: \\f560;\n$fa-var-arrow-down-a-z: \\f15d;\n$fa-var-sort-alpha-asc: \\f15d;\n$fa-var-sort-alpha-down: \\f15d;\n$fa-var-money-bill-wheat: \\e52a;\n$fa-var-cookie: \\f563;\n$fa-var-arrow-rotate-left: \\f0e2;\n$fa-var-arrow-left-rotate: \\f0e2;\n$fa-var-arrow-rotate-back: \\f0e2;\n$fa-var-arrow-rotate-backward: \\f0e2;\n$fa-var-undo: \\f0e2;\n$fa-var-hard-drive: \\f0a0;\n$fa-var-hdd: \\f0a0;\n$fa-var-face-grin-squint-tears: \\f586;\n$fa-var-grin-squint-tears: \\f586;\n$fa-var-dumbbell: \\f44b;\n$fa-var-rectangle-list: \\f022;\n$fa-var-list-alt: \\f022;\n$fa-var-tarp-droplet: \\e57c;\n$fa-var-house-medical-circle-check: \\e511;\n$fa-var-person-skiing-nordic: \\f7ca;\n$fa-var-skiing-nordic: \\f7ca;\n$fa-var-calendar-plus: \\f271;\n$fa-var-plane-arrival: \\f5af;\n$fa-var-circle-left: \\f359;\n$fa-var-arrow-alt-circle-left: \\f359;\n$fa-var-train-subway: \\f239;\n$fa-var-subway: \\f239;\n$fa-var-chart-gantt: \\e0e4;\n$fa-var-indian-rupee-sign: \\e1bc;\n$fa-var-indian-rupee: \\e1bc;\n$fa-var-inr: \\e1bc;\n$fa-var-crop-simple: \\f565;\n$fa-var-crop-alt: \\f565;\n$fa-var-money-bill-1: \\f3d1;\n$fa-var-money-bill-alt: \\f3d1;\n$fa-var-left-long: \\f30a;\n$fa-var-long-arrow-alt-left: \\f30a;\n$fa-var-dna: \\f471;\n$fa-var-virus-slash: \\e075;\n$fa-var-minus: \\f068;\n$fa-var-subtract: \\f068;\n$fa-var-chess: \\f439;\n$fa-var-arrow-left-long: \\f177;\n$fa-var-long-arrow-left: \\f177;\n$fa-var-plug-circle-check: \\e55c;\n$fa-var-street-view: \\f21d;\n$fa-var-franc-sign: \\e18f;\n$fa-var-volume-off: \\f026;\n$fa-var-hands-asl-interpreting: \\f2a3;\n$fa-var-american-sign-language-interpreting: \\f2a3;\n$fa-var-asl-interpreting: \\f2a3;\n$fa-var-hands-american-sign-language-interpreting: \\f2a3;\n$fa-var-gear: \\f013;\n$fa-var-cog: \\f013;\n$fa-var-droplet-slash: \\f5c7;\n$fa-var-tint-slash: \\f5c7;\n$fa-var-mosque: \\f678;\n$fa-var-mosquito: \\e52b;\n$fa-var-star-of-david: \\f69a;\n$fa-var-person-military-rifle: \\e54b;\n$fa-var-cart-shopping: \\f07a;\n$fa-var-shopping-cart: \\f07a;\n$fa-var-vials: \\f493;\n$fa-var-plug-circle-plus: \\e55f;\n$fa-var-place-of-worship: \\f67f;\n$fa-var-grip-vertical: \\f58e;\n$fa-var-arrow-turn-up: \\f148;\n$fa-var-level-up: \\f148;\n$fa-var-u: \\55;\n$fa-var-square-root-variable: \\f698;\n$fa-var-square-root-alt: \\f698;\n$fa-var-clock: \\f017;\n$fa-var-clock-four: \\f017;\n$fa-var-backward-step: \\f048;\n$fa-var-step-backward: \\f048;\n$fa-var-pallet: \\f482;\n$fa-var-faucet: \\e005;\n$fa-var-baseball-bat-ball: \\f432;\n$fa-var-s: \\53;\n$fa-var-timeline: \\e29c;\n$fa-var-keyboard: \\f11c;\n$fa-var-caret-down: \\f0d7;\n$fa-var-house-chimney-medical: \\f7f2;\n$fa-var-clinic-medical: \\f7f2;\n$fa-var-temperature-three-quarters: \\f2c8;\n$fa-var-temperature-3: \\f2c8;\n$fa-var-thermometer-3: \\f2c8;\n$fa-var-thermometer-three-quarters: \\f2c8;\n$fa-var-mobile-screen: \\f3cf;\n$fa-var-mobile-android-alt: \\f3cf;\n$fa-var-plane-up: \\e22d;\n$fa-var-piggy-bank: \\f4d3;\n$fa-var-battery-half: \\f242;\n$fa-var-battery-3: \\f242;\n$fa-var-mountain-city: \\e52e;\n$fa-var-coins: \\f51e;\n$fa-var-khanda: \\f66d;\n$fa-var-sliders: \\f1de;\n$fa-var-sliders-h: \\f1de;\n$fa-var-folder-tree: \\f802;\n$fa-var-network-wired: \\f6ff;\n$fa-var-map-pin: \\f276;\n$fa-var-hamsa: \\f665;\n$fa-var-cent-sign: \\e3f5;\n$fa-var-flask: \\f0c3;\n$fa-var-person-pregnant: \\e31e;\n$fa-var-wand-sparkles: \\f72b;\n$fa-var-ellipsis-vertical: \\f142;\n$fa-var-ellipsis-v: \\f142;\n$fa-var-ticket: \\f145;\n$fa-var-power-off: \\f011;\n$fa-var-right-long: \\f30b;\n$fa-var-long-arrow-alt-right: \\f30b;\n$fa-var-flag-usa: \\f74d;\n$fa-var-laptop-file: \\e51d;\n$fa-var-tty: \\f1e4;\n$fa-var-teletype: \\f1e4;\n$fa-var-diagram-next: \\e476;\n$fa-var-person-rifle: \\e54e;\n$fa-var-house-medical-circle-exclamation: \\e512;\n$fa-var-closed-captioning: \\f20a;\n$fa-var-person-hiking: \\f6ec;\n$fa-var-hiking: \\f6ec;\n$fa-var-venus-double: \\f226;\n$fa-var-images: \\f302;\n$fa-var-calculator: \\f1ec;\n$fa-var-people-pulling: \\e535;\n$fa-var-n: \\4e;\n$fa-var-cable-car: \\f7da;\n$fa-var-tram: \\f7da;\n$fa-var-cloud-rain: \\f73d;\n$fa-var-building-circle-xmark: \\e4d4;\n$fa-var-ship: \\f21a;\n$fa-var-arrows-down-to-line: \\e4b8;\n$fa-var-download: \\f019;\n$fa-var-face-grin: \\f580;\n$fa-var-grin: \\f580;\n$fa-var-delete-left: \\f55a;\n$fa-var-backspace: \\f55a;\n$fa-var-eye-dropper: \\f1fb;\n$fa-var-eye-dropper-empty: \\f1fb;\n$fa-var-eyedropper: \\f1fb;\n$fa-var-file-circle-check: \\e5a0;\n$fa-var-forward: \\f04e;\n$fa-var-mobile: \\f3ce;\n$fa-var-mobile-android: \\f3ce;\n$fa-var-mobile-phone: \\f3ce;\n$fa-var-face-meh: \\f11a;\n$fa-var-meh: \\f11a;\n$fa-var-align-center: \\f037;\n$fa-var-book-skull: \\f6b7;\n$fa-var-book-dead: \\f6b7;\n$fa-var-id-card: \\f2c2;\n$fa-var-drivers-license: \\f2c2;\n$fa-var-outdent: \\f03b;\n$fa-var-dedent: \\f03b;\n$fa-var-heart-circle-exclamation: \\e4fe;\n$fa-var-house: \\f015;\n$fa-var-home: \\f015;\n$fa-var-home-alt: \\f015;\n$fa-var-home-lg-alt: \\f015;\n$fa-var-calendar-week: \\f784;\n$fa-var-laptop-medical: \\f812;\n$fa-var-b: \\42;\n$fa-var-file-medical: \\f477;\n$fa-var-dice-one: \\f525;\n$fa-var-kiwi-bird: \\f535;\n$fa-var-arrow-right-arrow-left: \\f0ec;\n$fa-var-exchange: \\f0ec;\n$fa-var-rotate-right: \\f2f9;\n$fa-var-redo-alt: \\f2f9;\n$fa-var-rotate-forward: \\f2f9;\n$fa-var-utensils: \\f2e7;\n$fa-var-cutlery: \\f2e7;\n$fa-var-arrow-up-wide-short: \\f161;\n$fa-var-sort-amount-up: \\f161;\n$fa-var-mill-sign: \\e1ed;\n$fa-var-bowl-rice: \\e2eb;\n$fa-var-skull: \\f54c;\n$fa-var-tower-broadcast: \\f519;\n$fa-var-broadcast-tower: \\f519;\n$fa-var-truck-pickup: \\f63c;\n$fa-var-up-long: \\f30c;\n$fa-var-long-arrow-alt-up: \\f30c;\n$fa-var-stop: \\f04d;\n$fa-var-code-merge: \\f387;\n$fa-var-upload: \\f093;\n$fa-var-hurricane: \\f751;\n$fa-var-mound: \\e52d;\n$fa-var-toilet-portable: \\e583;\n$fa-var-compact-disc: \\f51f;\n$fa-var-file-arrow-down: \\f56d;\n$fa-var-file-download: \\f56d;\n$fa-var-caravan: \\f8ff;\n$fa-var-shield-cat: \\e572;\n$fa-var-bolt: \\f0e7;\n$fa-var-zap: \\f0e7;\n$fa-var-glass-water: \\e4f4;\n$fa-var-oil-well: \\e532;\n$fa-var-vault: \\e2c5;\n$fa-var-mars: \\f222;\n$fa-var-toilet: \\f7d8;\n$fa-var-plane-circle-xmark: \\e557;\n$fa-var-yen-sign: \\f157;\n$fa-var-cny: \\f157;\n$fa-var-jpy: \\f157;\n$fa-var-rmb: \\f157;\n$fa-var-yen: \\f157;\n$fa-var-ruble-sign: \\f158;\n$fa-var-rouble: \\f158;\n$fa-var-rub: \\f158;\n$fa-var-ruble: \\f158;\n$fa-var-sun: \\f185;\n$fa-var-guitar: \\f7a6;\n$fa-var-face-laugh-wink: \\f59c;\n$fa-var-laugh-wink: \\f59c;\n$fa-var-horse-head: \\f7ab;\n$fa-var-bore-hole: \\e4c3;\n$fa-var-industry: \\f275;\n$fa-var-circle-down: \\f358;\n$fa-var-arrow-alt-circle-down: \\f358;\n$fa-var-arrows-turn-to-dots: \\e4c1;\n$fa-var-florin-sign: \\e184;\n$fa-var-arrow-down-short-wide: \\f884;\n$fa-var-sort-amount-desc: \\f884;\n$fa-var-sort-amount-down-alt: \\f884;\n$fa-var-less-than: \\3c;\n$fa-var-angle-down: \\f107;\n$fa-var-car-tunnel: \\e4de;\n$fa-var-head-side-cough: \\e061;\n$fa-var-grip-lines: \\f7a4;\n$fa-var-thumbs-down: \\f165;\n$fa-var-user-lock: \\f502;\n$fa-var-arrow-right-long: \\f178;\n$fa-var-long-arrow-right: \\f178;\n$fa-var-anchor-circle-xmark: \\e4ac;\n$fa-var-ellipsis: \\f141;\n$fa-var-ellipsis-h: \\f141;\n$fa-var-chess-pawn: \\f443;\n$fa-var-kit-medical: \\f479;\n$fa-var-first-aid: \\f479;\n$fa-var-person-through-window: \\e5a9;\n$fa-var-toolbox: \\f552;\n$fa-var-hands-holding-circle: \\e4fb;\n$fa-var-bug: \\f188;\n$fa-var-credit-card: \\f09d;\n$fa-var-credit-card-alt: \\f09d;\n$fa-var-car: \\f1b9;\n$fa-var-automobile: \\f1b9;\n$fa-var-hand-holding-hand: \\e4f7;\n$fa-var-book-open-reader: \\f5da;\n$fa-var-book-reader: \\f5da;\n$fa-var-mountain-sun: \\e52f;\n$fa-var-arrows-left-right-to-line: \\e4ba;\n$fa-var-dice-d20: \\f6cf;\n$fa-var-truck-droplet: \\e58c;\n$fa-var-file-circle-xmark: \\e5a1;\n$fa-var-temperature-arrow-up: \\e040;\n$fa-var-temperature-up: \\e040;\n$fa-var-medal: \\f5a2;\n$fa-var-bed: \\f236;\n$fa-var-square-h: \\f0fd;\n$fa-var-h-square: \\f0fd;\n$fa-var-podcast: \\f2ce;\n$fa-var-temperature-full: \\f2c7;\n$fa-var-temperature-4: \\f2c7;\n$fa-var-thermometer-4: \\f2c7;\n$fa-var-thermometer-full: \\f2c7;\n$fa-var-bell: \\f0f3;\n$fa-var-superscript: \\f12b;\n$fa-var-plug-circle-xmark: \\e560;\n$fa-var-star-of-life: \\f621;\n$fa-var-phone-slash: \\f3dd;\n$fa-var-paint-roller: \\f5aa;\n$fa-var-handshake-angle: \\f4c4;\n$fa-var-hands-helping: \\f4c4;\n$fa-var-location-dot: \\f3c5;\n$fa-var-map-marker-alt: \\f3c5;\n$fa-var-file: \\f15b;\n$fa-var-greater-than: \\3e;\n$fa-var-person-swimming: \\f5c4;\n$fa-var-swimmer: \\f5c4;\n$fa-var-arrow-down: \\f063;\n$fa-var-droplet: \\f043;\n$fa-var-tint: \\f043;\n$fa-var-eraser: \\f12d;\n$fa-var-earth-americas: \\f57d;\n$fa-var-earth: \\f57d;\n$fa-var-earth-america: \\f57d;\n$fa-var-globe-americas: \\f57d;\n$fa-var-person-burst: \\e53b;\n$fa-var-dove: \\f4ba;\n$fa-var-battery-empty: \\f244;\n$fa-var-battery-0: \\f244;\n$fa-var-socks: \\f696;\n$fa-var-inbox: \\f01c;\n$fa-var-section: \\e447;\n$fa-var-gauge-high: \\f625;\n$fa-var-tachometer-alt: \\f625;\n$fa-var-tachometer-alt-fast: \\f625;\n$fa-var-envelope-open-text: \\f658;\n$fa-var-hospital: \\f0f8;\n$fa-var-hospital-alt: \\f0f8;\n$fa-var-hospital-wide: \\f0f8;\n$fa-var-wine-bottle: \\f72f;\n$fa-var-chess-rook: \\f447;\n$fa-var-bars-staggered: \\f550;\n$fa-var-reorder: \\f550;\n$fa-var-stream: \\f550;\n$fa-var-dharmachakra: \\f655;\n$fa-var-hotdog: \\f80f;\n$fa-var-person-walking-with-cane: \\f29d;\n$fa-var-blind: \\f29d;\n$fa-var-drum: \\f569;\n$fa-var-ice-cream: \\f810;\n$fa-var-heart-circle-bolt: \\e4fc;\n$fa-var-fax: \\f1ac;\n$fa-var-paragraph: \\f1dd;\n$fa-var-check-to-slot: \\f772;\n$fa-var-vote-yea: \\f772;\n$fa-var-star-half: \\f089;\n$fa-var-boxes-stacked: \\f468;\n$fa-var-boxes: \\f468;\n$fa-var-boxes-alt: \\f468;\n$fa-var-link: \\f0c1;\n$fa-var-chain: \\f0c1;\n$fa-var-ear-listen: \\f2a2;\n$fa-var-assistive-listening-systems: \\f2a2;\n$fa-var-tree-city: \\e587;\n$fa-var-play: \\f04b;\n$fa-var-font: \\f031;\n$fa-var-table-cells-row-lock: \\e67a;\n$fa-var-rupiah-sign: \\e23d;\n$fa-var-magnifying-glass: \\f002;\n$fa-var-search: \\f002;\n$fa-var-table-tennis-paddle-ball: \\f45d;\n$fa-var-ping-pong-paddle-ball: \\f45d;\n$fa-var-table-tennis: \\f45d;\n$fa-var-person-dots-from-line: \\f470;\n$fa-var-diagnoses: \\f470;\n$fa-var-trash-can-arrow-up: \\f82a;\n$fa-var-trash-restore-alt: \\f82a;\n$fa-var-naira-sign: \\e1f6;\n$fa-var-cart-arrow-down: \\f218;\n$fa-var-walkie-talkie: \\f8ef;\n$fa-var-file-pen: \\f31c;\n$fa-var-file-edit: \\f31c;\n$fa-var-receipt: \\f543;\n$fa-var-square-pen: \\f14b;\n$fa-var-pen-square: \\f14b;\n$fa-var-pencil-square: \\f14b;\n$fa-var-suitcase-rolling: \\f5c1;\n$fa-var-person-circle-exclamation: \\e53f;\n$fa-var-chevron-down: \\f078;\n$fa-var-battery-full: \\f240;\n$fa-var-battery: \\f240;\n$fa-var-battery-5: \\f240;\n$fa-var-skull-crossbones: \\f714;\n$fa-var-code-compare: \\e13a;\n$fa-var-list-ul: \\f0ca;\n$fa-var-list-dots: \\f0ca;\n$fa-var-school-lock: \\e56f;\n$fa-var-tower-cell: \\e585;\n$fa-var-down-long: \\f309;\n$fa-var-long-arrow-alt-down: \\f309;\n$fa-var-ranking-star: \\e561;\n$fa-var-chess-king: \\f43f;\n$fa-var-person-harassing: \\e549;\n$fa-var-brazilian-real-sign: \\e46c;\n$fa-var-landmark-dome: \\f752;\n$fa-var-landmark-alt: \\f752;\n$fa-var-arrow-up: \\f062;\n$fa-var-tv: \\f26c;\n$fa-var-television: \\f26c;\n$fa-var-tv-alt: \\f26c;\n$fa-var-shrimp: \\e448;\n$fa-var-list-check: \\f0ae;\n$fa-var-tasks: \\f0ae;\n$fa-var-jug-detergent: \\e519;\n$fa-var-circle-user: \\f2bd;\n$fa-var-user-circle: \\f2bd;\n$fa-var-user-shield: \\f505;\n$fa-var-wind: \\f72e;\n$fa-var-car-burst: \\f5e1;\n$fa-var-car-crash: \\f5e1;\n$fa-var-y: \\59;\n$fa-var-person-snowboarding: \\f7ce;\n$fa-var-snowboarding: \\f7ce;\n$fa-var-truck-fast: \\f48b;\n$fa-var-shipping-fast: \\f48b;\n$fa-var-fish: \\f578;\n$fa-var-user-graduate: \\f501;\n$fa-var-circle-half-stroke: \\f042;\n$fa-var-adjust: \\f042;\n$fa-var-clapperboard: \\e131;\n$fa-var-circle-radiation: \\f7ba;\n$fa-var-radiation-alt: \\f7ba;\n$fa-var-baseball: \\f433;\n$fa-var-baseball-ball: \\f433;\n$fa-var-jet-fighter-up: \\e518;\n$fa-var-diagram-project: \\f542;\n$fa-var-project-diagram: \\f542;\n$fa-var-copy: \\f0c5;\n$fa-var-volume-xmark: \\f6a9;\n$fa-var-volume-mute: \\f6a9;\n$fa-var-volume-times: \\f6a9;\n$fa-var-hand-sparkles: \\e05d;\n$fa-var-grip: \\f58d;\n$fa-var-grip-horizontal: \\f58d;\n$fa-var-share-from-square: \\f14d;\n$fa-var-share-square: \\f14d;\n$fa-var-child-combatant: \\e4e0;\n$fa-var-child-rifle: \\e4e0;\n$fa-var-gun: \\e19b;\n$fa-var-square-phone: \\f098;\n$fa-var-phone-square: \\f098;\n$fa-var-plus: \\2b;\n$fa-var-add: \\2b;\n$fa-var-expand: \\f065;\n$fa-var-computer: \\e4e5;\n$fa-var-xmark: \\f00d;\n$fa-var-close: \\f00d;\n$fa-var-multiply: \\f00d;\n$fa-var-remove: \\f00d;\n$fa-var-times: \\f00d;\n$fa-var-arrows-up-down-left-right: \\f047;\n$fa-var-arrows: \\f047;\n$fa-var-chalkboard-user: \\f51c;\n$fa-var-chalkboard-teacher: \\f51c;\n$fa-var-peso-sign: \\e222;\n$fa-var-building-shield: \\e4d8;\n$fa-var-baby: \\f77c;\n$fa-var-users-line: \\e592;\n$fa-var-quote-left: \\f10d;\n$fa-var-quote-left-alt: \\f10d;\n$fa-var-tractor: \\f722;\n$fa-var-trash-arrow-up: \\f829;\n$fa-var-trash-restore: \\f829;\n$fa-var-arrow-down-up-lock: \\e4b0;\n$fa-var-lines-leaning: \\e51e;\n$fa-var-ruler-combined: \\f546;\n$fa-var-copyright: \\f1f9;\n$fa-var-equals: \\3d;\n$fa-var-blender: \\f517;\n$fa-var-teeth: \\f62e;\n$fa-var-shekel-sign: \\f20b;\n$fa-var-ils: \\f20b;\n$fa-var-shekel: \\f20b;\n$fa-var-sheqel: \\f20b;\n$fa-var-sheqel-sign: \\f20b;\n$fa-var-map: \\f279;\n$fa-var-rocket: \\f135;\n$fa-var-photo-film: \\f87c;\n$fa-var-photo-video: \\f87c;\n$fa-var-folder-minus: \\f65d;\n$fa-var-store: \\f54e;\n$fa-var-arrow-trend-up: \\e098;\n$fa-var-plug-circle-minus: \\e55e;\n$fa-var-sign-hanging: \\f4d9;\n$fa-var-sign: \\f4d9;\n$fa-var-bezier-curve: \\f55b;\n$fa-var-bell-slash: \\f1f6;\n$fa-var-tablet: \\f3fb;\n$fa-var-tablet-android: \\f3fb;\n$fa-var-school-flag: \\e56e;\n$fa-var-fill: \\f575;\n$fa-var-angle-up: \\f106;\n$fa-var-drumstick-bite: \\f6d7;\n$fa-var-holly-berry: \\f7aa;\n$fa-var-chevron-left: \\f053;\n$fa-var-bacteria: \\e059;\n$fa-var-hand-lizard: \\f258;\n$fa-var-notdef: \\e1fe;\n$fa-var-disease: \\f7fa;\n$fa-var-briefcase-medical: \\f469;\n$fa-var-genderless: \\f22d;\n$fa-var-chevron-right: \\f054;\n$fa-var-retweet: \\f079;\n$fa-var-car-rear: \\f5de;\n$fa-var-car-alt: \\f5de;\n$fa-var-pump-soap: \\e06b;\n$fa-var-video-slash: \\f4e2;\n$fa-var-battery-quarter: \\f243;\n$fa-var-battery-2: \\f243;\n$fa-var-radio: \\f8d7;\n$fa-var-baby-carriage: \\f77d;\n$fa-var-carriage-baby: \\f77d;\n$fa-var-traffic-light: \\f637;\n$fa-var-thermometer: \\f491;\n$fa-var-vr-cardboard: \\f729;\n$fa-var-hand-middle-finger: \\f806;\n$fa-var-percent: \\25;\n$fa-var-percentage: \\25;\n$fa-var-truck-moving: \\f4df;\n$fa-var-glass-water-droplet: \\e4f5;\n$fa-var-display: \\e163;\n$fa-var-face-smile: \\f118;\n$fa-var-smile: \\f118;\n$fa-var-thumbtack: \\f08d;\n$fa-var-thumb-tack: \\f08d;\n$fa-var-trophy: \\f091;\n$fa-var-person-praying: \\f683;\n$fa-var-pray: \\f683;\n$fa-var-hammer: \\f6e3;\n$fa-var-hand-peace: \\f25b;\n$fa-var-rotate: \\f2f1;\n$fa-var-sync-alt: \\f2f1;\n$fa-var-spinner: \\f110;\n$fa-var-robot: \\f544;\n$fa-var-peace: \\f67c;\n$fa-var-gears: \\f085;\n$fa-var-cogs: \\f085;\n$fa-var-warehouse: \\f494;\n$fa-var-arrow-up-right-dots: \\e4b7;\n$fa-var-splotch: \\f5bc;\n$fa-var-face-grin-hearts: \\f584;\n$fa-var-grin-hearts: \\f584;\n$fa-var-dice-four: \\f524;\n$fa-var-sim-card: \\f7c4;\n$fa-var-transgender: \\f225;\n$fa-var-transgender-alt: \\f225;\n$fa-var-mercury: \\f223;\n$fa-var-arrow-turn-down: \\f149;\n$fa-var-level-down: \\f149;\n$fa-var-person-falling-burst: \\e547;\n$fa-var-award: \\f559;\n$fa-var-ticket-simple: \\f3ff;\n$fa-var-ticket-alt: \\f3ff;\n$fa-var-building: \\f1ad;\n$fa-var-angles-left: \\f100;\n$fa-var-angle-double-left: \\f100;\n$fa-var-qrcode: \\f029;\n$fa-var-clock-rotate-left: \\f1da;\n$fa-var-history: \\f1da;\n$fa-var-face-grin-beam-sweat: \\f583;\n$fa-var-grin-beam-sweat: \\f583;\n$fa-var-file-export: \\f56e;\n$fa-var-arrow-right-from-file: \\f56e;\n$fa-var-shield: \\f132;\n$fa-var-shield-blank: \\f132;\n$fa-var-arrow-up-short-wide: \\f885;\n$fa-var-sort-amount-up-alt: \\f885;\n$fa-var-house-medical: \\e3b2;\n$fa-var-golf-ball-tee: \\f450;\n$fa-var-golf-ball: \\f450;\n$fa-var-circle-chevron-left: \\f137;\n$fa-var-chevron-circle-left: \\f137;\n$fa-var-house-chimney-window: \\e00d;\n$fa-var-pen-nib: \\f5ad;\n$fa-var-tent-arrow-turn-left: \\e580;\n$fa-var-tents: \\e582;\n$fa-var-wand-magic: \\f0d0;\n$fa-var-magic: \\f0d0;\n$fa-var-dog: \\f6d3;\n$fa-var-carrot: \\f787;\n$fa-var-moon: \\f186;\n$fa-var-wine-glass-empty: \\f5ce;\n$fa-var-wine-glass-alt: \\f5ce;\n$fa-var-cheese: \\f7ef;\n$fa-var-yin-yang: \\f6ad;\n$fa-var-music: \\f001;\n$fa-var-code-commit: \\f386;\n$fa-var-temperature-low: \\f76b;\n$fa-var-person-biking: \\f84a;\n$fa-var-biking: \\f84a;\n$fa-var-broom: \\f51a;\n$fa-var-shield-heart: \\e574;\n$fa-var-gopuram: \\f664;\n$fa-var-earth-oceania: \\e47b;\n$fa-var-globe-oceania: \\e47b;\n$fa-var-square-xmark: \\f2d3;\n$fa-var-times-square: \\f2d3;\n$fa-var-xmark-square: \\f2d3;\n$fa-var-hashtag: \\23;\n$fa-var-up-right-and-down-left-from-center: \\f424;\n$fa-var-expand-alt: \\f424;\n$fa-var-oil-can: \\f613;\n$fa-var-t: \\54;\n$fa-var-hippo: \\f6ed;\n$fa-var-chart-column: \\e0e3;\n$fa-var-infinity: \\f534;\n$fa-var-vial-circle-check: \\e596;\n$fa-var-person-arrow-down-to-line: \\e538;\n$fa-var-voicemail: \\f897;\n$fa-var-fan: \\f863;\n$fa-var-person-walking-luggage: \\e554;\n$fa-var-up-down: \\f338;\n$fa-var-arrows-alt-v: \\f338;\n$fa-var-cloud-moon-rain: \\f73c;\n$fa-var-calendar: \\f133;\n$fa-var-trailer: \\e041;\n$fa-var-bahai: \\f666;\n$fa-var-haykal: \\f666;\n$fa-var-sd-card: \\f7c2;\n$fa-var-dragon: \\f6d5;\n$fa-var-shoe-prints: \\f54b;\n$fa-var-circle-plus: \\f055;\n$fa-var-plus-circle: \\f055;\n$fa-var-face-grin-tongue-wink: \\f58b;\n$fa-var-grin-tongue-wink: \\f58b;\n$fa-var-hand-holding: \\f4bd;\n$fa-var-plug-circle-exclamation: \\e55d;\n$fa-var-link-slash: \\f127;\n$fa-var-chain-broken: \\f127;\n$fa-var-chain-slash: \\f127;\n$fa-var-unlink: \\f127;\n$fa-var-clone: \\f24d;\n$fa-var-person-walking-arrow-loop-left: \\e551;\n$fa-var-arrow-up-z-a: \\f882;\n$fa-var-sort-alpha-up-alt: \\f882;\n$fa-var-fire-flame-curved: \\f7e4;\n$fa-var-fire-alt: \\f7e4;\n$fa-var-tornado: \\f76f;\n$fa-var-file-circle-plus: \\e494;\n$fa-var-book-quran: \\f687;\n$fa-var-quran: \\f687;\n$fa-var-anchor: \\f13d;\n$fa-var-border-all: \\f84c;\n$fa-var-face-angry: \\f556;\n$fa-var-angry: \\f556;\n$fa-var-cookie-bite: \\f564;\n$fa-var-arrow-trend-down: \\e097;\n$fa-var-rss: \\f09e;\n$fa-var-feed: \\f09e;\n$fa-var-draw-polygon: \\f5ee;\n$fa-var-scale-balanced: \\f24e;\n$fa-var-balance-scale: \\f24e;\n$fa-var-gauge-simple-high: \\f62a;\n$fa-var-tachometer: \\f62a;\n$fa-var-tachometer-fast: \\f62a;\n$fa-var-shower: \\f2cc;\n$fa-var-desktop: \\f390;\n$fa-var-desktop-alt: \\f390;\n$fa-var-m: \\4d;\n$fa-var-table-list: \\f00b;\n$fa-var-th-list: \\f00b;\n$fa-var-comment-sms: \\f7cd;\n$fa-var-sms: \\f7cd;\n$fa-var-book: \\f02d;\n$fa-var-user-plus: \\f234;\n$fa-var-check: \\f00c;\n$fa-var-battery-three-quarters: \\f241;\n$fa-var-battery-4: \\f241;\n$fa-var-house-circle-check: \\e509;\n$fa-var-angle-left: \\f104;\n$fa-var-diagram-successor: \\e47a;\n$fa-var-truck-arrow-right: \\e58b;\n$fa-var-arrows-split-up-and-left: \\e4bc;\n$fa-var-hand-fist: \\f6de;\n$fa-var-fist-raised: \\f6de;\n$fa-var-cloud-moon: \\f6c3;\n$fa-var-briefcase: \\f0b1;\n$fa-var-person-falling: \\e546;\n$fa-var-image-portrait: \\f3e0;\n$fa-var-portrait: \\f3e0;\n$fa-var-user-tag: \\f507;\n$fa-var-rug: \\e569;\n$fa-var-earth-europe: \\f7a2;\n$fa-var-globe-europe: \\f7a2;\n$fa-var-cart-flatbed-suitcase: \\f59d;\n$fa-var-luggage-cart: \\f59d;\n$fa-var-rectangle-xmark: \\f410;\n$fa-var-rectangle-times: \\f410;\n$fa-var-times-rectangle: \\f410;\n$fa-var-window-close: \\f410;\n$fa-var-baht-sign: \\e0ac;\n$fa-var-book-open: \\f518;\n$fa-var-book-journal-whills: \\f66a;\n$fa-var-journal-whills: \\f66a;\n$fa-var-handcuffs: \\e4f8;\n$fa-var-triangle-exclamation: \\f071;\n$fa-var-exclamation-triangle: \\f071;\n$fa-var-warning: \\f071;\n$fa-var-database: \\f1c0;\n$fa-var-share: \\f064;\n$fa-var-mail-forward: \\f064;\n$fa-var-bottle-droplet: \\e4c4;\n$fa-var-mask-face: \\e1d7;\n$fa-var-hill-rockslide: \\e508;\n$fa-var-right-left: \\f362;\n$fa-var-exchange-alt: \\f362;\n$fa-var-paper-plane: \\f1d8;\n$fa-var-road-circle-exclamation: \\e565;\n$fa-var-dungeon: \\f6d9;\n$fa-var-align-right: \\f038;\n$fa-var-money-bill-1-wave: \\f53b;\n$fa-var-money-bill-wave-alt: \\f53b;\n$fa-var-life-ring: \\f1cd;\n$fa-var-hands: \\f2a7;\n$fa-var-sign-language: \\f2a7;\n$fa-var-signing: \\f2a7;\n$fa-var-calendar-day: \\f783;\n$fa-var-water-ladder: \\f5c5;\n$fa-var-ladder-water: \\f5c5;\n$fa-var-swimming-pool: \\f5c5;\n$fa-var-arrows-up-down: \\f07d;\n$fa-var-arrows-v: \\f07d;\n$fa-var-face-grimace: \\f57f;\n$fa-var-grimace: \\f57f;\n$fa-var-wheelchair-move: \\e2ce;\n$fa-var-wheelchair-alt: \\e2ce;\n$fa-var-turn-down: \\f3be;\n$fa-var-level-down-alt: \\f3be;\n$fa-var-person-walking-arrow-right: \\e552;\n$fa-var-square-envelope: \\f199;\n$fa-var-envelope-square: \\f199;\n$fa-var-dice: \\f522;\n$fa-var-bowling-ball: \\f436;\n$fa-var-brain: \\f5dc;\n$fa-var-bandage: \\f462;\n$fa-var-band-aid: \\f462;\n$fa-var-calendar-minus: \\f272;\n$fa-var-circle-xmark: \\f057;\n$fa-var-times-circle: \\f057;\n$fa-var-xmark-circle: \\f057;\n$fa-var-gifts: \\f79c;\n$fa-var-hotel: \\f594;\n$fa-var-earth-asia: \\f57e;\n$fa-var-globe-asia: \\f57e;\n$fa-var-id-card-clip: \\f47f;\n$fa-var-id-card-alt: \\f47f;\n$fa-var-magnifying-glass-plus: \\f00e;\n$fa-var-search-plus: \\f00e;\n$fa-var-thumbs-up: \\f164;\n$fa-var-user-clock: \\f4fd;\n$fa-var-hand-dots: \\f461;\n$fa-var-allergies: \\f461;\n$fa-var-file-invoice: \\f570;\n$fa-var-window-minimize: \\f2d1;\n$fa-var-mug-saucer: \\f0f4;\n$fa-var-coffee: \\f0f4;\n$fa-var-brush: \\f55d;\n$fa-var-mask: \\f6fa;\n$fa-var-magnifying-glass-minus: \\f010;\n$fa-var-search-minus: \\f010;\n$fa-var-ruler-vertical: \\f548;\n$fa-var-user-large: \\f406;\n$fa-var-user-alt: \\f406;\n$fa-var-train-tram: \\e5b4;\n$fa-var-user-nurse: \\f82f;\n$fa-var-syringe: \\f48e;\n$fa-var-cloud-sun: \\f6c4;\n$fa-var-stopwatch-20: \\e06f;\n$fa-var-square-full: \\f45c;\n$fa-var-magnet: \\f076;\n$fa-var-jar: \\e516;\n$fa-var-note-sticky: \\f249;\n$fa-var-sticky-note: \\f249;\n$fa-var-bug-slash: \\e490;\n$fa-var-arrow-up-from-water-pump: \\e4b6;\n$fa-var-bone: \\f5d7;\n$fa-var-user-injured: \\f728;\n$fa-var-face-sad-tear: \\f5b4;\n$fa-var-sad-tear: \\f5b4;\n$fa-var-plane: \\f072;\n$fa-var-tent-arrows-down: \\e581;\n$fa-var-exclamation: \\21;\n$fa-var-arrows-spin: \\e4bb;\n$fa-var-print: \\f02f;\n$fa-var-turkish-lira-sign: \\e2bb;\n$fa-var-try: \\e2bb;\n$fa-var-turkish-lira: \\e2bb;\n$fa-var-dollar-sign: \\24;\n$fa-var-dollar: \\24;\n$fa-var-usd: \\24;\n$fa-var-x: \\58;\n$fa-var-magnifying-glass-dollar: \\f688;\n$fa-var-search-dollar: \\f688;\n$fa-var-users-gear: \\f509;\n$fa-var-users-cog: \\f509;\n$fa-var-person-military-pointing: \\e54a;\n$fa-var-building-columns: \\f19c;\n$fa-var-bank: \\f19c;\n$fa-var-institution: \\f19c;\n$fa-var-museum: \\f19c;\n$fa-var-university: \\f19c;\n$fa-var-umbrella: \\f0e9;\n$fa-var-trowel: \\e589;\n$fa-var-d: \\44;\n$fa-var-stapler: \\e5af;\n$fa-var-masks-theater: \\f630;\n$fa-var-theater-masks: \\f630;\n$fa-var-kip-sign: \\e1c4;\n$fa-var-hand-point-left: \\f0a5;\n$fa-var-handshake-simple: \\f4c6;\n$fa-var-handshake-alt: \\f4c6;\n$fa-var-jet-fighter: \\f0fb;\n$fa-var-fighter-jet: \\f0fb;\n$fa-var-square-share-nodes: \\f1e1;\n$fa-var-share-alt-square: \\f1e1;\n$fa-var-barcode: \\f02a;\n$fa-var-plus-minus: \\e43c;\n$fa-var-video: \\f03d;\n$fa-var-video-camera: \\f03d;\n$fa-var-graduation-cap: \\f19d;\n$fa-var-mortar-board: \\f19d;\n$fa-var-hand-holding-medical: \\e05c;\n$fa-var-person-circle-check: \\e53e;\n$fa-var-turn-up: \\f3bf;\n$fa-var-level-up-alt: \\f3bf;\n\n$fa-var-monero: \\f3d0;\n$fa-var-hooli: \\f427;\n$fa-var-yelp: \\f1e9;\n$fa-var-cc-visa: \\f1f0;\n$fa-var-lastfm: \\f202;\n$fa-var-shopware: \\f5b5;\n$fa-var-creative-commons-nc: \\f4e8;\n$fa-var-aws: \\f375;\n$fa-var-redhat: \\f7bc;\n$fa-var-yoast: \\f2b1;\n$fa-var-cloudflare: \\e07d;\n$fa-var-ups: \\f7e0;\n$fa-var-pixiv: \\e640;\n$fa-var-wpexplorer: \\f2de;\n$fa-var-dyalog: \\f399;\n$fa-var-bity: \\f37a;\n$fa-var-stackpath: \\f842;\n$fa-var-buysellads: \\f20d;\n$fa-var-first-order: \\f2b0;\n$fa-var-modx: \\f285;\n$fa-var-guilded: \\e07e;\n$fa-var-vnv: \\f40b;\n$fa-var-square-js: \\f3b9;\n$fa-var-js-square: \\f3b9;\n$fa-var-microsoft: \\f3ca;\n$fa-var-qq: \\f1d6;\n$fa-var-orcid: \\f8d2;\n$fa-var-java: \\f4e4;\n$fa-var-invision: \\f7b0;\n$fa-var-creative-commons-pd-alt: \\f4ed;\n$fa-var-centercode: \\f380;\n$fa-var-glide-g: \\f2a6;\n$fa-var-drupal: \\f1a9;\n$fa-var-jxl: \\e67b;\n$fa-var-hire-a-helper: \\f3b0;\n$fa-var-creative-commons-by: \\f4e7;\n$fa-var-unity: \\e049;\n$fa-var-whmcs: \\f40d;\n$fa-var-rocketchat: \\f3e8;\n$fa-var-vk: \\f189;\n$fa-var-untappd: \\f405;\n$fa-var-mailchimp: \\f59e;\n$fa-var-css3-alt: \\f38b;\n$fa-var-square-reddit: \\f1a2;\n$fa-var-reddit-square: \\f1a2;\n$fa-var-vimeo-v: \\f27d;\n$fa-var-contao: \\f26d;\n$fa-var-square-font-awesome: \\e5ad;\n$fa-var-deskpro: \\f38f;\n$fa-var-brave: \\e63c;\n$fa-var-sistrix: \\f3ee;\n$fa-var-square-instagram: \\e055;\n$fa-var-instagram-square: \\e055;\n$fa-var-battle-net: \\f835;\n$fa-var-the-red-yeti: \\f69d;\n$fa-var-square-hacker-news: \\f3af;\n$fa-var-hacker-news-square: \\f3af;\n$fa-var-edge: \\f282;\n$fa-var-threads: \\e618;\n$fa-var-napster: \\f3d2;\n$fa-var-square-snapchat: \\f2ad;\n$fa-var-snapchat-square: \\f2ad;\n$fa-var-google-plus-g: \\f0d5;\n$fa-var-artstation: \\f77a;\n$fa-var-markdown: \\f60f;\n$fa-var-sourcetree: \\f7d3;\n$fa-var-google-plus: \\f2b3;\n$fa-var-diaspora: \\f791;\n$fa-var-foursquare: \\f180;\n$fa-var-stack-overflow: \\f16c;\n$fa-var-github-alt: \\f113;\n$fa-var-phoenix-squadron: \\f511;\n$fa-var-pagelines: \\f18c;\n$fa-var-algolia: \\f36c;\n$fa-var-red-river: \\f3e3;\n$fa-var-creative-commons-sa: \\f4ef;\n$fa-var-safari: \\f267;\n$fa-var-google: \\f1a0;\n$fa-var-square-font-awesome-stroke: \\f35c;\n$fa-var-font-awesome-alt: \\f35c;\n$fa-var-atlassian: \\f77b;\n$fa-var-linkedin-in: \\f0e1;\n$fa-var-digital-ocean: \\f391;\n$fa-var-nimblr: \\f5a8;\n$fa-var-chromecast: \\f838;\n$fa-var-evernote: \\f839;\n$fa-var-hacker-news: \\f1d4;\n$fa-var-creative-commons-sampling: \\f4f0;\n$fa-var-adversal: \\f36a;\n$fa-var-creative-commons: \\f25e;\n$fa-var-watchman-monitoring: \\e087;\n$fa-var-fonticons: \\f280;\n$fa-var-weixin: \\f1d7;\n$fa-var-shirtsinbulk: \\f214;\n$fa-var-codepen: \\f1cb;\n$fa-var-git-alt: \\f841;\n$fa-var-lyft: \\f3c3;\n$fa-var-rev: \\f5b2;\n$fa-var-windows: \\f17a;\n$fa-var-wizards-of-the-coast: \\f730;\n$fa-var-square-viadeo: \\f2aa;\n$fa-var-viadeo-square: \\f2aa;\n$fa-var-meetup: \\f2e0;\n$fa-var-centos: \\f789;\n$fa-var-adn: \\f170;\n$fa-var-cloudsmith: \\f384;\n$fa-var-opensuse: \\e62b;\n$fa-var-pied-piper-alt: \\f1a8;\n$fa-var-square-dribbble: \\f397;\n$fa-var-dribbble-square: \\f397;\n$fa-var-codiepie: \\f284;\n$fa-var-node: \\f419;\n$fa-var-mix: \\f3cb;\n$fa-var-steam: \\f1b6;\n$fa-var-cc-apple-pay: \\f416;\n$fa-var-scribd: \\f28a;\n$fa-var-debian: \\e60b;\n$fa-var-openid: \\f19b;\n$fa-var-instalod: \\e081;\n$fa-var-expeditedssl: \\f23e;\n$fa-var-sellcast: \\f2da;\n$fa-var-square-twitter: \\f081;\n$fa-var-twitter-square: \\f081;\n$fa-var-r-project: \\f4f7;\n$fa-var-delicious: \\f1a5;\n$fa-var-freebsd: \\f3a4;\n$fa-var-vuejs: \\f41f;\n$fa-var-accusoft: \\f369;\n$fa-var-ioxhost: \\f208;\n$fa-var-fonticons-fi: \\f3a2;\n$fa-var-app-store: \\f36f;\n$fa-var-cc-mastercard: \\f1f1;\n$fa-var-itunes-note: \\f3b5;\n$fa-var-golang: \\e40f;\n$fa-var-kickstarter: \\f3bb;\n$fa-var-square-kickstarter: \\f3bb;\n$fa-var-grav: \\f2d6;\n$fa-var-weibo: \\f18a;\n$fa-var-uncharted: \\e084;\n$fa-var-firstdraft: \\f3a1;\n$fa-var-square-youtube: \\f431;\n$fa-var-youtube-square: \\f431;\n$fa-var-wikipedia-w: \\f266;\n$fa-var-wpressr: \\f3e4;\n$fa-var-rendact: \\f3e4;\n$fa-var-angellist: \\f209;\n$fa-var-galactic-republic: \\f50c;\n$fa-var-nfc-directional: \\e530;\n$fa-var-skype: \\f17e;\n$fa-var-joget: \\f3b7;\n$fa-var-fedora: \\f798;\n$fa-var-stripe-s: \\f42a;\n$fa-var-meta: \\e49b;\n$fa-var-laravel: \\f3bd;\n$fa-var-hotjar: \\f3b1;\n$fa-var-bluetooth-b: \\f294;\n$fa-var-square-letterboxd: \\e62e;\n$fa-var-sticker-mule: \\f3f7;\n$fa-var-creative-commons-zero: \\f4f3;\n$fa-var-hips: \\f452;\n$fa-var-behance: \\f1b4;\n$fa-var-reddit: \\f1a1;\n$fa-var-discord: \\f392;\n$fa-var-chrome: \\f268;\n$fa-var-app-store-ios: \\f370;\n$fa-var-cc-discover: \\f1f2;\n$fa-var-wpbeginner: \\f297;\n$fa-var-confluence: \\f78d;\n$fa-var-shoelace: \\e60c;\n$fa-var-mdb: \\f8ca;\n$fa-var-dochub: \\f394;\n$fa-var-accessible-icon: \\f368;\n$fa-var-ebay: \\f4f4;\n$fa-var-amazon: \\f270;\n$fa-var-unsplash: \\e07c;\n$fa-var-yarn: \\f7e3;\n$fa-var-square-steam: \\f1b7;\n$fa-var-steam-square: \\f1b7;\n$fa-var-500px: \\f26e;\n$fa-var-square-vimeo: \\f194;\n$fa-var-vimeo-square: \\f194;\n$fa-var-asymmetrik: \\f372;\n$fa-var-font-awesome: \\f2b4;\n$fa-var-font-awesome-flag: \\f2b4;\n$fa-var-font-awesome-logo-full: \\f2b4;\n$fa-var-gratipay: \\f184;\n$fa-var-apple: \\f179;\n$fa-var-hive: \\e07f;\n$fa-var-gitkraken: \\f3a6;\n$fa-var-keybase: \\f4f5;\n$fa-var-apple-pay: \\f415;\n$fa-var-padlet: \\e4a0;\n$fa-var-amazon-pay: \\f42c;\n$fa-var-square-github: \\f092;\n$fa-var-github-square: \\f092;\n$fa-var-stumbleupon: \\f1a4;\n$fa-var-fedex: \\f797;\n$fa-var-phoenix-framework: \\f3dc;\n$fa-var-shopify: \\e057;\n$fa-var-neos: \\f612;\n$fa-var-square-threads: \\e619;\n$fa-var-hackerrank: \\f5f7;\n$fa-var-researchgate: \\f4f8;\n$fa-var-swift: \\f8e1;\n$fa-var-angular: \\f420;\n$fa-var-speakap: \\f3f3;\n$fa-var-angrycreative: \\f36e;\n$fa-var-y-combinator: \\f23b;\n$fa-var-empire: \\f1d1;\n$fa-var-envira: \\f299;\n$fa-var-google-scholar: \\e63b;\n$fa-var-square-gitlab: \\e5ae;\n$fa-var-gitlab-square: \\e5ae;\n$fa-var-studiovinari: \\f3f8;\n$fa-var-pied-piper: \\f2ae;\n$fa-var-wordpress: \\f19a;\n$fa-var-product-hunt: \\f288;\n$fa-var-firefox: \\f269;\n$fa-var-linode: \\f2b8;\n$fa-var-goodreads: \\f3a8;\n$fa-var-square-odnoklassniki: \\f264;\n$fa-var-odnoklassniki-square: \\f264;\n$fa-var-jsfiddle: \\f1cc;\n$fa-var-sith: \\f512;\n$fa-var-themeisle: \\f2b2;\n$fa-var-page4: \\f3d7;\n$fa-var-hashnode: \\e499;\n$fa-var-react: \\f41b;\n$fa-var-cc-paypal: \\f1f4;\n$fa-var-squarespace: \\f5be;\n$fa-var-cc-stripe: \\f1f5;\n$fa-var-creative-commons-share: \\f4f2;\n$fa-var-bitcoin: \\f379;\n$fa-var-keycdn: \\f3ba;\n$fa-var-opera: \\f26a;\n$fa-var-itch-io: \\f83a;\n$fa-var-umbraco: \\f8e8;\n$fa-var-galactic-senate: \\f50d;\n$fa-var-ubuntu: \\f7df;\n$fa-var-draft2digital: \\f396;\n$fa-var-stripe: \\f429;\n$fa-var-houzz: \\f27c;\n$fa-var-gg: \\f260;\n$fa-var-dhl: \\f790;\n$fa-var-square-pinterest: \\f0d3;\n$fa-var-pinterest-square: \\f0d3;\n$fa-var-xing: \\f168;\n$fa-var-blackberry: \\f37b;\n$fa-var-creative-commons-pd: \\f4ec;\n$fa-var-playstation: \\f3df;\n$fa-var-quinscape: \\f459;\n$fa-var-less: \\f41d;\n$fa-var-blogger-b: \\f37d;\n$fa-var-opencart: \\f23d;\n$fa-var-vine: \\f1ca;\n$fa-var-signal-messenger: \\e663;\n$fa-var-paypal: \\f1ed;\n$fa-var-gitlab: \\f296;\n$fa-var-typo3: \\f42b;\n$fa-var-reddit-alien: \\f281;\n$fa-var-yahoo: \\f19e;\n$fa-var-dailymotion: \\e052;\n$fa-var-affiliatetheme: \\f36b;\n$fa-var-pied-piper-pp: \\f1a7;\n$fa-var-bootstrap: \\f836;\n$fa-var-odnoklassniki: \\f263;\n$fa-var-nfc-symbol: \\e531;\n$fa-var-mintbit: \\e62f;\n$fa-var-ethereum: \\f42e;\n$fa-var-speaker-deck: \\f83c;\n$fa-var-creative-commons-nc-eu: \\f4e9;\n$fa-var-patreon: \\f3d9;\n$fa-var-avianex: \\f374;\n$fa-var-ello: \\f5f1;\n$fa-var-gofore: \\f3a7;\n$fa-var-bimobject: \\f378;\n$fa-var-brave-reverse: \\e63d;\n$fa-var-facebook-f: \\f39e;\n$fa-var-square-google-plus: \\f0d4;\n$fa-var-google-plus-square: \\f0d4;\n$fa-var-web-awesome: \\e682;\n$fa-var-mandalorian: \\f50f;\n$fa-var-first-order-alt: \\f50a;\n$fa-var-osi: \\f41a;\n$fa-var-google-wallet: \\f1ee;\n$fa-var-d-and-d-beyond: \\f6ca;\n$fa-var-periscope: \\f3da;\n$fa-var-fulcrum: \\f50b;\n$fa-var-cloudscale: \\f383;\n$fa-var-forumbee: \\f211;\n$fa-var-mizuni: \\f3cc;\n$fa-var-schlix: \\f3ea;\n$fa-var-square-xing: \\f169;\n$fa-var-xing-square: \\f169;\n$fa-var-bandcamp: \\f2d5;\n$fa-var-wpforms: \\f298;\n$fa-var-cloudversify: \\f385;\n$fa-var-usps: \\f7e1;\n$fa-var-megaport: \\f5a3;\n$fa-var-magento: \\f3c4;\n$fa-var-spotify: \\f1bc;\n$fa-var-optin-monster: \\f23c;\n$fa-var-fly: \\f417;\n$fa-var-aviato: \\f421;\n$fa-var-itunes: \\f3b4;\n$fa-var-cuttlefish: \\f38c;\n$fa-var-blogger: \\f37c;\n$fa-var-flickr: \\f16e;\n$fa-var-viber: \\f409;\n$fa-var-soundcloud: \\f1be;\n$fa-var-digg: \\f1a6;\n$fa-var-tencent-weibo: \\f1d5;\n$fa-var-letterboxd: \\e62d;\n$fa-var-symfony: \\f83d;\n$fa-var-maxcdn: \\f136;\n$fa-var-etsy: \\f2d7;\n$fa-var-facebook-messenger: \\f39f;\n$fa-var-audible: \\f373;\n$fa-var-think-peaks: \\f731;\n$fa-var-bilibili: \\e3d9;\n$fa-var-erlang: \\f39d;\n$fa-var-x-twitter: \\e61b;\n$fa-var-cotton-bureau: \\f89e;\n$fa-var-dashcube: \\f210;\n$fa-var-42-group: \\e080;\n$fa-var-innosoft: \\e080;\n$fa-var-stack-exchange: \\f18d;\n$fa-var-elementor: \\f430;\n$fa-var-square-pied-piper: \\e01e;\n$fa-var-pied-piper-square: \\e01e;\n$fa-var-creative-commons-nd: \\f4eb;\n$fa-var-palfed: \\f3d8;\n$fa-var-superpowers: \\f2dd;\n$fa-var-resolving: \\f3e7;\n$fa-var-xbox: \\f412;\n$fa-var-square-web-awesome-stroke: \\e684;\n$fa-var-searchengin: \\f3eb;\n$fa-var-tiktok: \\e07b;\n$fa-var-square-facebook: \\f082;\n$fa-var-facebook-square: \\f082;\n$fa-var-renren: \\f18b;\n$fa-var-linux: \\f17c;\n$fa-var-glide: \\f2a5;\n$fa-var-linkedin: \\f08c;\n$fa-var-hubspot: \\f3b2;\n$fa-var-deploydog: \\f38e;\n$fa-var-twitch: \\f1e8;\n$fa-var-ravelry: \\f2d9;\n$fa-var-mixer: \\e056;\n$fa-var-square-lastfm: \\f203;\n$fa-var-lastfm-square: \\f203;\n$fa-var-vimeo: \\f40a;\n$fa-var-mendeley: \\f7b3;\n$fa-var-uniregistry: \\f404;\n$fa-var-figma: \\f799;\n$fa-var-creative-commons-remix: \\f4ee;\n$fa-var-cc-amazon-pay: \\f42d;\n$fa-var-dropbox: \\f16b;\n$fa-var-instagram: \\f16d;\n$fa-var-cmplid: \\e360;\n$fa-var-upwork: \\e641;\n$fa-var-facebook: \\f09a;\n$fa-var-gripfire: \\f3ac;\n$fa-var-jedi-order: \\f50e;\n$fa-var-uikit: \\f403;\n$fa-var-fort-awesome-alt: \\f3a3;\n$fa-var-phabricator: \\f3db;\n$fa-var-ussunnah: \\f407;\n$fa-var-earlybirds: \\f39a;\n$fa-var-trade-federation: \\f513;\n$fa-var-autoprefixer: \\f41c;\n$fa-var-whatsapp: \\f232;\n$fa-var-square-upwork: \\e67c;\n$fa-var-slideshare: \\f1e7;\n$fa-var-google-play: \\f3ab;\n$fa-var-viadeo: \\f2a9;\n$fa-var-line: \\f3c0;\n$fa-var-google-drive: \\f3aa;\n$fa-var-servicestack: \\f3ec;\n$fa-var-simplybuilt: \\f215;\n$fa-var-bitbucket: \\f171;\n$fa-var-imdb: \\f2d8;\n$fa-var-deezer: \\e077;\n$fa-var-raspberry-pi: \\f7bb;\n$fa-var-jira: \\f7b1;\n$fa-var-docker: \\f395;\n$fa-var-screenpal: \\e570;\n$fa-var-bluetooth: \\f293;\n$fa-var-gitter: \\f426;\n$fa-var-d-and-d: \\f38d;\n$fa-var-microblog: \\e01a;\n$fa-var-cc-diners-club: \\f24c;\n$fa-var-gg-circle: \\f261;\n$fa-var-pied-piper-hat: \\f4e5;\n$fa-var-kickstarter-k: \\f3bc;\n$fa-var-yandex: \\f413;\n$fa-var-readme: \\f4d5;\n$fa-var-html5: \\f13b;\n$fa-var-sellsy: \\f213;\n$fa-var-square-web-awesome: \\e683;\n$fa-var-sass: \\f41e;\n$fa-var-wirsindhandwerk: \\e2d0;\n$fa-var-wsh: \\e2d0;\n$fa-var-buromobelexperte: \\f37f;\n$fa-var-salesforce: \\f83b;\n$fa-var-octopus-deploy: \\e082;\n$fa-var-medapps: \\f3c6;\n$fa-var-ns8: \\f3d5;\n$fa-var-pinterest-p: \\f231;\n$fa-var-apper: \\f371;\n$fa-var-fort-awesome: \\f286;\n$fa-var-waze: \\f83f;\n$fa-var-bluesky: \\e671;\n$fa-var-cc-jcb: \\f24b;\n$fa-var-snapchat: \\f2ab;\n$fa-var-snapchat-ghost: \\f2ab;\n$fa-var-fantasy-flight-games: \\f6dc;\n$fa-var-rust: \\e07a;\n$fa-var-wix: \\f5cf;\n$fa-var-square-behance: \\f1b5;\n$fa-var-behance-square: \\f1b5;\n$fa-var-supple: \\f3f9;\n$fa-var-webflow: \\e65c;\n$fa-var-rebel: \\f1d0;\n$fa-var-css3: \\f13c;\n$fa-var-staylinked: \\f3f5;\n$fa-var-kaggle: \\f5fa;\n$fa-var-space-awesome: \\e5ac;\n$fa-var-deviantart: \\f1bd;\n$fa-var-cpanel: \\f388;\n$fa-var-goodreads-g: \\f3a9;\n$fa-var-square-git: \\f1d2;\n$fa-var-git-square: \\f1d2;\n$fa-var-square-tumblr: \\f174;\n$fa-var-tumblr-square: \\f174;\n$fa-var-trello: \\f181;\n$fa-var-creative-commons-nc-jp: \\f4ea;\n$fa-var-get-pocket: \\f265;\n$fa-var-perbyte: \\e083;\n$fa-var-grunt: \\f3ad;\n$fa-var-weebly: \\f5cc;\n$fa-var-connectdevelop: \\f20e;\n$fa-var-leanpub: \\f212;\n$fa-var-black-tie: \\f27e;\n$fa-var-themeco: \\f5c6;\n$fa-var-python: \\f3e2;\n$fa-var-android: \\f17b;\n$fa-var-bots: \\e340;\n$fa-var-free-code-camp: \\f2c5;\n$fa-var-hornbill: \\f592;\n$fa-var-js: \\f3b8;\n$fa-var-ideal: \\e013;\n$fa-var-git: \\f1d3;\n$fa-var-dev: \\f6cc;\n$fa-var-sketch: \\f7c6;\n$fa-var-yandex-international: \\f414;\n$fa-var-cc-amex: \\f1f3;\n$fa-var-uber: \\f402;\n$fa-var-github: \\f09b;\n$fa-var-php: \\f457;\n$fa-var-alipay: \\f642;\n$fa-var-youtube: \\f167;\n$fa-var-skyatlas: \\f216;\n$fa-var-firefox-browser: \\e007;\n$fa-var-replyd: \\f3e6;\n$fa-var-suse: \\f7d6;\n$fa-var-jenkins: \\f3b6;\n$fa-var-twitter: \\f099;\n$fa-var-rockrms: \\f3e9;\n$fa-var-pinterest: \\f0d2;\n$fa-var-buffer: \\f837;\n$fa-var-npm: \\f3d4;\n$fa-var-yammer: \\f840;\n$fa-var-btc: \\f15a;\n$fa-var-dribbble: \\f17d;\n$fa-var-stumbleupon-circle: \\f1a3;\n$fa-var-internet-explorer: \\f26b;\n$fa-var-stubber: \\e5c7;\n$fa-var-telegram: \\f2c6;\n$fa-var-telegram-plane: \\f2c6;\n$fa-var-old-republic: \\f510;\n$fa-var-odysee: \\e5c6;\n$fa-var-square-whatsapp: \\f40c;\n$fa-var-whatsapp-square: \\f40c;\n$fa-var-node-js: \\f3d3;\n$fa-var-edge-legacy: \\e078;\n$fa-var-slack: \\f198;\n$fa-var-slack-hash: \\f198;\n$fa-var-medrt: \\f3c8;\n$fa-var-usb: \\f287;\n$fa-var-tumblr: \\f173;\n$fa-var-vaadin: \\f408;\n$fa-var-quora: \\f2c4;\n$fa-var-square-x-twitter: \\e61a;\n$fa-var-reacteurope: \\f75d;\n$fa-var-medium: \\f23a;\n$fa-var-medium-m: \\f23a;\n$fa-var-amilia: \\f36d;\n$fa-var-mixcloud: \\f289;\n$fa-var-flipboard: \\f44d;\n$fa-var-viacoin: \\f237;\n$fa-var-critical-role: \\f6c9;\n$fa-var-sitrox: \\e44a;\n$fa-var-discourse: \\f393;\n$fa-var-joomla: \\f1aa;\n$fa-var-mastodon: \\f4f6;\n$fa-var-airbnb: \\f834;\n$fa-var-wolf-pack-battalion: \\f514;\n$fa-var-buy-n-large: \\f8a6;\n$fa-var-gulp: \\f3ae;\n$fa-var-creative-commons-sampling-plus: \\f4f1;\n$fa-var-strava: \\f428;\n$fa-var-ember: \\f423;\n$fa-var-canadian-maple-leaf: \\f785;\n$fa-var-teamspeak: \\f4f9;\n$fa-var-pushed: \\f3e1;\n$fa-var-wordpress-simple: \\f411;\n$fa-var-nutritionix: \\f3d6;\n$fa-var-wodu: \\e088;\n$fa-var-google-pay: \\e079;\n$fa-var-intercom: \\f7af;\n$fa-var-zhihu: \\f63f;\n$fa-var-korvue: \\f42f;\n$fa-var-pix: \\e43a;\n$fa-var-steam-symbol: \\f3f6;\n\n$fa-icons: (\n  \"0\": $fa-var-0,\n  \"1\": $fa-var-1,\n  \"2\": $fa-var-2,\n  \"3\": $fa-var-3,\n  \"4\": $fa-var-4,\n  \"5\": $fa-var-5,\n  \"6\": $fa-var-6,\n  \"7\": $fa-var-7,\n  \"8\": $fa-var-8,\n  \"9\": $fa-var-9,\n  \"fill-drip\": $fa-var-fill-drip,\n  \"arrows-to-circle\": $fa-var-arrows-to-circle,\n  \"circle-chevron-right\": $fa-var-circle-chevron-right,\n  \"chevron-circle-right\": $fa-var-chevron-circle-right,\n  \"at\": $fa-var-at,\n  \"trash-can\": $fa-var-trash-can,\n  \"trash-alt\": $fa-var-trash-alt,\n  \"text-height\": $fa-var-text-height,\n  \"user-xmark\": $fa-var-user-xmark,\n  \"user-times\": $fa-var-user-times,\n  \"stethoscope\": $fa-var-stethoscope,\n  \"message\": $fa-var-message,\n  \"comment-alt\": $fa-var-comment-alt,\n  \"info\": $fa-var-info,\n  \"down-left-and-up-right-to-center\": $fa-var-down-left-and-up-right-to-center,\n  \"compress-alt\": $fa-var-compress-alt,\n  \"explosion\": $fa-var-explosion,\n  \"file-lines\": $fa-var-file-lines,\n  \"file-alt\": $fa-var-file-alt,\n  \"file-text\": $fa-var-file-text,\n  \"wave-square\": $fa-var-wave-square,\n  \"ring\": $fa-var-ring,\n  \"building-un\": $fa-var-building-un,\n  \"dice-three\": $fa-var-dice-three,\n  \"calendar-days\": $fa-var-calendar-days,\n  \"calendar-alt\": $fa-var-calendar-alt,\n  \"anchor-circle-check\": $fa-var-anchor-circle-check,\n  \"building-circle-arrow-right\": $fa-var-building-circle-arrow-right,\n  \"volleyball\": $fa-var-volleyball,\n  \"volleyball-ball\": $fa-var-volleyball-ball,\n  \"arrows-up-to-line\": $fa-var-arrows-up-to-line,\n  \"sort-down\": $fa-var-sort-down,\n  \"sort-desc\": $fa-var-sort-desc,\n  \"circle-minus\": $fa-var-circle-minus,\n  \"minus-circle\": $fa-var-minus-circle,\n  \"door-open\": $fa-var-door-open,\n  \"right-from-bracket\": $fa-var-right-from-bracket,\n  \"sign-out-alt\": $fa-var-sign-out-alt,\n  \"atom\": $fa-var-atom,\n  \"soap\": $fa-var-soap,\n  \"icons\": $fa-var-icons,\n  \"heart-music-camera-bolt\": $fa-var-heart-music-camera-bolt,\n  \"microphone-lines-slash\": $fa-var-microphone-lines-slash,\n  \"microphone-alt-slash\": $fa-var-microphone-alt-slash,\n  \"bridge-circle-check\": $fa-var-bridge-circle-check,\n  \"pump-medical\": $fa-var-pump-medical,\n  \"fingerprint\": $fa-var-fingerprint,\n  \"hand-point-right\": $fa-var-hand-point-right,\n  \"magnifying-glass-location\": $fa-var-magnifying-glass-location,\n  \"search-location\": $fa-var-search-location,\n  \"forward-step\": $fa-var-forward-step,\n  \"step-forward\": $fa-var-step-forward,\n  \"face-smile-beam\": $fa-var-face-smile-beam,\n  \"smile-beam\": $fa-var-smile-beam,\n  \"flag-checkered\": $fa-var-flag-checkered,\n  \"football\": $fa-var-football,\n  \"football-ball\": $fa-var-football-ball,\n  \"school-circle-exclamation\": $fa-var-school-circle-exclamation,\n  \"crop\": $fa-var-crop,\n  \"angles-down\": $fa-var-angles-down,\n  \"angle-double-down\": $fa-var-angle-double-down,\n  \"users-rectangle\": $fa-var-users-rectangle,\n  \"people-roof\": $fa-var-people-roof,\n  \"people-line\": $fa-var-people-line,\n  \"beer-mug-empty\": $fa-var-beer-mug-empty,\n  \"beer\": $fa-var-beer,\n  \"diagram-predecessor\": $fa-var-diagram-predecessor,\n  \"arrow-up-long\": $fa-var-arrow-up-long,\n  \"long-arrow-up\": $fa-var-long-arrow-up,\n  \"fire-flame-simple\": $fa-var-fire-flame-simple,\n  \"burn\": $fa-var-burn,\n  \"person\": $fa-var-person,\n  \"male\": $fa-var-male,\n  \"laptop\": $fa-var-laptop,\n  \"file-csv\": $fa-var-file-csv,\n  \"menorah\": $fa-var-menorah,\n  \"truck-plane\": $fa-var-truck-plane,\n  \"record-vinyl\": $fa-var-record-vinyl,\n  \"face-grin-stars\": $fa-var-face-grin-stars,\n  \"grin-stars\": $fa-var-grin-stars,\n  \"bong\": $fa-var-bong,\n  \"spaghetti-monster-flying\": $fa-var-spaghetti-monster-flying,\n  \"pastafarianism\": $fa-var-pastafarianism,\n  \"arrow-down-up-across-line\": $fa-var-arrow-down-up-across-line,\n  \"spoon\": $fa-var-spoon,\n  \"utensil-spoon\": $fa-var-utensil-spoon,\n  \"jar-wheat\": $fa-var-jar-wheat,\n  \"envelopes-bulk\": $fa-var-envelopes-bulk,\n  \"mail-bulk\": $fa-var-mail-bulk,\n  \"file-circle-exclamation\": $fa-var-file-circle-exclamation,\n  \"circle-h\": $fa-var-circle-h,\n  \"hospital-symbol\": $fa-var-hospital-symbol,\n  \"pager\": $fa-var-pager,\n  \"address-book\": $fa-var-address-book,\n  \"contact-book\": $fa-var-contact-book,\n  \"strikethrough\": $fa-var-strikethrough,\n  \"k\": $fa-var-k,\n  \"landmark-flag\": $fa-var-landmark-flag,\n  \"pencil\": $fa-var-pencil,\n  \"pencil-alt\": $fa-var-pencil-alt,\n  \"backward\": $fa-var-backward,\n  \"caret-right\": $fa-var-caret-right,\n  \"comments\": $fa-var-comments,\n  \"paste\": $fa-var-paste,\n  \"file-clipboard\": $fa-var-file-clipboard,\n  \"code-pull-request\": $fa-var-code-pull-request,\n  \"clipboard-list\": $fa-var-clipboard-list,\n  \"truck-ramp-box\": $fa-var-truck-ramp-box,\n  \"truck-loading\": $fa-var-truck-loading,\n  \"user-check\": $fa-var-user-check,\n  \"vial-virus\": $fa-var-vial-virus,\n  \"sheet-plastic\": $fa-var-sheet-plastic,\n  \"blog\": $fa-var-blog,\n  \"user-ninja\": $fa-var-user-ninja,\n  \"person-arrow-up-from-line\": $fa-var-person-arrow-up-from-line,\n  \"scroll-torah\": $fa-var-scroll-torah,\n  \"torah\": $fa-var-torah,\n  \"broom-ball\": $fa-var-broom-ball,\n  \"quidditch\": $fa-var-quidditch,\n  \"quidditch-broom-ball\": $fa-var-quidditch-broom-ball,\n  \"toggle-off\": $fa-var-toggle-off,\n  \"box-archive\": $fa-var-box-archive,\n  \"archive\": $fa-var-archive,\n  \"person-drowning\": $fa-var-person-drowning,\n  \"arrow-down-9-1\": $fa-var-arrow-down-9-1,\n  \"sort-numeric-desc\": $fa-var-sort-numeric-desc,\n  \"sort-numeric-down-alt\": $fa-var-sort-numeric-down-alt,\n  \"face-grin-tongue-squint\": $fa-var-face-grin-tongue-squint,\n  \"grin-tongue-squint\": $fa-var-grin-tongue-squint,\n  \"spray-can\": $fa-var-spray-can,\n  \"truck-monster\": $fa-var-truck-monster,\n  \"w\": $fa-var-w,\n  \"earth-africa\": $fa-var-earth-africa,\n  \"globe-africa\": $fa-var-globe-africa,\n  \"rainbow\": $fa-var-rainbow,\n  \"circle-notch\": $fa-var-circle-notch,\n  \"tablet-screen-button\": $fa-var-tablet-screen-button,\n  \"tablet-alt\": $fa-var-tablet-alt,\n  \"paw\": $fa-var-paw,\n  \"cloud\": $fa-var-cloud,\n  \"trowel-bricks\": $fa-var-trowel-bricks,\n  \"face-flushed\": $fa-var-face-flushed,\n  \"flushed\": $fa-var-flushed,\n  \"hospital-user\": $fa-var-hospital-user,\n  \"tent-arrow-left-right\": $fa-var-tent-arrow-left-right,\n  \"gavel\": $fa-var-gavel,\n  \"legal\": $fa-var-legal,\n  \"binoculars\": $fa-var-binoculars,\n  \"microphone-slash\": $fa-var-microphone-slash,\n  \"box-tissue\": $fa-var-box-tissue,\n  \"motorcycle\": $fa-var-motorcycle,\n  \"bell-concierge\": $fa-var-bell-concierge,\n  \"concierge-bell\": $fa-var-concierge-bell,\n  \"pen-ruler\": $fa-var-pen-ruler,\n  \"pencil-ruler\": $fa-var-pencil-ruler,\n  \"people-arrows\": $fa-var-people-arrows,\n  \"people-arrows-left-right\": $fa-var-people-arrows-left-right,\n  \"mars-and-venus-burst\": $fa-var-mars-and-venus-burst,\n  \"square-caret-right\": $fa-var-square-caret-right,\n  \"caret-square-right\": $fa-var-caret-square-right,\n  \"scissors\": $fa-var-scissors,\n  \"cut\": $fa-var-cut,\n  \"sun-plant-wilt\": $fa-var-sun-plant-wilt,\n  \"toilets-portable\": $fa-var-toilets-portable,\n  \"hockey-puck\": $fa-var-hockey-puck,\n  \"table\": $fa-var-table,\n  \"magnifying-glass-arrow-right\": $fa-var-magnifying-glass-arrow-right,\n  \"tachograph-digital\": $fa-var-tachograph-digital,\n  \"digital-tachograph\": $fa-var-digital-tachograph,\n  \"users-slash\": $fa-var-users-slash,\n  \"clover\": $fa-var-clover,\n  \"reply\": $fa-var-reply,\n  \"mail-reply\": $fa-var-mail-reply,\n  \"star-and-crescent\": $fa-var-star-and-crescent,\n  \"house-fire\": $fa-var-house-fire,\n  \"square-minus\": $fa-var-square-minus,\n  \"minus-square\": $fa-var-minus-square,\n  \"helicopter\": $fa-var-helicopter,\n  \"compass\": $fa-var-compass,\n  \"square-caret-down\": $fa-var-square-caret-down,\n  \"caret-square-down\": $fa-var-caret-square-down,\n  \"file-circle-question\": $fa-var-file-circle-question,\n  \"laptop-code\": $fa-var-laptop-code,\n  \"swatchbook\": $fa-var-swatchbook,\n  \"prescription-bottle\": $fa-var-prescription-bottle,\n  \"bars\": $fa-var-bars,\n  \"navicon\": $fa-var-navicon,\n  \"people-group\": $fa-var-people-group,\n  \"hourglass-end\": $fa-var-hourglass-end,\n  \"hourglass-3\": $fa-var-hourglass-3,\n  \"heart-crack\": $fa-var-heart-crack,\n  \"heart-broken\": $fa-var-heart-broken,\n  \"square-up-right\": $fa-var-square-up-right,\n  \"external-link-square-alt\": $fa-var-external-link-square-alt,\n  \"face-kiss-beam\": $fa-var-face-kiss-beam,\n  \"kiss-beam\": $fa-var-kiss-beam,\n  \"film\": $fa-var-film,\n  \"ruler-horizontal\": $fa-var-ruler-horizontal,\n  \"people-robbery\": $fa-var-people-robbery,\n  \"lightbulb\": $fa-var-lightbulb,\n  \"caret-left\": $fa-var-caret-left,\n  \"circle-exclamation\": $fa-var-circle-exclamation,\n  \"exclamation-circle\": $fa-var-exclamation-circle,\n  \"school-circle-xmark\": $fa-var-school-circle-xmark,\n  \"arrow-right-from-bracket\": $fa-var-arrow-right-from-bracket,\n  \"sign-out\": $fa-var-sign-out,\n  \"circle-chevron-down\": $fa-var-circle-chevron-down,\n  \"chevron-circle-down\": $fa-var-chevron-circle-down,\n  \"unlock-keyhole\": $fa-var-unlock-keyhole,\n  \"unlock-alt\": $fa-var-unlock-alt,\n  \"cloud-showers-heavy\": $fa-var-cloud-showers-heavy,\n  \"headphones-simple\": $fa-var-headphones-simple,\n  \"headphones-alt\": $fa-var-headphones-alt,\n  \"sitemap\": $fa-var-sitemap,\n  \"circle-dollar-to-slot\": $fa-var-circle-dollar-to-slot,\n  \"donate\": $fa-var-donate,\n  \"memory\": $fa-var-memory,\n  \"road-spikes\": $fa-var-road-spikes,\n  \"fire-burner\": $fa-var-fire-burner,\n  \"flag\": $fa-var-flag,\n  \"hanukiah\": $fa-var-hanukiah,\n  \"feather\": $fa-var-feather,\n  \"volume-low\": $fa-var-volume-low,\n  \"volume-down\": $fa-var-volume-down,\n  \"comment-slash\": $fa-var-comment-slash,\n  \"cloud-sun-rain\": $fa-var-cloud-sun-rain,\n  \"compress\": $fa-var-compress,\n  \"wheat-awn\": $fa-var-wheat-awn,\n  \"wheat-alt\": $fa-var-wheat-alt,\n  \"ankh\": $fa-var-ankh,\n  \"hands-holding-child\": $fa-var-hands-holding-child,\n  \"asterisk\": $fa-var-asterisk,\n  \"square-check\": $fa-var-square-check,\n  \"check-square\": $fa-var-check-square,\n  \"peseta-sign\": $fa-var-peseta-sign,\n  \"heading\": $fa-var-heading,\n  \"header\": $fa-var-header,\n  \"ghost\": $fa-var-ghost,\n  \"list\": $fa-var-list,\n  \"list-squares\": $fa-var-list-squares,\n  \"square-phone-flip\": $fa-var-square-phone-flip,\n  \"phone-square-alt\": $fa-var-phone-square-alt,\n  \"cart-plus\": $fa-var-cart-plus,\n  \"gamepad\": $fa-var-gamepad,\n  \"circle-dot\": $fa-var-circle-dot,\n  \"dot-circle\": $fa-var-dot-circle,\n  \"face-dizzy\": $fa-var-face-dizzy,\n  \"dizzy\": $fa-var-dizzy,\n  \"egg\": $fa-var-egg,\n  \"house-medical-circle-xmark\": $fa-var-house-medical-circle-xmark,\n  \"campground\": $fa-var-campground,\n  \"folder-plus\": $fa-var-folder-plus,\n  \"futbol\": $fa-var-futbol,\n  \"futbol-ball\": $fa-var-futbol-ball,\n  \"soccer-ball\": $fa-var-soccer-ball,\n  \"paintbrush\": $fa-var-paintbrush,\n  \"paint-brush\": $fa-var-paint-brush,\n  \"lock\": $fa-var-lock,\n  \"gas-pump\": $fa-var-gas-pump,\n  \"hot-tub-person\": $fa-var-hot-tub-person,\n  \"hot-tub\": $fa-var-hot-tub,\n  \"map-location\": $fa-var-map-location,\n  \"map-marked\": $fa-var-map-marked,\n  \"house-flood-water\": $fa-var-house-flood-water,\n  \"tree\": $fa-var-tree,\n  \"bridge-lock\": $fa-var-bridge-lock,\n  \"sack-dollar\": $fa-var-sack-dollar,\n  \"pen-to-square\": $fa-var-pen-to-square,\n  \"edit\": $fa-var-edit,\n  \"car-side\": $fa-var-car-side,\n  \"share-nodes\": $fa-var-share-nodes,\n  \"share-alt\": $fa-var-share-alt,\n  \"heart-circle-minus\": $fa-var-heart-circle-minus,\n  \"hourglass-half\": $fa-var-hourglass-half,\n  \"hourglass-2\": $fa-var-hourglass-2,\n  \"microscope\": $fa-var-microscope,\n  \"sink\": $fa-var-sink,\n  \"bag-shopping\": $fa-var-bag-shopping,\n  \"shopping-bag\": $fa-var-shopping-bag,\n  \"arrow-down-z-a\": $fa-var-arrow-down-z-a,\n  \"sort-alpha-desc\": $fa-var-sort-alpha-desc,\n  \"sort-alpha-down-alt\": $fa-var-sort-alpha-down-alt,\n  \"mitten\": $fa-var-mitten,\n  \"person-rays\": $fa-var-person-rays,\n  \"users\": $fa-var-users,\n  \"eye-slash\": $fa-var-eye-slash,\n  \"flask-vial\": $fa-var-flask-vial,\n  \"hand\": $fa-var-hand,\n  \"hand-paper\": $fa-var-hand-paper,\n  \"om\": $fa-var-om,\n  \"worm\": $fa-var-worm,\n  \"house-circle-xmark\": $fa-var-house-circle-xmark,\n  \"plug\": $fa-var-plug,\n  \"chevron-up\": $fa-var-chevron-up,\n  \"hand-spock\": $fa-var-hand-spock,\n  \"stopwatch\": $fa-var-stopwatch,\n  \"face-kiss\": $fa-var-face-kiss,\n  \"kiss\": $fa-var-kiss,\n  \"bridge-circle-xmark\": $fa-var-bridge-circle-xmark,\n  \"face-grin-tongue\": $fa-var-face-grin-tongue,\n  \"grin-tongue\": $fa-var-grin-tongue,\n  \"chess-bishop\": $fa-var-chess-bishop,\n  \"face-grin-wink\": $fa-var-face-grin-wink,\n  \"grin-wink\": $fa-var-grin-wink,\n  \"ear-deaf\": $fa-var-ear-deaf,\n  \"deaf\": $fa-var-deaf,\n  \"deafness\": $fa-var-deafness,\n  \"hard-of-hearing\": $fa-var-hard-of-hearing,\n  \"road-circle-check\": $fa-var-road-circle-check,\n  \"dice-five\": $fa-var-dice-five,\n  \"square-rss\": $fa-var-square-rss,\n  \"rss-square\": $fa-var-rss-square,\n  \"land-mine-on\": $fa-var-land-mine-on,\n  \"i-cursor\": $fa-var-i-cursor,\n  \"stamp\": $fa-var-stamp,\n  \"stairs\": $fa-var-stairs,\n  \"i\": $fa-var-i,\n  \"hryvnia-sign\": $fa-var-hryvnia-sign,\n  \"hryvnia\": $fa-var-hryvnia,\n  \"pills\": $fa-var-pills,\n  \"face-grin-wide\": $fa-var-face-grin-wide,\n  \"grin-alt\": $fa-var-grin-alt,\n  \"tooth\": $fa-var-tooth,\n  \"v\": $fa-var-v,\n  \"bangladeshi-taka-sign\": $fa-var-bangladeshi-taka-sign,\n  \"bicycle\": $fa-var-bicycle,\n  \"staff-snake\": $fa-var-staff-snake,\n  \"rod-asclepius\": $fa-var-rod-asclepius,\n  \"rod-snake\": $fa-var-rod-snake,\n  \"staff-aesculapius\": $fa-var-staff-aesculapius,\n  \"head-side-cough-slash\": $fa-var-head-side-cough-slash,\n  \"truck-medical\": $fa-var-truck-medical,\n  \"ambulance\": $fa-var-ambulance,\n  \"wheat-awn-circle-exclamation\": $fa-var-wheat-awn-circle-exclamation,\n  \"snowman\": $fa-var-snowman,\n  \"mortar-pestle\": $fa-var-mortar-pestle,\n  \"road-barrier\": $fa-var-road-barrier,\n  \"school\": $fa-var-school,\n  \"igloo\": $fa-var-igloo,\n  \"joint\": $fa-var-joint,\n  \"angle-right\": $fa-var-angle-right,\n  \"horse\": $fa-var-horse,\n  \"q\": $fa-var-q,\n  \"g\": $fa-var-g,\n  \"notes-medical\": $fa-var-notes-medical,\n  \"temperature-half\": $fa-var-temperature-half,\n  \"temperature-2\": $fa-var-temperature-2,\n  \"thermometer-2\": $fa-var-thermometer-2,\n  \"thermometer-half\": $fa-var-thermometer-half,\n  \"dong-sign\": $fa-var-dong-sign,\n  \"capsules\": $fa-var-capsules,\n  \"poo-storm\": $fa-var-poo-storm,\n  \"poo-bolt\": $fa-var-poo-bolt,\n  \"face-frown-open\": $fa-var-face-frown-open,\n  \"frown-open\": $fa-var-frown-open,\n  \"hand-point-up\": $fa-var-hand-point-up,\n  \"money-bill\": $fa-var-money-bill,\n  \"bookmark\": $fa-var-bookmark,\n  \"align-justify\": $fa-var-align-justify,\n  \"umbrella-beach\": $fa-var-umbrella-beach,\n  \"helmet-un\": $fa-var-helmet-un,\n  \"bullseye\": $fa-var-bullseye,\n  \"bacon\": $fa-var-bacon,\n  \"hand-point-down\": $fa-var-hand-point-down,\n  \"arrow-up-from-bracket\": $fa-var-arrow-up-from-bracket,\n  \"folder\": $fa-var-folder,\n  \"folder-blank\": $fa-var-folder-blank,\n  \"file-waveform\": $fa-var-file-waveform,\n  \"file-medical-alt\": $fa-var-file-medical-alt,\n  \"radiation\": $fa-var-radiation,\n  \"chart-simple\": $fa-var-chart-simple,\n  \"mars-stroke\": $fa-var-mars-stroke,\n  \"vial\": $fa-var-vial,\n  \"gauge\": $fa-var-gauge,\n  \"dashboard\": $fa-var-dashboard,\n  \"gauge-med\": $fa-var-gauge-med,\n  \"tachometer-alt-average\": $fa-var-tachometer-alt-average,\n  \"wand-magic-sparkles\": $fa-var-wand-magic-sparkles,\n  \"magic-wand-sparkles\": $fa-var-magic-wand-sparkles,\n  \"e\": $fa-var-e,\n  \"pen-clip\": $fa-var-pen-clip,\n  \"pen-alt\": $fa-var-pen-alt,\n  \"bridge-circle-exclamation\": $fa-var-bridge-circle-exclamation,\n  \"user\": $fa-var-user,\n  \"school-circle-check\": $fa-var-school-circle-check,\n  \"dumpster\": $fa-var-dumpster,\n  \"van-shuttle\": $fa-var-van-shuttle,\n  \"shuttle-van\": $fa-var-shuttle-van,\n  \"building-user\": $fa-var-building-user,\n  \"square-caret-left\": $fa-var-square-caret-left,\n  \"caret-square-left\": $fa-var-caret-square-left,\n  \"highlighter\": $fa-var-highlighter,\n  \"key\": $fa-var-key,\n  \"bullhorn\": $fa-var-bullhorn,\n  \"globe\": $fa-var-globe,\n  \"synagogue\": $fa-var-synagogue,\n  \"person-half-dress\": $fa-var-person-half-dress,\n  \"road-bridge\": $fa-var-road-bridge,\n  \"location-arrow\": $fa-var-location-arrow,\n  \"c\": $fa-var-c,\n  \"tablet-button\": $fa-var-tablet-button,\n  \"building-lock\": $fa-var-building-lock,\n  \"pizza-slice\": $fa-var-pizza-slice,\n  \"money-bill-wave\": $fa-var-money-bill-wave,\n  \"chart-area\": $fa-var-chart-area,\n  \"area-chart\": $fa-var-area-chart,\n  \"house-flag\": $fa-var-house-flag,\n  \"person-circle-minus\": $fa-var-person-circle-minus,\n  \"ban\": $fa-var-ban,\n  \"cancel\": $fa-var-cancel,\n  \"camera-rotate\": $fa-var-camera-rotate,\n  \"spray-can-sparkles\": $fa-var-spray-can-sparkles,\n  \"air-freshener\": $fa-var-air-freshener,\n  \"star\": $fa-var-star,\n  \"repeat\": $fa-var-repeat,\n  \"cross\": $fa-var-cross,\n  \"box\": $fa-var-box,\n  \"venus-mars\": $fa-var-venus-mars,\n  \"arrow-pointer\": $fa-var-arrow-pointer,\n  \"mouse-pointer\": $fa-var-mouse-pointer,\n  \"maximize\": $fa-var-maximize,\n  \"expand-arrows-alt\": $fa-var-expand-arrows-alt,\n  \"charging-station\": $fa-var-charging-station,\n  \"shapes\": $fa-var-shapes,\n  \"triangle-circle-square\": $fa-var-triangle-circle-square,\n  \"shuffle\": $fa-var-shuffle,\n  \"random\": $fa-var-random,\n  \"person-running\": $fa-var-person-running,\n  \"running\": $fa-var-running,\n  \"mobile-retro\": $fa-var-mobile-retro,\n  \"grip-lines-vertical\": $fa-var-grip-lines-vertical,\n  \"spider\": $fa-var-spider,\n  \"hands-bound\": $fa-var-hands-bound,\n  \"file-invoice-dollar\": $fa-var-file-invoice-dollar,\n  \"plane-circle-exclamation\": $fa-var-plane-circle-exclamation,\n  \"x-ray\": $fa-var-x-ray,\n  \"spell-check\": $fa-var-spell-check,\n  \"slash\": $fa-var-slash,\n  \"computer-mouse\": $fa-var-computer-mouse,\n  \"mouse\": $fa-var-mouse,\n  \"arrow-right-to-bracket\": $fa-var-arrow-right-to-bracket,\n  \"sign-in\": $fa-var-sign-in,\n  \"shop-slash\": $fa-var-shop-slash,\n  \"store-alt-slash\": $fa-var-store-alt-slash,\n  \"server\": $fa-var-server,\n  \"virus-covid-slash\": $fa-var-virus-covid-slash,\n  \"shop-lock\": $fa-var-shop-lock,\n  \"hourglass-start\": $fa-var-hourglass-start,\n  \"hourglass-1\": $fa-var-hourglass-1,\n  \"blender-phone\": $fa-var-blender-phone,\n  \"building-wheat\": $fa-var-building-wheat,\n  \"person-breastfeeding\": $fa-var-person-breastfeeding,\n  \"right-to-bracket\": $fa-var-right-to-bracket,\n  \"sign-in-alt\": $fa-var-sign-in-alt,\n  \"venus\": $fa-var-venus,\n  \"passport\": $fa-var-passport,\n  \"heart-pulse\": $fa-var-heart-pulse,\n  \"heartbeat\": $fa-var-heartbeat,\n  \"people-carry-box\": $fa-var-people-carry-box,\n  \"people-carry\": $fa-var-people-carry,\n  \"temperature-high\": $fa-var-temperature-high,\n  \"microchip\": $fa-var-microchip,\n  \"crown\": $fa-var-crown,\n  \"weight-hanging\": $fa-var-weight-hanging,\n  \"xmarks-lines\": $fa-var-xmarks-lines,\n  \"file-prescription\": $fa-var-file-prescription,\n  \"weight-scale\": $fa-var-weight-scale,\n  \"weight\": $fa-var-weight,\n  \"user-group\": $fa-var-user-group,\n  \"user-friends\": $fa-var-user-friends,\n  \"arrow-up-a-z\": $fa-var-arrow-up-a-z,\n  \"sort-alpha-up\": $fa-var-sort-alpha-up,\n  \"chess-knight\": $fa-var-chess-knight,\n  \"face-laugh-squint\": $fa-var-face-laugh-squint,\n  \"laugh-squint\": $fa-var-laugh-squint,\n  \"wheelchair\": $fa-var-wheelchair,\n  \"circle-arrow-up\": $fa-var-circle-arrow-up,\n  \"arrow-circle-up\": $fa-var-arrow-circle-up,\n  \"toggle-on\": $fa-var-toggle-on,\n  \"person-walking\": $fa-var-person-walking,\n  \"walking\": $fa-var-walking,\n  \"l\": $fa-var-l,\n  \"fire\": $fa-var-fire,\n  \"bed-pulse\": $fa-var-bed-pulse,\n  \"procedures\": $fa-var-procedures,\n  \"shuttle-space\": $fa-var-shuttle-space,\n  \"space-shuttle\": $fa-var-space-shuttle,\n  \"face-laugh\": $fa-var-face-laugh,\n  \"laugh\": $fa-var-laugh,\n  \"folder-open\": $fa-var-folder-open,\n  \"heart-circle-plus\": $fa-var-heart-circle-plus,\n  \"code-fork\": $fa-var-code-fork,\n  \"city\": $fa-var-city,\n  \"microphone-lines\": $fa-var-microphone-lines,\n  \"microphone-alt\": $fa-var-microphone-alt,\n  \"pepper-hot\": $fa-var-pepper-hot,\n  \"unlock\": $fa-var-unlock,\n  \"colon-sign\": $fa-var-colon-sign,\n  \"headset\": $fa-var-headset,\n  \"store-slash\": $fa-var-store-slash,\n  \"road-circle-xmark\": $fa-var-road-circle-xmark,\n  \"user-minus\": $fa-var-user-minus,\n  \"mars-stroke-up\": $fa-var-mars-stroke-up,\n  \"mars-stroke-v\": $fa-var-mars-stroke-v,\n  \"champagne-glasses\": $fa-var-champagne-glasses,\n  \"glass-cheers\": $fa-var-glass-cheers,\n  \"clipboard\": $fa-var-clipboard,\n  \"house-circle-exclamation\": $fa-var-house-circle-exclamation,\n  \"file-arrow-up\": $fa-var-file-arrow-up,\n  \"file-upload\": $fa-var-file-upload,\n  \"wifi\": $fa-var-wifi,\n  \"wifi-3\": $fa-var-wifi-3,\n  \"wifi-strong\": $fa-var-wifi-strong,\n  \"bath\": $fa-var-bath,\n  \"bathtub\": $fa-var-bathtub,\n  \"underline\": $fa-var-underline,\n  \"user-pen\": $fa-var-user-pen,\n  \"user-edit\": $fa-var-user-edit,\n  \"signature\": $fa-var-signature,\n  \"stroopwafel\": $fa-var-stroopwafel,\n  \"bold\": $fa-var-bold,\n  \"anchor-lock\": $fa-var-anchor-lock,\n  \"building-ngo\": $fa-var-building-ngo,\n  \"manat-sign\": $fa-var-manat-sign,\n  \"not-equal\": $fa-var-not-equal,\n  \"border-top-left\": $fa-var-border-top-left,\n  \"border-style\": $fa-var-border-style,\n  \"map-location-dot\": $fa-var-map-location-dot,\n  \"map-marked-alt\": $fa-var-map-marked-alt,\n  \"jedi\": $fa-var-jedi,\n  \"square-poll-vertical\": $fa-var-square-poll-vertical,\n  \"poll\": $fa-var-poll,\n  \"mug-hot\": $fa-var-mug-hot,\n  \"car-battery\": $fa-var-car-battery,\n  \"battery-car\": $fa-var-battery-car,\n  \"gift\": $fa-var-gift,\n  \"dice-two\": $fa-var-dice-two,\n  \"chess-queen\": $fa-var-chess-queen,\n  \"glasses\": $fa-var-glasses,\n  \"chess-board\": $fa-var-chess-board,\n  \"building-circle-check\": $fa-var-building-circle-check,\n  \"person-chalkboard\": $fa-var-person-chalkboard,\n  \"mars-stroke-right\": $fa-var-mars-stroke-right,\n  \"mars-stroke-h\": $fa-var-mars-stroke-h,\n  \"hand-back-fist\": $fa-var-hand-back-fist,\n  \"hand-rock\": $fa-var-hand-rock,\n  \"square-caret-up\": $fa-var-square-caret-up,\n  \"caret-square-up\": $fa-var-caret-square-up,\n  \"cloud-showers-water\": $fa-var-cloud-showers-water,\n  \"chart-bar\": $fa-var-chart-bar,\n  \"bar-chart\": $fa-var-bar-chart,\n  \"hands-bubbles\": $fa-var-hands-bubbles,\n  \"hands-wash\": $fa-var-hands-wash,\n  \"less-than-equal\": $fa-var-less-than-equal,\n  \"train\": $fa-var-train,\n  \"eye-low-vision\": $fa-var-eye-low-vision,\n  \"low-vision\": $fa-var-low-vision,\n  \"crow\": $fa-var-crow,\n  \"sailboat\": $fa-var-sailboat,\n  \"window-restore\": $fa-var-window-restore,\n  \"square-plus\": $fa-var-square-plus,\n  \"plus-square\": $fa-var-plus-square,\n  \"torii-gate\": $fa-var-torii-gate,\n  \"frog\": $fa-var-frog,\n  \"bucket\": $fa-var-bucket,\n  \"image\": $fa-var-image,\n  \"microphone\": $fa-var-microphone,\n  \"cow\": $fa-var-cow,\n  \"caret-up\": $fa-var-caret-up,\n  \"screwdriver\": $fa-var-screwdriver,\n  \"folder-closed\": $fa-var-folder-closed,\n  \"house-tsunami\": $fa-var-house-tsunami,\n  \"square-nfi\": $fa-var-square-nfi,\n  \"arrow-up-from-ground-water\": $fa-var-arrow-up-from-ground-water,\n  \"martini-glass\": $fa-var-martini-glass,\n  \"glass-martini-alt\": $fa-var-glass-martini-alt,\n  \"rotate-left\": $fa-var-rotate-left,\n  \"rotate-back\": $fa-var-rotate-back,\n  \"rotate-backward\": $fa-var-rotate-backward,\n  \"undo-alt\": $fa-var-undo-alt,\n  \"table-columns\": $fa-var-table-columns,\n  \"columns\": $fa-var-columns,\n  \"lemon\": $fa-var-lemon,\n  \"head-side-mask\": $fa-var-head-side-mask,\n  \"handshake\": $fa-var-handshake,\n  \"gem\": $fa-var-gem,\n  \"dolly\": $fa-var-dolly,\n  \"dolly-box\": $fa-var-dolly-box,\n  \"smoking\": $fa-var-smoking,\n  \"minimize\": $fa-var-minimize,\n  \"compress-arrows-alt\": $fa-var-compress-arrows-alt,\n  \"monument\": $fa-var-monument,\n  \"snowplow\": $fa-var-snowplow,\n  \"angles-right\": $fa-var-angles-right,\n  \"angle-double-right\": $fa-var-angle-double-right,\n  \"cannabis\": $fa-var-cannabis,\n  \"circle-play\": $fa-var-circle-play,\n  \"play-circle\": $fa-var-play-circle,\n  \"tablets\": $fa-var-tablets,\n  \"ethernet\": $fa-var-ethernet,\n  \"euro-sign\": $fa-var-euro-sign,\n  \"eur\": $fa-var-eur,\n  \"euro\": $fa-var-euro,\n  \"chair\": $fa-var-chair,\n  \"circle-check\": $fa-var-circle-check,\n  \"check-circle\": $fa-var-check-circle,\n  \"circle-stop\": $fa-var-circle-stop,\n  \"stop-circle\": $fa-var-stop-circle,\n  \"compass-drafting\": $fa-var-compass-drafting,\n  \"drafting-compass\": $fa-var-drafting-compass,\n  \"plate-wheat\": $fa-var-plate-wheat,\n  \"icicles\": $fa-var-icicles,\n  \"person-shelter\": $fa-var-person-shelter,\n  \"neuter\": $fa-var-neuter,\n  \"id-badge\": $fa-var-id-badge,\n  \"marker\": $fa-var-marker,\n  \"face-laugh-beam\": $fa-var-face-laugh-beam,\n  \"laugh-beam\": $fa-var-laugh-beam,\n  \"helicopter-symbol\": $fa-var-helicopter-symbol,\n  \"universal-access\": $fa-var-universal-access,\n  \"circle-chevron-up\": $fa-var-circle-chevron-up,\n  \"chevron-circle-up\": $fa-var-chevron-circle-up,\n  \"lari-sign\": $fa-var-lari-sign,\n  \"volcano\": $fa-var-volcano,\n  \"person-walking-dashed-line-arrow-right\": $fa-var-person-walking-dashed-line-arrow-right,\n  \"sterling-sign\": $fa-var-sterling-sign,\n  \"gbp\": $fa-var-gbp,\n  \"pound-sign\": $fa-var-pound-sign,\n  \"viruses\": $fa-var-viruses,\n  \"square-person-confined\": $fa-var-square-person-confined,\n  \"user-tie\": $fa-var-user-tie,\n  \"arrow-down-long\": $fa-var-arrow-down-long,\n  \"long-arrow-down\": $fa-var-long-arrow-down,\n  \"tent-arrow-down-to-line\": $fa-var-tent-arrow-down-to-line,\n  \"certificate\": $fa-var-certificate,\n  \"reply-all\": $fa-var-reply-all,\n  \"mail-reply-all\": $fa-var-mail-reply-all,\n  \"suitcase\": $fa-var-suitcase,\n  \"person-skating\": $fa-var-person-skating,\n  \"skating\": $fa-var-skating,\n  \"filter-circle-dollar\": $fa-var-filter-circle-dollar,\n  \"funnel-dollar\": $fa-var-funnel-dollar,\n  \"camera-retro\": $fa-var-camera-retro,\n  \"circle-arrow-down\": $fa-var-circle-arrow-down,\n  \"arrow-circle-down\": $fa-var-arrow-circle-down,\n  \"file-import\": $fa-var-file-import,\n  \"arrow-right-to-file\": $fa-var-arrow-right-to-file,\n  \"square-arrow-up-right\": $fa-var-square-arrow-up-right,\n  \"external-link-square\": $fa-var-external-link-square,\n  \"box-open\": $fa-var-box-open,\n  \"scroll\": $fa-var-scroll,\n  \"spa\": $fa-var-spa,\n  \"location-pin-lock\": $fa-var-location-pin-lock,\n  \"pause\": $fa-var-pause,\n  \"hill-avalanche\": $fa-var-hill-avalanche,\n  \"temperature-empty\": $fa-var-temperature-empty,\n  \"temperature-0\": $fa-var-temperature-0,\n  \"thermometer-0\": $fa-var-thermometer-0,\n  \"thermometer-empty\": $fa-var-thermometer-empty,\n  \"bomb\": $fa-var-bomb,\n  \"registered\": $fa-var-registered,\n  \"address-card\": $fa-var-address-card,\n  \"contact-card\": $fa-var-contact-card,\n  \"vcard\": $fa-var-vcard,\n  \"scale-unbalanced-flip\": $fa-var-scale-unbalanced-flip,\n  \"balance-scale-right\": $fa-var-balance-scale-right,\n  \"subscript\": $fa-var-subscript,\n  \"diamond-turn-right\": $fa-var-diamond-turn-right,\n  \"directions\": $fa-var-directions,\n  \"burst\": $fa-var-burst,\n  \"house-laptop\": $fa-var-house-laptop,\n  \"laptop-house\": $fa-var-laptop-house,\n  \"face-tired\": $fa-var-face-tired,\n  \"tired\": $fa-var-tired,\n  \"money-bills\": $fa-var-money-bills,\n  \"smog\": $fa-var-smog,\n  \"crutch\": $fa-var-crutch,\n  \"cloud-arrow-up\": $fa-var-cloud-arrow-up,\n  \"cloud-upload\": $fa-var-cloud-upload,\n  \"cloud-upload-alt\": $fa-var-cloud-upload-alt,\n  \"palette\": $fa-var-palette,\n  \"arrows-turn-right\": $fa-var-arrows-turn-right,\n  \"vest\": $fa-var-vest,\n  \"ferry\": $fa-var-ferry,\n  \"arrows-down-to-people\": $fa-var-arrows-down-to-people,\n  \"seedling\": $fa-var-seedling,\n  \"sprout\": $fa-var-sprout,\n  \"left-right\": $fa-var-left-right,\n  \"arrows-alt-h\": $fa-var-arrows-alt-h,\n  \"boxes-packing\": $fa-var-boxes-packing,\n  \"circle-arrow-left\": $fa-var-circle-arrow-left,\n  \"arrow-circle-left\": $fa-var-arrow-circle-left,\n  \"group-arrows-rotate\": $fa-var-group-arrows-rotate,\n  \"bowl-food\": $fa-var-bowl-food,\n  \"candy-cane\": $fa-var-candy-cane,\n  \"arrow-down-wide-short\": $fa-var-arrow-down-wide-short,\n  \"sort-amount-asc\": $fa-var-sort-amount-asc,\n  \"sort-amount-down\": $fa-var-sort-amount-down,\n  \"cloud-bolt\": $fa-var-cloud-bolt,\n  \"thunderstorm\": $fa-var-thunderstorm,\n  \"text-slash\": $fa-var-text-slash,\n  \"remove-format\": $fa-var-remove-format,\n  \"face-smile-wink\": $fa-var-face-smile-wink,\n  \"smile-wink\": $fa-var-smile-wink,\n  \"file-word\": $fa-var-file-word,\n  \"file-powerpoint\": $fa-var-file-powerpoint,\n  \"arrows-left-right\": $fa-var-arrows-left-right,\n  \"arrows-h\": $fa-var-arrows-h,\n  \"house-lock\": $fa-var-house-lock,\n  \"cloud-arrow-down\": $fa-var-cloud-arrow-down,\n  \"cloud-download\": $fa-var-cloud-download,\n  \"cloud-download-alt\": $fa-var-cloud-download-alt,\n  \"children\": $fa-var-children,\n  \"chalkboard\": $fa-var-chalkboard,\n  \"blackboard\": $fa-var-blackboard,\n  \"user-large-slash\": $fa-var-user-large-slash,\n  \"user-alt-slash\": $fa-var-user-alt-slash,\n  \"envelope-open\": $fa-var-envelope-open,\n  \"handshake-simple-slash\": $fa-var-handshake-simple-slash,\n  \"handshake-alt-slash\": $fa-var-handshake-alt-slash,\n  \"mattress-pillow\": $fa-var-mattress-pillow,\n  \"guarani-sign\": $fa-var-guarani-sign,\n  \"arrows-rotate\": $fa-var-arrows-rotate,\n  \"refresh\": $fa-var-refresh,\n  \"sync\": $fa-var-sync,\n  \"fire-extinguisher\": $fa-var-fire-extinguisher,\n  \"cruzeiro-sign\": $fa-var-cruzeiro-sign,\n  \"greater-than-equal\": $fa-var-greater-than-equal,\n  \"shield-halved\": $fa-var-shield-halved,\n  \"shield-alt\": $fa-var-shield-alt,\n  \"book-atlas\": $fa-var-book-atlas,\n  \"atlas\": $fa-var-atlas,\n  \"virus\": $fa-var-virus,\n  \"envelope-circle-check\": $fa-var-envelope-circle-check,\n  \"layer-group\": $fa-var-layer-group,\n  \"arrows-to-dot\": $fa-var-arrows-to-dot,\n  \"archway\": $fa-var-archway,\n  \"heart-circle-check\": $fa-var-heart-circle-check,\n  \"house-chimney-crack\": $fa-var-house-chimney-crack,\n  \"house-damage\": $fa-var-house-damage,\n  \"file-zipper\": $fa-var-file-zipper,\n  \"file-archive\": $fa-var-file-archive,\n  \"square\": $fa-var-square,\n  \"martini-glass-empty\": $fa-var-martini-glass-empty,\n  \"glass-martini\": $fa-var-glass-martini,\n  \"couch\": $fa-var-couch,\n  \"cedi-sign\": $fa-var-cedi-sign,\n  \"italic\": $fa-var-italic,\n  \"table-cells-column-lock\": $fa-var-table-cells-column-lock,\n  \"church\": $fa-var-church,\n  \"comments-dollar\": $fa-var-comments-dollar,\n  \"democrat\": $fa-var-democrat,\n  \"z\": $fa-var-z,\n  \"person-skiing\": $fa-var-person-skiing,\n  \"skiing\": $fa-var-skiing,\n  \"road-lock\": $fa-var-road-lock,\n  \"a\": $fa-var-a,\n  \"temperature-arrow-down\": $fa-var-temperature-arrow-down,\n  \"temperature-down\": $fa-var-temperature-down,\n  \"feather-pointed\": $fa-var-feather-pointed,\n  \"feather-alt\": $fa-var-feather-alt,\n  \"p\": $fa-var-p,\n  \"snowflake\": $fa-var-snowflake,\n  \"newspaper\": $fa-var-newspaper,\n  \"rectangle-ad\": $fa-var-rectangle-ad,\n  \"ad\": $fa-var-ad,\n  \"circle-arrow-right\": $fa-var-circle-arrow-right,\n  \"arrow-circle-right\": $fa-var-arrow-circle-right,\n  \"filter-circle-xmark\": $fa-var-filter-circle-xmark,\n  \"locust\": $fa-var-locust,\n  \"sort\": $fa-var-sort,\n  \"unsorted\": $fa-var-unsorted,\n  \"list-ol\": $fa-var-list-ol,\n  \"list-1-2\": $fa-var-list-1-2,\n  \"list-numeric\": $fa-var-list-numeric,\n  \"person-dress-burst\": $fa-var-person-dress-burst,\n  \"money-check-dollar\": $fa-var-money-check-dollar,\n  \"money-check-alt\": $fa-var-money-check-alt,\n  \"vector-square\": $fa-var-vector-square,\n  \"bread-slice\": $fa-var-bread-slice,\n  \"language\": $fa-var-language,\n  \"face-kiss-wink-heart\": $fa-var-face-kiss-wink-heart,\n  \"kiss-wink-heart\": $fa-var-kiss-wink-heart,\n  \"filter\": $fa-var-filter,\n  \"question\": $fa-var-question,\n  \"file-signature\": $fa-var-file-signature,\n  \"up-down-left-right\": $fa-var-up-down-left-right,\n  \"arrows-alt\": $fa-var-arrows-alt,\n  \"house-chimney-user\": $fa-var-house-chimney-user,\n  \"hand-holding-heart\": $fa-var-hand-holding-heart,\n  \"puzzle-piece\": $fa-var-puzzle-piece,\n  \"money-check\": $fa-var-money-check,\n  \"star-half-stroke\": $fa-var-star-half-stroke,\n  \"star-half-alt\": $fa-var-star-half-alt,\n  \"code\": $fa-var-code,\n  \"whiskey-glass\": $fa-var-whiskey-glass,\n  \"glass-whiskey\": $fa-var-glass-whiskey,\n  \"building-circle-exclamation\": $fa-var-building-circle-exclamation,\n  \"magnifying-glass-chart\": $fa-var-magnifying-glass-chart,\n  \"arrow-up-right-from-square\": $fa-var-arrow-up-right-from-square,\n  \"external-link\": $fa-var-external-link,\n  \"cubes-stacked\": $fa-var-cubes-stacked,\n  \"won-sign\": $fa-var-won-sign,\n  \"krw\": $fa-var-krw,\n  \"won\": $fa-var-won,\n  \"virus-covid\": $fa-var-virus-covid,\n  \"austral-sign\": $fa-var-austral-sign,\n  \"f\": $fa-var-f,\n  \"leaf\": $fa-var-leaf,\n  \"road\": $fa-var-road,\n  \"taxi\": $fa-var-taxi,\n  \"cab\": $fa-var-cab,\n  \"person-circle-plus\": $fa-var-person-circle-plus,\n  \"chart-pie\": $fa-var-chart-pie,\n  \"pie-chart\": $fa-var-pie-chart,\n  \"bolt-lightning\": $fa-var-bolt-lightning,\n  \"sack-xmark\": $fa-var-sack-xmark,\n  \"file-excel\": $fa-var-file-excel,\n  \"file-contract\": $fa-var-file-contract,\n  \"fish-fins\": $fa-var-fish-fins,\n  \"building-flag\": $fa-var-building-flag,\n  \"face-grin-beam\": $fa-var-face-grin-beam,\n  \"grin-beam\": $fa-var-grin-beam,\n  \"object-ungroup\": $fa-var-object-ungroup,\n  \"poop\": $fa-var-poop,\n  \"location-pin\": $fa-var-location-pin,\n  \"map-marker\": $fa-var-map-marker,\n  \"kaaba\": $fa-var-kaaba,\n  \"toilet-paper\": $fa-var-toilet-paper,\n  \"helmet-safety\": $fa-var-helmet-safety,\n  \"hard-hat\": $fa-var-hard-hat,\n  \"hat-hard\": $fa-var-hat-hard,\n  \"eject\": $fa-var-eject,\n  \"circle-right\": $fa-var-circle-right,\n  \"arrow-alt-circle-right\": $fa-var-arrow-alt-circle-right,\n  \"plane-circle-check\": $fa-var-plane-circle-check,\n  \"face-rolling-eyes\": $fa-var-face-rolling-eyes,\n  \"meh-rolling-eyes\": $fa-var-meh-rolling-eyes,\n  \"object-group\": $fa-var-object-group,\n  \"chart-line\": $fa-var-chart-line,\n  \"line-chart\": $fa-var-line-chart,\n  \"mask-ventilator\": $fa-var-mask-ventilator,\n  \"arrow-right\": $fa-var-arrow-right,\n  \"signs-post\": $fa-var-signs-post,\n  \"map-signs\": $fa-var-map-signs,\n  \"cash-register\": $fa-var-cash-register,\n  \"person-circle-question\": $fa-var-person-circle-question,\n  \"h\": $fa-var-h,\n  \"tarp\": $fa-var-tarp,\n  \"screwdriver-wrench\": $fa-var-screwdriver-wrench,\n  \"tools\": $fa-var-tools,\n  \"arrows-to-eye\": $fa-var-arrows-to-eye,\n  \"plug-circle-bolt\": $fa-var-plug-circle-bolt,\n  \"heart\": $fa-var-heart,\n  \"mars-and-venus\": $fa-var-mars-and-venus,\n  \"house-user\": $fa-var-house-user,\n  \"home-user\": $fa-var-home-user,\n  \"dumpster-fire\": $fa-var-dumpster-fire,\n  \"house-crack\": $fa-var-house-crack,\n  \"martini-glass-citrus\": $fa-var-martini-glass-citrus,\n  \"cocktail\": $fa-var-cocktail,\n  \"face-surprise\": $fa-var-face-surprise,\n  \"surprise\": $fa-var-surprise,\n  \"bottle-water\": $fa-var-bottle-water,\n  \"circle-pause\": $fa-var-circle-pause,\n  \"pause-circle\": $fa-var-pause-circle,\n  \"toilet-paper-slash\": $fa-var-toilet-paper-slash,\n  \"apple-whole\": $fa-var-apple-whole,\n  \"apple-alt\": $fa-var-apple-alt,\n  \"kitchen-set\": $fa-var-kitchen-set,\n  \"r\": $fa-var-r,\n  \"temperature-quarter\": $fa-var-temperature-quarter,\n  \"temperature-1\": $fa-var-temperature-1,\n  \"thermometer-1\": $fa-var-thermometer-1,\n  \"thermometer-quarter\": $fa-var-thermometer-quarter,\n  \"cube\": $fa-var-cube,\n  \"bitcoin-sign\": $fa-var-bitcoin-sign,\n  \"shield-dog\": $fa-var-shield-dog,\n  \"solar-panel\": $fa-var-solar-panel,\n  \"lock-open\": $fa-var-lock-open,\n  \"elevator\": $fa-var-elevator,\n  \"money-bill-transfer\": $fa-var-money-bill-transfer,\n  \"money-bill-trend-up\": $fa-var-money-bill-trend-up,\n  \"house-flood-water-circle-arrow-right\": $fa-var-house-flood-water-circle-arrow-right,\n  \"square-poll-horizontal\": $fa-var-square-poll-horizontal,\n  \"poll-h\": $fa-var-poll-h,\n  \"circle\": $fa-var-circle,\n  \"backward-fast\": $fa-var-backward-fast,\n  \"fast-backward\": $fa-var-fast-backward,\n  \"recycle\": $fa-var-recycle,\n  \"user-astronaut\": $fa-var-user-astronaut,\n  \"plane-slash\": $fa-var-plane-slash,\n  \"trademark\": $fa-var-trademark,\n  \"basketball\": $fa-var-basketball,\n  \"basketball-ball\": $fa-var-basketball-ball,\n  \"satellite-dish\": $fa-var-satellite-dish,\n  \"circle-up\": $fa-var-circle-up,\n  \"arrow-alt-circle-up\": $fa-var-arrow-alt-circle-up,\n  \"mobile-screen-button\": $fa-var-mobile-screen-button,\n  \"mobile-alt\": $fa-var-mobile-alt,\n  \"volume-high\": $fa-var-volume-high,\n  \"volume-up\": $fa-var-volume-up,\n  \"users-rays\": $fa-var-users-rays,\n  \"wallet\": $fa-var-wallet,\n  \"clipboard-check\": $fa-var-clipboard-check,\n  \"file-audio\": $fa-var-file-audio,\n  \"burger\": $fa-var-burger,\n  \"hamburger\": $fa-var-hamburger,\n  \"wrench\": $fa-var-wrench,\n  \"bugs\": $fa-var-bugs,\n  \"rupee-sign\": $fa-var-rupee-sign,\n  \"rupee\": $fa-var-rupee,\n  \"file-image\": $fa-var-file-image,\n  \"circle-question\": $fa-var-circle-question,\n  \"question-circle\": $fa-var-question-circle,\n  \"plane-departure\": $fa-var-plane-departure,\n  \"handshake-slash\": $fa-var-handshake-slash,\n  \"book-bookmark\": $fa-var-book-bookmark,\n  \"code-branch\": $fa-var-code-branch,\n  \"hat-cowboy\": $fa-var-hat-cowboy,\n  \"bridge\": $fa-var-bridge,\n  \"phone-flip\": $fa-var-phone-flip,\n  \"phone-alt\": $fa-var-phone-alt,\n  \"truck-front\": $fa-var-truck-front,\n  \"cat\": $fa-var-cat,\n  \"anchor-circle-exclamation\": $fa-var-anchor-circle-exclamation,\n  \"truck-field\": $fa-var-truck-field,\n  \"route\": $fa-var-route,\n  \"clipboard-question\": $fa-var-clipboard-question,\n  \"panorama\": $fa-var-panorama,\n  \"comment-medical\": $fa-var-comment-medical,\n  \"teeth-open\": $fa-var-teeth-open,\n  \"file-circle-minus\": $fa-var-file-circle-minus,\n  \"tags\": $fa-var-tags,\n  \"wine-glass\": $fa-var-wine-glass,\n  \"forward-fast\": $fa-var-forward-fast,\n  \"fast-forward\": $fa-var-fast-forward,\n  \"face-meh-blank\": $fa-var-face-meh-blank,\n  \"meh-blank\": $fa-var-meh-blank,\n  \"square-parking\": $fa-var-square-parking,\n  \"parking\": $fa-var-parking,\n  \"house-signal\": $fa-var-house-signal,\n  \"bars-progress\": $fa-var-bars-progress,\n  \"tasks-alt\": $fa-var-tasks-alt,\n  \"faucet-drip\": $fa-var-faucet-drip,\n  \"cart-flatbed\": $fa-var-cart-flatbed,\n  \"dolly-flatbed\": $fa-var-dolly-flatbed,\n  \"ban-smoking\": $fa-var-ban-smoking,\n  \"smoking-ban\": $fa-var-smoking-ban,\n  \"terminal\": $fa-var-terminal,\n  \"mobile-button\": $fa-var-mobile-button,\n  \"house-medical-flag\": $fa-var-house-medical-flag,\n  \"basket-shopping\": $fa-var-basket-shopping,\n  \"shopping-basket\": $fa-var-shopping-basket,\n  \"tape\": $fa-var-tape,\n  \"bus-simple\": $fa-var-bus-simple,\n  \"bus-alt\": $fa-var-bus-alt,\n  \"eye\": $fa-var-eye,\n  \"face-sad-cry\": $fa-var-face-sad-cry,\n  \"sad-cry\": $fa-var-sad-cry,\n  \"audio-description\": $fa-var-audio-description,\n  \"person-military-to-person\": $fa-var-person-military-to-person,\n  \"file-shield\": $fa-var-file-shield,\n  \"user-slash\": $fa-var-user-slash,\n  \"pen\": $fa-var-pen,\n  \"tower-observation\": $fa-var-tower-observation,\n  \"file-code\": $fa-var-file-code,\n  \"signal\": $fa-var-signal,\n  \"signal-5\": $fa-var-signal-5,\n  \"signal-perfect\": $fa-var-signal-perfect,\n  \"bus\": $fa-var-bus,\n  \"heart-circle-xmark\": $fa-var-heart-circle-xmark,\n  \"house-chimney\": $fa-var-house-chimney,\n  \"home-lg\": $fa-var-home-lg,\n  \"window-maximize\": $fa-var-window-maximize,\n  \"face-frown\": $fa-var-face-frown,\n  \"frown\": $fa-var-frown,\n  \"prescription\": $fa-var-prescription,\n  \"shop\": $fa-var-shop,\n  \"store-alt\": $fa-var-store-alt,\n  \"floppy-disk\": $fa-var-floppy-disk,\n  \"save\": $fa-var-save,\n  \"vihara\": $fa-var-vihara,\n  \"scale-unbalanced\": $fa-var-scale-unbalanced,\n  \"balance-scale-left\": $fa-var-balance-scale-left,\n  \"sort-up\": $fa-var-sort-up,\n  \"sort-asc\": $fa-var-sort-asc,\n  \"comment-dots\": $fa-var-comment-dots,\n  \"commenting\": $fa-var-commenting,\n  \"plant-wilt\": $fa-var-plant-wilt,\n  \"diamond\": $fa-var-diamond,\n  \"face-grin-squint\": $fa-var-face-grin-squint,\n  \"grin-squint\": $fa-var-grin-squint,\n  \"hand-holding-dollar\": $fa-var-hand-holding-dollar,\n  \"hand-holding-usd\": $fa-var-hand-holding-usd,\n  \"bacterium\": $fa-var-bacterium,\n  \"hand-pointer\": $fa-var-hand-pointer,\n  \"drum-steelpan\": $fa-var-drum-steelpan,\n  \"hand-scissors\": $fa-var-hand-scissors,\n  \"hands-praying\": $fa-var-hands-praying,\n  \"praying-hands\": $fa-var-praying-hands,\n  \"arrow-rotate-right\": $fa-var-arrow-rotate-right,\n  \"arrow-right-rotate\": $fa-var-arrow-right-rotate,\n  \"arrow-rotate-forward\": $fa-var-arrow-rotate-forward,\n  \"redo\": $fa-var-redo,\n  \"biohazard\": $fa-var-biohazard,\n  \"location-crosshairs\": $fa-var-location-crosshairs,\n  \"location\": $fa-var-location,\n  \"mars-double\": $fa-var-mars-double,\n  \"child-dress\": $fa-var-child-dress,\n  \"users-between-lines\": $fa-var-users-between-lines,\n  \"lungs-virus\": $fa-var-lungs-virus,\n  \"face-grin-tears\": $fa-var-face-grin-tears,\n  \"grin-tears\": $fa-var-grin-tears,\n  \"phone\": $fa-var-phone,\n  \"calendar-xmark\": $fa-var-calendar-xmark,\n  \"calendar-times\": $fa-var-calendar-times,\n  \"child-reaching\": $fa-var-child-reaching,\n  \"head-side-virus\": $fa-var-head-side-virus,\n  \"user-gear\": $fa-var-user-gear,\n  \"user-cog\": $fa-var-user-cog,\n  \"arrow-up-1-9\": $fa-var-arrow-up-1-9,\n  \"sort-numeric-up\": $fa-var-sort-numeric-up,\n  \"door-closed\": $fa-var-door-closed,\n  \"shield-virus\": $fa-var-shield-virus,\n  \"dice-six\": $fa-var-dice-six,\n  \"mosquito-net\": $fa-var-mosquito-net,\n  \"bridge-water\": $fa-var-bridge-water,\n  \"person-booth\": $fa-var-person-booth,\n  \"text-width\": $fa-var-text-width,\n  \"hat-wizard\": $fa-var-hat-wizard,\n  \"pen-fancy\": $fa-var-pen-fancy,\n  \"person-digging\": $fa-var-person-digging,\n  \"digging\": $fa-var-digging,\n  \"trash\": $fa-var-trash,\n  \"gauge-simple\": $fa-var-gauge-simple,\n  \"gauge-simple-med\": $fa-var-gauge-simple-med,\n  \"tachometer-average\": $fa-var-tachometer-average,\n  \"book-medical\": $fa-var-book-medical,\n  \"poo\": $fa-var-poo,\n  \"quote-right\": $fa-var-quote-right,\n  \"quote-right-alt\": $fa-var-quote-right-alt,\n  \"shirt\": $fa-var-shirt,\n  \"t-shirt\": $fa-var-t-shirt,\n  \"tshirt\": $fa-var-tshirt,\n  \"cubes\": $fa-var-cubes,\n  \"divide\": $fa-var-divide,\n  \"tenge-sign\": $fa-var-tenge-sign,\n  \"tenge\": $fa-var-tenge,\n  \"headphones\": $fa-var-headphones,\n  \"hands-holding\": $fa-var-hands-holding,\n  \"hands-clapping\": $fa-var-hands-clapping,\n  \"republican\": $fa-var-republican,\n  \"arrow-left\": $fa-var-arrow-left,\n  \"person-circle-xmark\": $fa-var-person-circle-xmark,\n  \"ruler\": $fa-var-ruler,\n  \"align-left\": $fa-var-align-left,\n  \"dice-d6\": $fa-var-dice-d6,\n  \"restroom\": $fa-var-restroom,\n  \"j\": $fa-var-j,\n  \"users-viewfinder\": $fa-var-users-viewfinder,\n  \"file-video\": $fa-var-file-video,\n  \"up-right-from-square\": $fa-var-up-right-from-square,\n  \"external-link-alt\": $fa-var-external-link-alt,\n  \"table-cells\": $fa-var-table-cells,\n  \"th\": $fa-var-th,\n  \"file-pdf\": $fa-var-file-pdf,\n  \"book-bible\": $fa-var-book-bible,\n  \"bible\": $fa-var-bible,\n  \"o\": $fa-var-o,\n  \"suitcase-medical\": $fa-var-suitcase-medical,\n  \"medkit\": $fa-var-medkit,\n  \"user-secret\": $fa-var-user-secret,\n  \"otter\": $fa-var-otter,\n  \"person-dress\": $fa-var-person-dress,\n  \"female\": $fa-var-female,\n  \"comment-dollar\": $fa-var-comment-dollar,\n  \"business-time\": $fa-var-business-time,\n  \"briefcase-clock\": $fa-var-briefcase-clock,\n  \"table-cells-large\": $fa-var-table-cells-large,\n  \"th-large\": $fa-var-th-large,\n  \"book-tanakh\": $fa-var-book-tanakh,\n  \"tanakh\": $fa-var-tanakh,\n  \"phone-volume\": $fa-var-phone-volume,\n  \"volume-control-phone\": $fa-var-volume-control-phone,\n  \"hat-cowboy-side\": $fa-var-hat-cowboy-side,\n  \"clipboard-user\": $fa-var-clipboard-user,\n  \"child\": $fa-var-child,\n  \"lira-sign\": $fa-var-lira-sign,\n  \"satellite\": $fa-var-satellite,\n  \"plane-lock\": $fa-var-plane-lock,\n  \"tag\": $fa-var-tag,\n  \"comment\": $fa-var-comment,\n  \"cake-candles\": $fa-var-cake-candles,\n  \"birthday-cake\": $fa-var-birthday-cake,\n  \"cake\": $fa-var-cake,\n  \"envelope\": $fa-var-envelope,\n  \"angles-up\": $fa-var-angles-up,\n  \"angle-double-up\": $fa-var-angle-double-up,\n  \"paperclip\": $fa-var-paperclip,\n  \"arrow-right-to-city\": $fa-var-arrow-right-to-city,\n  \"ribbon\": $fa-var-ribbon,\n  \"lungs\": $fa-var-lungs,\n  \"arrow-up-9-1\": $fa-var-arrow-up-9-1,\n  \"sort-numeric-up-alt\": $fa-var-sort-numeric-up-alt,\n  \"litecoin-sign\": $fa-var-litecoin-sign,\n  \"border-none\": $fa-var-border-none,\n  \"circle-nodes\": $fa-var-circle-nodes,\n  \"parachute-box\": $fa-var-parachute-box,\n  \"indent\": $fa-var-indent,\n  \"truck-field-un\": $fa-var-truck-field-un,\n  \"hourglass\": $fa-var-hourglass,\n  \"hourglass-empty\": $fa-var-hourglass-empty,\n  \"mountain\": $fa-var-mountain,\n  \"user-doctor\": $fa-var-user-doctor,\n  \"user-md\": $fa-var-user-md,\n  \"circle-info\": $fa-var-circle-info,\n  \"info-circle\": $fa-var-info-circle,\n  \"cloud-meatball\": $fa-var-cloud-meatball,\n  \"camera\": $fa-var-camera,\n  \"camera-alt\": $fa-var-camera-alt,\n  \"square-virus\": $fa-var-square-virus,\n  \"meteor\": $fa-var-meteor,\n  \"car-on\": $fa-var-car-on,\n  \"sleigh\": $fa-var-sleigh,\n  \"arrow-down-1-9\": $fa-var-arrow-down-1-9,\n  \"sort-numeric-asc\": $fa-var-sort-numeric-asc,\n  \"sort-numeric-down\": $fa-var-sort-numeric-down,\n  \"hand-holding-droplet\": $fa-var-hand-holding-droplet,\n  \"hand-holding-water\": $fa-var-hand-holding-water,\n  \"water\": $fa-var-water,\n  \"calendar-check\": $fa-var-calendar-check,\n  \"braille\": $fa-var-braille,\n  \"prescription-bottle-medical\": $fa-var-prescription-bottle-medical,\n  \"prescription-bottle-alt\": $fa-var-prescription-bottle-alt,\n  \"landmark\": $fa-var-landmark,\n  \"truck\": $fa-var-truck,\n  \"crosshairs\": $fa-var-crosshairs,\n  \"person-cane\": $fa-var-person-cane,\n  \"tent\": $fa-var-tent,\n  \"vest-patches\": $fa-var-vest-patches,\n  \"check-double\": $fa-var-check-double,\n  \"arrow-down-a-z\": $fa-var-arrow-down-a-z,\n  \"sort-alpha-asc\": $fa-var-sort-alpha-asc,\n  \"sort-alpha-down\": $fa-var-sort-alpha-down,\n  \"money-bill-wheat\": $fa-var-money-bill-wheat,\n  \"cookie\": $fa-var-cookie,\n  \"arrow-rotate-left\": $fa-var-arrow-rotate-left,\n  \"arrow-left-rotate\": $fa-var-arrow-left-rotate,\n  \"arrow-rotate-back\": $fa-var-arrow-rotate-back,\n  \"arrow-rotate-backward\": $fa-var-arrow-rotate-backward,\n  \"undo\": $fa-var-undo,\n  \"hard-drive\": $fa-var-hard-drive,\n  \"hdd\": $fa-var-hdd,\n  \"face-grin-squint-tears\": $fa-var-face-grin-squint-tears,\n  \"grin-squint-tears\": $fa-var-grin-squint-tears,\n  \"dumbbell\": $fa-var-dumbbell,\n  \"rectangle-list\": $fa-var-rectangle-list,\n  \"list-alt\": $fa-var-list-alt,\n  \"tarp-droplet\": $fa-var-tarp-droplet,\n  \"house-medical-circle-check\": $fa-var-house-medical-circle-check,\n  \"person-skiing-nordic\": $fa-var-person-skiing-nordic,\n  \"skiing-nordic\": $fa-var-skiing-nordic,\n  \"calendar-plus\": $fa-var-calendar-plus,\n  \"plane-arrival\": $fa-var-plane-arrival,\n  \"circle-left\": $fa-var-circle-left,\n  \"arrow-alt-circle-left\": $fa-var-arrow-alt-circle-left,\n  \"train-subway\": $fa-var-train-subway,\n  \"subway\": $fa-var-subway,\n  \"chart-gantt\": $fa-var-chart-gantt,\n  \"indian-rupee-sign\": $fa-var-indian-rupee-sign,\n  \"indian-rupee\": $fa-var-indian-rupee,\n  \"inr\": $fa-var-inr,\n  \"crop-simple\": $fa-var-crop-simple,\n  \"crop-alt\": $fa-var-crop-alt,\n  \"money-bill-1\": $fa-var-money-bill-1,\n  \"money-bill-alt\": $fa-var-money-bill-alt,\n  \"left-long\": $fa-var-left-long,\n  \"long-arrow-alt-left\": $fa-var-long-arrow-alt-left,\n  \"dna\": $fa-var-dna,\n  \"virus-slash\": $fa-var-virus-slash,\n  \"minus\": $fa-var-minus,\n  \"subtract\": $fa-var-subtract,\n  \"chess\": $fa-var-chess,\n  \"arrow-left-long\": $fa-var-arrow-left-long,\n  \"long-arrow-left\": $fa-var-long-arrow-left,\n  \"plug-circle-check\": $fa-var-plug-circle-check,\n  \"street-view\": $fa-var-street-view,\n  \"franc-sign\": $fa-var-franc-sign,\n  \"volume-off\": $fa-var-volume-off,\n  \"hands-asl-interpreting\": $fa-var-hands-asl-interpreting,\n  \"american-sign-language-interpreting\": $fa-var-american-sign-language-interpreting,\n  \"asl-interpreting\": $fa-var-asl-interpreting,\n  \"hands-american-sign-language-interpreting\": $fa-var-hands-american-sign-language-interpreting,\n  \"gear\": $fa-var-gear,\n  \"cog\": $fa-var-cog,\n  \"droplet-slash\": $fa-var-droplet-slash,\n  \"tint-slash\": $fa-var-tint-slash,\n  \"mosque\": $fa-var-mosque,\n  \"mosquito\": $fa-var-mosquito,\n  \"star-of-david\": $fa-var-star-of-david,\n  \"person-military-rifle\": $fa-var-person-military-rifle,\n  \"cart-shopping\": $fa-var-cart-shopping,\n  \"shopping-cart\": $fa-var-shopping-cart,\n  \"vials\": $fa-var-vials,\n  \"plug-circle-plus\": $fa-var-plug-circle-plus,\n  \"place-of-worship\": $fa-var-place-of-worship,\n  \"grip-vertical\": $fa-var-grip-vertical,\n  \"arrow-turn-up\": $fa-var-arrow-turn-up,\n  \"level-up\": $fa-var-level-up,\n  \"u\": $fa-var-u,\n  \"square-root-variable\": $fa-var-square-root-variable,\n  \"square-root-alt\": $fa-var-square-root-alt,\n  \"clock\": $fa-var-clock,\n  \"clock-four\": $fa-var-clock-four,\n  \"backward-step\": $fa-var-backward-step,\n  \"step-backward\": $fa-var-step-backward,\n  \"pallet\": $fa-var-pallet,\n  \"faucet\": $fa-var-faucet,\n  \"baseball-bat-ball\": $fa-var-baseball-bat-ball,\n  \"s\": $fa-var-s,\n  \"timeline\": $fa-var-timeline,\n  \"keyboard\": $fa-var-keyboard,\n  \"caret-down\": $fa-var-caret-down,\n  \"house-chimney-medical\": $fa-var-house-chimney-medical,\n  \"clinic-medical\": $fa-var-clinic-medical,\n  \"temperature-three-quarters\": $fa-var-temperature-three-quarters,\n  \"temperature-3\": $fa-var-temperature-3,\n  \"thermometer-3\": $fa-var-thermometer-3,\n  \"thermometer-three-quarters\": $fa-var-thermometer-three-quarters,\n  \"mobile-screen\": $fa-var-mobile-screen,\n  \"mobile-android-alt\": $fa-var-mobile-android-alt,\n  \"plane-up\": $fa-var-plane-up,\n  \"piggy-bank\": $fa-var-piggy-bank,\n  \"battery-half\": $fa-var-battery-half,\n  \"battery-3\": $fa-var-battery-3,\n  \"mountain-city\": $fa-var-mountain-city,\n  \"coins\": $fa-var-coins,\n  \"khanda\": $fa-var-khanda,\n  \"sliders\": $fa-var-sliders,\n  \"sliders-h\": $fa-var-sliders-h,\n  \"folder-tree\": $fa-var-folder-tree,\n  \"network-wired\": $fa-var-network-wired,\n  \"map-pin\": $fa-var-map-pin,\n  \"hamsa\": $fa-var-hamsa,\n  \"cent-sign\": $fa-var-cent-sign,\n  \"flask\": $fa-var-flask,\n  \"person-pregnant\": $fa-var-person-pregnant,\n  \"wand-sparkles\": $fa-var-wand-sparkles,\n  \"ellipsis-vertical\": $fa-var-ellipsis-vertical,\n  \"ellipsis-v\": $fa-var-ellipsis-v,\n  \"ticket\": $fa-var-ticket,\n  \"power-off\": $fa-var-power-off,\n  \"right-long\": $fa-var-right-long,\n  \"long-arrow-alt-right\": $fa-var-long-arrow-alt-right,\n  \"flag-usa\": $fa-var-flag-usa,\n  \"laptop-file\": $fa-var-laptop-file,\n  \"tty\": $fa-var-tty,\n  \"teletype\": $fa-var-teletype,\n  \"diagram-next\": $fa-var-diagram-next,\n  \"person-rifle\": $fa-var-person-rifle,\n  \"house-medical-circle-exclamation\": $fa-var-house-medical-circle-exclamation,\n  \"closed-captioning\": $fa-var-closed-captioning,\n  \"person-hiking\": $fa-var-person-hiking,\n  \"hiking\": $fa-var-hiking,\n  \"venus-double\": $fa-var-venus-double,\n  \"images\": $fa-var-images,\n  \"calculator\": $fa-var-calculator,\n  \"people-pulling\": $fa-var-people-pulling,\n  \"n\": $fa-var-n,\n  \"cable-car\": $fa-var-cable-car,\n  \"tram\": $fa-var-tram,\n  \"cloud-rain\": $fa-var-cloud-rain,\n  \"building-circle-xmark\": $fa-var-building-circle-xmark,\n  \"ship\": $fa-var-ship,\n  \"arrows-down-to-line\": $fa-var-arrows-down-to-line,\n  \"download\": $fa-var-download,\n  \"face-grin\": $fa-var-face-grin,\n  \"grin\": $fa-var-grin,\n  \"delete-left\": $fa-var-delete-left,\n  \"backspace\": $fa-var-backspace,\n  \"eye-dropper\": $fa-var-eye-dropper,\n  \"eye-dropper-empty\": $fa-var-eye-dropper-empty,\n  \"eyedropper\": $fa-var-eyedropper,\n  \"file-circle-check\": $fa-var-file-circle-check,\n  \"forward\": $fa-var-forward,\n  \"mobile\": $fa-var-mobile,\n  \"mobile-android\": $fa-var-mobile-android,\n  \"mobile-phone\": $fa-var-mobile-phone,\n  \"face-meh\": $fa-var-face-meh,\n  \"meh\": $fa-var-meh,\n  \"align-center\": $fa-var-align-center,\n  \"book-skull\": $fa-var-book-skull,\n  \"book-dead\": $fa-var-book-dead,\n  \"id-card\": $fa-var-id-card,\n  \"drivers-license\": $fa-var-drivers-license,\n  \"outdent\": $fa-var-outdent,\n  \"dedent\": $fa-var-dedent,\n  \"heart-circle-exclamation\": $fa-var-heart-circle-exclamation,\n  \"house\": $fa-var-house,\n  \"home\": $fa-var-home,\n  \"home-alt\": $fa-var-home-alt,\n  \"home-lg-alt\": $fa-var-home-lg-alt,\n  \"calendar-week\": $fa-var-calendar-week,\n  \"laptop-medical\": $fa-var-laptop-medical,\n  \"b\": $fa-var-b,\n  \"file-medical\": $fa-var-file-medical,\n  \"dice-one\": $fa-var-dice-one,\n  \"kiwi-bird\": $fa-var-kiwi-bird,\n  \"arrow-right-arrow-left\": $fa-var-arrow-right-arrow-left,\n  \"exchange\": $fa-var-exchange,\n  \"rotate-right\": $fa-var-rotate-right,\n  \"redo-alt\": $fa-var-redo-alt,\n  \"rotate-forward\": $fa-var-rotate-forward,\n  \"utensils\": $fa-var-utensils,\n  \"cutlery\": $fa-var-cutlery,\n  \"arrow-up-wide-short\": $fa-var-arrow-up-wide-short,\n  \"sort-amount-up\": $fa-var-sort-amount-up,\n  \"mill-sign\": $fa-var-mill-sign,\n  \"bowl-rice\": $fa-var-bowl-rice,\n  \"skull\": $fa-var-skull,\n  \"tower-broadcast\": $fa-var-tower-broadcast,\n  \"broadcast-tower\": $fa-var-broadcast-tower,\n  \"truck-pickup\": $fa-var-truck-pickup,\n  \"up-long\": $fa-var-up-long,\n  \"long-arrow-alt-up\": $fa-var-long-arrow-alt-up,\n  \"stop\": $fa-var-stop,\n  \"code-merge\": $fa-var-code-merge,\n  \"upload\": $fa-var-upload,\n  \"hurricane\": $fa-var-hurricane,\n  \"mound\": $fa-var-mound,\n  \"toilet-portable\": $fa-var-toilet-portable,\n  \"compact-disc\": $fa-var-compact-disc,\n  \"file-arrow-down\": $fa-var-file-arrow-down,\n  \"file-download\": $fa-var-file-download,\n  \"caravan\": $fa-var-caravan,\n  \"shield-cat\": $fa-var-shield-cat,\n  \"bolt\": $fa-var-bolt,\n  \"zap\": $fa-var-zap,\n  \"glass-water\": $fa-var-glass-water,\n  \"oil-well\": $fa-var-oil-well,\n  \"vault\": $fa-var-vault,\n  \"mars\": $fa-var-mars,\n  \"toilet\": $fa-var-toilet,\n  \"plane-circle-xmark\": $fa-var-plane-circle-xmark,\n  \"yen-sign\": $fa-var-yen-sign,\n  \"cny\": $fa-var-cny,\n  \"jpy\": $fa-var-jpy,\n  \"rmb\": $fa-var-rmb,\n  \"yen\": $fa-var-yen,\n  \"ruble-sign\": $fa-var-ruble-sign,\n  \"rouble\": $fa-var-rouble,\n  \"rub\": $fa-var-rub,\n  \"ruble\": $fa-var-ruble,\n  \"sun\": $fa-var-sun,\n  \"guitar\": $fa-var-guitar,\n  \"face-laugh-wink\": $fa-var-face-laugh-wink,\n  \"laugh-wink\": $fa-var-laugh-wink,\n  \"horse-head\": $fa-var-horse-head,\n  \"bore-hole\": $fa-var-bore-hole,\n  \"industry\": $fa-var-industry,\n  \"circle-down\": $fa-var-circle-down,\n  \"arrow-alt-circle-down\": $fa-var-arrow-alt-circle-down,\n  \"arrows-turn-to-dots\": $fa-var-arrows-turn-to-dots,\n  \"florin-sign\": $fa-var-florin-sign,\n  \"arrow-down-short-wide\": $fa-var-arrow-down-short-wide,\n  \"sort-amount-desc\": $fa-var-sort-amount-desc,\n  \"sort-amount-down-alt\": $fa-var-sort-amount-down-alt,\n  \"less-than\": $fa-var-less-than,\n  \"angle-down\": $fa-var-angle-down,\n  \"car-tunnel\": $fa-var-car-tunnel,\n  \"head-side-cough\": $fa-var-head-side-cough,\n  \"grip-lines\": $fa-var-grip-lines,\n  \"thumbs-down\": $fa-var-thumbs-down,\n  \"user-lock\": $fa-var-user-lock,\n  \"arrow-right-long\": $fa-var-arrow-right-long,\n  \"long-arrow-right\": $fa-var-long-arrow-right,\n  \"anchor-circle-xmark\": $fa-var-anchor-circle-xmark,\n  \"ellipsis\": $fa-var-ellipsis,\n  \"ellipsis-h\": $fa-var-ellipsis-h,\n  \"chess-pawn\": $fa-var-chess-pawn,\n  \"kit-medical\": $fa-var-kit-medical,\n  \"first-aid\": $fa-var-first-aid,\n  \"person-through-window\": $fa-var-person-through-window,\n  \"toolbox\": $fa-var-toolbox,\n  \"hands-holding-circle\": $fa-var-hands-holding-circle,\n  \"bug\": $fa-var-bug,\n  \"credit-card\": $fa-var-credit-card,\n  \"credit-card-alt\": $fa-var-credit-card-alt,\n  \"car\": $fa-var-car,\n  \"automobile\": $fa-var-automobile,\n  \"hand-holding-hand\": $fa-var-hand-holding-hand,\n  \"book-open-reader\": $fa-var-book-open-reader,\n  \"book-reader\": $fa-var-book-reader,\n  \"mountain-sun\": $fa-var-mountain-sun,\n  \"arrows-left-right-to-line\": $fa-var-arrows-left-right-to-line,\n  \"dice-d20\": $fa-var-dice-d20,\n  \"truck-droplet\": $fa-var-truck-droplet,\n  \"file-circle-xmark\": $fa-var-file-circle-xmark,\n  \"temperature-arrow-up\": $fa-var-temperature-arrow-up,\n  \"temperature-up\": $fa-var-temperature-up,\n  \"medal\": $fa-var-medal,\n  \"bed\": $fa-var-bed,\n  \"square-h\": $fa-var-square-h,\n  \"h-square\": $fa-var-h-square,\n  \"podcast\": $fa-var-podcast,\n  \"temperature-full\": $fa-var-temperature-full,\n  \"temperature-4\": $fa-var-temperature-4,\n  \"thermometer-4\": $fa-var-thermometer-4,\n  \"thermometer-full\": $fa-var-thermometer-full,\n  \"bell\": $fa-var-bell,\n  \"superscript\": $fa-var-superscript,\n  \"plug-circle-xmark\": $fa-var-plug-circle-xmark,\n  \"star-of-life\": $fa-var-star-of-life,\n  \"phone-slash\": $fa-var-phone-slash,\n  \"paint-roller\": $fa-var-paint-roller,\n  \"handshake-angle\": $fa-var-handshake-angle,\n  \"hands-helping\": $fa-var-hands-helping,\n  \"location-dot\": $fa-var-location-dot,\n  \"map-marker-alt\": $fa-var-map-marker-alt,\n  \"file\": $fa-var-file,\n  \"greater-than\": $fa-var-greater-than,\n  \"person-swimming\": $fa-var-person-swimming,\n  \"swimmer\": $fa-var-swimmer,\n  \"arrow-down\": $fa-var-arrow-down,\n  \"droplet\": $fa-var-droplet,\n  \"tint\": $fa-var-tint,\n  \"eraser\": $fa-var-eraser,\n  \"earth-americas\": $fa-var-earth-americas,\n  \"earth\": $fa-var-earth,\n  \"earth-america\": $fa-var-earth-america,\n  \"globe-americas\": $fa-var-globe-americas,\n  \"person-burst\": $fa-var-person-burst,\n  \"dove\": $fa-var-dove,\n  \"battery-empty\": $fa-var-battery-empty,\n  \"battery-0\": $fa-var-battery-0,\n  \"socks\": $fa-var-socks,\n  \"inbox\": $fa-var-inbox,\n  \"section\": $fa-var-section,\n  \"gauge-high\": $fa-var-gauge-high,\n  \"tachometer-alt\": $fa-var-tachometer-alt,\n  \"tachometer-alt-fast\": $fa-var-tachometer-alt-fast,\n  \"envelope-open-text\": $fa-var-envelope-open-text,\n  \"hospital\": $fa-var-hospital,\n  \"hospital-alt\": $fa-var-hospital-alt,\n  \"hospital-wide\": $fa-var-hospital-wide,\n  \"wine-bottle\": $fa-var-wine-bottle,\n  \"chess-rook\": $fa-var-chess-rook,\n  \"bars-staggered\": $fa-var-bars-staggered,\n  \"reorder\": $fa-var-reorder,\n  \"stream\": $fa-var-stream,\n  \"dharmachakra\": $fa-var-dharmachakra,\n  \"hotdog\": $fa-var-hotdog,\n  \"person-walking-with-cane\": $fa-var-person-walking-with-cane,\n  \"blind\": $fa-var-blind,\n  \"drum\": $fa-var-drum,\n  \"ice-cream\": $fa-var-ice-cream,\n  \"heart-circle-bolt\": $fa-var-heart-circle-bolt,\n  \"fax\": $fa-var-fax,\n  \"paragraph\": $fa-var-paragraph,\n  \"check-to-slot\": $fa-var-check-to-slot,\n  \"vote-yea\": $fa-var-vote-yea,\n  \"star-half\": $fa-var-star-half,\n  \"boxes-stacked\": $fa-var-boxes-stacked,\n  \"boxes\": $fa-var-boxes,\n  \"boxes-alt\": $fa-var-boxes-alt,\n  \"link\": $fa-var-link,\n  \"chain\": $fa-var-chain,\n  \"ear-listen\": $fa-var-ear-listen,\n  \"assistive-listening-systems\": $fa-var-assistive-listening-systems,\n  \"tree-city\": $fa-var-tree-city,\n  \"play\": $fa-var-play,\n  \"font\": $fa-var-font,\n  \"table-cells-row-lock\": $fa-var-table-cells-row-lock,\n  \"rupiah-sign\": $fa-var-rupiah-sign,\n  \"magnifying-glass\": $fa-var-magnifying-glass,\n  \"search\": $fa-var-search,\n  \"table-tennis-paddle-ball\": $fa-var-table-tennis-paddle-ball,\n  \"ping-pong-paddle-ball\": $fa-var-ping-pong-paddle-ball,\n  \"table-tennis\": $fa-var-table-tennis,\n  \"person-dots-from-line\": $fa-var-person-dots-from-line,\n  \"diagnoses\": $fa-var-diagnoses,\n  \"trash-can-arrow-up\": $fa-var-trash-can-arrow-up,\n  \"trash-restore-alt\": $fa-var-trash-restore-alt,\n  \"naira-sign\": $fa-var-naira-sign,\n  \"cart-arrow-down\": $fa-var-cart-arrow-down,\n  \"walkie-talkie\": $fa-var-walkie-talkie,\n  \"file-pen\": $fa-var-file-pen,\n  \"file-edit\": $fa-var-file-edit,\n  \"receipt\": $fa-var-receipt,\n  \"square-pen\": $fa-var-square-pen,\n  \"pen-square\": $fa-var-pen-square,\n  \"pencil-square\": $fa-var-pencil-square,\n  \"suitcase-rolling\": $fa-var-suitcase-rolling,\n  \"person-circle-exclamation\": $fa-var-person-circle-exclamation,\n  \"chevron-down\": $fa-var-chevron-down,\n  \"battery-full\": $fa-var-battery-full,\n  \"battery\": $fa-var-battery,\n  \"battery-5\": $fa-var-battery-5,\n  \"skull-crossbones\": $fa-var-skull-crossbones,\n  \"code-compare\": $fa-var-code-compare,\n  \"list-ul\": $fa-var-list-ul,\n  \"list-dots\": $fa-var-list-dots,\n  \"school-lock\": $fa-var-school-lock,\n  \"tower-cell\": $fa-var-tower-cell,\n  \"down-long\": $fa-var-down-long,\n  \"long-arrow-alt-down\": $fa-var-long-arrow-alt-down,\n  \"ranking-star\": $fa-var-ranking-star,\n  \"chess-king\": $fa-var-chess-king,\n  \"person-harassing\": $fa-var-person-harassing,\n  \"brazilian-real-sign\": $fa-var-brazilian-real-sign,\n  \"landmark-dome\": $fa-var-landmark-dome,\n  \"landmark-alt\": $fa-var-landmark-alt,\n  \"arrow-up\": $fa-var-arrow-up,\n  \"tv\": $fa-var-tv,\n  \"television\": $fa-var-television,\n  \"tv-alt\": $fa-var-tv-alt,\n  \"shrimp\": $fa-var-shrimp,\n  \"list-check\": $fa-var-list-check,\n  \"tasks\": $fa-var-tasks,\n  \"jug-detergent\": $fa-var-jug-detergent,\n  \"circle-user\": $fa-var-circle-user,\n  \"user-circle\": $fa-var-user-circle,\n  \"user-shield\": $fa-var-user-shield,\n  \"wind\": $fa-var-wind,\n  \"car-burst\": $fa-var-car-burst,\n  \"car-crash\": $fa-var-car-crash,\n  \"y\": $fa-var-y,\n  \"person-snowboarding\": $fa-var-person-snowboarding,\n  \"snowboarding\": $fa-var-snowboarding,\n  \"truck-fast\": $fa-var-truck-fast,\n  \"shipping-fast\": $fa-var-shipping-fast,\n  \"fish\": $fa-var-fish,\n  \"user-graduate\": $fa-var-user-graduate,\n  \"circle-half-stroke\": $fa-var-circle-half-stroke,\n  \"adjust\": $fa-var-adjust,\n  \"clapperboard\": $fa-var-clapperboard,\n  \"circle-radiation\": $fa-var-circle-radiation,\n  \"radiation-alt\": $fa-var-radiation-alt,\n  \"baseball\": $fa-var-baseball,\n  \"baseball-ball\": $fa-var-baseball-ball,\n  \"jet-fighter-up\": $fa-var-jet-fighter-up,\n  \"diagram-project\": $fa-var-diagram-project,\n  \"project-diagram\": $fa-var-project-diagram,\n  \"copy\": $fa-var-copy,\n  \"volume-xmark\": $fa-var-volume-xmark,\n  \"volume-mute\": $fa-var-volume-mute,\n  \"volume-times\": $fa-var-volume-times,\n  \"hand-sparkles\": $fa-var-hand-sparkles,\n  \"grip\": $fa-var-grip,\n  \"grip-horizontal\": $fa-var-grip-horizontal,\n  \"share-from-square\": $fa-var-share-from-square,\n  \"share-square\": $fa-var-share-square,\n  \"child-combatant\": $fa-var-child-combatant,\n  \"child-rifle\": $fa-var-child-rifle,\n  \"gun\": $fa-var-gun,\n  \"square-phone\": $fa-var-square-phone,\n  \"phone-square\": $fa-var-phone-square,\n  \"plus\": $fa-var-plus,\n  \"add\": $fa-var-add,\n  \"expand\": $fa-var-expand,\n  \"computer\": $fa-var-computer,\n  \"xmark\": $fa-var-xmark,\n  \"close\": $fa-var-close,\n  \"multiply\": $fa-var-multiply,\n  \"remove\": $fa-var-remove,\n  \"times\": $fa-var-times,\n  \"arrows-up-down-left-right\": $fa-var-arrows-up-down-left-right,\n  \"arrows\": $fa-var-arrows,\n  \"chalkboard-user\": $fa-var-chalkboard-user,\n  \"chalkboard-teacher\": $fa-var-chalkboard-teacher,\n  \"peso-sign\": $fa-var-peso-sign,\n  \"building-shield\": $fa-var-building-shield,\n  \"baby\": $fa-var-baby,\n  \"users-line\": $fa-var-users-line,\n  \"quote-left\": $fa-var-quote-left,\n  \"quote-left-alt\": $fa-var-quote-left-alt,\n  \"tractor\": $fa-var-tractor,\n  \"trash-arrow-up\": $fa-var-trash-arrow-up,\n  \"trash-restore\": $fa-var-trash-restore,\n  \"arrow-down-up-lock\": $fa-var-arrow-down-up-lock,\n  \"lines-leaning\": $fa-var-lines-leaning,\n  \"ruler-combined\": $fa-var-ruler-combined,\n  \"copyright\": $fa-var-copyright,\n  \"equals\": $fa-var-equals,\n  \"blender\": $fa-var-blender,\n  \"teeth\": $fa-var-teeth,\n  \"shekel-sign\": $fa-var-shekel-sign,\n  \"ils\": $fa-var-ils,\n  \"shekel\": $fa-var-shekel,\n  \"sheqel\": $fa-var-sheqel,\n  \"sheqel-sign\": $fa-var-sheqel-sign,\n  \"map\": $fa-var-map,\n  \"rocket\": $fa-var-rocket,\n  \"photo-film\": $fa-var-photo-film,\n  \"photo-video\": $fa-var-photo-video,\n  \"folder-minus\": $fa-var-folder-minus,\n  \"store\": $fa-var-store,\n  \"arrow-trend-up\": $fa-var-arrow-trend-up,\n  \"plug-circle-minus\": $fa-var-plug-circle-minus,\n  \"sign-hanging\": $fa-var-sign-hanging,\n  \"sign\": $fa-var-sign,\n  \"bezier-curve\": $fa-var-bezier-curve,\n  \"bell-slash\": $fa-var-bell-slash,\n  \"tablet\": $fa-var-tablet,\n  \"tablet-android\": $fa-var-tablet-android,\n  \"school-flag\": $fa-var-school-flag,\n  \"fill\": $fa-var-fill,\n  \"angle-up\": $fa-var-angle-up,\n  \"drumstick-bite\": $fa-var-drumstick-bite,\n  \"holly-berry\": $fa-var-holly-berry,\n  \"chevron-left\": $fa-var-chevron-left,\n  \"bacteria\": $fa-var-bacteria,\n  \"hand-lizard\": $fa-var-hand-lizard,\n  \"notdef\": $fa-var-notdef,\n  \"disease\": $fa-var-disease,\n  \"briefcase-medical\": $fa-var-briefcase-medical,\n  \"genderless\": $fa-var-genderless,\n  \"chevron-right\": $fa-var-chevron-right,\n  \"retweet\": $fa-var-retweet,\n  \"car-rear\": $fa-var-car-rear,\n  \"car-alt\": $fa-var-car-alt,\n  \"pump-soap\": $fa-var-pump-soap,\n  \"video-slash\": $fa-var-video-slash,\n  \"battery-quarter\": $fa-var-battery-quarter,\n  \"battery-2\": $fa-var-battery-2,\n  \"radio\": $fa-var-radio,\n  \"baby-carriage\": $fa-var-baby-carriage,\n  \"carriage-baby\": $fa-var-carriage-baby,\n  \"traffic-light\": $fa-var-traffic-light,\n  \"thermometer\": $fa-var-thermometer,\n  \"vr-cardboard\": $fa-var-vr-cardboard,\n  \"hand-middle-finger\": $fa-var-hand-middle-finger,\n  \"percent\": $fa-var-percent,\n  \"percentage\": $fa-var-percentage,\n  \"truck-moving\": $fa-var-truck-moving,\n  \"glass-water-droplet\": $fa-var-glass-water-droplet,\n  \"display\": $fa-var-display,\n  \"face-smile\": $fa-var-face-smile,\n  \"smile\": $fa-var-smile,\n  \"thumbtack\": $fa-var-thumbtack,\n  \"thumb-tack\": $fa-var-thumb-tack,\n  \"trophy\": $fa-var-trophy,\n  \"person-praying\": $fa-var-person-praying,\n  \"pray\": $fa-var-pray,\n  \"hammer\": $fa-var-hammer,\n  \"hand-peace\": $fa-var-hand-peace,\n  \"rotate\": $fa-var-rotate,\n  \"sync-alt\": $fa-var-sync-alt,\n  \"spinner\": $fa-var-spinner,\n  \"robot\": $fa-var-robot,\n  \"peace\": $fa-var-peace,\n  \"gears\": $fa-var-gears,\n  \"cogs\": $fa-var-cogs,\n  \"warehouse\": $fa-var-warehouse,\n  \"arrow-up-right-dots\": $fa-var-arrow-up-right-dots,\n  \"splotch\": $fa-var-splotch,\n  \"face-grin-hearts\": $fa-var-face-grin-hearts,\n  \"grin-hearts\": $fa-var-grin-hearts,\n  \"dice-four\": $fa-var-dice-four,\n  \"sim-card\": $fa-var-sim-card,\n  \"transgender\": $fa-var-transgender,\n  \"transgender-alt\": $fa-var-transgender-alt,\n  \"mercury\": $fa-var-mercury,\n  \"arrow-turn-down\": $fa-var-arrow-turn-down,\n  \"level-down\": $fa-var-level-down,\n  \"person-falling-burst\": $fa-var-person-falling-burst,\n  \"award\": $fa-var-award,\n  \"ticket-simple\": $fa-var-ticket-simple,\n  \"ticket-alt\": $fa-var-ticket-alt,\n  \"building\": $fa-var-building,\n  \"angles-left\": $fa-var-angles-left,\n  \"angle-double-left\": $fa-var-angle-double-left,\n  \"qrcode\": $fa-var-qrcode,\n  \"clock-rotate-left\": $fa-var-clock-rotate-left,\n  \"history\": $fa-var-history,\n  \"face-grin-beam-sweat\": $fa-var-face-grin-beam-sweat,\n  \"grin-beam-sweat\": $fa-var-grin-beam-sweat,\n  \"file-export\": $fa-var-file-export,\n  \"arrow-right-from-file\": $fa-var-arrow-right-from-file,\n  \"shield\": $fa-var-shield,\n  \"shield-blank\": $fa-var-shield-blank,\n  \"arrow-up-short-wide\": $fa-var-arrow-up-short-wide,\n  \"sort-amount-up-alt\": $fa-var-sort-amount-up-alt,\n  \"house-medical\": $fa-var-house-medical,\n  \"golf-ball-tee\": $fa-var-golf-ball-tee,\n  \"golf-ball\": $fa-var-golf-ball,\n  \"circle-chevron-left\": $fa-var-circle-chevron-left,\n  \"chevron-circle-left\": $fa-var-chevron-circle-left,\n  \"house-chimney-window\": $fa-var-house-chimney-window,\n  \"pen-nib\": $fa-var-pen-nib,\n  \"tent-arrow-turn-left\": $fa-var-tent-arrow-turn-left,\n  \"tents\": $fa-var-tents,\n  \"wand-magic\": $fa-var-wand-magic,\n  \"magic\": $fa-var-magic,\n  \"dog\": $fa-var-dog,\n  \"carrot\": $fa-var-carrot,\n  \"moon\": $fa-var-moon,\n  \"wine-glass-empty\": $fa-var-wine-glass-empty,\n  \"wine-glass-alt\": $fa-var-wine-glass-alt,\n  \"cheese\": $fa-var-cheese,\n  \"yin-yang\": $fa-var-yin-yang,\n  \"music\": $fa-var-music,\n  \"code-commit\": $fa-var-code-commit,\n  \"temperature-low\": $fa-var-temperature-low,\n  \"person-biking\": $fa-var-person-biking,\n  \"biking\": $fa-var-biking,\n  \"broom\": $fa-var-broom,\n  \"shield-heart\": $fa-var-shield-heart,\n  \"gopuram\": $fa-var-gopuram,\n  \"earth-oceania\": $fa-var-earth-oceania,\n  \"globe-oceania\": $fa-var-globe-oceania,\n  \"square-xmark\": $fa-var-square-xmark,\n  \"times-square\": $fa-var-times-square,\n  \"xmark-square\": $fa-var-xmark-square,\n  \"hashtag\": $fa-var-hashtag,\n  \"up-right-and-down-left-from-center\": $fa-var-up-right-and-down-left-from-center,\n  \"expand-alt\": $fa-var-expand-alt,\n  \"oil-can\": $fa-var-oil-can,\n  \"t\": $fa-var-t,\n  \"hippo\": $fa-var-hippo,\n  \"chart-column\": $fa-var-chart-column,\n  \"infinity\": $fa-var-infinity,\n  \"vial-circle-check\": $fa-var-vial-circle-check,\n  \"person-arrow-down-to-line\": $fa-var-person-arrow-down-to-line,\n  \"voicemail\": $fa-var-voicemail,\n  \"fan\": $fa-var-fan,\n  \"person-walking-luggage\": $fa-var-person-walking-luggage,\n  \"up-down\": $fa-var-up-down,\n  \"arrows-alt-v\": $fa-var-arrows-alt-v,\n  \"cloud-moon-rain\": $fa-var-cloud-moon-rain,\n  \"calendar\": $fa-var-calendar,\n  \"trailer\": $fa-var-trailer,\n  \"bahai\": $fa-var-bahai,\n  \"haykal\": $fa-var-haykal,\n  \"sd-card\": $fa-var-sd-card,\n  \"dragon\": $fa-var-dragon,\n  \"shoe-prints\": $fa-var-shoe-prints,\n  \"circle-plus\": $fa-var-circle-plus,\n  \"plus-circle\": $fa-var-plus-circle,\n  \"face-grin-tongue-wink\": $fa-var-face-grin-tongue-wink,\n  \"grin-tongue-wink\": $fa-var-grin-tongue-wink,\n  \"hand-holding\": $fa-var-hand-holding,\n  \"plug-circle-exclamation\": $fa-var-plug-circle-exclamation,\n  \"link-slash\": $fa-var-link-slash,\n  \"chain-broken\": $fa-var-chain-broken,\n  \"chain-slash\": $fa-var-chain-slash,\n  \"unlink\": $fa-var-unlink,\n  \"clone\": $fa-var-clone,\n  \"person-walking-arrow-loop-left\": $fa-var-person-walking-arrow-loop-left,\n  \"arrow-up-z-a\": $fa-var-arrow-up-z-a,\n  \"sort-alpha-up-alt\": $fa-var-sort-alpha-up-alt,\n  \"fire-flame-curved\": $fa-var-fire-flame-curved,\n  \"fire-alt\": $fa-var-fire-alt,\n  \"tornado\": $fa-var-tornado,\n  \"file-circle-plus\": $fa-var-file-circle-plus,\n  \"book-quran\": $fa-var-book-quran,\n  \"quran\": $fa-var-quran,\n  \"anchor\": $fa-var-anchor,\n  \"border-all\": $fa-var-border-all,\n  \"face-angry\": $fa-var-face-angry,\n  \"angry\": $fa-var-angry,\n  \"cookie-bite\": $fa-var-cookie-bite,\n  \"arrow-trend-down\": $fa-var-arrow-trend-down,\n  \"rss\": $fa-var-rss,\n  \"feed\": $fa-var-feed,\n  \"draw-polygon\": $fa-var-draw-polygon,\n  \"scale-balanced\": $fa-var-scale-balanced,\n  \"balance-scale\": $fa-var-balance-scale,\n  \"gauge-simple-high\": $fa-var-gauge-simple-high,\n  \"tachometer\": $fa-var-tachometer,\n  \"tachometer-fast\": $fa-var-tachometer-fast,\n  \"shower\": $fa-var-shower,\n  \"desktop\": $fa-var-desktop,\n  \"desktop-alt\": $fa-var-desktop-alt,\n  \"m\": $fa-var-m,\n  \"table-list\": $fa-var-table-list,\n  \"th-list\": $fa-var-th-list,\n  \"comment-sms\": $fa-var-comment-sms,\n  \"sms\": $fa-var-sms,\n  \"book\": $fa-var-book,\n  \"user-plus\": $fa-var-user-plus,\n  \"check\": $fa-var-check,\n  \"battery-three-quarters\": $fa-var-battery-three-quarters,\n  \"battery-4\": $fa-var-battery-4,\n  \"house-circle-check\": $fa-var-house-circle-check,\n  \"angle-left\": $fa-var-angle-left,\n  \"diagram-successor\": $fa-var-diagram-successor,\n  \"truck-arrow-right\": $fa-var-truck-arrow-right,\n  \"arrows-split-up-and-left\": $fa-var-arrows-split-up-and-left,\n  \"hand-fist\": $fa-var-hand-fist,\n  \"fist-raised\": $fa-var-fist-raised,\n  \"cloud-moon\": $fa-var-cloud-moon,\n  \"briefcase\": $fa-var-briefcase,\n  \"person-falling\": $fa-var-person-falling,\n  \"image-portrait\": $fa-var-image-portrait,\n  \"portrait\": $fa-var-portrait,\n  \"user-tag\": $fa-var-user-tag,\n  \"rug\": $fa-var-rug,\n  \"earth-europe\": $fa-var-earth-europe,\n  \"globe-europe\": $fa-var-globe-europe,\n  \"cart-flatbed-suitcase\": $fa-var-cart-flatbed-suitcase,\n  \"luggage-cart\": $fa-var-luggage-cart,\n  \"rectangle-xmark\": $fa-var-rectangle-xmark,\n  \"rectangle-times\": $fa-var-rectangle-times,\n  \"times-rectangle\": $fa-var-times-rectangle,\n  \"window-close\": $fa-var-window-close,\n  \"baht-sign\": $fa-var-baht-sign,\n  \"book-open\": $fa-var-book-open,\n  \"book-journal-whills\": $fa-var-book-journal-whills,\n  \"journal-whills\": $fa-var-journal-whills,\n  \"handcuffs\": $fa-var-handcuffs,\n  \"triangle-exclamation\": $fa-var-triangle-exclamation,\n  \"exclamation-triangle\": $fa-var-exclamation-triangle,\n  \"warning\": $fa-var-warning,\n  \"database\": $fa-var-database,\n  \"share\": $fa-var-share,\n  \"mail-forward\": $fa-var-mail-forward,\n  \"bottle-droplet\": $fa-var-bottle-droplet,\n  \"mask-face\": $fa-var-mask-face,\n  \"hill-rockslide\": $fa-var-hill-rockslide,\n  \"right-left\": $fa-var-right-left,\n  \"exchange-alt\": $fa-var-exchange-alt,\n  \"paper-plane\": $fa-var-paper-plane,\n  \"road-circle-exclamation\": $fa-var-road-circle-exclamation,\n  \"dungeon\": $fa-var-dungeon,\n  \"align-right\": $fa-var-align-right,\n  \"money-bill-1-wave\": $fa-var-money-bill-1-wave,\n  \"money-bill-wave-alt\": $fa-var-money-bill-wave-alt,\n  \"life-ring\": $fa-var-life-ring,\n  \"hands\": $fa-var-hands,\n  \"sign-language\": $fa-var-sign-language,\n  \"signing\": $fa-var-signing,\n  \"calendar-day\": $fa-var-calendar-day,\n  \"water-ladder\": $fa-var-water-ladder,\n  \"ladder-water\": $fa-var-ladder-water,\n  \"swimming-pool\": $fa-var-swimming-pool,\n  \"arrows-up-down\": $fa-var-arrows-up-down,\n  \"arrows-v\": $fa-var-arrows-v,\n  \"face-grimace\": $fa-var-face-grimace,\n  \"grimace\": $fa-var-grimace,\n  \"wheelchair-move\": $fa-var-wheelchair-move,\n  \"wheelchair-alt\": $fa-var-wheelchair-alt,\n  \"turn-down\": $fa-var-turn-down,\n  \"level-down-alt\": $fa-var-level-down-alt,\n  \"person-walking-arrow-right\": $fa-var-person-walking-arrow-right,\n  \"square-envelope\": $fa-var-square-envelope,\n  \"envelope-square\": $fa-var-envelope-square,\n  \"dice\": $fa-var-dice,\n  \"bowling-ball\": $fa-var-bowling-ball,\n  \"brain\": $fa-var-brain,\n  \"bandage\": $fa-var-bandage,\n  \"band-aid\": $fa-var-band-aid,\n  \"calendar-minus\": $fa-var-calendar-minus,\n  \"circle-xmark\": $fa-var-circle-xmark,\n  \"times-circle\": $fa-var-times-circle,\n  \"xmark-circle\": $fa-var-xmark-circle,\n  \"gifts\": $fa-var-gifts,\n  \"hotel\": $fa-var-hotel,\n  \"earth-asia\": $fa-var-earth-asia,\n  \"globe-asia\": $fa-var-globe-asia,\n  \"id-card-clip\": $fa-var-id-card-clip,\n  \"id-card-alt\": $fa-var-id-card-alt,\n  \"magnifying-glass-plus\": $fa-var-magnifying-glass-plus,\n  \"search-plus\": $fa-var-search-plus,\n  \"thumbs-up\": $fa-var-thumbs-up,\n  \"user-clock\": $fa-var-user-clock,\n  \"hand-dots\": $fa-var-hand-dots,\n  \"allergies\": $fa-var-allergies,\n  \"file-invoice\": $fa-var-file-invoice,\n  \"window-minimize\": $fa-var-window-minimize,\n  \"mug-saucer\": $fa-var-mug-saucer,\n  \"coffee\": $fa-var-coffee,\n  \"brush\": $fa-var-brush,\n  \"mask\": $fa-var-mask,\n  \"magnifying-glass-minus\": $fa-var-magnifying-glass-minus,\n  \"search-minus\": $fa-var-search-minus,\n  \"ruler-vertical\": $fa-var-ruler-vertical,\n  \"user-large\": $fa-var-user-large,\n  \"user-alt\": $fa-var-user-alt,\n  \"train-tram\": $fa-var-train-tram,\n  \"user-nurse\": $fa-var-user-nurse,\n  \"syringe\": $fa-var-syringe,\n  \"cloud-sun\": $fa-var-cloud-sun,\n  \"stopwatch-20\": $fa-var-stopwatch-20,\n  \"square-full\": $fa-var-square-full,\n  \"magnet\": $fa-var-magnet,\n  \"jar\": $fa-var-jar,\n  \"note-sticky\": $fa-var-note-sticky,\n  \"sticky-note\": $fa-var-sticky-note,\n  \"bug-slash\": $fa-var-bug-slash,\n  \"arrow-up-from-water-pump\": $fa-var-arrow-up-from-water-pump,\n  \"bone\": $fa-var-bone,\n  \"user-injured\": $fa-var-user-injured,\n  \"face-sad-tear\": $fa-var-face-sad-tear,\n  \"sad-tear\": $fa-var-sad-tear,\n  \"plane\": $fa-var-plane,\n  \"tent-arrows-down\": $fa-var-tent-arrows-down,\n  \"exclamation\": $fa-var-exclamation,\n  \"arrows-spin\": $fa-var-arrows-spin,\n  \"print\": $fa-var-print,\n  \"turkish-lira-sign\": $fa-var-turkish-lira-sign,\n  \"try\": $fa-var-try,\n  \"turkish-lira\": $fa-var-turkish-lira,\n  \"dollar-sign\": $fa-var-dollar-sign,\n  \"dollar\": $fa-var-dollar,\n  \"usd\": $fa-var-usd,\n  \"x\": $fa-var-x,\n  \"magnifying-glass-dollar\": $fa-var-magnifying-glass-dollar,\n  \"search-dollar\": $fa-var-search-dollar,\n  \"users-gear\": $fa-var-users-gear,\n  \"users-cog\": $fa-var-users-cog,\n  \"person-military-pointing\": $fa-var-person-military-pointing,\n  \"building-columns\": $fa-var-building-columns,\n  \"bank\": $fa-var-bank,\n  \"institution\": $fa-var-institution,\n  \"museum\": $fa-var-museum,\n  \"university\": $fa-var-university,\n  \"umbrella\": $fa-var-umbrella,\n  \"trowel\": $fa-var-trowel,\n  \"d\": $fa-var-d,\n  \"stapler\": $fa-var-stapler,\n  \"masks-theater\": $fa-var-masks-theater,\n  \"theater-masks\": $fa-var-theater-masks,\n  \"kip-sign\": $fa-var-kip-sign,\n  \"hand-point-left\": $fa-var-hand-point-left,\n  \"handshake-simple\": $fa-var-handshake-simple,\n  \"handshake-alt\": $fa-var-handshake-alt,\n  \"jet-fighter\": $fa-var-jet-fighter,\n  \"fighter-jet\": $fa-var-fighter-jet,\n  \"square-share-nodes\": $fa-var-square-share-nodes,\n  \"share-alt-square\": $fa-var-share-alt-square,\n  \"barcode\": $fa-var-barcode,\n  \"plus-minus\": $fa-var-plus-minus,\n  \"video\": $fa-var-video,\n  \"video-camera\": $fa-var-video-camera,\n  \"graduation-cap\": $fa-var-graduation-cap,\n  \"mortar-board\": $fa-var-mortar-board,\n  \"hand-holding-medical\": $fa-var-hand-holding-medical,\n  \"person-circle-check\": $fa-var-person-circle-check,\n  \"turn-up\": $fa-var-turn-up,\n  \"level-up-alt\": $fa-var-level-up-alt,\n);\n\n$fa-brand-icons: (\n  \"monero\": $fa-var-monero,\n  \"hooli\": $fa-var-hooli,\n  \"yelp\": $fa-var-yelp,\n  \"cc-visa\": $fa-var-cc-visa,\n  \"lastfm\": $fa-var-lastfm,\n  \"shopware\": $fa-var-shopware,\n  \"creative-commons-nc\": $fa-var-creative-commons-nc,\n  \"aws\": $fa-var-aws,\n  \"redhat\": $fa-var-redhat,\n  \"yoast\": $fa-var-yoast,\n  \"cloudflare\": $fa-var-cloudflare,\n  \"ups\": $fa-var-ups,\n  \"pixiv\": $fa-var-pixiv,\n  \"wpexplorer\": $fa-var-wpexplorer,\n  \"dyalog\": $fa-var-dyalog,\n  \"bity\": $fa-var-bity,\n  \"stackpath\": $fa-var-stackpath,\n  \"buysellads\": $fa-var-buysellads,\n  \"first-order\": $fa-var-first-order,\n  \"modx\": $fa-var-modx,\n  \"guilded\": $fa-var-guilded,\n  \"vnv\": $fa-var-vnv,\n  \"square-js\": $fa-var-square-js,\n  \"js-square\": $fa-var-js-square,\n  \"microsoft\": $fa-var-microsoft,\n  \"qq\": $fa-var-qq,\n  \"orcid\": $fa-var-orcid,\n  \"java\": $fa-var-java,\n  \"invision\": $fa-var-invision,\n  \"creative-commons-pd-alt\": $fa-var-creative-commons-pd-alt,\n  \"centercode\": $fa-var-centercode,\n  \"glide-g\": $fa-var-glide-g,\n  \"drupal\": $fa-var-drupal,\n  \"jxl\": $fa-var-jxl,\n  \"hire-a-helper\": $fa-var-hire-a-helper,\n  \"creative-commons-by\": $fa-var-creative-commons-by,\n  \"unity\": $fa-var-unity,\n  \"whmcs\": $fa-var-whmcs,\n  \"rocketchat\": $fa-var-rocketchat,\n  \"vk\": $fa-var-vk,\n  \"untappd\": $fa-var-untappd,\n  \"mailchimp\": $fa-var-mailchimp,\n  \"css3-alt\": $fa-var-css3-alt,\n  \"square-reddit\": $fa-var-square-reddit,\n  \"reddit-square\": $fa-var-reddit-square,\n  \"vimeo-v\": $fa-var-vimeo-v,\n  \"contao\": $fa-var-contao,\n  \"square-font-awesome\": $fa-var-square-font-awesome,\n  \"deskpro\": $fa-var-deskpro,\n  \"brave\": $fa-var-brave,\n  \"sistrix\": $fa-var-sistrix,\n  \"square-instagram\": $fa-var-square-instagram,\n  \"instagram-square\": $fa-var-instagram-square,\n  \"battle-net\": $fa-var-battle-net,\n  \"the-red-yeti\": $fa-var-the-red-yeti,\n  \"square-hacker-news\": $fa-var-square-hacker-news,\n  \"hacker-news-square\": $fa-var-hacker-news-square,\n  \"edge\": $fa-var-edge,\n  \"threads\": $fa-var-threads,\n  \"napster\": $fa-var-napster,\n  \"square-snapchat\": $fa-var-square-snapchat,\n  \"snapchat-square\": $fa-var-snapchat-square,\n  \"google-plus-g\": $fa-var-google-plus-g,\n  \"artstation\": $fa-var-artstation,\n  \"markdown\": $fa-var-markdown,\n  \"sourcetree\": $fa-var-sourcetree,\n  \"google-plus\": $fa-var-google-plus,\n  \"diaspora\": $fa-var-diaspora,\n  \"foursquare\": $fa-var-foursquare,\n  \"stack-overflow\": $fa-var-stack-overflow,\n  \"github-alt\": $fa-var-github-alt,\n  \"phoenix-squadron\": $fa-var-phoenix-squadron,\n  \"pagelines\": $fa-var-pagelines,\n  \"algolia\": $fa-var-algolia,\n  \"red-river\": $fa-var-red-river,\n  \"creative-commons-sa\": $fa-var-creative-commons-sa,\n  \"safari\": $fa-var-safari,\n  \"google\": $fa-var-google,\n  \"square-font-awesome-stroke\": $fa-var-square-font-awesome-stroke,\n  \"font-awesome-alt\": $fa-var-font-awesome-alt,\n  \"atlassian\": $fa-var-atlassian,\n  \"linkedin-in\": $fa-var-linkedin-in,\n  \"digital-ocean\": $fa-var-digital-ocean,\n  \"nimblr\": $fa-var-nimblr,\n  \"chromecast\": $fa-var-chromecast,\n  \"evernote\": $fa-var-evernote,\n  \"hacker-news\": $fa-var-hacker-news,\n  \"creative-commons-sampling\": $fa-var-creative-commons-sampling,\n  \"adversal\": $fa-var-adversal,\n  \"creative-commons\": $fa-var-creative-commons,\n  \"watchman-monitoring\": $fa-var-watchman-monitoring,\n  \"fonticons\": $fa-var-fonticons,\n  \"weixin\": $fa-var-weixin,\n  \"shirtsinbulk\": $fa-var-shirtsinbulk,\n  \"codepen\": $fa-var-codepen,\n  \"git-alt\": $fa-var-git-alt,\n  \"lyft\": $fa-var-lyft,\n  \"rev\": $fa-var-rev,\n  \"windows\": $fa-var-windows,\n  \"wizards-of-the-coast\": $fa-var-wizards-of-the-coast,\n  \"square-viadeo\": $fa-var-square-viadeo,\n  \"viadeo-square\": $fa-var-viadeo-square,\n  \"meetup\": $fa-var-meetup,\n  \"centos\": $fa-var-centos,\n  \"adn\": $fa-var-adn,\n  \"cloudsmith\": $fa-var-cloudsmith,\n  \"opensuse\": $fa-var-opensuse,\n  \"pied-piper-alt\": $fa-var-pied-piper-alt,\n  \"square-dribbble\": $fa-var-square-dribbble,\n  \"dribbble-square\": $fa-var-dribbble-square,\n  \"codiepie\": $fa-var-codiepie,\n  \"node\": $fa-var-node,\n  \"mix\": $fa-var-mix,\n  \"steam\": $fa-var-steam,\n  \"cc-apple-pay\": $fa-var-cc-apple-pay,\n  \"scribd\": $fa-var-scribd,\n  \"debian\": $fa-var-debian,\n  \"openid\": $fa-var-openid,\n  \"instalod\": $fa-var-instalod,\n  \"expeditedssl\": $fa-var-expeditedssl,\n  \"sellcast\": $fa-var-sellcast,\n  \"square-twitter\": $fa-var-square-twitter,\n  \"twitter-square\": $fa-var-twitter-square,\n  \"r-project\": $fa-var-r-project,\n  \"delicious\": $fa-var-delicious,\n  \"freebsd\": $fa-var-freebsd,\n  \"vuejs\": $fa-var-vuejs,\n  \"accusoft\": $fa-var-accusoft,\n  \"ioxhost\": $fa-var-ioxhost,\n  \"fonticons-fi\": $fa-var-fonticons-fi,\n  \"app-store\": $fa-var-app-store,\n  \"cc-mastercard\": $fa-var-cc-mastercard,\n  \"itunes-note\": $fa-var-itunes-note,\n  \"golang\": $fa-var-golang,\n  \"kickstarter\": $fa-var-kickstarter,\n  \"square-kickstarter\": $fa-var-square-kickstarter,\n  \"grav\": $fa-var-grav,\n  \"weibo\": $fa-var-weibo,\n  \"uncharted\": $fa-var-uncharted,\n  \"firstdraft\": $fa-var-firstdraft,\n  \"square-youtube\": $fa-var-square-youtube,\n  \"youtube-square\": $fa-var-youtube-square,\n  \"wikipedia-w\": $fa-var-wikipedia-w,\n  \"wpressr\": $fa-var-wpressr,\n  \"rendact\": $fa-var-rendact,\n  \"angellist\": $fa-var-angellist,\n  \"galactic-republic\": $fa-var-galactic-republic,\n  \"nfc-directional\": $fa-var-nfc-directional,\n  \"skype\": $fa-var-skype,\n  \"joget\": $fa-var-joget,\n  \"fedora\": $fa-var-fedora,\n  \"stripe-s\": $fa-var-stripe-s,\n  \"meta\": $fa-var-meta,\n  \"laravel\": $fa-var-laravel,\n  \"hotjar\": $fa-var-hotjar,\n  \"bluetooth-b\": $fa-var-bluetooth-b,\n  \"square-letterboxd\": $fa-var-square-letterboxd,\n  \"sticker-mule\": $fa-var-sticker-mule,\n  \"creative-commons-zero\": $fa-var-creative-commons-zero,\n  \"hips\": $fa-var-hips,\n  \"behance\": $fa-var-behance,\n  \"reddit\": $fa-var-reddit,\n  \"discord\": $fa-var-discord,\n  \"chrome\": $fa-var-chrome,\n  \"app-store-ios\": $fa-var-app-store-ios,\n  \"cc-discover\": $fa-var-cc-discover,\n  \"wpbeginner\": $fa-var-wpbeginner,\n  \"confluence\": $fa-var-confluence,\n  \"shoelace\": $fa-var-shoelace,\n  \"mdb\": $fa-var-mdb,\n  \"dochub\": $fa-var-dochub,\n  \"accessible-icon\": $fa-var-accessible-icon,\n  \"ebay\": $fa-var-ebay,\n  \"amazon\": $fa-var-amazon,\n  \"unsplash\": $fa-var-unsplash,\n  \"yarn\": $fa-var-yarn,\n  \"square-steam\": $fa-var-square-steam,\n  \"steam-square\": $fa-var-steam-square,\n  \"500px\": $fa-var-500px,\n  \"square-vimeo\": $fa-var-square-vimeo,\n  \"vimeo-square\": $fa-var-vimeo-square,\n  \"asymmetrik\": $fa-var-asymmetrik,\n  \"font-awesome\": $fa-var-font-awesome,\n  \"font-awesome-flag\": $fa-var-font-awesome-flag,\n  \"font-awesome-logo-full\": $fa-var-font-awesome-logo-full,\n  \"gratipay\": $fa-var-gratipay,\n  \"apple\": $fa-var-apple,\n  \"hive\": $fa-var-hive,\n  \"gitkraken\": $fa-var-gitkraken,\n  \"keybase\": $fa-var-keybase,\n  \"apple-pay\": $fa-var-apple-pay,\n  \"padlet\": $fa-var-padlet,\n  \"amazon-pay\": $fa-var-amazon-pay,\n  \"square-github\": $fa-var-square-github,\n  \"github-square\": $fa-var-github-square,\n  \"stumbleupon\": $fa-var-stumbleupon,\n  \"fedex\": $fa-var-fedex,\n  \"phoenix-framework\": $fa-var-phoenix-framework,\n  \"shopify\": $fa-var-shopify,\n  \"neos\": $fa-var-neos,\n  \"square-threads\": $fa-var-square-threads,\n  \"hackerrank\": $fa-var-hackerrank,\n  \"researchgate\": $fa-var-researchgate,\n  \"swift\": $fa-var-swift,\n  \"angular\": $fa-var-angular,\n  \"speakap\": $fa-var-speakap,\n  \"angrycreative\": $fa-var-angrycreative,\n  \"y-combinator\": $fa-var-y-combinator,\n  \"empire\": $fa-var-empire,\n  \"envira\": $fa-var-envira,\n  \"google-scholar\": $fa-var-google-scholar,\n  \"square-gitlab\": $fa-var-square-gitlab,\n  \"gitlab-square\": $fa-var-gitlab-square,\n  \"studiovinari\": $fa-var-studiovinari,\n  \"pied-piper\": $fa-var-pied-piper,\n  \"wordpress\": $fa-var-wordpress,\n  \"product-hunt\": $fa-var-product-hunt,\n  \"firefox\": $fa-var-firefox,\n  \"linode\": $fa-var-linode,\n  \"goodreads\": $fa-var-goodreads,\n  \"square-odnoklassniki\": $fa-var-square-odnoklassniki,\n  \"odnoklassniki-square\": $fa-var-odnoklassniki-square,\n  \"jsfiddle\": $fa-var-jsfiddle,\n  \"sith\": $fa-var-sith,\n  \"themeisle\": $fa-var-themeisle,\n  \"page4\": $fa-var-page4,\n  \"hashnode\": $fa-var-hashnode,\n  \"react\": $fa-var-react,\n  \"cc-paypal\": $fa-var-cc-paypal,\n  \"squarespace\": $fa-var-squarespace,\n  \"cc-stripe\": $fa-var-cc-stripe,\n  \"creative-commons-share\": $fa-var-creative-commons-share,\n  \"bitcoin\": $fa-var-bitcoin,\n  \"keycdn\": $fa-var-keycdn,\n  \"opera\": $fa-var-opera,\n  \"itch-io\": $fa-var-itch-io,\n  \"umbraco\": $fa-var-umbraco,\n  \"galactic-senate\": $fa-var-galactic-senate,\n  \"ubuntu\": $fa-var-ubuntu,\n  \"draft2digital\": $fa-var-draft2digital,\n  \"stripe\": $fa-var-stripe,\n  \"houzz\": $fa-var-houzz,\n  \"gg\": $fa-var-gg,\n  \"dhl\": $fa-var-dhl,\n  \"square-pinterest\": $fa-var-square-pinterest,\n  \"pinterest-square\": $fa-var-pinterest-square,\n  \"xing\": $fa-var-xing,\n  \"blackberry\": $fa-var-blackberry,\n  \"creative-commons-pd\": $fa-var-creative-commons-pd,\n  \"playstation\": $fa-var-playstation,\n  \"quinscape\": $fa-var-quinscape,\n  \"less\": $fa-var-less,\n  \"blogger-b\": $fa-var-blogger-b,\n  \"opencart\": $fa-var-opencart,\n  \"vine\": $fa-var-vine,\n  \"signal-messenger\": $fa-var-signal-messenger,\n  \"paypal\": $fa-var-paypal,\n  \"gitlab\": $fa-var-gitlab,\n  \"typo3\": $fa-var-typo3,\n  \"reddit-alien\": $fa-var-reddit-alien,\n  \"yahoo\": $fa-var-yahoo,\n  \"dailymotion\": $fa-var-dailymotion,\n  \"affiliatetheme\": $fa-var-affiliatetheme,\n  \"pied-piper-pp\": $fa-var-pied-piper-pp,\n  \"bootstrap\": $fa-var-bootstrap,\n  \"odnoklassniki\": $fa-var-odnoklassniki,\n  \"nfc-symbol\": $fa-var-nfc-symbol,\n  \"mintbit\": $fa-var-mintbit,\n  \"ethereum\": $fa-var-ethereum,\n  \"speaker-deck\": $fa-var-speaker-deck,\n  \"creative-commons-nc-eu\": $fa-var-creative-commons-nc-eu,\n  \"patreon\": $fa-var-patreon,\n  \"avianex\": $fa-var-avianex,\n  \"ello\": $fa-var-ello,\n  \"gofore\": $fa-var-gofore,\n  \"bimobject\": $fa-var-bimobject,\n  \"brave-reverse\": $fa-var-brave-reverse,\n  \"facebook-f\": $fa-var-facebook-f,\n  \"square-google-plus\": $fa-var-square-google-plus,\n  \"google-plus-square\": $fa-var-google-plus-square,\n  \"web-awesome\": $fa-var-web-awesome,\n  \"mandalorian\": $fa-var-mandalorian,\n  \"first-order-alt\": $fa-var-first-order-alt,\n  \"osi\": $fa-var-osi,\n  \"google-wallet\": $fa-var-google-wallet,\n  \"d-and-d-beyond\": $fa-var-d-and-d-beyond,\n  \"periscope\": $fa-var-periscope,\n  \"fulcrum\": $fa-var-fulcrum,\n  \"cloudscale\": $fa-var-cloudscale,\n  \"forumbee\": $fa-var-forumbee,\n  \"mizuni\": $fa-var-mizuni,\n  \"schlix\": $fa-var-schlix,\n  \"square-xing\": $fa-var-square-xing,\n  \"xing-square\": $fa-var-xing-square,\n  \"bandcamp\": $fa-var-bandcamp,\n  \"wpforms\": $fa-var-wpforms,\n  \"cloudversify\": $fa-var-cloudversify,\n  \"usps\": $fa-var-usps,\n  \"megaport\": $fa-var-megaport,\n  \"magento\": $fa-var-magento,\n  \"spotify\": $fa-var-spotify,\n  \"optin-monster\": $fa-var-optin-monster,\n  \"fly\": $fa-var-fly,\n  \"aviato\": $fa-var-aviato,\n  \"itunes\": $fa-var-itunes,\n  \"cuttlefish\": $fa-var-cuttlefish,\n  \"blogger\": $fa-var-blogger,\n  \"flickr\": $fa-var-flickr,\n  \"viber\": $fa-var-viber,\n  \"soundcloud\": $fa-var-soundcloud,\n  \"digg\": $fa-var-digg,\n  \"tencent-weibo\": $fa-var-tencent-weibo,\n  \"letterboxd\": $fa-var-letterboxd,\n  \"symfony\": $fa-var-symfony,\n  \"maxcdn\": $fa-var-maxcdn,\n  \"etsy\": $fa-var-etsy,\n  \"facebook-messenger\": $fa-var-facebook-messenger,\n  \"audible\": $fa-var-audible,\n  \"think-peaks\": $fa-var-think-peaks,\n  \"bilibili\": $fa-var-bilibili,\n  \"erlang\": $fa-var-erlang,\n  \"x-twitter\": $fa-var-x-twitter,\n  \"cotton-bureau\": $fa-var-cotton-bureau,\n  \"dashcube\": $fa-var-dashcube,\n  \"42-group\": $fa-var-42-group,\n  \"innosoft\": $fa-var-innosoft,\n  \"stack-exchange\": $fa-var-stack-exchange,\n  \"elementor\": $fa-var-elementor,\n  \"square-pied-piper\": $fa-var-square-pied-piper,\n  \"pied-piper-square\": $fa-var-pied-piper-square,\n  \"creative-commons-nd\": $fa-var-creative-commons-nd,\n  \"palfed\": $fa-var-palfed,\n  \"superpowers\": $fa-var-superpowers,\n  \"resolving\": $fa-var-resolving,\n  \"xbox\": $fa-var-xbox,\n  \"square-web-awesome-stroke\": $fa-var-square-web-awesome-stroke,\n  \"searchengin\": $fa-var-searchengin,\n  \"tiktok\": $fa-var-tiktok,\n  \"square-facebook\": $fa-var-square-facebook,\n  \"facebook-square\": $fa-var-facebook-square,\n  \"renren\": $fa-var-renren,\n  \"linux\": $fa-var-linux,\n  \"glide\": $fa-var-glide,\n  \"linkedin\": $fa-var-linkedin,\n  \"hubspot\": $fa-var-hubspot,\n  \"deploydog\": $fa-var-deploydog,\n  \"twitch\": $fa-var-twitch,\n  \"ravelry\": $fa-var-ravelry,\n  \"mixer\": $fa-var-mixer,\n  \"square-lastfm\": $fa-var-square-lastfm,\n  \"lastfm-square\": $fa-var-lastfm-square,\n  \"vimeo\": $fa-var-vimeo,\n  \"mendeley\": $fa-var-mendeley,\n  \"uniregistry\": $fa-var-uniregistry,\n  \"figma\": $fa-var-figma,\n  \"creative-commons-remix\": $fa-var-creative-commons-remix,\n  \"cc-amazon-pay\": $fa-var-cc-amazon-pay,\n  \"dropbox\": $fa-var-dropbox,\n  \"instagram\": $fa-var-instagram,\n  \"cmplid\": $fa-var-cmplid,\n  \"upwork\": $fa-var-upwork,\n  \"facebook\": $fa-var-facebook,\n  \"gripfire\": $fa-var-gripfire,\n  \"jedi-order\": $fa-var-jedi-order,\n  \"uikit\": $fa-var-uikit,\n  \"fort-awesome-alt\": $fa-var-fort-awesome-alt,\n  \"phabricator\": $fa-var-phabricator,\n  \"ussunnah\": $fa-var-ussunnah,\n  \"earlybirds\": $fa-var-earlybirds,\n  \"trade-federation\": $fa-var-trade-federation,\n  \"autoprefixer\": $fa-var-autoprefixer,\n  \"whatsapp\": $fa-var-whatsapp,\n  \"square-upwork\": $fa-var-square-upwork,\n  \"slideshare\": $fa-var-slideshare,\n  \"google-play\": $fa-var-google-play,\n  \"viadeo\": $fa-var-viadeo,\n  \"line\": $fa-var-line,\n  \"google-drive\": $fa-var-google-drive,\n  \"servicestack\": $fa-var-servicestack,\n  \"simplybuilt\": $fa-var-simplybuilt,\n  \"bitbucket\": $fa-var-bitbucket,\n  \"imdb\": $fa-var-imdb,\n  \"deezer\": $fa-var-deezer,\n  \"raspberry-pi\": $fa-var-raspberry-pi,\n  \"jira\": $fa-var-jira,\n  \"docker\": $fa-var-docker,\n  \"screenpal\": $fa-var-screenpal,\n  \"bluetooth\": $fa-var-bluetooth,\n  \"gitter\": $fa-var-gitter,\n  \"d-and-d\": $fa-var-d-and-d,\n  \"microblog\": $fa-var-microblog,\n  \"cc-diners-club\": $fa-var-cc-diners-club,\n  \"gg-circle\": $fa-var-gg-circle,\n  \"pied-piper-hat\": $fa-var-pied-piper-hat,\n  \"kickstarter-k\": $fa-var-kickstarter-k,\n  \"yandex\": $fa-var-yandex,\n  \"readme\": $fa-var-readme,\n  \"html5\": $fa-var-html5,\n  \"sellsy\": $fa-var-sellsy,\n  \"square-web-awesome\": $fa-var-square-web-awesome,\n  \"sass\": $fa-var-sass,\n  \"wirsindhandwerk\": $fa-var-wirsindhandwerk,\n  \"wsh\": $fa-var-wsh,\n  \"buromobelexperte\": $fa-var-buromobelexperte,\n  \"salesforce\": $fa-var-salesforce,\n  \"octopus-deploy\": $fa-var-octopus-deploy,\n  \"medapps\": $fa-var-medapps,\n  \"ns8\": $fa-var-ns8,\n  \"pinterest-p\": $fa-var-pinterest-p,\n  \"apper\": $fa-var-apper,\n  \"fort-awesome\": $fa-var-fort-awesome,\n  \"waze\": $fa-var-waze,\n  \"bluesky\": $fa-var-bluesky,\n  \"cc-jcb\": $fa-var-cc-jcb,\n  \"snapchat\": $fa-var-snapchat,\n  \"snapchat-ghost\": $fa-var-snapchat-ghost,\n  \"fantasy-flight-games\": $fa-var-fantasy-flight-games,\n  \"rust\": $fa-var-rust,\n  \"wix\": $fa-var-wix,\n  \"square-behance\": $fa-var-square-behance,\n  \"behance-square\": $fa-var-behance-square,\n  \"supple\": $fa-var-supple,\n  \"webflow\": $fa-var-webflow,\n  \"rebel\": $fa-var-rebel,\n  \"css3\": $fa-var-css3,\n  \"staylinked\": $fa-var-staylinked,\n  \"kaggle\": $fa-var-kaggle,\n  \"space-awesome\": $fa-var-space-awesome,\n  \"deviantart\": $fa-var-deviantart,\n  \"cpanel\": $fa-var-cpanel,\n  \"goodreads-g\": $fa-var-goodreads-g,\n  \"square-git\": $fa-var-square-git,\n  \"git-square\": $fa-var-git-square,\n  \"square-tumblr\": $fa-var-square-tumblr,\n  \"tumblr-square\": $fa-var-tumblr-square,\n  \"trello\": $fa-var-trello,\n  \"creative-commons-nc-jp\": $fa-var-creative-commons-nc-jp,\n  \"get-pocket\": $fa-var-get-pocket,\n  \"perbyte\": $fa-var-perbyte,\n  \"grunt\": $fa-var-grunt,\n  \"weebly\": $fa-var-weebly,\n  \"connectdevelop\": $fa-var-connectdevelop,\n  \"leanpub\": $fa-var-leanpub,\n  \"black-tie\": $fa-var-black-tie,\n  \"themeco\": $fa-var-themeco,\n  \"python\": $fa-var-python,\n  \"android\": $fa-var-android,\n  \"bots\": $fa-var-bots,\n  \"free-code-camp\": $fa-var-free-code-camp,\n  \"hornbill\": $fa-var-hornbill,\n  \"js\": $fa-var-js,\n  \"ideal\": $fa-var-ideal,\n  \"git\": $fa-var-git,\n  \"dev\": $fa-var-dev,\n  \"sketch\": $fa-var-sketch,\n  \"yandex-international\": $fa-var-yandex-international,\n  \"cc-amex\": $fa-var-cc-amex,\n  \"uber\": $fa-var-uber,\n  \"github\": $fa-var-github,\n  \"php\": $fa-var-php,\n  \"alipay\": $fa-var-alipay,\n  \"youtube\": $fa-var-youtube,\n  \"skyatlas\": $fa-var-skyatlas,\n  \"firefox-browser\": $fa-var-firefox-browser,\n  \"replyd\": $fa-var-replyd,\n  \"suse\": $fa-var-suse,\n  \"jenkins\": $fa-var-jenkins,\n  \"twitter\": $fa-var-twitter,\n  \"rockrms\": $fa-var-rockrms,\n  \"pinterest\": $fa-var-pinterest,\n  \"buffer\": $fa-var-buffer,\n  \"npm\": $fa-var-npm,\n  \"yammer\": $fa-var-yammer,\n  \"btc\": $fa-var-btc,\n  \"dribbble\": $fa-var-dribbble,\n  \"stumbleupon-circle\": $fa-var-stumbleupon-circle,\n  \"internet-explorer\": $fa-var-internet-explorer,\n  \"stubber\": $fa-var-stubber,\n  \"telegram\": $fa-var-telegram,\n  \"telegram-plane\": $fa-var-telegram-plane,\n  \"old-republic\": $fa-var-old-republic,\n  \"odysee\": $fa-var-odysee,\n  \"square-whatsapp\": $fa-var-square-whatsapp,\n  \"whatsapp-square\": $fa-var-whatsapp-square,\n  \"node-js\": $fa-var-node-js,\n  \"edge-legacy\": $fa-var-edge-legacy,\n  \"slack\": $fa-var-slack,\n  \"slack-hash\": $fa-var-slack-hash,\n  \"medrt\": $fa-var-medrt,\n  \"usb\": $fa-var-usb,\n  \"tumblr\": $fa-var-tumblr,\n  \"vaadin\": $fa-var-vaadin,\n  \"quora\": $fa-var-quora,\n  \"square-x-twitter\": $fa-var-square-x-twitter,\n  \"reacteurope\": $fa-var-reacteurope,\n  \"medium\": $fa-var-medium,\n  \"medium-m\": $fa-var-medium-m,\n  \"amilia\": $fa-var-amilia,\n  \"mixcloud\": $fa-var-mixcloud,\n  \"flipboard\": $fa-var-flipboard,\n  \"viacoin\": $fa-var-viacoin,\n  \"critical-role\": $fa-var-critical-role,\n  \"sitrox\": $fa-var-sitrox,\n  \"discourse\": $fa-var-discourse,\n  \"joomla\": $fa-var-joomla,\n  \"mastodon\": $fa-var-mastodon,\n  \"airbnb\": $fa-var-airbnb,\n  \"wolf-pack-battalion\": $fa-var-wolf-pack-battalion,\n  \"buy-n-large\": $fa-var-buy-n-large,\n  \"gulp\": $fa-var-gulp,\n  \"creative-commons-sampling-plus\": $fa-var-creative-commons-sampling-plus,\n  \"strava\": $fa-var-strava,\n  \"ember\": $fa-var-ember,\n  \"canadian-maple-leaf\": $fa-var-canadian-maple-leaf,\n  \"teamspeak\": $fa-var-teamspeak,\n  \"pushed\": $fa-var-pushed,\n  \"wordpress-simple\": $fa-var-wordpress-simple,\n  \"nutritionix\": $fa-var-nutritionix,\n  \"wodu\": $fa-var-wodu,\n  \"google-pay\": $fa-var-google-pay,\n  \"intercom\": $fa-var-intercom,\n  \"zhihu\": $fa-var-zhihu,\n  \"korvue\": $fa-var-korvue,\n  \"pix\": $fa-var-pix,\n  \"steam-symbol\": $fa-var-steam-symbol,\n);\n","// icons in a list\n// -------------------------\n\n.#{$fa-css-prefix}-ul {\n  list-style-type: none;\n  margin-left: var(--#{$fa-css-prefix}-li-margin, #{$fa-li-margin});\n  padding-left: 0;\n\n  > li { position: relative; }\n}\n\n.#{$fa-css-prefix}-li {\n  left: calc(var(--#{$fa-css-prefix}-li-width, #{$fa-li-width}) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--#{$fa-css-prefix}-li-width, #{$fa-li-width});\n  line-height: inherit;\n}\n","// bordered + pulled icons\n// -------------------------\n\n.#{$fa-css-prefix}-border {\n  border-color: var(--#{$fa-css-prefix}-border-color, #{$fa-border-color});\n  border-radius: var(--#{$fa-css-prefix}-border-radius, #{$fa-border-radius});\n  border-style: var(--#{$fa-css-prefix}-border-style, #{$fa-border-style});\n  border-width: var(--#{$fa-css-prefix}-border-width, #{$fa-border-width});\n  padding: var(--#{$fa-css-prefix}-border-padding, #{$fa-border-padding});\n}\n\n.#{$fa-css-prefix}-pull-left {\n  float: left;\n  margin-right: var(--#{$fa-css-prefix}-pull-margin, #{$fa-pull-margin}); \n}\n\n.#{$fa-css-prefix}-pull-right {\n  float: right;\n  margin-left: var(--#{$fa-css-prefix}-pull-margin, #{$fa-pull-margin}); \n}\n","// animating icons\n// --------------------------\n\n.#{$fa-css-prefix}-beat {\n  animation-name: #{$fa-css-prefix}-beat;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, ease-in-out);\n}\n\n.#{$fa-css-prefix}-bounce {\n  animation-name: #{$fa-css-prefix}-bounce;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, cubic-bezier(0.280, 0.840, 0.420, 1));\n}\n\n.#{$fa-css-prefix}-fade {\n  animation-name: #{$fa-css-prefix}-fade;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, cubic-bezier(.4,0,.6,1));\n}\n\n.#{$fa-css-prefix}-beat-fade {\n  animation-name: #{$fa-css-prefix}-beat-fade;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, cubic-bezier(.4,0,.6,1));\n}\n\n.#{$fa-css-prefix}-flip {\n  animation-name: #{$fa-css-prefix}-flip;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, ease-in-out);\n}\n\n.#{$fa-css-prefix}-shake {\n  animation-name: #{$fa-css-prefix}-shake;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, linear);\n}\n\n.#{$fa-css-prefix}-spin {\n  animation-name: #{$fa-css-prefix}-spin;\n  animation-delay: var(--#{$fa-css-prefix}-animation-delay, 0s);\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 2s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, linear);\n}\n\n.#{$fa-css-prefix}-spin-reverse {\n  --#{$fa-css-prefix}-animation-direction: reverse;\n}\n\n.#{$fa-css-prefix}-pulse,\n.#{$fa-css-prefix}-spin-pulse {\n  animation-name: #{$fa-css-prefix}-spin;\n  animation-direction: var(--#{$fa-css-prefix}-animation-direction, normal);\n  animation-duration: var(--#{$fa-css-prefix}-animation-duration, 1s);\n  animation-iteration-count: var(--#{$fa-css-prefix}-animation-iteration-count, infinite);\n  animation-timing-function: var(--#{$fa-css-prefix}-animation-timing, steps(8));\n}\n\n// if agent or operating system prefers reduced motion, disable animations\n// see: https://www.smashingmagazine.com/2020/09/design-reduced-motion-sensitivities/\n// see: https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion\n@media (prefers-reduced-motion: reduce) {\n  .#{$fa-css-prefix}-beat,\n  .#{$fa-css-prefix}-bounce,\n  .#{$fa-css-prefix}-fade,\n  .#{$fa-css-prefix}-beat-fade,\n  .#{$fa-css-prefix}-flip,\n  .#{$fa-css-prefix}-pulse,\n  .#{$fa-css-prefix}-shake,\n  .#{$fa-css-prefix}-spin,\n  .#{$fa-css-prefix}-spin-pulse {\n    animation-delay: -1ms;\n    animation-duration: 1ms;\n    animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n\n@keyframes #{$fa-css-prefix}-beat {\n  0%, 90% { transform: scale(1); }\n  45% { transform: scale(var(--#{$fa-css-prefix}-beat-scale, 1.25)); }\n}\n\n@keyframes #{$fa-css-prefix}-bounce {\n  0%   { transform: scale(1,1) translateY(0); }\n  10%  { transform: scale(var(--#{$fa-css-prefix}-bounce-start-scale-x, 1.1),var(--#{$fa-css-prefix}-bounce-start-scale-y, 0.9)) translateY(0); }\n  30%  { transform: scale(var(--#{$fa-css-prefix}-bounce-jump-scale-x, 0.9),var(--#{$fa-css-prefix}-bounce-jump-scale-y, 1.1)) translateY(var(--#{$fa-css-prefix}-bounce-height, -0.5em)); }\n  50%  { transform: scale(var(--#{$fa-css-prefix}-bounce-land-scale-x, 1.05),var(--#{$fa-css-prefix}-bounce-land-scale-y, 0.95)) translateY(0); }\n  57%  { transform: scale(1,1) translateY(var(--#{$fa-css-prefix}-bounce-rebound, -0.125em)); }\n  64%  { transform: scale(1,1) translateY(0); }\n  100% { transform: scale(1,1) translateY(0); }\n}\n\n@keyframes #{$fa-css-prefix}-fade {\n  50% { opacity: var(--#{$fa-css-prefix}-fade-opacity, 0.4); }\n}\n\n@keyframes #{$fa-css-prefix}-beat-fade {\n  0%, 100% {\n    opacity: var(--#{$fa-css-prefix}-beat-fade-opacity, 0.4);\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(var(--#{$fa-css-prefix}-beat-fade-scale, 1.125));\n  }\n}\n\n@keyframes #{$fa-css-prefix}-flip {\n  50% {\n    transform: rotate3d(var(--#{$fa-css-prefix}-flip-x, 0), var(--#{$fa-css-prefix}-flip-y, 1), var(--#{$fa-css-prefix}-flip-z, 0), var(--#{$fa-css-prefix}-flip-angle, -180deg));\n  }\n}\n\n@keyframes #{$fa-css-prefix}-shake {\n  0% { transform: rotate(-15deg); }\n  4% { transform: rotate(15deg); }\n  8%, 24% { transform: rotate(-18deg); }\n  12%, 28% { transform: rotate(18deg); }\n  16% { transform: rotate(-22deg); }\n  20% { transform: rotate(22deg); }\n  32% { transform: rotate(-12deg); }\n  36% { transform: rotate(12deg); }\n  40%, 100% { transform: rotate(0deg); }\n}\n\n@keyframes #{$fa-css-prefix}-spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n","// rotating + flipping icons\n// -------------------------\n\n.#{$fa-css-prefix}-rotate-90 {\n  transform: rotate(90deg);\n}\n\n.#{$fa-css-prefix}-rotate-180 {\n  transform: rotate(180deg);\n}\n\n.#{$fa-css-prefix}-rotate-270 {\n  transform: rotate(270deg);\n}\n\n.#{$fa-css-prefix}-flip-horizontal {\n  transform: scale(-1, 1);\n}\n\n.#{$fa-css-prefix}-flip-vertical {\n  transform: scale(1, -1);\n}\n\n.#{$fa-css-prefix}-flip-both,\n.#{$fa-css-prefix}-flip-horizontal.#{$fa-css-prefix}-flip-vertical {\n  transform: scale(-1, -1);\n}\n\n.#{$fa-css-prefix}-rotate-by {\n  transform: rotate(var(--#{$fa-css-prefix}-rotate-angle, 0));\n}\n","// stacking icons\n// -------------------------\n\n.#{$fa-css-prefix}-stack {\n  display: inline-block;\n  height: 2em;\n  line-height: 2em;\n  position: relative;\n  vertical-align: $fa-stack-vertical-align;\n  width: $fa-stack-width;\n}\n\n.#{$fa-css-prefix}-stack-1x,\n.#{$fa-css-prefix}-stack-2x {\n  left: 0;\n  position: absolute;\n  text-align: center;\n  width: 100%;\n  z-index: var(--#{$fa-css-prefix}-stack-z-index, #{$fa-stack-z-index});\n}\n\n.#{$fa-css-prefix}-stack-1x {\n  line-height: inherit;\n}\n\n.#{$fa-css-prefix}-stack-2x {\n  font-size: 2em;\n}\n\n.#{$fa-css-prefix}-inverse {\n  color: var(--#{$fa-css-prefix}-inverse, #{$fa-inverse});\n}\n","// specific icon class definition\n// -------------------------\n\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\nreaders do not read off random characters that represent icons */\n\n@each $name, $icon in $fa-icons {\n  .#{$fa-css-prefix}-#{$name}::before { content: unquote(\"\\\"#{ $icon }\\\"\"); }\n}\n\n","// screen-reader utilities\n// -------------------------\n\n// only display content to screen readers\n.sr-only,\n.#{$fa-css-prefix}-sr-only {\n  @include fa-sr-only;\n}\n\n// use in conjunction with .sr-only to only display content when it's focused\n.sr-only-focusable,\n.#{$fa-css-prefix}-sr-only-focusable {\n  @include fa-sr-only-focusable;\n}\n","/*!\n * Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n * Copyright 2024 Fonticons, Inc.\n */\n@import 'functions';\n@import 'variables';\n\n:root, :host {\n  --#{$fa-css-prefix}-style-family-classic: '#{ $fa-style-family }';\n  --#{$fa-css-prefix}-font-regular: normal 400 1em/1 '#{ $fa-style-family }';\n}\n\n@font-face {\n  font-family: 'Font Awesome 6 Free';\n  font-style: normal;\n  font-weight: 400;\n  font-display: $fa-font-display;\n  src: url('#{$fa-font-path}/fa-regular-400.woff2') format('woff2'),\n    url('#{$fa-font-path}/fa-regular-400.ttf') format('truetype');\n}\n\n.far,\n.#{$fa-css-prefix}-regular {\n  font-weight: 400;\n}\n","/*!\n * Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n * Copyright 2024 Fonticons, Inc.\n */\n@import 'functions';\n@import 'variables';\n\n:root, :host {\n  --#{$fa-css-prefix}-style-family-classic: '#{ $fa-style-family }';\n  --#{$fa-css-prefix}-font-solid: normal 900 1em/1 '#{ $fa-style-family }';\n}\n\n@font-face {\n  font-family: 'Font Awesome 6 Free';\n  font-style: normal;\n  font-weight: 900;\n  font-display: $fa-font-display;\n  src: url('#{$fa-font-path}/fa-solid-900.woff2') format('woff2'),\n    url('#{$fa-font-path}/fa-solid-900.ttf') format('truetype');\n}\n\n.fas,\n.#{$fa-css-prefix}-solid {\n  font-weight: 900;\n}\n","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.3 (https://getbootstrap.com/)\n   * Copyright 2011-2024 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='M2 5L8 11L14 5'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='M2 5L8 11L14 5'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n\n      &::after {\n        position: absolute;\n        inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n        z-index: -1;\n        height: $form-floating-label-height;\n        content: \"\";\n        background-color: $input-bg;\n        @include border-radius($input-border-radius);\n      }\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n\n    &::after {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(#{$input-border-width} * -1); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-header .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n    // stylelint-enable selector-max-class\n\n    > .accordion-collapse {\n      @include border-radius(0);\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(#{$pagination-border-width} * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .btn-close {\n      @include btn-close-white();\n    }\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    @if $color-mode-type == \"media-query\" {\n      .carousel {\n        @include carousel-dark();\n      }\n    } @else {\n      .carousel,\n      &.carousel {\n        @include carousel-dark();\n      }\n    }\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","\n// Colours\n$black: #0000;\n$body-bg: #f7f7f7;\n$h-purple: #37003c;\n$bg-header: #37023b;\n\n$pink-theme-h: #910c45;\n$pink-theme-start: #fd2982;\n$pink-theme-end: #910c45;\n\n$blue-theme-h: #0c4693;\n$blue-theme-start: #29d4fd;\n$blue-theme-end: #0c4591;\n\n$green-theme-h: #0f932e;\n$green-theme-start: #29fd5a;\n$green-theme-end: #0c912c;\n\n$orange-theme-h: #f06f2a;\n$orange-theme-start: #fdb429;\n$orange-theme-end: #f47000;\n\n// Fonts\n$pl-regular: 'PremierLeague-Regular', serif;\n$pl-bold: 'PremierLeague-Bold', serif;\n$pl-bold-italic: 'PremierLeague-BoldItalic', serif;\n$pl-light: 'PremierLeague-Light', serif;\n\n// Spacing\n$spacing-25: 25px;\n\n// Background\n$login-bg: url('../asset/img/login_bg@2x.png');\n\n$min-contrast-ratio:   0.5 !default;\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}offcanvas-padding-y)) calc(-.5 * var(--#{$prefix}offcanvas-padding-x)) calc(-.5 * var(--#{$prefix}offcanvas-padding-y)) auto;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
